var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbkhazia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.782,
    height: 65.651,
    viewBox: "0 0 81.782 65.651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2461",
    "data-name": "Group 2461",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M626.735,111.327l.526.463a.3.3,0,0,1,.061.327c-.166.234-.445.185-.669.274-.247.1-.379.242-.12.479.45.551.258,1.22.338,1.84a.855.855,0,0,1-.389.722c-.232-.076-.258-.3-.341-.482a.972.972,0,0,1-.054-.233,3.338,3.338,0,0,1,.036-.865c-.127.357.052.736-.164,1.05a.77.77,0,0,0-.433,1.043.908.908,0,0,1-.571.89c-.381.076-.785.108-1.007.527.112.165.369.058.476.24.085.276-.118.468-.2.7h0a.316.316,0,0,1-.332.058c-.233-.142-.5-.214-.743-.333-.352-.313-.83-.118-1.214-.305-.289-.255-.046-.426.094-.614a.817.817,0,0,1,.2-.127,2.587,2.587,0,0,0,.916-.4,3.826,3.826,0,0,0,1.286-1.644.736.736,0,0,1,.157-.175,1.156,1.156,0,0,0,.52-.641c-.14,0-.221.142-.357.127a1.878,1.878,0,0,1-.12-2.085,2.7,2.7,0,0,0,.465-.786C625.635,110.937,626.187,111.193,626.735,111.327Z",
    transform: "translate(-545.562 -87.29)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M603.5,214.133l-.335.359a.883.883,0,0,1-.715.321.443.443,0,0,1-.411-.567c.1-.307.412-.389.617-.585.136-.124.333-.223.277-.45-.028-.11-.118-.032-.176.019-.207.5-.558.881-1.1.67a1.067,1.067,0,0,1-.577-1.275,5.862,5.862,0,0,0,2.024-.608.665.665,0,0,1,.713,0,4.292,4.292,0,0,1,.046,1.793A.932.932,0,0,1,603.5,214.133Z",
    transform: "translate(-530.58 -159.753)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M355.363,38.216l.347-.819c.194-.219.429-.394.637-.6.243.011.377-.148.514-.32s.28-.262.464-.063a1.175,1.175,0,0,1,.162.837c.007.06.013.121.024.178.085.143.211.015.314.048a.382.382,0,0,1,.2.369c-.042.231.008.5-.243.65a3.131,3.131,0,0,1-1.106.1c-.153,0-.307-.009-.46,0a2.152,2.152,0,0,0-.514.181.357.357,0,0,1-.215-.044A.486.486,0,0,1,355.363,38.216Z",
    transform: "translate(-353.139 -33.495)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M446.263,40.81l1.392,1.3c.011.2.569.112.254.488-.591.171-1.183.337-1.689-.2-.064-.719-.582-.921-1.169-1.032-.312-.06-.672.037-.893-.3a.626.626,0,0,1,.084-.647c.633-.139,1.123.387,1.729.377Z",
    transform: "translate(-417.244 -36.431)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M542.381,85.663c.4.167.756.472,1.252.375s.546.509.891.671c.158.064.3.144.331.337.253.513.861.6,1.191,1.026l-.083.082c-.376.187-.653-.094-.966-.209a1.458,1.458,0,0,1-.308-.139c-.148-.115-.281-.247-.429-.362-.305-.516-.851-.557-1.348-.694-.684-.214-1.356-.439-1.314-1.367a.3.3,0,0,1,.325-.139C542.149,85.3,542.2,85.56,542.381,85.663Z",
    transform: "translate(-487.645 -68.677)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M370.043,26.9c.617-.086,1.294.186,1.841-.316a1.329,1.329,0,0,1,1.666.022,1.866,1.866,0,0,0,1.65.412.228.228,0,0,1,.109.226.727.727,0,0,1-1.1.37,6.7,6.7,0,0,1-1.695-.7,2.579,2.579,0,0,1-1.971.568c-.129,0-.258,0-.387,0-.265,0-.529,0-.793,0a1.208,1.208,0,0,1-.656-.149.235.235,0,0,1-.076-.248.46.46,0,0,1,.225-.146A2.185,2.185,0,0,1,370.043,26.9Z",
    transform: "translate(-362.74 -26.302)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M608.574,168.114a.274.274,0,0,1-.129.028,1.122,1.122,0,0,1-.8.114,8.037,8.037,0,0,1-.817-.448,1.016,1.016,0,0,1-.144-.649.8.8,0,0,1,.12-.371c.313-.279.526.023.771.138.185.119.391.047.588.067a.657.657,0,0,1,.214.124C608.647,167.408,608.9,167.7,608.574,168.114Z",
    transform: "translate(-534.643 -127.225)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M560.116,97.025c.049.4.38.425.662.516.217.115.35.265.214.526-.449.269-.781-.039-1.03-.308-.442-.479-.984-.836-1.431-1.3-.147-.214-.43-.253-.583-.458-.1-.133.034-.187.1-.264-.288.017-.495-.062-.472-.41l.008-.009a1.516,1.516,0,0,1,1.446.94C559.2,96.67,559.956,96.458,560.116,97.025Z",
    transform: "translate(-499.18 -75.922)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M359.15,31.411c.537-.3.5-.8.49-1.313-.011-.6.086-1.127.868-1.086a.558.558,0,0,1,.076.552,2.539,2.539,0,0,0-.21,1.123c-.043.3,0,.73-.542.565-.342-.059-.368.655-.815.341q-.087-.04-.062-.088c.017-.033.035-.05.053-.05A.268.268,0,0,0,359.15,31.411Z",
    transform: "translate(-355.752 -28.249)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M393.146,29.224c.372.548,1.074.275,1.525.626a7.019,7.019,0,0,0,2.532.393c-.124.328-.409.364-.7.394-1.245.125-2.318-.526-3.472-.807a.817.817,0,0,1-.552-.78v-.177a.216.216,0,0,1,.33.017A.564.564,0,0,0,393.146,29.224Z",
    transform: "translate(-379.965 -28.101)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M635.061,125.122c-.233.243-.519.454-.524.842l-.155,0c-.245-.176.035-.484-.166-.671-.279-.568-.394-1.054.506-1.026a.225.225,0,0,1,.336,0l0,0C635.269,124.552,634.857,124.837,635.061,125.122Z",
    transform: "translate(-554.379 -96.681)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M604.775,181.38a1.37,1.37,0,0,0,.138,1.02.325.325,0,0,1-.226.08,1.71,1.71,0,0,1-.834-1.3c.044-.268-.4-.6.093-.812l.117-.009C604.743,180.383,604.455,181.1,604.775,181.38Z",
    transform: "translate(-532.496 -137.066)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M629.45,131.672l-.471.16q-.116.124-.208-.019h-.892c.4-.49.6-1.146,1.4-.854.072.188-.03.486.31.506Z",
    transform: "translate(-549.949 -101.497)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M576.391,102.863l.35-.164c.2.5-.168.712-.49.9a.683.683,0,0,1-.9-.171c-.115-.12-.22-.248-.338-.363-.311-.478-.728-.073-1.089-.132-.23-.154-.1-.333-.037-.508a.477.477,0,0,1,.164-.158.276.276,0,0,1,.31.073,1.249,1.249,0,0,1,1.011.348C575.656,103.1,575.9,103.734,576.391,102.863Z",
    transform: "translate(-510.895 -80.91)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M442.962,36.988c.238-.017.345.11.354.336.018.436.291.536.656.521l1.031.5a3.245,3.245,0,0,1-1.7-.333c-.3.181-.4-.024-.5-.25a1.046,1.046,0,0,1-.036-.274A.667.667,0,0,1,442.962,36.988Z",
    transform: "translate(-416.277 -33.984)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M605.349,172.6a2.646,2.646,0,0,0-1.562,2.032l-.019.011c-.427.157-.43-.136-.439-.423.147-.452.5-.789.674-1.227a1.344,1.344,0,0,1,.571-.552A.693.693,0,0,1,605.349,172.6Z",
    transform: "translate(-532.221 -131.335)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M631.826,110.941c-.566.047-1.212-.356-1.668.306a1.877,1.877,0,0,1-.7.433c-.422.029-.613-.181-.605-.6a.364.364,0,0,1,.139-.2c.33.542.738.251,1.04.029A1.372,1.372,0,0,1,631.826,110.941Z",
    transform: "translate(-550.653 -86.905)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M632.546,129.468l-.57.046.261-.552a1.261,1.261,0,0,0,.508-.853c.246.176.147.439.167.671C632.766,129,632.818,129.32,632.546,129.468Z",
    transform: "translate(-552.907 -99.498)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M619.442,108.239a3.831,3.831,0,0,0,1.173-.047c.9-.33,1.327.058,1.549.88l-.037.033c-.756-.791-1.811-.3-2.674-.637A.154.154,0,0,1,619.442,108.239Z",
    transform: "translate(-543.823 -85.094)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M610.458,214.174c.3-.544-.112-1.161.169-1.708a.185.185,0,0,1,.206-.006.213.213,0,0,1-.023.211c-.177.608.434,1.069.3,1.668C610.835,214.519,610.651,214.331,610.458,214.174Z",
    transform: "translate(-537.369 -160.125)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M537.539,76.346l1,.061c.108.121.194.287.329.354.609.3.6.7.2,1.168l-.095-.077a1.458,1.458,0,0,0-1.123-1.121C537.681,76.7,537.448,76.637,537.539,76.346Z",
    transform: "translate(-484.699 -62.283)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M596.821,227.916a1.58,1.58,0,0,1,.973-.166l-.138.5c-.088.1-.031.267-.169.337h0c-.083.114-.145.259-.328.222a1.592,1.592,0,0,1-.4-.5.542.542,0,0,1-.045-.213A.3.3,0,0,1,596.821,227.916Z",
    transform: "translate(-527.445 -171.136)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M406.089,34.115a1.241,1.241,0,0,0,.681-.191.38.38,0,0,1,.372.171l.12.2c-.109.456-.49.316-.785.368a1.241,1.241,0,0,1-.661-.135C405.547,34.148,405.982,34.242,406.089,34.115Z",
    transform: "translate(-389.533 -31.782)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M608.29,171.828l-.884-.019c-.051-.674.313-.5.675-.341l.882.016A.635.635,0,0,1,608.29,171.828Z",
    transform: "translate(-535.161 -130.567)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M617.1,107.227l.009.19c-.089.5-.335.539-.664.207a1.054,1.054,0,0,1-.291-.676.385.385,0,0,1,.106-.239l.008-.031C616.745,106.553,616.568,107.443,617.1,107.227Z",
    transform: "translate(-541.483 -84.082)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M493.606,66.484a.348.348,0,0,1-.336-.17c.412-.056.822-.357,1.314.006C494.252,66.582,493.91,66.44,493.606,66.484Z",
    transform: "translate(-452.746 -54.947)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M611.489,209.656l-.019-.2a1.737,1.737,0,0,1,.023-1.012.434.434,0,0,1,.153-.2l.334.355A.882.882,0,0,1,611.489,209.656Z",
    transform: "translate(-538.048 -157.111)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M587.5,235.764l-.69.645h-.078l-.078.006a.513.513,0,0,1-.478.054c-.18-.384.213-.369.357-.529.327-.132.564-.5.984-.393A.171.171,0,0,1,587.5,235.764Z",
    transform: "translate(-519.801 -176.73)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M354.113,43.1l.173.488a1.165,1.165,0,0,1-.373.589.248.248,0,0,1-.313-.09A1.294,1.294,0,0,1,354.113,43.1Z",
    transform: "translate(-351.889 -38.381)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M542.57,83.268a.487.487,0,0,1-.379-.328c-.186-.342-.636-.681-.01-1.032l.026.019Z",
    transform: "translate(-487.833 -66.281)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M369.243,28.011c.206-.268.631-.073.811-.393l.434.229A2.745,2.745,0,0,1,369.243,28.011Z",
    transform: "translate(-363.185 -27.248)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M610.015,218.632l.653.165c-.23.282-.55.107-.824.166Z",
    transform: "translate(-536.926 -164.583)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M353.181,46.614l.333.032c.171.191.086.378-.007.566a.516.516,0,0,1-.177.164.268.268,0,0,1-.223-.061c.025-.18.115-.371-.089-.509Z",
    transform: "translate(-351.47 -40.906)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M585.489,238.542l.515.026c-.008.048-.015.1-.02.145l-.481.2a.171.171,0,0,1-.218.016.34.34,0,0,1-.014-.35A.192.192,0,0,1,585.489,238.542Z",
    transform: "translate(-519.151 -178.885)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M630.643,134.183l.208.019-.2.492-.165.18A1.046,1.046,0,0,1,630.643,134.183Z",
    transform: "translate(-551.82 -103.866)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M416.051,110.986a.366.366,0,0,0-.13-.032.155.155,0,0,1-.081-.189c.219-.447-.077-.4-.351-.369a.382.382,0,0,1-.378-.253.5.5,0,0,1,.033-.354.612.612,0,0,1,.273-.2c.288-.067.293-.366.438-.552a.983.983,0,0,1,.388-.235.572.572,0,0,1,.453.048.45.45,0,0,1,.129.183,1.217,1.217,0,0,0,.2.817.77.77,0,0,1-.027.563c-.4.394.145.775.019,1.165a.5.5,0,0,1-.224.275.186.186,0,0,1-.215-.049l0,.006C416.348,111.574,416.3,111.214,416.051,110.986Z",
    transform: "translate(-396.294 -85.602)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M363.647,68.272l-.464-.494a.365.365,0,0,1-.286-.238c-.056-.3.011-.519.357-.554a1.743,1.743,0,0,1,.771.364,2.024,2.024,0,0,1,.411.435.542.542,0,0,1,0,.459.348.348,0,0,1-.282.153C363.974,68.406,363.821,68.294,363.647,68.272Z",
    transform: "translate(-358.59 -55.553)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M420.435,119.523a1.673,1.673,0,0,0,.167-.011c.292.112.385.417.588.616a1.273,1.273,0,0,0,.517.488,1.479,1.479,0,0,0,.638.062c.308.01.622-.209.923.025l.057.035C421.96,121.459,420.94,121.222,420.435,119.523Z",
    transform: "translate(-400.151 -93.318)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M349.588,62.636c-.3-.229-.741-.084-1-.4a.253.253,0,0,1,.006-.357.91.91,0,0,1,.508-.149,2.169,2.169,0,0,1,.543.031.668.668,0,0,1,.518.738C350.028,62.786,349.824,62.778,349.588,62.636Z",
    transform: "translate(-348.217 -51.769)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M358.055,66.163l.162.217c-.171.269-.346.037-.519,0l-1.007-.693-.681-.349c-.045-.226.116-.26.271-.3a.846.846,0,0,1,.23.02,2.181,2.181,0,0,1,.711.329c.137.113.257.244.384.367A3.666,3.666,0,0,0,358.055,66.163Z",
    transform: "translate(-353.623 -54.155)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M369.525,72.483c-.319.114-.447-.242-.7-.29-.191-.16-.313-.338-.146-.59a1.032,1.032,0,0,1,.653-.146c.265.037.535.07.589.414C369.9,72.145,369.68,72.294,369.525,72.483Z",
    transform: "translate(-362.721 -58.766)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M389.477,107.926a.5.5,0,0,0-.137-.028.469.469,0,0,1-.275-.4.691.691,0,0,1,.334-.553.541.541,0,0,1,.721.227.656.656,0,0,1-.03.55A.516.516,0,0,1,389.477,107.926Z",
    transform: "translate(-377.499 -84.244)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M386.343,106.934l.216.318c-.634-.192-1.244-.412-1.345-1.21a.239.239,0,0,1,.2-.044,1.622,1.622,0,0,1,.544.32A1.016,1.016,0,0,1,386.343,106.934Z",
    transform: "translate(-374.718 -83.598)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M366.625,71.782l.214.519c-.543.221-.761-.169-.989-.539a.4.4,0,0,1,.344-.15l.292-.006A.238.238,0,0,1,366.625,71.782Z",
    transform: "translate(-360.736 -58.875)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M353.707,64.253a.338.338,0,0,0-.315.171c-.337-.111-.825.27-1.015-.32.179-.038.392.044.527-.152a.361.361,0,0,1,.18-.159.644.644,0,0,1,.482.043C353.7,63.947,353.82,64.06,353.707,64.253Z",
    transform: "translate(-351.007 -53.238)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M397.432,107.489l-.33-.007c-.394-.327-.789-.171-1.185,0a.276.276,0,0,1-.013-.353,1.435,1.435,0,0,1,.812-.338,1.108,1.108,0,0,1,.5.06.608.608,0,0,1,.282.248.356.356,0,0,1-.028.36Z",
    transform: "translate(-382.396 -84.165)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M383.6,101.326l-.183-.5c.2-.271-.092-.625.146-.889.372-.117.464.115.505.412-.055.328.053.675-.11.991a.146.146,0,0,1-.213,0C383.7,101.332,383.648,101.328,383.6,101.326Z",
    transform: "translate(-373.42 -79.219)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M393.6,107.845c-.006.108-.011.216-.017.324-.434.029-.449.622-.873.664a.4.4,0,0,1-.053-.438,1.151,1.151,0,0,1,.333-.471.537.537,0,0,1,.527-.16Z",
    transform: "translate(-380.065 -84.856)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M376.8,75.963c-.289-.02-.541-.239-.849-.158a.575.575,0,0,0-.037-.163.467.467,0,0,1,.261-.309.609.609,0,0,1,.656.113A.39.39,0,0,1,376.8,75.963Z",
    transform: "translate(-368 -61.52)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M391.3,109.813l-.084.459c-.3.069-.572.094-.67-.3l.543-.19A.128.128,0,0,1,391.3,109.813Z",
    transform: "translate(-378.57 -86.294)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M371.894,73.948c-.031-.223-.034-.43.269-.449a.4.4,0,0,1,.428.19c.035.129.042.248-.115.3Z",
    transform: "translate(-365.09 -60.231)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M374.024,74.281l.063-.331.1-.054a.945.945,0,0,1,.6.331.188.188,0,0,1-.015.214l-.223.2Z",
    transform: "translate(-366.638 -60.521)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M347.819,61.487l-.007.307-.3-.008q-.033-.143-.066-.286l.019-.337.34-.051A.283.283,0,0,1,347.819,61.487Z",
    transform: "translate(-347.444 -51.33)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M418.541,116.631c.364.153.448.489.529.827C418.712,117.3,418.627,116.966,418.541,116.631Z",
    transform: "translate(-398.784 -91.247)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M384.6,104.8l.172-.008a.319.319,0,0,1,.367-.034c.106.094.191.221.126.35s-.209.139-.336.042a.5.5,0,0,0-.158-.025Z",
    transform: "translate(-374.273 -82.677)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M366.044,71.206a.348.348,0,0,1-.344.15l-.058-.169C365.785,70.987,365.919,70.992,366.044,71.206Z",
    transform: "translate(-360.585 -58.469)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M348.134,58.232c-.168-.076-.179-.245-.228-.393q.016-.258.032-.517l.056.006a.358.358,0,0,1,.429-.086.274.274,0,0,1,.126.19C348.521,57.757,348.473,58.072,348.134,58.232Z",
    transform: "translate(-347.778 -48.522)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M348.726,58.454l.343-.9a.19.19,0,0,1,.21,0,.5.5,0,0,1,.1.316,2.173,2.173,0,0,0-.065.837.225.225,0,0,1-.078.185l-.487.017q-.008-.188-.016-.375Z",
    transform: "translate(-348.37 -48.744)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M467.92,133.308l-1.317-1.715q-.014-.168-.029-.336a.5.5,0,0,1,.312-.169,1.4,1.4,0,0,1,.358-.011.789.789,0,0,1,.333.106.751.751,0,0,1,.251.49.41.41,0,0,0,.147.35c.232.1.518.06.7.283a.9.9,0,0,1,.117.355,5.978,5.978,0,0,1,0,.92.879.879,0,0,1-.121.376.322.322,0,0,1-.22.123C468,134.025,468.1,133.562,467.92,133.308Z",
    transform: "translate(-433.469 -101.629)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M554.152,254.624l-.194-2.039c.14-.066.216.018.285.121-.046.8.713.676,1.106.973a.733.733,0,0,1,.36.587c-.086.287-.389.226-.569.362Z",
    transform: "translate(-496.569 -188.978)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M559.158,255.8l-.338-.457c-.042-.434.209-.58.582-.606a1.873,1.873,0,0,1,.493.292.381.381,0,0,1,.128.181l-.221.29-.335.313C559.358,255.956,559.255,255.938,559.158,255.8Z",
    transform: "translate(-500.077 -190.539)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M465.774,129.461l-.332.011a.681.681,0,0,0-.547-.189l-.13,0a.476.476,0,0,1-.168-.165c-.067-.158-.113-.312.068-.43a1.136,1.136,0,0,1,.488-.1,1.046,1.046,0,0,1,.625.146.547.547,0,0,1,.149.366A.583.583,0,0,1,465.774,129.461Z",
    transform: "translate(-431.998 -99.839)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M465.824,130.7c.28-.226.477-.207.547.189l-.339,0Z",
    transform: "translate(-432.927 -101.26)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M605.812,101.791l.329.558c-.042.532.511.649.7,1.022a.511.511,0,0,1-.218.134c-.513.136-.883-.279-1.341-.355a.409.409,0,0,1-.227-.32.627.627,0,0,0,.06.266c.052.153.028.3-.146.3-.3,0-.4-.239-.483-.481C604.529,101.927,604.883,101.629,605.812,101.791Z",
    transform: "translate(-533.054 -80.547)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M603.929,101c-.741.047-1.3.286-1.207,1.193,0,.042,0,.084,0,.126-.151.393-.26.853-.847.525l.028-.123c.659-.485.433-1.546,1.3-1.947C603.617,100.58,603.787,100.575,603.929,101Z",
    transform: "translate(-531.171 -79.754)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M589.733,104.92l.468.2c.282.282.758.169,1.01.511.157.368.621.473.733.879-.426.561-.7-.095-1.058-.131a3.329,3.329,0,0,1-.419-.363c-.258-.346-.753-.5-.807-1.014Z",
    transform: "translate(-522.349 -82.827)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M595.916,107.965a1.029,1.029,0,0,1-.673-.8c.3.116.567.643.939.033.043-.07.674-.357.932.126l-.026.036c-.255.22-.62.25-.851.512A.422.422,0,0,1,595.916,107.965Z",
    transform: "translate(-526.382 -84.356)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M611.07,104.883c-.417-.2-.794-.429-.677-1,.308.812,1.061.691,1.692.825,0,.059,0,.118,0,.176A.714.714,0,0,1,611.07,104.883Z",
    transform: "translate(-537.306 -82.081)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M604.453,107.441h1.015c.3.149.017,1.251.849.532.572-.1,1.15,0,1.733-.143.556-.139.549.628.943.819.034.328.062.66.509.663a.382.382,0,0,1,.349.182,4.178,4.178,0,0,0,0,2.046c.23.3.107.511-.169.682-.474.5-.818,1.113-1.291,1.617-.339.233-.719.394-1.071.6h0a7.824,7.824,0,0,1-1.548.766,1.218,1.218,0,0,1-.226.06,2.183,2.183,0,0,1-1-.275c-.253-.046-.437-.436-.756-.153a.377.377,0,0,1-.217-.017,4.678,4.678,0,0,0-1.078-.767,9.22,9.22,0,0,0-.932-.146.578.578,0,0,1-.219-.134c-.207-.329-.21-.591.225-.71a3.255,3.255,0,0,1,.62-.042c.456.115.536-.306.748-.539a2.851,2.851,0,0,1,1.3-.354.856.856,0,0,1,.213.132c.235.189.464.537.789.314.352-.243.136-.614.031-.932s.1-.524.236-.757a1,1,0,0,1,.159-.168,15.355,15.355,0,0,0,1.3-1.2l-.034.029a.645.645,0,0,1-.279.128,1.684,1.684,0,0,0-1.374.636c-.505.552-1.041,1.077-1.575,1.6a.728.728,0,0,1-.228.112.547.547,0,0,1-.706-.413,1.812,1.812,0,0,1,.465-1.921,5.049,5.049,0,0,0,1.056-2.246Z",
    transform: "translate(-530.689 -84.639)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M626.649,126c.386-.569.6-1.3,1.35-1.536a2.827,2.827,0,0,1-1.35,1.878A.23.23,0,0,1,626.649,126Z",
    transform: "translate(-549.005 -96.875)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M620.826,134.838c.265.034.615-.109.68.337l-.01.01a4.024,4.024,0,0,1-2.283.178c-.25-.175-.786-.013-.692-.6A3.86,3.86,0,0,1,620.826,134.838Z",
    transform: "translate(-543.184 -104.182)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M619.831,134.151l-2.365.011c-.192.094-.344.111-.333-.18h0c.46.037.838-.588,1.346-.171C618.924,133.958,619.521,133.47,619.831,134.151Z",
    transform: "translate(-542.189 -103.496)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M631.7,121.1a1.161,1.161,0,0,0,.169-.682l.49-.63C632.489,120.434,632.484,120.989,631.7,121.1Z",
    transform: "translate(-552.711 -93.518)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M618.491,132.869l-1.346.171a3.987,3.987,0,0,1,1.684-.683Z",
    transform: "translate(-542.197 -102.553)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M636.9,121.114h-.336c.039-.4-.121-.845.336-1.307Z",
    transform: "translate(-556.219 -93.531)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M624.216,129.925v.342a1.26,1.26,0,0,1-1.013.342C623.376,130.13,623.833,130.085,624.216,129.925Z",
    transform: "translate(-546.572 -100.805)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M631.405,113.432a.37.37,0,0,1-.349-.182.643.643,0,0,1,.692-.331C632.037,113.365,631.655,113.353,631.405,113.432Z",
    transform: "translate(-552.243 -88.576)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M636.892,125.321c-.847-.285.161-.57,0-.855.2.127.157.337.174.527A.311.311,0,0,1,636.892,125.321Z",
    transform: "translate(-556.209 -96.88)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M636.525,113.089c-.138.213-.393.181-.586.282-.12.063-.293.089-.348-.085-.065-.206.117-.284.258-.369C636.041,113.11,636.333,112.9,636.525,113.089Z",
    transform: "translate(-555.508 -88.576)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M637.231,113.021c-.233-.025-.5.076-.676-.173C636.773,112.933,637.085,112.643,637.231,113.021Z",
    transform: "translate(-556.213 -88.507)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M496.117,68.715l.186.192a.806.806,0,0,1,.194.273c.244.33-.2.581-.1.9-.08.347-.368.4-.645.474a.925.925,0,0,1-.61-.19,4.768,4.768,0,0,0-2.794-.893,5.36,5.36,0,0,1-.913-.049,1.423,1.423,0,0,1-.7-.4c-.395-.4-.9-.212-1.348-.228-1.98-.069-2.6-.964-1.962-2.9a.367.367,0,0,1,.105-.129.487.487,0,0,1,.533.052l.155.133c.416.9,1.3,1.059,2.1,1.354.218.081.346-.073.494-.223a1.586,1.586,0,0,1,1.979-.189.1.1,0,0,1-.02.085c.07.142.252.213.247.4a.347.347,0,0,1-.105.207c-.3.112-.769-.295-.908.3-.025.087-.119.246-.06.246.16,0,.168-.228.3-.308a.362.362,0,0,1,.492.2c.2.366.417.124.635.043.5-.016.928-.5,1.467-.215a.16.16,0,0,1,.114.014,2.923,2.923,0,0,0,.841.536A.7.7,0,0,1,496.117,68.715Z",
    transform: "translate(-448.355 -54.629)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M480.009,62.877l-.54.013a2.436,2.436,0,0,1-.425-.272.744.744,0,0,0-.555-.168c-.384.025-.594.369-.916.509a.49.49,0,0,1-.227-.043c-.341-.185-.7-.337-1.033-.534-.2-.119-.384-.249-.22-.526a.242.242,0,0,1,.339.007,1.928,1.928,0,0,0,1.8-.081C478.955,61.4,479.3,61.663,480.009,62.877Z",
    transform: "translate(-440.297 -51.695)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M495.433,67.509c-.716.024-1.531-.353-2.032.554-.055.1-.394.131-.549.067-.584-.241-1.155-.517-1.713-.815a.655.655,0,0,1-.277-.748,3.9,3.9,0,0,0,1.2.854c.516.188,1.116.731,1.43-.278.071-.228.316-.214.5-.112a1.606,1.606,0,0,0,.9.1c.337-.109.662-.2.541.372Z",
    transform: "translate(-450.995 -55.251)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M507.694,71.773l0-.173a11.16,11.16,0,0,1,1.845.342.8.8,0,0,1,.064.15c-.541.047-.979.554-1.573.363C507.752,72.313,507.54,72.136,507.694,71.773Z",
    transform: "translate(-463.124 -58.87)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M509.284,70.953c-.616-.107-1.281.052-1.845-.342l-.155-.387C507.853,70.741,508.7,70.482,509.284,70.953Z",
    transform: "translate(-462.866 -57.881)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M475.123,58.934l-.337,0-.077-.065a2.608,2.608,0,0,0-.288-.526.885.885,0,0,1-.106-.181c-.056-.2-.171-.4-.033-.617l.335.023C475.227,57.857,474.778,58.547,475.123,58.934Z",
    transform: "translate(-438.988 -48.766)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M515.967,74.092a.824.824,0,0,1-.844-.69l.505.012C515.71,73.655,516.061,73.76,515.967,74.092Z",
    transform: "translate(-468.526 -60.166)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M517.278,74.12c-.1-.235-.361-.383-.339-.678l.651.517q0,.161.008.321Z",
    transform: "translate(-469.837 -60.195)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M505.933,68.471c-.04-.332-.268-.386-.541-.372a.4.4,0,0,1,.632-.043C506.164,68.2,506.245,68.4,505.933,68.471Z",
    transform: "translate(-461.5 -56.224)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M588.9,170.912c-.265.033-.619-.117-.675.341.027.265-.234.336-.338.513a2.353,2.353,0,0,1-.605.646c-.535.961-.5,1.181.266,1.573-.074.609.406.937.678,1.372.236.181.069.459.16.675l.029.33a6.418,6.418,0,0,1-.032.864l-.15.5c.168.656-.326.545-.646.517a3.8,3.8,0,0,0-1.4.033c-.861.245-1.05.565-.844,1.469a.39.39,0,0,1-.74.243,1.2,1.2,0,0,0-.511-.417.384.384,0,0,1-.147-.173.467.467,0,0,1,.036-.23,1.617,1.617,0,0,0,.316-.686.888.888,0,0,1,.891-.909c.132.036.055-.187.029-.077,0,.02-.033.018-.082.022a.4.4,0,0,1-.31-.1c-.045-.377.173-.528.495-.588.686.271,1.255-.167,1.8-.417.377-.173.168-.671-.07-1.032.323.975.055,1.3-.925,1.151-.183-.229-.063-.552-.236-.793-.84.86-1.843.471-2.8.4-.2-.121-.128-.259-.032-.407.03-.046.162-.074.067-.146-.036-.027-.147.045-.229.059a5.255,5.255,0,0,1-1.084.3c-.943-.3-.943-.3-.932-1.473a.679.679,0,0,1-.019-.357.462.462,0,0,1,.139-.2,1.22,1.22,0,0,1,.6-.128c.155-.006.31-.007.464-.019.474.033.589-.284.638-.668a.525.525,0,0,1,.131-.188,1.344,1.344,0,0,0,1-.414.97.97,0,0,1,.241-.053,2.678,2.678,0,0,1,1.088.258c.184.141.414.463.483-.066a2.5,2.5,0,0,0-.2-1.482.35.35,0,0,1,.166-.343,11.5,11.5,0,0,1,2.622-.228C588.493,170.6,588.847,170.455,588.9,170.912Z",
    transform: "translate(-515.984 -130.011)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M596,198.149c-.435-.824-.091-1.491.856-1.72a2.539,2.539,0,0,1,1.559-.019c.257.1.578.089.631-.328.375.635.276,1.428.671,2.057.2.129.044.371.164.525l.007.337a24.777,24.777,0,0,1-2.777,1.583.236.236,0,0,1-.193-.107C596.506,199.745,596.4,198.887,596,198.149Z",
    transform: "translate(-526.796 -148.37)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M599.968,208.008a9.213,9.213,0,0,1,2.874-1.538c.148.186.435.229.5.5l-.011.185c-.368.176-.984.029-.943.746a.153.153,0,0,1-.192.115c-.8-.433-1.352.2-1.994.45C599.951,208.406,599.819,208.281,599.968,208.008Z",
    transform: "translate(-529.748 -155.839)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M607.525,192.1a.581.581,0,0,1,.032-.864C608.027,191.542,607.816,191.823,607.525,192.1Z",
    transform: "translate(-535.122 -144.886)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M607.573,188.31c-.235-.181-.14-.442-.16-.675l.171-.01C607.85,187.858,607.69,188.083,607.573,188.31Z",
    transform: "translate(-535.168 -142.29)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M569.629,103.394a.593.593,0,0,0,.669.338c-.35.454-.456.449-.929-.04l-.261-.459Z",
    transform: "translate(-507.509 -81.614)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M601.159,209.78a1.369,1.369,0,0,1,1.928-.465c-.007-.959-.007-.959,1.1-.733a1.673,1.673,0,0,1-.165,1.031c-.054,0-.109,0-.164,0-.735-.162-1.186.579-1.906.61a5.569,5.569,0,0,1-.794-.1A.238.238,0,0,1,601.159,209.78Z",
    transform: "translate(-530.603 -157.269)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M598.565,218.772l-.341.335c-.547.044-.889.525-1.39.669a.623.623,0,0,1-.144-.55c-.169-.537-.837-.108-1.052-.555a.5.5,0,0,1-.067-.234,1.059,1.059,0,0,1,.221-.582.748.748,0,0,1,.223-.116c.285-.065.578-.069.865-.12.477.12.83.506,1.308.625C598.173,218.523,598.224,218.753,598.565,218.772Z",
    transform: "translate(-526.618 -163.855)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M598.891,213.54c-.571.154-.9-.348-1.35-.512l-.083-.076c-.142-.284-.1-.658-.417-.857-.063-.207-.266-.214-.419-.3a.632.632,0,0,1-.078-.223c0-.226.043-.422.291-.5a.9.9,0,0,1,.706.241h0a.311.311,0,0,0,.337.343q0,.17,0,.341c.026.108.02.244.083.318.235.272.091.849.636.86.486.01.6-.386.74-.754.019-.05.147-.057.224-.085a.87.87,0,0,1,0,.855C599.333,213.3,599.185,213.564,598.891,213.54Z",
    transform: "translate(-527.322 -159.152)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M607.412,216.075q0-.427,0-.855c.221-.187.362-.234.36.156A.773.773,0,0,1,607.412,216.075Z",
    transform: "translate(-535.168 -162.03)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M599.088,131.4h.147a.388.388,0,0,1,.289.193c.243.79.891.825,1.546.846.35.083.7-.1,1.053.013a.491.491,0,0,1,.193.138c.036.256-.2.248-.358.312a.683.683,0,0,1,.644-.019c-.228.215.143.548-.145.751-.354.313-.918.227-1.214.652l-.439.033a2.458,2.458,0,0,1-1.309.146,2.075,2.075,0,0,0-1.189.273c-.3.072-.542-.326-.866-.108-.054.289.3.3.338.529,0,.568-.557,1.083-.161,1.691l.133.13c.042.669.808.981.808,1.673-.211.484.239,1.019-.113,1.492a1.192,1.192,0,0,1-1.08.109c-.453-.463-.339-1.112-.361-1.64a1.237,1.237,0,0,0-.382-.979,2.328,2.328,0,0,1-.739-1.2c-.125-.484.064-1.013-.332-1.476-.186-.218-.1-.645.067-.958.418-.293.606,0,.751.325a2.674,2.674,0,0,1,.19,1.09c-.129-.616.225-1.584-.83-1.983a1.477,1.477,0,0,1-.791-1.031.393.393,0,0,1,.095-.208,1.676,1.676,0,0,0,.69-.677,2.691,2.691,0,0,1,1.207-.2c.1.082.028-.019.018-.02-.419-.07-.349-.34-.235-.624a.568.568,0,0,1,.346-.113,3.005,3.005,0,0,1,.612.025C598.2,130.739,598.566,131.209,599.088,131.4Z",
    transform: "translate(-526.161 -101.252)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M603.936,146.4a1.373,1.373,0,0,1,.112-1.7c-.078-.3.146-.395.34-.51.857-.579,1.817-.276,2.736-.326-.243.357-.6.349-.974.33A2.067,2.067,0,0,0,603.936,146.4Z",
    transform: "translate(-532.479 -110.805)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M605.606,154.849c-.431-.372-.83-.76-.656-1.419.541.162,1.169.155,1.482.769a.805.805,0,0,1-.461.661A.265.265,0,0,1,605.606,154.849Z",
    transform: "translate(-533.361 -117.704)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M580.069,239.371l.185.007c-.423.293-1.019.245-1.361.7l-.865-.009A.349.349,0,0,1,578,239.7c.225-.234.567-.168.821-.329a1.675,1.675,0,0,1,.622-.2A.775.775,0,0,1,580.069,239.371Z",
    transform: "translate(-513.902 -179.35)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M575.258,240.461q-.01.174-.02.348c-.411,0-.66.335-.993.5a.494.494,0,0,1-.135-.213.666.666,0,0,1,.035-.381,1,1,0,0,1,1.1-.475A.152.152,0,0,1,575.258,240.461Z",
    transform: "translate(-511.112 -180.09)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M571.107,244.441l-.17,0c-.178.062-.219-.057-.248-.193a.416.416,0,0,1,.441-.4c.138.044.228.121.193.285Z",
    transform: "translate(-508.652 -182.718)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M572.33,243.52l-.216-.208a.172.172,0,0,1,.045-.239.518.518,0,0,1,.632.062v.178Z",
    transform: "translate(-509.658 -182.099)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M537.705,77.813c-.358.348.126.687.011,1.032h-.337c-.332-.1-.342-.1-.293-.387.092-.538.212-1.077-.395-1.411a4.017,4.017,0,0,0-.544-.06,1.093,1.093,0,0,1-.329-.065.323.323,0,0,1-.154-.158c.146-.206.034-.688.537-.513.1.219.319.16.5.215C537.343,76.666,537.835,77.007,537.705,77.813Z",
    transform: "translate(-483.358 -62.187)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M524.3,78.71c.852.823,1.566.005,2.326-.21a4.014,4.014,0,0,0,.666-.326l.037.04c.2.779-.552.794-.9,1.136a2.819,2.819,0,0,1-1.078.111,1.776,1.776,0,0,1-1.047-.223.687.687,0,0,1-.235-.322C524.076,78.763,524.121,78.659,524.3,78.71Z",
    transform: "translate(-474.989 -63.596)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M521.348,77.906l-.185.178a.2.2,0,0,1-.213.006c-.192-.416-.632-.476-.968-.687V77.07l1.011-.015c.225.172.193.472.334.686A.383.383,0,0,1,521.348,77.906Z",
    transform: "translate(-472.035 -62.792)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M523.954,77.741a.947.947,0,0,1-.334-.686C524.057,77.121,523.94,77.464,523.954,77.741Z",
    transform: "translate(-474.662 -62.792)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M375.027,31.062l-.33.323c-.251.23.1.287.124.44a1,1,0,0,1-.5,1.3c-.349.2-.627.046-.915-.162-.143-.1-.337-.393-.495.005-.009.56-.146,1.005-.819,1.039-.427.021-.549.308-.532.7a.5.5,0,0,0,.6.536,21.245,21.245,0,0,1,2.2.178c.254.186.513.37.357.754-.544.349-.415.789-.155,1.238a2.08,2.08,0,0,1-.221,2.576.919.919,0,0,1-.392.151,10.083,10.083,0,0,1-2.445-.054.34.34,0,0,1-.193-.533,9.476,9.476,0,0,1-3.175,1.276c-.671.031-1.34.027-2.009.017-.283-.015-.57-.042-.772.229a.411.411,0,0,1-.344.11c-.276-.126-.28-.389-.316-.636-.1-.745-.636-.243-.963-.341a.449.449,0,0,1-.213-.1c-.13-.3.074-.456.27-.611a2.811,2.811,0,0,1,.494-.335c.177-.084.425.172.535-.049.119-.239-.1-.411-.268-.56-.043-.037-.1-.059-.138-.1-.188-.171-.645-.233-.448-.574.177-.307.562-.158.837-.007a6.228,6.228,0,0,0,1.024.569c.251.059.239.669.607.379.422-.332,1.144-.255,1.291-.95.052-.246.02-.514.2-.726a.74.74,0,0,1,.33-.144,1.829,1.829,0,0,1,.581-.022c.666.1.859-.217.882-.853.052-1.439.079-1.438-1.382-1.442a2.366,2.366,0,0,0-1.735.511,2.5,2.5,0,0,0-.577.308.513.513,0,0,1-.2.08c-.254.069-.332-.436-.639-.2a2.876,2.876,0,0,0-1.114-.071c-.355-.092-.793.175-1.072-.249a.285.285,0,0,1,.107-.3c.395-.156,0-.4.066-.6a2.576,2.576,0,0,0,.133-.517.55.55,0,0,1,.076-.21.343.343,0,0,1,.553.118c.167.346.495.4.772.543.563.137,1.136.4,1.631-.153-.033-.168-.125-.243-.289-.175a1.726,1.726,0,0,1-2.17-.337c-.168-.187-.482-.124-.646-.339a.347.347,0,0,0-.173-.338.231.231,0,0,1-.335,0q0-.084,0-.168a3.651,3.651,0,0,0,.364-1.89.5.5,0,0,1,.117-.191c.191-.1.413.019.6-.089a2.64,2.64,0,0,0,.243-.185.68.68,0,0,1,.285-.145,4.363,4.363,0,0,1,.657.062,1,1,0,0,0,.936-.463h.337c.43.285.641.594.077.943.135.289.4.277.591.33.983.27.906,1.244,1.28,1.915.055.1-.015-.037.066.039.028.026.093-.04.106-.107a2.766,2.766,0,0,1,.147-1.038c.4-.415.967-.047,1.417-.321-.478.008-.966.312-1.409-.073a1.1,1.1,0,0,1-.1-1.054c.519-.335,1.031-.133,1.576.033-.133-.166-.5-.043-.423-.377.054-.223.208-.229.382-.121.4.314.706.051,1.018-.173A6.683,6.683,0,0,0,375.027,31.062Z",
    transform: "translate(-358.47 -28.729)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M365.681,43.029c-.294-.2-.691-.241-.812-.685-.049-.18-.26-.151-.38.025a.106.106,0,0,1-.158-.026.446.446,0,0,1,0-.509,1.768,1.768,0,0,1,1.074.47,1.192,1.192,0,0,0,1.527.062c.662-.634.673-.166.772.322C367.117,43.327,366.388,43.11,365.681,43.029Z",
    transform: "translate(-359.581 -37.469)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M362.8,31.412c0,.426.012.852-.007,1.277-.016.346-.067.692-.5.772-.3-.235.136-.615-.164-.85.539-.139.263-.585.33-.9.063-.293-.168-.708.339-.811l.081.085A.354.354,0,0,1,362.8,31.412Z",
    transform: "translate(-358.045 -29.607)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M361.03,43.645l.158.026a1.04,1.04,0,0,0,.015.15c-.291.593-.789.361-1.24.318a.4.4,0,0,1-.274-.461Z",
    transform: "translate(-356.281 -38.771)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M354.253,45.863l.152-.5c0-.254.013-.5.353-.53.054,0,.108,0,.161,0a.523.523,0,0,1-.017.458,1.555,1.555,0,0,1-.323.633A.269.269,0,0,1,354.253,45.863Z",
    transform: "translate(-352.361 -39.623)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M356.136,44.394l.144-.361a.48.48,0,0,1,.355-.313.6.6,0,0,1,.23.545.394.394,0,0,1-.263.251A.449.449,0,0,1,356.136,44.394Z",
    transform: "translate(-353.721 -38.825)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M358.079,44.212l-.15-.492.5.012.16.316a.334.334,0,0,1-.2.253A.267.267,0,0,1,358.079,44.212Z",
    transform: "translate(-355.015 -38.825)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M362.416,40.614l.335,0c-.017.214-.1.385-.341.294C362.232,40.846,362.3,40.713,362.416,40.614Z",
    transform: "translate(-358.173 -36.592)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M464.83,51.381a1.345,1.345,0,0,1,.165.705.41.41,0,0,1-.367.119.82.82,0,0,1-.5-.424,2.024,2.024,0,0,1-.376-1.276c.032-.523-.306-.556-.7-.58a3.754,3.754,0,0,1-1.784-.179.6.6,0,0,1-.054-.691.175.175,0,0,1,.257-.048,5.582,5.582,0,0,0,1.951.35c.864.014,1.178.3,1.01,1.154C464.331,51,464.559,51.159,464.83,51.381Z",
    transform: "translate(-429.536 -42.601)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M458.4,47.241l-.188.011c-.477.3-.783.1-1.009-.346l-.324-.391A3.123,3.123,0,0,1,458.4,47.241Z",
    transform: "translate(-426.466 -40.834)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M415.29,36.41a2.631,2.631,0,0,0,2.133,1.471,2.333,2.333,0,0,0,2.239-.977l.2-.019c.38.486.018.779-.275,1.091-.015.2-.492.034-.3.395a.352.352,0,0,1-.133.331.65.65,0,0,1-.368.076,2.994,2.994,0,0,0-1.35-.272,3.173,3.173,0,0,1-1.47-.216A1.456,1.456,0,0,1,415,36.7a.506.506,0,0,1,.159-.236Z",
    transform: "translate(-396.215 -33.569)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M430.723,36.794c.211-.328.666-.537.5-1.05a.513.513,0,0,1,.321-.327c.439-.189.992.1,1.37-.341l0,0c.408-.056.893-.645,1.175.173l.182.179v.509c-.489.37-1.185-.135-1.635.4-.552.073-.729.805-1.336.785a.91.91,0,0,1-.222-.051A.836.836,0,0,1,430.723,36.794Z",
    transform: "translate(-407.58 -32.428)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M439.762,35.03c-.318-.569-.785-.107-1.175-.173l.349-.325C439.3,34.545,439.8,34.334,439.762,35.03Z",
    transform: "translate(-413.259 -32.204)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M435.045,35.727c-.337.6-.9.269-1.37.341C434.09,35.785,434.617,35.959,435.045,35.727Z",
    transform: "translate(-409.712 -33.078)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M438.111,44.833c.344.092.593.47,1.009.346q0,.339.005.678a2.966,2.966,0,0,1-2.941-.167,1.747,1.747,0,0,0-2.331.375,1,1,0,0,1-.891.378c-.59,0-1.18.033-1.769,0a1.906,1.906,0,0,1-.534-.094.519.519,0,0,1-.19-.149c-.146-.367.3-.477.327-.771.068-.141.138-.279.307-.32a3.453,3.453,0,0,0,1.823.1c.066-.039.134-.075.2-.113.361-.279.1-.918.62-1.1.129-.054.281-.044.4-.108a1.6,1.6,0,0,1,2.279.608C436.868,45.217,437.562,44.653,438.111,44.833Z",
    transform: "translate(-407.376 -38.762)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M439.773,39.245a.315.315,0,0,0,.339.346v.681c.018.411-.3.412-.568.483a8.486,8.486,0,0,0-1.025-.062.257.257,0,0,1-.168-.144,3.3,3.3,0,0,1,.589-1.351A2.446,2.446,0,0,1,439.773,39.245Z",
    transform: "translate(-413.089 -35.564)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M442.047,43.306a.946.946,0,0,0,.681-.346,2.513,2.513,0,0,1,2.083.624c.264.215.323.32-.058.4a.666.666,0,0,1-.5-.26,1.008,1.008,0,0,0-1.475-.221,1.232,1.232,0,0,1-.723.135A.226.226,0,0,1,442.047,43.306Z",
    transform: "translate(-415.705 -38.254)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M640.058,118.325c-.136-.034-.288-.08-.237-.257a.376.376,0,0,1,.452-.257Z",
    transform: "translate(-558.564 -92.092)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M522.978,79.312c.1-.5.887-.4.852-1.016l.331-.005c.226.455.45.325.674,0,.924.366.747,1.1.552,1.8-.058.206-.035.22.123.246.23.553.42,1.146,1.2,1.094.044,0,.1.176.151.271-.125.151-.265.288-.082.5.146.173.27.373.046.588a3.389,3.389,0,0,1-2.051-.7,1.4,1.4,0,0,1-.47-1.792c.238-.354.238-.354.071-.7-.177.165.006.37-.062.543a2.2,2.2,0,0,0-.153,1.059c0,.34-.071.617-.492.6-1.129-.7-2.164-.231-3.2.256-.341.16-.681.411-1.086.157-.333-.565,0-1.152-.06-1.727a1.218,1.218,0,0,1,0-.369.5.5,0,0,1,.118-.206.6.6,0,0,1,.755-.016c.335.145.42-.22.634-.32a1.921,1.921,0,0,0,.97-.006,1.742,1.742,0,0,0,1.018.194C523.184,79.729,523.079,79.522,522.978,79.312Z",
    transform: "translate(-471.489 -63.68)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M550.833,93.285c.333.346.817.536,1.026,1.011l-.073.087c-.377.123-.548.5-.847.717a1.261,1.261,0,0,1-.728.051,4.591,4.591,0,0,1-1.974-1.786c.152-.446.086-1.16.922-.776a.309.309,0,0,1,.338.34c.11.207.222.076.334,0C550.177,93.016,550.422,93.393,550.833,93.285Z",
    transform: "translate(-492.438 -73.882)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M546.547,90.971c-.617-.2-.541.483-.843.683-.335.138-.624.207-.506-.342,0-.223-.187-.319-.295-.471s-.391-.249-.239-.451c.082-.108.35-.073.534-.1A1.03,1.03,0,0,1,546.547,90.971Z",
    transform: "translate(-489.827 -72.264)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M552.541,94.083c-.1.171-.186.365-.434.266-.054-.022-.079-.119-.117-.182l.217-.087Z",
    transform: "translate(-495.148 -75.033)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M607.054,158.481l.365.01c-.373.655.193,1.238.141,1.869a2.709,2.709,0,0,1,.169.852l-.675-.341a.486.486,0,0,1,0-.682Q607.054,159.335,607.054,158.481Z",
    transform: "translate(-534.809 -121.336)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M609.39,166.018a1.381,1.381,0,0,1-.169-.852c.244.141.1.611.506.613l.339.239Z",
    transform: "translate(-536.471 -126.142)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M410.058,35.734c.095,1.337.6,1.7,2.363,1.706.026.328.38.239.529.429.256.325.368.588-.131.765a1.827,1.827,0,0,0-.766.25.7.7,0,0,1-.351.032c-1.223-.347-1.223-.347-1.578.843-.1.119-.237.2-.332.324.109-.04.155-.148.234-.223a.465.465,0,0,1,.3-.167.78.78,0,0,1,.236.031c.113.041.219.1.328.148.38.162.812.012,1.189.2a.506.506,0,0,1,.26.419.29.29,0,0,1-.228.264.966.966,0,0,0-1.129.611,1.17,1.17,0,0,1-1.348.6c-.479-.165-.442.2-.637.325a.416.416,0,0,1-.486-.061c.016-1-.051-1.993-.037-2.989.064-.358-.152-.642-.244-.96a1.968,1.968,0,0,1,.109-1.317c.152-.377.251-.763-.179-1.047a.763.763,0,0,1-.179-.173.312.312,0,0,1,.055-.35c.279-.041.589.1.832-.146.432.176.95-.009,1.345.327l-.015.011c-.232.122-.49.013-.714.08C409.668,35.66,409.875,35.59,410.058,35.734Z",
    transform: "translate(-391.135 -32.732)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M377,31.38c-.21.618-.53.2-.608-.008a3.757,3.757,0,0,1-.343-.907c-.037-.881-.666-.967-1.261-1.129-.185-.05-.409-.009-.459-.266-.044-.231.062-.352.293-.423.656-.2-.161-.455.015-.681a2.316,2.316,0,0,0,2.024-.674c.39.633-.223.824-.5,1.164-.223.1-.308.232-.118.444a1.987,1.987,0,0,1,.133.177C376.759,29.735,376.675,30.632,377,31.38Z",
    transform: "translate(-366.853 -27.014)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M379.843,28.305c.4-.222.74-.479.675-1.014a4.514,4.514,0,0,0,1.687.844c-.206.253-.206.253.2.513h-1.721a.78.78,0,0,1-.781.154C379.615,28.671,379.565,28.51,379.843,28.305Z",
    transform: "translate(-370.707 -27.013)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M371.38,29.691c.04.8-.533.671-1.013.681-.216-.3-.011-.485.17-.68Z",
    transform: "translate(-363.929 -28.739)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M367.744,29.462l-.17.68-.673-.168c-.214-.144-.616-.136-.458-.581.211,0,.429-.078.625.065Z",
    transform: "translate(-361.137 -28.508)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M366.156,29.228l-.674.013c-.186.081-.355.129-.337-.181l1.011-.01Z",
    transform: "translate(-360.225 -28.278)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M577.935,102.864a1.057,1.057,0,0,1,.206.134c.732.767.989.72,1.494-.283.289-.322.568-.7,1.011-.194-.021.044-.043.088-.063.133-.518.73-.989,1.511-2.095,1.3C577.8,103.827,577.664,103.614,577.935,102.864Z",
    transform: "translate(-513.789 -80.925)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M587.793,103.148a.574.574,0,0,1,.526.5l-.04.034c-.526.2-.685.021-.508-.5Z",
    transform: "translate(-520.936 -81.553)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M364.7,29.03a.377.377,0,0,0,.337.181c.126.212.538.128.507.5l-.164.169c-.126-.008-.171.066-.177.179-.171.21-.339.21-.5-.006-.091-.158.033-.387-.166-.509l0-.005q0-.264.008-.528A.325.325,0,0,1,364.7,29.03Z",
    transform: "translate(-359.783 -28.247)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M560.567,248.182q.012.255.024.511a.708.708,0,0,1-.62.021c-.106-.019-.243-.082-.3.028-.041.076.092.1.162.12a.537.537,0,0,1,.345.217.33.33,0,0,1-.08.35c-.392.025-.777.105-1.169.12l-.321.037-.022-.051a1.437,1.437,0,0,0-.231-.323c-.054-.044-.108-.089-.164-.131-.123-.057-.314-.044-.36-.163-.122-.311-.184-.369-.251.014a.515.515,0,0,1-.113.216c-.375.186-.411-.152-.536-.354a1.656,1.656,0,0,1,.013-1.024c.132-.275.434-.251.65-.376.092-.11.063-.262.131-.381.18-.17.33-.1.469.06.162.328.45.35.764.337a2.849,2.849,0,0,1,1.124.154C560.345,247.684,560.418,247.964,560.567,248.182Z",
    transform: "translate(-498.66 -184.918)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M567.512,246.7c-.311-.034-.349-.318-.469-.527-.187-.277-.684-.345-.549-.838a2.221,2.221,0,0,1,.737-.452.477.477,0,0,1,.482.08l.178.2C567.25,245.547,567.489,246.151,567.512,246.7Z",
    transform: "translate(-505.605 -183.437)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M569.015,253.392l-.646.337v-.341a.237.237,0,0,1,0-.34.408.408,0,0,1,.484,0Z",
    transform: "translate(-506.925 -189.269)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M600.022,168.353a5.527,5.527,0,0,1-2.7.341.514.514,0,0,1-.039-.683c.51-.44,1.244-.022,1.753-.47a.941.941,0,0,1,.982.13Z",
    transform: "translate(-527.777 -127.793)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M601.2,165.583h-1.012c-.368.275-.782.152-1.182.139-.325-.153-.2-.323-.007-.479a5.323,5.323,0,0,1,.8-.377c.116-.07.134-.216.224-.307H601.2q0,.341,0,.682Z",
    transform: "translate(-528.952 -125.706)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M568.307,100.153q-.035.55.508.5c.165.441.746.526.851,1.018a.858.858,0,0,1-.766.235c.248.144.343.5.526.784a1.752,1.752,0,0,1-.216,1.623c-.5.755-.657,1.768-1.564,2.238-.01,0,.221.174.212.347-.108.3-.414.361-.629.531a1.909,1.909,0,0,1-1.576.286.292.292,0,0,1-.109-.2,1.859,1.859,0,0,1,.124-.46c.1-.294.148-.62.456-.791.34-.212.681-.423.664-.905a23.229,23.229,0,0,1,1.279-2.392c-.03-.3.255-.827-.448-.607-.03.274.226.476.179.751-.322.671-.335,1.537-1.162,1.888-.789-.368-1.826-.254-2.294-1.262-.1-.227-.46-.1-.7-.152a1.354,1.354,0,0,1-.779-.385c-.191-.215-.476-.306-.676-.51a.849.849,0,0,1-.137-.336.847.847,0,0,0-.675-.824c-.364-.1-.664-.277-.6-.743a.355.355,0,0,1,.144-.182.64.64,0,0,1,.164.009c.228.034.516.345.664.068.163-.306-.2-.442-.422-.6-.39-.278-.808-.559-.437-1.141h0a13.927,13.927,0,0,1,1.764,1.461.7.7,0,0,0,.674.2c.308.062.6.453.93.04l.176-.169c.394.026.782-.739,1.181-.01.066.312-.2.812.376.847s1.282.214,1.585-.514C567.737,100.423,567.887,100.17,568.307,100.153Z",
    transform: "translate(-501.472 -78.53)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M591.309,222.35l-.348.334a1.316,1.316,0,0,1-.617.288,2.744,2.744,0,0,1-.551.124,1,1,0,0,1-.56-.351,2.46,2.46,0,0,1-.37-.571.573.573,0,0,1-.008-.232.839.839,0,0,1,.4-.41c.3-.156.557-.425.94-.334a1.4,1.4,0,0,1,.427.325c.055.043.107.089.159.135.171.178.474.149.605.392A.289.289,0,0,1,591.309,222.35Z",
    transform: "translate(-521.763 -166.414)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M597.5,223.184l0-.344a.3.3,0,0,1,0-.4.513.513,0,0,1,.672.055q0,.338,0,.677Z",
    transform: "translate(-527.956 -167.248)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M594.2,227.528l-.007.175a3.883,3.883,0,0,1-.672.566.339.339,0,0,1-.226-.049.735.735,0,0,1-.208-.575.511.511,0,0,1,.331-.378.519.519,0,0,1,.613.092Z",
    transform: "translate(-524.827 -170.749)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M594.624,226.873l-.673-.006c-.037-.026-.052-.055-.044-.086s.018-.049.029-.049c.164-.282.44-.177.678-.2C594.617,226.646,594.62,226.759,594.624,226.873Z",
    transform: "translate(-525.415 -170.263)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M621.791,139.06c.132-.214-.355-.579.166-.7a1.5,1.5,0,0,1,1.734.024c-.036.334-.3.426-.552.533A2.015,2.015,0,0,0,621.791,139.06Z",
    transform: "translate(-545.494 -106.68)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M602.591,178.412c-.326-.079-.976.157-.916-.229.074-.479-.007-1.156.581-1.478a.377.377,0,0,1,0,.513c-.005.243,0,.482.316.525C602.212,177.977,602.619,178.188,602.591,178.412Z",
    transform: "translate(-531.023 -134.439)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M439.087,38.629a1.491,1.491,0,0,1-.843,0,.9.9,0,0,1-.741.225l-.1-.055c.411-.881,1.121-.243,1.686-.34C439.088,38.518,439.088,38.574,439.087,38.629Z",
    transform: "translate(-412.403 -34.949)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M603.774,175.906v-.513l.675-.513A1.727,1.727,0,0,1,603.774,175.906Z",
    transform: "translate(-532.542 -133.127)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M349.569,53.6l-.193.01-.013-.018c-.287-.235-.215-.541-.163-.843q.012-.078.025-.157a.371.371,0,0,0,.315-.209l.37-.3a.123.123,0,0,1,.19,0c.148.336-.136.564-.205.846a1.731,1.731,0,0,0-.106.521C349.756,53.554,349.705,53.639,349.569,53.6Z",
    transform: "translate(-348.677 -44.8)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M352.024,49.941h-.073l-.073.005q.2-.432.407-.864l.219-.011c.129.129.071.278.047.425a.96.96,0,0,1-.129.318C352.311,49.926,352.2,50.034,352.024,49.941Z",
    transform: "translate(-350.646 -42.672)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M592.909,231.223l-.214.482a1.8,1.8,0,0,0-.665.514l-1,.218c0-.068-.007-.136-.01-.2a.507.507,0,0,1,.3-.327c.473-.142.62-.6.886-.941a.554.554,0,0,1,.351-.059A.451.451,0,0,1,592.909,231.223Z",
    transform: "translate(-523.332 -173.403)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M595.1,229.612l-.317.022c-.154.033-.213-.032-.189-.185.142-.289.283-.579.685-.506,0,.058.006.117.009.176A.387.387,0,0,1,595.1,229.612Z",
    transform: "translate(-525.909 -171.989)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M596.428,230.09l.188-.493a.55.55,0,0,1,.356.513l-.158.177Z",
    transform: "translate(-527.237 -172.467)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M404.976,35.756V36.1a.284.284,0,0,1-.289.084c-.09-.21-.275.029-.386-.082-.2-.043-.447.1-.587-.172.142-.271.393-.127.589-.172Z",
    transform: "translate(-388.078 -33.097)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M588.908,232.614l-.333.178-.843.507a.381.381,0,0,1-.1-.222.574.574,0,0,1,.073-.235c.336-.411.834-.638,1.165-1.061a.283.283,0,0,1,.441,0C589.515,232.227,589.192,232.411,588.908,232.614Z",
    transform: "translate(-520.888 -173.962)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M585.12,236.562l.006.182-.506.32-.168.024a.258.258,0,0,1-.315.061.322.322,0,0,1-.112-.2.372.372,0,0,1,.173-.3C584.5,236.533,584.792,236.356,585.12,236.562Z",
    transform: "translate(-518.281 -177.406)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M348.488,54.569c.258.241.037.577.163.843l-.47.019C348.151,55.1,348.128,54.763,348.488,54.569Z",
    transform: "translate(-347.965 -46.625)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M621.727,136.717l-2.195,0a1.405,1.405,0,0,0-.161-.007c-.139-.181-.447.037-.548-.237.137-.276.34-.2.548-.107l2.35.009Q621.725,136.548,621.727,136.717Z",
    transform: "translate(-543.41 -105.376)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M353.648,49.03l.134-.367q.016-.08.034-.159l.322,0c.165.168.089.326-.021.482a.516.516,0,0,1-.176.121A.3.3,0,0,1,353.648,49.03Z",
    transform: "translate(-351.924 -42.265)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M583.418,238.672h.342q0,.169,0,.339h-.682C583.024,238.728,583.219,238.7,583.418,238.672Z",
    transform: "translate(-517.589 -178.992)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M382.672,92.72a6.574,6.574,0,0,1-.158-2.262,1.6,1.6,0,0,1-.052-.837c.068-.143.1-.339.3-.337s.241.2.275.35a5.552,5.552,0,0,1,.051,1.151c0,.092-.005.185-.009.277a2.644,2.644,0,0,1-.017.273,2.521,2.521,0,0,1-.075.4C382.882,92.061,382.81,92.4,382.672,92.72Z",
    transform: "translate(-372.709 -71.584)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M382.243,86.488q-.011.427-.023.854a7.461,7.461,0,0,1-.168-2.383c.19-.047.262.085.33.223A1.938,1.938,0,0,1,382.243,86.488Z",
    transform: "translate(-372.415 -68.469)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M381.855,83.551l-.187-.138-.174-.328h.053a.54.54,0,0,1,.387-.287.386.386,0,0,1,.386.281.741.741,0,0,1-.073.637C382.024,83.884,381.943,83.71,381.855,83.551Z",
    transform: "translate(-372.032 -66.922)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M383.3,98.795c.086-.35-.123-.751.181-1.063a.485.485,0,0,1,.008.684c-.039.284.1.6-.156.846Q383.313,99.028,383.3,98.795Z",
    transform: "translate(-373.333 -77.659)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M436.922,122.185a.517.517,0,0,1-.368-.323.779.779,0,0,1,.142-.705.449.449,0,0,1,.222-.108.911.911,0,0,1,.751.412.512.512,0,0,1,.038.253A.641.641,0,0,1,436.922,122.185Z",
    transform: "translate(-411.765 -94.423)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M434.79,120.711a1.024,1.024,0,0,1-.232.712.776.776,0,0,1-.8-.538,1.075,1.075,0,0,1,.253-.343.477.477,0,0,1,.195-.1A.6.6,0,0,1,434.79,120.711Z",
    transform: "translate(-409.769 -93.984)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M437.971,123.652c.25-.152.568-.21.694-.529a.435.435,0,0,1,.446.083.551.551,0,0,1,.191.305.52.52,0,0,1-.124.457,2.4,2.4,0,0,0-1.022-.121Z",
    transform: "translate(-412.814 -95.89)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M430.417,120.868l-.5.388a.181.181,0,0,1-.238.01.569.569,0,0,1-.11-.5.388.388,0,0,1,.349-.314.624.624,0,0,1,.43.192A.317.317,0,0,1,430.417,120.868Z",
    transform: "translate(-406.738 -93.997)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M427.807,122.759l.214.045a.311.311,0,0,0-.063.126c-.335-.013-.627.259-.977.153-.159-.329.073-.4.3-.468A.664.664,0,0,1,427.807,122.759Z",
    transform: "translate(-404.84 -95.545)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M433.523,120.79a.281.281,0,0,1-.316.189l-.2-.035a.25.25,0,0,1,0-.173.452.452,0,0,1,.183-.19.3.3,0,0,1,.173,0C433.453,120.627,433.467,120.724,433.523,120.79Z",
    transform: "translate(-409.222 -94.078)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M432.655,121.286a.3.3,0,0,1-.028.138l-.054.009-.054,0a.761.761,0,0,1-.053-.137l.054-.054.076,0Z",
    transform: "translate(-408.84 -94.557)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M446.485,125.564l-.17-.049a.273.273,0,0,1,.018-.39.741.741,0,0,1,.268-.116c.369.026.869-.123.741.567C447.054,125.777,446.77,125.631,446.485,125.564Z",
    transform: "translate(-418.787 -97.27)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M443.809,125.191q0,.154.006.307a.83.83,0,0,1-.151.016c-.253-.266-.6-.07-.884-.18.136-.455.484-.347.805-.311A.464.464,0,0,1,443.809,125.191Z",
    transform: "translate(-416.287 -97.254)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M420.72,115.889a.874.874,0,0,0-.227-.591c-.19-.257-.171-.525.214-.621l.085.06a2.091,2.091,0,0,0,.436.585.483.483,0,0,1,.1.44.388.388,0,0,1-.264.239A.366.366,0,0,1,420.72,115.889Z",
    transform: "translate(-400.108 -89.842)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M420.976,108.711l-.028-.173.076-.093a1.056,1.056,0,0,1,.8-.176.613.613,0,0,1,.245,1.092.243.243,0,0,1-.215.058c-.18-.082-.234-.387-.513-.3a.445.445,0,0,1-.208-.028C421,109,421.058,108.826,420.976,108.711Z",
    transform: "translate(-400.522 -85.22)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M419.211,106.77l-.476,0a.491.491,0,0,1-.187-.341.76.76,0,0,1,.111-.515.448.448,0,0,1,.366-.121.443.443,0,0,1,.309.229.8.8,0,0,1,.067.256.659.659,0,0,1-.163.486Z",
    transform: "translate(-398.785 -83.452)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M417.12,114.179l-.359-.508c.193-.228.445-.27.605-.031A.325.325,0,0,1,417.12,114.179Z",
    transform: "translate(-397.498 -88.981)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M421.2,118.99l.332.018a.585.585,0,0,1,0,.855,1.191,1.191,0,0,1-.492-.726Z",
    transform: "translate(-400.586 -92.943)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M421.423,111.071q.06,0,.119,0a.4.4,0,0,1,.341.291,1.074,1.074,0,0,1,.013.59.512.512,0,0,1-.125.2.26.26,0,0,1-.318-.038l-.043-.027q0-.326,0-.652A.267.267,0,0,1,421.423,111.071Z",
    transform: "translate(-400.811 -87.248)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M414.246,110.709l-.332-.022c-.081-.153.057-.366-.129-.493a.547.547,0,0,1,.151-.594.351.351,0,0,1,.384.076.551.551,0,0,1-.063.671Z",
    transform: "translate(-395.331 -86.173)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M417.263,107.731l.037.342a.373.373,0,0,1-.35.165.171.171,0,0,1-.2.05.383.383,0,0,1-.181-.411.492.492,0,0,1,.256-.248A.405.405,0,0,1,417.263,107.731Z",
    transform: "translate(-397.349 -84.757)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M416.569,109.7a.922.922,0,0,0,.147.021c0,.277.169.633-.315.68a.5.5,0,0,1-.086-.658A.189.189,0,0,1,416.569,109.7Z",
    transform: "translate(-397.116 -86.244)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M415.906,109.683q0,.34,0,.679l-.358.013q0-.346,0-.693A.259.259,0,0,1,415.906,109.683Z",
    transform: "translate(-396.625 -86.201)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M420.761,110.227l-.008.361c-.52-.127-.282-.421-.149-.692C420.749,109.96,420.755,110.093,420.761,110.227Z",
    transform: "translate(-400.149 -86.404)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M404.733,109.721a2.612,2.612,0,0,1-1.342-.7.4.4,0,0,1,.23-.286.678.678,0,0,1,.787.192c-.253.439.424.362.375.688Z",
    transform: "translate(-387.844 -85.538)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M409.6,112.236c-.538.184-1.066.327-1.377-.366l.018-.023a.614.614,0,0,1,.544-.162,1.491,1.491,0,0,1,.7.358A.376.376,0,0,1,409.6,112.236Z",
    transform: "translate(-391.331 -87.687)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M402.144,108.209l-.174.177-.473-.2-.074-.3c.262-.169.485-.047.706.1A.169.169,0,0,1,402.144,108.209Z",
    transform: "translate(-386.423 -84.899)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M413.235,112.1c.2.11.033.234.013.352l-.318.035-.016-.056a.268.268,0,0,1-.026-.349A.271.271,0,0,1,413.235,112.1Z",
    transform: "translate(-394.663 -87.934)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M379.1,76.194l.006-.508.082-.072c.306-.052.45.185.631.359a.4.4,0,0,1,.034.317.512.512,0,0,1-.135.167.8.8,0,0,1-.3.1Z",
    transform: "translate(-370.302 -61.751)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M380.234,78.5l.208-.193c.08.056.18.089.214.2,0,.034,0,.068,0,.1l-.056.085a.161.161,0,0,1-.182-.03Z",
    transform: "translate(-371.122 -63.695)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M368.826,67.792c.023.236-.078.5.166.683a.328.328,0,0,1,0,.484l-.714.032-.139-.175q0-.252,0-.5a1.173,1.173,0,0,1,.237-.369.768.768,0,0,1,.254-.21A.182.182,0,0,1,368.826,67.792Z",
    transform: "translate(-362.389 -56.084)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M361.9,66.632a.53.53,0,0,1-.575-.284.777.777,0,0,1,.4-.61.4.4,0,0,1,.552.16.313.313,0,0,1-.041.246C361.928,66.17,361.851,66.357,361.9,66.632Z",
    transform: "translate(-357.466 -54.624)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M364.6,66.718a.736.736,0,0,0,.026-.136.168.168,0,0,1,.29-.015h.163c.079.052.18.067.238.153a.34.34,0,0,1,.009.282l-.069.068A.768.768,0,0,1,364.6,66.718Z",
    transform: "translate(-359.835 -55.197)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M367.61,68.235c.011.231-.124.314-.326.329-.223-.009-.346-.114-.327-.353l0,0A.437.437,0,0,1,367.61,68.235Z",
    transform: "translate(-361.531 -56.336)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M422.809,118.925q0-.427,0-.855l.175-.162c.1-.188.222-.318.435-.13a1.179,1.179,0,0,1,.293.486,2.16,2.16,0,0,1-.076.683.818.818,0,0,1-.294.485C423,119.44,422.928,119.156,422.809,118.925Z",
    transform: "translate(-401.866 -92.005)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M424.726,122.152l.152-.51a.532.532,0,0,1,.6-.135.4.4,0,0,1,.266.416c-.181.048-.359.1-.355.342C425.158,122.295,424.915,122.383,424.726,122.152Z",
    transform: "translate(-403.25 -94.726)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M352.878,61.715l-.157.029c-.234-.133-.157-.564-.529-.564a.287.287,0,0,1,0-.377.615.615,0,0,1,.4-.108.494.494,0,0,1,.368.2A.707.707,0,0,1,352.878,61.715Z",
    transform: "translate(-350.823 -51.03)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M351,61.016q0,.148-.005.3l-.507-.011c0-.042-.006-.085-.012-.126-.062-.273.128-.28.308-.3A.32.32,0,0,1,351,61.016Z",
    transform: "translate(-349.623 -51.161)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M356.706,63.875l-.176-.307a.42.42,0,0,1,.264-.307.536.536,0,0,1,.691.338c-.035.44-.282.426-.59.282Z",
    transform: "translate(-354.005 -52.859)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M360.872,65.756c-.109.192-.154.431-.387.53l-.3-.348c-.059-.146.027-.222.135-.287a.558.558,0,0,1,.47.019Z",
    transform: "translate(-356.627 -54.562)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M358.7,64.709l-.192.187-.664-.354c.235,0,.477.019.508-.314a.162.162,0,0,1,.176-.065.5.5,0,0,1,.138.153C358.722,64.442,358.789,64.569,358.7,64.709Z",
    transform: "translate(-354.953 -53.519)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M371.209,70.051v-.484l.172-.175A.555.555,0,0,1,372,69.3a.5.5,0,0,1,.213.323,1.655,1.655,0,0,1,.035.385,1.473,1.473,0,0,1-.02.251.533.533,0,0,1-.182.317l0,.031c-.14-.021-.288-.02-.377-.162C371.721,70.068,371.427,70.106,371.209,70.051Z",
    transform: "translate(-364.605 -57.176)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M388.073,107.157a1.226,1.226,0,0,1-.463-.529c.079-.436.359-.336.636-.245a.186.186,0,0,1,.051.251Z",
    transform: "translate(-376.448 -83.822)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M392.709,108.036l-.211-.027q0-.261,0-.522c.05-.1.1-.2.223-.216.218.048.273.222.311.41Z",
    transform: "translate(-379.976 -84.517)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M390.913,106.284l-.163.17c-.185-.222-.436-.152-.671-.157a.7.7,0,0,1,.012-.167.3.3,0,0,1,.167-.264.517.517,0,0,1,.323-.01.825.825,0,0,1,.365.234A.17.17,0,0,1,390.913,106.284Z",
    transform: "translate(-378.231 -83.484)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M387.141,104.844l-.152.157c-.242.012-.511-.1-.7.161l-.508-.338c.3.006.263-.153.168-.343a.13.13,0,0,1-.052-.122c.007-.045.017-.068.029-.068.278-.106.47.131.709.18a1.516,1.516,0,0,1,.2.081A.562.562,0,0,1,387.141,104.844Z",
    transform: "translate(-375.128 -82.357)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M355.494,61.57l-.206.176-.47-.023q0-.409-.008-.819c.158-.237.384-.216.617-.17.206.082.407.171.439.433C355.857,61.41,355.3,61.136,355.494,61.57Z",
    transform: "translate(-352.763 -51.037)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M401.669,104.644l-.689-.157-.171-.158a.937.937,0,0,1,.314-.476c.224-.173.208-.511.451-.672a1.124,1.124,0,0,1,.622-.1.725.725,0,0,1,.363.142.74.74,0,0,1-.041.853c-.181.219-.345.406-.685.212-.143-.082-.02.124-.055.188A.226.226,0,0,1,401.669,104.644Z",
    transform: "translate(-385.979 -81.501)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M399.821,105.007a.63.63,0,0,1-.382.364l-.427-.044a.11.11,0,0,1-.1-.129c.073-.118.017-.245.023-.371a.556.556,0,0,1,.154-.159c.26-.134.519-.233.781-.006A.293.293,0,0,1,399.821,105.007Z",
    transform: "translate(-384.609 -82.544)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M396.906,106.5a.493.493,0,0,0,.022.157l-.865.206-.038-.046C396.184,106.33,396.5,106.284,396.906,106.5Z",
    transform: "translate(-382.525 -83.874)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M383.956,97.527q0-.342-.008-.684,0-.174.006-.348c.209.216.583.062.762.346a.884.884,0,0,1,.1.353,1.268,1.268,0,0,1-.069.495c-.1.178-.169.4-.446.351C384.291,97.795,384.3,97.542,383.956,97.527Z",
    transform: "translate(-373.804 -76.769)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M385,100.982l.329-.348c.159-.1.292-.019.426.061a.313.313,0,0,1,.129.3,3.472,3.472,0,0,1-.545.66q0,.093-.01.187l-.325-.015C385.047,101.542,384.808,101.264,385,100.982Z",
    transform: "translate(-374.509 -79.711)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M394.778,105.73a1.232,1.232,0,0,0-.881.318l-.447.22-.372-.363c0-.054,0-.108,0-.161a.82.82,0,0,1,.268-.322c.263-.15.559-.057.836-.115a.824.824,0,0,1,.6.267.7.7,0,0,1,.048.115C394.837,105.7,394.8,105.716,394.778,105.73Z",
    transform: "translate(-380.397 -83.105)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M376.362,73.883c0-.056-.008-.112-.009-.168a.384.384,0,0,1-.106-.418.331.331,0,0,1,.145-.162c.239-.071.4.126.6.18a.349.349,0,0,1,.138.162.37.37,0,0,1-.1.4l0,.02Z",
    transform: "translate(-368.228 -59.963)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M374.911,72.864l0,.5c-.3.025-.449-.245-.68-.353q.007-.159.013-.317A.516.516,0,0,1,374.911,72.864Z",
    transform: "translate(-366.789 -59.617)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M350.442,58.879a.373.373,0,0,0-.36.189c-.3-.3-.117-.583.018-.87a.828.828,0,0,1,.455-.226,2.541,2.541,0,0,1,1.378.161.264.264,0,0,1,.064.23c-.168.21-.427.212-.651.294a1.306,1.306,0,0,1-.331.048C350.81,58.715,350.593,58.684,350.442,58.879Z",
    transform: "translate(-349.232 -49.054)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M351.07,57.448h-.5q.012-.174.024-.349l.156-.15a.213.213,0,0,1,.225-.025C351.144,57.073,351.25,57.233,351.07,57.448Z",
    transform: "translate(-349.7 -48.304)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M476.765,143.628a.5.5,0,0,0-.35.488.468.468,0,0,1-.667.01l0,0a1.519,1.519,0,0,1-.657-1.047c-.01-.216.006-.42.231-.531.514.22.85.88,1.55.644a.232.232,0,0,1,.124.186A.312.312,0,0,1,476.765,143.628Z",
    transform: "translate(-439.616 -109.879)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M510.118,182.169c-.774-.151-1.462-.717-2.314-.494a.217.217,0,0,1-.231.021.385.385,0,0,1-.064-.354,1.151,1.151,0,0,1,.409-.44.469.469,0,0,1,.337-.013c.183.1.367.232.549-.005a.453.453,0,0,1,.292-.147.608.608,0,0,1,.391.214c.058.494.566.539.821.838C510.387,181.988,510.237,182.07,510.118,182.169Z",
    transform: "translate(-463.016 -137.338)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M516.943,184.787l.168-.343a1.7,1.7,0,0,1,.6-.065c.26.042.542.015.744.242.049.284-.162.346-.353.427-.163-.019-.339.029-.482-.094Z",
    transform: "translate(-469.841 -139.956)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M520.634,187.44l-.643-.006.165-.466c.132-.185.247-.032.367.019a.623.623,0,0,1,.192.267A.2.2,0,0,1,520.634,187.44Z",
    transform: "translate(-472.042 -141.753)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M520.057,186.636l-.334-.138-.332-.216.507,0a.13.13,0,0,1,.213.006A.3.3,0,0,1,520.057,186.636Z",
    transform: "translate(-471.608 -141.284)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M473.686,141.926l-.5-.346-.172-.178a.227.227,0,0,1,0-.338h.174a1.946,1.946,0,0,1,.735-.161.458.458,0,0,1,.3.145c.025.273-.15.336-.367.355C473.659,141.528,473.708,141.739,473.686,141.926Z",
    transform: "translate(-438.067 -108.696)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M542.565,196.916l-.167-.492a.909.909,0,0,1,.108-.714.559.559,0,0,1,.33-.145.648.648,0,0,1,.348.07.277.277,0,0,1,.116.187c-.047.207-.191.387-.171.615a.882.882,0,0,1-.371.536A.17.17,0,0,1,542.565,196.916Z",
    transform: "translate(-488.203 -147.998)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M541.135,195.763c-.029.232.061.492-.16.677l-.165-.04c-.1-.063-.081-.207-.179-.272l-.182-.182a.186.186,0,0,1-.01-.237.536.536,0,0,1,.362-.123A.419.419,0,0,1,541.135,195.763Z",
    transform: "translate(-486.78 -148.014)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M521.789,186.1v-.345a1.516,1.516,0,0,1,.764-.269.7.7,0,0,1,.232.011.894.894,0,0,1,.29.186c.217.252.568.184.822.351.331.3.477.606.069.955l-.318.01-.5-.22c-.239-.244-.56-.146-.843-.211-.155-.046-.241-.179-.351-.282Z",
    transform: "translate(-473.34 -140.748)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M529.231,187.258a.794.794,0,0,0-.151-.9.463.463,0,0,1,.2-.434.667.667,0,0,1,.6-.005,1.435,1.435,0,0,1,.44.4.415.415,0,0,1,.023.332c-.091.1-.265.167-.2.364-.186.1.156.423-.193.448a1.279,1.279,0,0,1-.564-.065Z",
    transform: "translate(-478.604 -141.017)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M532.159,189.263l-.228-.243.22-.085a.477.477,0,0,1,.268-.168,1.047,1.047,0,0,0,.482-.2.554.554,0,0,1,.206-.083.35.35,0,0,1,.308.132.85.85,0,0,1,.105.352,1.451,1.451,0,0,1-.015.383.508.508,0,0,1-.2.328.634.634,0,0,1-.5-.059.226.226,0,0,1-.151-.04C532.523,189.426,532.264,189.467,532.159,189.263Z",
    transform: "translate(-480.664 -142.909)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M530.895,191.248c.222.017.475-.013.5.32a2.33,2.33,0,0,1-1.212-.291Z",
    transform: "translate(-479.399 -144.895)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M539.415,195.207q0-.242,0-.485a.286.286,0,0,1,.36-.018.289.289,0,0,1-.023.363l-.017.205Z",
    transform: "translate(-486.068 -147.34)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M551.458,222.954q-.015-.686-.03-1.373c.339-.22.738-.134,1.1-.221a2.865,2.865,0,0,0,.431-.075c.124-.045.339.029.291-.237a1.487,1.487,0,0,1,.105-.4.564.564,0,0,1,.127-.171,4.421,4.421,0,0,0,.662-.338.41.41,0,0,1,.321.008.63.63,0,0,1,.256.353c.042.306-.177.437-.378.577-.045.035-.092.072-.133.11a.092.092,0,0,0,.02.144c.275.1.614-.023.823.267a.328.328,0,0,1-.051.248,1.106,1.106,0,0,1-.876.294c-.36,0-.72,0-1.08,0-.391-.026-.728,0-.7.546a.775.775,0,0,1-.213.617.39.39,0,0,1-.5-.03Z",
    transform: "translate(-494.742 -165.648)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M552.184,231.385h.5l.1.1a2.943,2.943,0,0,1,.129,1.207q0,.386-.014.773a2,2,0,0,1-.065.5.547.547,0,0,1-.133.205.2.2,0,0,1-.223-.029Z",
    transform: "translate(-495.288 -173.752)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M553.521,244.024a3.462,3.462,0,0,1-.128-1.568c.2-.5-.073-1.037.144-1.531l.007-.008a.267.267,0,0,1,.379.031,2.79,2.79,0,0,1,.149,1.6.594.594,0,0,0,.179.6c.021.179-.1.264-.222.35C553.782,243.6,553.74,243.9,553.521,244.024Z",
    transform: "translate(-496.142 -180.559)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M553.906,250.322c.019-.288.028-.58.354-.712a.83.83,0,0,1,.085.968.18.18,0,0,1-.252.059l-.177-.174A.244.244,0,0,1,553.906,250.322Z",
    transform: "translate(-496.527 -186.856)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M553.436,241.113c-.105.505.206,1.05-.144,1.531q-.032-.758-.065-1.516Z",
    transform: "translate(-496.042 -180.747)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M494.419,163.079a4.915,4.915,0,0,1-.181-1.685,1.046,1.046,0,0,1-.03-.7c.247-.188.435-.067.612.118.424.59.244,1.317.436,1.961.135.47.1.869-.437,1.052a.439.439,0,0,1-.24-.021C494.4,163.591,494.714,163.267,494.419,163.079Z",
    transform: "translate(-453.391 -122.86)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M495.6,171.832h.161c.393-.046.3.3.377.494.195.479.317,1,.863,1.228a.756.756,0,0,1,.325.121.628.628,0,0,1,.177.557.757.757,0,0,1-.583.39c-.712-.305-.844-1.1-1.323-1.6l-.016-.5A1.746,1.746,0,0,1,495.6,171.832Z",
    transform: "translate(-454.398 -130.932)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M495.654,176.07c.574.4.812,1.1,1.345,1.533a.184.184,0,0,1,.046.2,1.4,1.4,0,0,1-.048.152l-.334-.17v0a5.291,5.291,0,0,1-.506-.681l-.168-.173C495.973,176.605,495.535,176.449,495.654,176.07Z",
    transform: "translate(-454.453 -133.982)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M493.723,155.4c-.008-.042-.014-.084-.021-.126a.463.463,0,0,1,.2-.277.638.638,0,0,1,.346-.058.644.644,0,0,1,.222.085.394.394,0,0,1,.15.427.758.758,0,0,1-.567.395C493.819,155.791,493.764,155.6,493.723,155.4Z",
    transform: "translate(-453.058 -118.783)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M495.258,170.1c.07.232.162.464-.02.688-.261-.432-.11-.912-.157-1.369C495.6,169.522,495.316,169.84,495.258,170.1Z",
    transform: "translate(-454.053 -129.199)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M493.186,153.9l-.237.232-.29-.182q0-.177.008-.355a.317.317,0,1,1,.52.305Z",
    transform: "translate(-452.305 -117.651)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M493.535,156.583l.37.371a.269.269,0,0,1,.039.2.645.645,0,0,1-.207.355.147.147,0,0,1-.179-.047C493.588,157.167,493.3,156.882,493.535,156.583Z",
    transform: "translate(-452.87 -119.971)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M493.836,159.681l.17-.009a.246.246,0,0,1,.014.339q-.013.357-.025.714C493.732,160.41,493.861,160.034,493.836,159.681Z",
    transform: "translate(-453.148 -122.192)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M474.506,136.731c-.224-.06-.444.311-.67.006q0-.174,0-.349c.218-.212.238-.555.481-.751a7.264,7.264,0,0,0,.894-.708.635.635,0,0,1,.484,0c.261.163.469.357.392.71-.138.3-.552.187-.689.485a1.079,1.079,0,0,1-.165.272.338.338,0,0,1-.2.059C474.8,136.427,474.657,136.587,474.506,136.731Z",
    transform: "translate(-438.713 -104.369)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M473.043,131.667l-.492-.006c-.256.208-.419-.032-.613-.127a5.127,5.127,0,0,0-1.289-.264.372.372,0,0,1-.3-.134l-.17-.5a.781.781,0,0,1,.361-.418.419.419,0,0,1,.328.031c.272.158.438.524.837.431a1.177,1.177,0,0,1,.225,0,3.06,3.06,0,0,1,.762.2,3.027,3.027,0,0,1,.524.428A.256.256,0,0,1,473.043,131.667Z",
    transform: "translate(-436.075 -101.002)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M474.669,134.2c.188.092.261.366.523.339a.858.858,0,0,1-.839.689c-.186.125.043-.462-.271-.161-.054.052-.174-.095-.238-.183l0-.332C474.032,134.225,474.4,134.318,474.669,134.2Z",
    transform: "translate(-438.717 -103.876)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M472.447,133.737c-.133.461-.58.167-.828.352-.283-.07-.613.085-.855-.182.06-.171.245-.214.345-.344A3.686,3.686,0,0,1,472.447,133.737Z",
    transform: "translate(-436.494 -103.417)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M473.848,136.631c.158.132.606-.176.509.343-.071.3-.113.623-.509.671Q473.848,137.138,473.848,136.631Z",
    transform: "translate(-438.721 -105.626)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M469.646,130.173a.308.308,0,0,1-.336.341l-.332-.013,0-.33A.464.464,0,0,1,469.646,130.173Z",
    transform: "translate(-435.202 -100.878)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M470.8,133.545a.317.317,0,0,1-.345.344c-.178-.124-.134-.242.009-.357Z",
    transform: "translate(-436.191 -103.398)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M554.586,253.182l.168-.006c.264-.129.356.256.594.2,0,0,.08-.028.08-.028.153-.023.11.351.34.171a1.233,1.233,0,0,1,1.01,0h0c0,.288-.146.284-.344.174a.8.8,0,0,0-.672.506C555.246,254.008,554.519,254.064,554.586,253.182Z",
    transform: "translate(-497.02 -189.401)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M546.141,208.422c-.009-.054-.018-.108-.03-.162-.107-.1-.245-.175-.208-.358a1.745,1.745,0,0,1,.135-.559c.117-.152.191-.39.461-.238a.946.946,0,0,1,.162.6,2.175,2.175,0,0,1-.04.506.607.607,0,0,1-.11.228.2.2,0,0,1-.233.032A.306.306,0,0,0,546.141,208.422Z",
    transform: "translate(-490.748 -156.26)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M549.307,216.729q-.007-.243-.013-.486a.2.2,0,0,1,.2,0c.431.192.754-.03,1.068-.287a.64.64,0,0,1,.313-.168,2.1,2.1,0,0,1,1.089.245.353.353,0,0,1,.017.364,3.671,3.671,0,0,1-.732.474c-.4.124-.743.436-1.192.439a.781.781,0,0,1-.617-.216Z",
    transform: "translate(-493.202 -162.536)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M549.832,220.433l.647.005c.3.188.322.57.542.811-.01.358.362.176.487.345a.163.163,0,0,1-.012.205l-1.22.011C549.847,221.445,549.953,220.9,549.832,220.433Z",
    transform: "translate(-493.59 -165.878)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M523.529,188.856c.336-.005.692-.062.866.346l-.508-.01C523.8,189.046,523.46,189.173,523.529,188.856Z",
    transform: "translate(-474.59 -143.171)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M522.651,188.492l.358.337-.5-.019-.205-.316a.887.887,0,0,0,.02-.15Z",
    transform: "translate(-473.712 -142.808)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M491.844,149.469l.158-.16a.156.156,0,0,1,.241.033.736.736,0,0,1-.03.818.262.262,0,0,1-.38-.035.213.213,0,0,1-.024-.1C491.9,149.846,491.6,149.64,491.844,149.469Z",
    transform: "translate(-451.646 -114.71)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M492.062,152.324l.325.031a.287.287,0,0,1,.233.153.168.168,0,0,1-.043.176l-.341.174Z",
    transform: "translate(-451.874 -116.909)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M491.213,149.966c-.06.183.173.384-.034.559l-.307-.567Z",
    transform: "translate(-451.015 -115.208)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M561.249,254.643a.361.361,0,0,0,.344-.174c.255.1.315.262.165.5C561.5,255,561.277,254.979,561.249,254.643Z",
    transform: "translate(-501.834 -190.349)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M462.341,127.027l-.553.011c-.359.143-.653-.079-.969-.177l.025-.051c-.208-.241-.129-.428.108-.586a1.259,1.259,0,0,1,.935,0,.7.7,0,0,1,.273.262C462.234,126.659,462.435,126.793,462.341,127.027Z",
    transform: "translate(-429.244 -98.078)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M465.677,127.845l-.334-.347a.993.993,0,0,1,.694-.223c.442.03.907-.1,1.311.192a.334.334,0,0,1,.021.425.967.967,0,0,1-1.014-.032Z",
    transform: "translate(-432.58 -98.896)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M468.978,129.371l1.009.008a.3.3,0,0,1,.063.222l-.066.1h-.338l-.672,0Z",
    transform: "translate(-435.202 -100.406)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M548.933,215.475H548.8l-.186-.363q0-.161,0-.321a.338.338,0,0,1,.222-.074,1.981,1.981,0,0,1,.925.2.366.366,0,0,1,.089.334C549.625,215.671,549.281,215.58,548.933,215.475Z",
    transform: "translate(-492.71 -161.77)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M589.718,106.054l.151-.136a1.415,1.415,0,0,1,.8-.212.9.9,0,0,0,1.07-.811l-.006-.013.343.406c.123-.352-.094-.635.081-.9.176.128.05.431.27.519a7.079,7.079,0,0,1,.831.5c.28.2.377.394.057.637-.658.067-.718.5-.607,1.031-.789.814-.477,1.956-.84,2.9a2.253,2.253,0,0,1-1.36.852c-.385.049-.535.388-.76.635a.789.789,0,0,1-.217.095.913.913,0,0,1-.574-.054.287.287,0,0,1-.129-.155c-.125-.291-.3.026-.439-.029a.9.9,0,0,1-.228,0,2.358,2.358,0,0,1-.662-.19c-.207-.186-.5-.213-.715-.383-.238-.257-.1-.478.085-.669a8.126,8.126,0,0,0,.7-1.145,11.391,11.391,0,0,0,.889-2.441.942.942,0,0,1,.262-.56c.214-.141.324.027.481.134S589.556,106.408,589.718,106.054Z",
    transform: "translate(-520.184 -82.445)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M606.507,107.21c.288-.3-.069-.326-.185-.455-.2-.217-.544-.254-.658-.569.511-.135.837.474,1.348.343a2.5,2.5,0,0,1-.84,2.317,1.836,1.836,0,0,0-.509,1.778c-.2.2.07.488-.117.694a.429.429,0,0,1-.345.113.409.409,0,0,1-.213-.125c.059-.7.158-1.4.164-2.094,0-.523.612-.544.679-.979A2.01,2.01,0,0,1,606.507,107.21Z",
    transform: "translate(-533.419 -83.723)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M600.081,106.188c.132.766-.439.894-.951,1.015a3.989,3.989,0,0,1-.92.008.894.894,0,0,1,1.02-.472C599.819,107.037,599.781,106.345,600.081,106.188Z",
    transform: "translate(-528.524 -83.738)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M590.984,109q0,.341,0,.683c-.225,0-.45.213-.674,0-.5-.059-.265-.588-.509-.81a1.058,1.058,0,0,1,.846-.214A.311.311,0,0,1,590.984,109Z",
    transform: "translate(-522.451 -85.516)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M609.845,117.083a13.523,13.523,0,0,1,2.079-2.25c.255-.272.636-.1.958-.14-.012.7-.7.889-1.012,1.366h0c-.356.346-.76.634-1.143.946C610.459,117.222,610.166,117.372,609.845,117.083Z",
    transform: "translate(-536.926 -89.84)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M613.288,121.955c.615.2.268.7.309,1.067.027.243-.208.286-.416.3a.837.837,0,0,1-.906-.679C612.568,122.342,612.695,121.8,613.288,121.955Z",
    transform: "translate(-538.681 -95.054)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M609.556,120.282c-.46.042-.495.729-1.012.684-.463.06-.845.448-1.349.342a.283.283,0,0,1-.056-.336c.175-.262.551-.093.729-.348h0c.413.093.68-.169.956-.4a1.917,1.917,0,0,1,1.069-.62C609.918,119.9,609.65,120.046,609.556,120.282Z",
    transform: "translate(-534.949 -93.381)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M601.472,124.455l.167,0a.635.635,0,0,1-.167,1.021H600.8c-.164-.241-.524-.083-.678-.343Z",
    transform: "translate(-529.903 -96.872)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M598.385,126.872c.264.037.623-.116.678.343-.439.03-.112.335-.175.5a.37.37,0,0,1-.422.117c-.154-.064-.27-.234-.471-.177a.3.3,0,0,1-.278-.108C597.773,127.154,597.9,126.833,598.385,126.872Z",
    transform: "translate(-528.169 -98.608)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M614.958,134.439c-.186.013-.389-.026-.514.172-.326.135-.59-.116-.89-.145a1.224,1.224,0,0,1-.842-.609c-.012-.155.123-.188.211-.26a2.144,2.144,0,0,0,1.017.334.345.345,0,0,0,.333.18Z",
    transform: "translate(-538.995 -103.446)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M617.133,116.1c.089-.643.774-.835,1.012-1.366h.338A2.253,2.253,0,0,1,617.133,116.1Z",
    transform: "translate(-542.189 -89.886)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M596.318,129.221l.333.008c.189-.109.242.08.344.161l.494,0,.178.021a.223.223,0,0,1,0,.331l-.334.017a.657.657,0,0,1-.622.139,3.566,3.566,0,0,1-.862-.252c-.227-.373.195-.266.291-.4Z",
    transform: "translate(-526.769 -100.281)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M604.989,125.366a1.739,1.739,0,0,0,.167-1.021l.339,0a.1.1,0,0,1,.168,0c0,.114,0,.228,0,.343C605.737,125.215,605.513,125.443,604.989,125.366Z",
    transform: "translate(-533.419 -96.759)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M606.315,131.38a2.553,2.553,0,0,1-1.37-.676.383.383,0,0,1,.352-.183A1.5,1.5,0,0,1,606.315,131.38Z",
    transform: "translate(-533.388 -101.233)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M611.782,129.671a1.387,1.387,0,0,1-1.491.063C610.824,129.432,611.311,129.679,611.782,129.671Z",
    transform: "translate(-537.248 -100.559)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M606.974,122.711h-.168c.023-.236-.078-.5.168-.683.055.458.409.309.675.341C607.594,122.827,607.239,122.678,606.974,122.711Z",
    transform: "translate(-534.73 -95.127)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M603.575,130.065a.385.385,0,0,1-.352.183l-.663-.01q0-.166,0-.332C602.9,129.942,603.275,129.766,603.575,130.065Z",
    transform: "translate(-531.665 -100.777)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M611.256,132.722l-.171.169a.353.353,0,0,1-.5,0l-.183-.171C610.693,131.867,610.969,132.918,611.256,132.722Z",
    transform: "translate(-537.328 -102.57)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M621.981,113.273c.042-.194-.1-.441.149-.571.026-.013.139.071.153.125.067.256-.026.419-.3.447Z",
    transform: "translate(-545.688 -88.421)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M484.766,64.919a.31.31,0,0,1,.336.342c0,.6-.02,1.192.006,1.786.021.473.15.674.763.777.771.129,1.53.108,2.292.178.2.019.284.149.313.333-1.03.322-2.113.381-3.157.645a.428.428,0,0,1-.542-.406c-.009-1.166-.733-2.106-.948-3.2C484.028,64.982,484.412,64.982,484.766,64.919Z",
    transform: "translate(-445.929 -54.067)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M482.386,64.4c.373,1.058,1.1,1.995,1.026,3.208-.024.368.223.371.515.287a7.628,7.628,0,0,1,3.014-.422l.507.341c.3.222.917-.051.917.62a.341.341,0,0,1-.172.174.935.935,0,0,1-.806-.134,2.824,2.824,0,0,0-2.948-.074,1.3,1.3,0,0,1-.23.066c-.452-.114-.878.3-1.338.072a.515.515,0,0,1-.092-.214,5.371,5.371,0,0,0-.958-3.469.714.714,0,0,1-.11-.454c.107-.449.5-.529.844-.679C482.8,64.024,482.447,64.175,482.386,64.4Z",
    transform: "translate(-444.395 -53.205)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M503.215,78.915c-.041-.532-.621-.38-.844-.682a8,8,0,0,1,3.028.361,2.213,2.213,0,0,1,.853.663C505.168,79.8,504.194,79.337,503.215,78.915Z",
    transform: "translate(-459.318 -63.624)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M505.407,80.714c1.02.044,1.992.519,3.036.343l.506.171c.3.037.683-.009.507.512h0a.751.751,0,0,1-.9.061c-.5-.321-1.081-.1-1.613-.219a1.394,1.394,0,0,1-.245-.061c-.432-.266-1.083-.176-1.3-.805Z",
    transform: "translate(-461.51 -65.423)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M505.2,71.331l.339.682c-.185.506-.434.5-.651.044-.09-.186-.117-.372-.361-.385a.231.231,0,0,1-.336,0C504.168,70.456,504.785,71.2,505.2,71.331Z",
    transform: "translate(-460.633 -58.428)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M518.665,81.521c.032-.374-.39-.289-.507-.512.116-.224.538-.139.506-.512a.351.351,0,0,1,.388-.05c.344.289.624.6.287,1.074C519.114,81.356,518.889,81.515,518.665,81.521Z",
    transform: "translate(-470.718 -65.205)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M520.172,78.967h-.337c-.228-.228.336-.454,0-.682.481.008,1.053-.121,1.013.681A.6.6,0,0,1,520.172,78.967Z",
    transform: "translate(-471.888 -63.674)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M503.354,73.424l.336,0c-.039.252.117.6-.309.659a.265.265,0,0,1-.325-.188C502.983,73.631,503.065,73.459,503.354,73.424Z",
    transform: "translate(-459.794 -60.182)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M469.51,65.734a.354.354,0,0,1,.169.342,6.236,6.236,0,0,1,.385.836A1.382,1.382,0,0,1,468.8,69.03c-.221.022-.444.009-.665.009-.139,0-.278,0-.416-.017a1.06,1.06,0,0,1-.374-.1c-.384-.839-1.266-.869-1.95-1.222-.208-.107-.6-.047-.584-.347.023-.347.394-.414.652-.509-.064-.054-.257.064-.359-.089a.315.315,0,0,1,.011-.351,1.045,1.045,0,0,1,.7-.238c1.364-.255,2.146.864,3.2,1.421a1.092,1.092,0,0,0-.213-1.251c-.142-.169-.321-.373-.126-.6a.427.427,0,0,1,.665,0Z",
    transform: "translate(-432.195 -54.539)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M467.426,61.766c-.19.019-.436-.075-.55.109s.11.3.221.4c.551.517.276,1.142.289,1.82a4.017,4.017,0,0,1-1.208-.773,2.346,2.346,0,0,0-2.093-.874c-.046.008-.115-.112-.173-.173-.2,0-.4,0-.6,0a1.145,1.145,0,0,1-.824-.187.856.856,0,0,1-.339-.351c.048-.3.29-.294.506-.338a4.254,4.254,0,0,1,3.68,1.047,1.219,1.219,0,0,0,.386.269,1.957,1.957,0,0,0-1.044-.8c-.388-.159-.886-.2-1.045-.715a.372.372,0,0,1,.1-.2c.452-.149.4-.656.661-.946l.337,0,0,0c.227.169.1.516.337.681h0c.2.46.683.482,1.049.675C467.292,61.5,467.4,61.578,467.426,61.766Z",
    transform: "translate(-430.278 -50.572)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M483.886,64.388c-.35-.33.306-.4.169-.68a.587.587,0,0,1,.677.337C484.562,64.443,484.212,64.385,483.886,64.388Z",
    transform: "translate(-445.895 -53.192)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M475.387,60.746c-.453-.055-.307-.413-.337-.681C475.5,60.12,475.353,60.479,475.387,60.746Z",
    transform: "translate(-439.589 -50.577)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M588.9,188.934a1.052,1.052,0,0,0-.507.512,7.381,7.381,0,0,1-.858,1.128.968.968,0,0,1-.635.04c-.607-.171-1.145-.412-1.155-1.181a1.16,1.16,0,0,1,.143-.449,1.918,1.918,0,0,0,.29-.561,1.534,1.534,0,0,1,.054-.205.5.5,0,0,1,.118-.177.156.156,0,0,1,.188.038c.493,0,.985,0,1.478,0,.473-.005,1.023.164,1.155-.58a.341.341,0,0,1,.42-.182c.165.051.147.216.15.351.006.308,0,.617,0,.925C589.6,189.058,589.31,189.147,588.9,188.934Z",
    transform: "translate(-519.522 -142.057)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M586.916,202.227a.507.507,0,0,1,.512.341c-.2.386.26.55.286.861a1.971,1.971,0,0,1,.111.8.47.47,0,0,1-.15.185.653.653,0,0,1-.463.116.642.642,0,0,1-.392-.441,1.547,1.547,0,0,1-.044-.324c-.032-.626-.273-.657-.673-.243a.718.718,0,0,1-.472.289.471.471,0,0,1-.193-.119c-.171-.287-.549-.208-.756-.433a.353.353,0,0,1,.006-.331c.186-.252.575-.175.737-.467a.658.658,0,0,1,.175-.144C586.032,202.2,586.493,202.495,586.916,202.227Z",
    transform: "translate(-518.728 -152.788)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M582.7,176.05c0,.057,0,.114,0,.17a.188.188,0,0,1-.165.074c-.127-.03-.228-.006-.263.144-.029.216-.055.431-.3.52-.185-.093-.352-.109-.461.115h-.668a.557.557,0,0,1-.184-.46.793.793,0,0,1,.093-.365.614.614,0,0,1,.174-.161c.229-.147.568-.193.532-.588a.888.888,0,0,1,.29-.473.682.682,0,0,1,.2-.131.9.9,0,0,1,.733.055.513.513,0,0,1,.154.212,1,1,0,0,1,.055.262A.8.8,0,0,1,582.7,176.05Z",
    transform: "translate(-515.85 -133.1)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M595.43,205.144a1.4,1.4,0,0,1-.169-.852c.461-.035-.049-.4.169-.513a.354.354,0,0,0,.168-.341c.054.012.135.006.158.04a6.225,6.225,0,0,1,.855,2.349c-.234-.022-.5.08-.676-.171C595.686,205.567,595.407,205.508,595.43,205.144Z",
    transform: "translate(-526.391 -153.659)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M597.1,187.947a.973.973,0,0,0,.843-.342c1.052-.313,1.08-.407.414-1.677a1.684,1.684,0,0,1,.9.982c.084.221.051.538-.13.625a4.74,4.74,0,0,1-1.884.687C597.2,188.223,597.146,188.042,597.1,187.947Z",
    transform: "translate(-527.721 -141.07)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M596.378,173.059c.274.261.527,1.725.28,1.885-.318.205-.645.191-.618-.348a.619.619,0,0,1-.166-.326,2.182,2.182,0,0,1,.412-1.132Z",
    transform: "translate(-526.833 -131.817)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M591.221,195.957c.085-.507.473-.758.844-1.023h.5c-1.088.181-.537,1.557-1.366,1.887a.175.175,0,0,1-.209-.031C590.725,196.414,590.787,196.131,591.221,195.957Z",
    transform: "translate(-523.196 -147.545)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M578.906,184.6c.132.024.36.109.265.209-.7.732.085.808.437,1.076a1.115,1.115,0,0,0,.142.079l.027.124a.323.323,0,0,1-.5.191,3.435,3.435,0,0,0-.862-.293c-.354-.081-.556-.264-.343-.658a7.881,7.881,0,0,1,.735-.688Z",
    transform: "translate(-513.916 -140.117)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M592.711,175.4v.341l-1.175-.17a.664.664,0,0,1-.276-.513.446.446,0,0,1,.375-.407,1.722,1.722,0,0,1,.8.4C592.56,175.14,592.613,175.287,592.711,175.4Z",
    transform: "translate(-523.505 -132.96)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M587.989,177.031l0-.687c.449-.224.82-.212,1.007.346C588.876,177.454,588.383,177.091,587.989,177.031Z",
    transform: "translate(-521.144 -134.081)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M594.956,169.242q0,.341,0,.682c0,.114,0,.228,0,.342h0a.747.747,0,0,1-.607.192.541.541,0,0,1-.437-.236.447.447,0,0,1,.076-.353c.245-.291.405-.694.876-.7Z",
    transform: "translate(-525.411 -129.023)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M593.24,185.564a1.733,1.733,0,0,1,1.4.246A1.571,1.571,0,0,1,593.24,185.564Z",
    transform: "translate(-524.935 -140.756)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M594.325,203.781l.351.62c-.209.141-.349-.064-.52-.107-.064-.283-.817-.425-.17-.853A.585.585,0,0,0,594.325,203.781Z",
    transform: "translate(-525.286 -153.661)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M585.381,180.353l.169-.516c.076-.13.151-.264.337-.172h.171c.118.567-.1.855-.681.851q-.082-.057-.053-.111C585.343,180.371,585.362,180.353,585.381,180.353Z",
    transform: "translate(-519.214 -136.546)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M585.356,188.667c0,.057,0,.114,0,.17-.452.233-.735-.044-1.012-.341v0c.35-.074.583-.506,1.012-.339A.373.373,0,0,1,585.356,188.667Z",
    transform: "translate(-518.511 -142.644)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M587.988,188.317q0-.256,0-.512a.945.945,0,0,1,.892-.1c-.1.387-.652.214-.724.612Z",
    transform: "translate(-521.143 -142.293)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M589.261,201.686c-.374.647-.883.216-1.344.171a.188.188,0,0,1,.055-.253,1.025,1.025,0,0,1,1.095.066Z",
    transform: "translate(-521.072 -152.247)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M589,176.091a1.58,1.58,0,0,0-1.007-.346c0-.053,0-.106,0-.159a.7.7,0,0,1,1.007,0l.178.5Z",
    transform: "translate(-521.144 -133.482)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M579.324,182.683v.335h0a.785.785,0,0,1-.5.26c-.378-.188-.26-.5-.2-.8a.4.4,0,0,1,.33-.07A.8.8,0,0,1,579.324,182.683Z",
    transform: "translate(-514.335 -138.532)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M584.009,181.139q0,.082,0,.164l-.5,0c.059-.189-.262-.463.061-.566C583.821,180.657,583.805,181.06,584.009,181.139Z",
    transform: "translate(-517.842 -137.331)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M589.061,201.052l-1.148.01a.215.215,0,0,1,.008-.233.64.64,0,0,1,1,.051q.073.015.147.024A.487.487,0,0,1,589.061,201.052Z",
    transform: "translate(-521.067 -151.629)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M580.349,181.653a.373.373,0,0,1-.34-.176c-.068-.294-.034-.518.34-.511q0,.255,0,.51C580.351,181.535,580.35,181.594,580.349,181.653Z",
    transform: "translate(-515.36 -137.502)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M596.408,221.578l-.68.008a.485.485,0,0,1-.659,0l-.01-.01c-.166-.251-.06-.4.179-.508.37.243.8.1,1.188.187S596.732,221.486,596.408,221.578Z",
    transform: "translate(-526.19 -166.334)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M595.157,216.079l-.075,0-.075-.01a.632.632,0,0,1-.505-.1.294.294,0,0,1-.069-.2,1.687,1.687,0,0,1,.265-.476.612.612,0,0,1,.166-.155.651.651,0,0,1,.227-.051.446.446,0,0,1,.319.145.654.654,0,0,1,.091.357A.544.544,0,0,1,595.157,216.079Z",
    transform: "translate(-525.797 -162.04)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M597.04,217.119l.228-.506c.394-.233.458.157.63.342h0C597.656,217.242,597.331,217.089,597.04,217.119Z",
    transform: "translate(-527.679 -163.08)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M594.48,217.842c.176.037.383,0,.489.205-.013.191.034.4-.168.531a.163.163,0,0,1-.209.019.973.973,0,0,1-.212-.549A.293.293,0,0,1,594.48,217.842Z",
    transform: "translate(-525.759 -164.015)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M594.231,220.342l.175.011c0,.057,0,.114,0,.17l-.179.508a.311.311,0,0,1-.338-.341.17.17,0,0,1-.061-.128c0-.05.006-.075.016-.075C593.948,220.36,594.054,220.256,594.231,220.342Z",
    transform: "translate(-525.364 -165.79)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M598.3,215.4c-.225-.085-.357-.347-.631-.342l-.04-.344c-.092-.187.017-.272.167-.336C598.612,214.389,598.188,215.029,598.3,215.4Z",
    transform: "translate(-528.078 -161.524)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M594.716,212.616a1.277,1.277,0,0,1-.124.044c-.374.051-.4-.258-.5-.492a.878.878,0,0,1,.014-.4.447.447,0,0,1,.155-.215c.433-.181.536.128.639.44-.007.042-.013.083-.019.125C594.926,212.317,594.922,212.5,594.716,212.616Z",
    transform: "translate(-525.54 -159.454)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M595.2,210.562c-.17-.2-.319-.445-.646-.359-.17-.274.048-.467.141-.686l.181-.008.5.512C595.181,210.152,595.231,210.37,595.2,210.562Z",
    transform: "translate(-525.842 -158.025)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M596.375,214.077c.02-.179-.011-.375.167-.5.177-.043.381-.141.371.19l-.167.336Z",
    transform: "translate(-527.199 -160.916)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M576.765,129.27l.676.016c.084.272.087.612.552.567a3.4,3.4,0,0,1-1.568.272l-.105-.027c-.2-.078-.4-.155-.406.194a.613.613,0,0,1-.163.515h0c-.2.169-.378.06-.517-.075a1.625,1.625,0,0,0-1.147-.414.713.713,0,0,1-.324-.158.776.776,0,0,0-1.117-.505c.34.387.842.148,1.09.477,1.53,1.309,1.526,1.418-.083,2.844-.606.339-.486.739-.092,1.161a1.4,1.4,0,0,1,.382,1.025,3.583,3.583,0,0,0,.073,1.078c.3-.2.4-.5.6-.715.132-.149.231-.354.485-.3a.526.526,0,0,1,.144.335c-.048,1.007-.8,1.408-1.535,1.829-.653.135-1.05-.358-1.535-.636-.3-.233-.323-.668-.641-.885-.2-.048-.385.231-.586.016a.829.829,0,0,1-.111-.332,2.764,2.764,0,0,1-.024-.365,1.291,1.291,0,0,1,.616-1.338,1.33,1.33,0,0,0,.065-.418.569.569,0,0,0-.287-.508,1.15,1.15,0,0,0-1.136-.679c-.24-.008-.651.054-.648-.212.007-.863-.753-.673-1.154-.966a.5.5,0,0,1-.018-.242,1.538,1.538,0,0,1,.9-.785,2.494,2.494,0,0,0,1.691-.9.849.849,0,0,1,.242-.034,4.408,4.408,0,0,0,1.665-.472,2.359,2.359,0,0,1,.879-.083,1.511,1.511,0,0,1,.358.064,2.631,2.631,0,0,1,.715.412c.24.185.13-.143.233-.162a.581.581,0,0,1,.317-.1.624.624,0,0,1,.32.1.459.459,0,0,1,.149.279c.148.265.388.219.624.185A1.684,1.684,0,0,1,576.765,129.27Z",
    transform: "translate(-506.881 -99.81)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M595.725,141.514c-.176.893.568,1.661.337,2.561.17.361.08.592-.325.666a.535.535,0,0,1-.415-.158,1.435,1.435,0,0,1-.16-.985c.091-.769-.252-1.5-.19-2.259a.491.491,0,0,1,.641-.237A.255.255,0,0,1,595.725,141.514Z",
    transform: "translate(-526.18 -108.808)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M595.3,140.761c-.1-.558-.414-.262-.675-.17-.148.06-.208-.03-.25-.15a.429.429,0,0,1,.195-.393,1.533,1.533,0,0,1,.73.031.947.947,0,0,1,1.006,1.073c-.016.632.056,1.259.1,1.9-.479-.467-.39-1.112-.566-1.664C595.731,141.07,595.693,140.782,595.3,140.761Z",
    transform: "translate(-525.75 -108.056)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M591.563,135.758a.546.546,0,0,1-.675,0c-.065.055-.165.121-.222.078a3.968,3.968,0,0,1-1.465-1.786c.746-.236,1.14.417,1.687.683A3.071,3.071,0,0,0,591.563,135.758Z",
    transform: "translate(-522.019 -103.735)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M597.641,152.31c.342-.017.339-.265.337-.513a3.1,3.1,0,0,0,.862,1.112c.081.064.2.164.2.238-.058.753.437,1.473.123,2.237l.167.34a.918.918,0,0,1-.609.075c-.239-.194.011-.372.016-.559a3.33,3.33,0,0,0-.768-2.221C597.8,152.815,597.534,152.646,597.641,152.31Z",
    transform: "translate(-528.095 -116.53)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M611.059,134.181l.5,0a1.752,1.752,0,0,0,.852.518c.152.14.432.192.335.5C611.343,135.2,611.154,135.089,611.059,134.181Z",
    transform: "translate(-537.803 -103.865)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M603.736,144.228c.026.265-.236.334-.34.51-.218-.165-.639-.089-.609-.554.011-.169.044-.287.218-.284C603.288,143.908,603.657,143.746,603.736,144.228Z",
    transform: "translate(-531.828 -110.838)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M595.274,134.5v-.682a.472.472,0,0,1,.675,0Q596.06,134.611,595.274,134.5Z",
    transform: "translate(-526.404 -103.5)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M616.261,136.543l-.335-.5.839.327c.185.015.386-.018.513.172C616.94,136.417,616.6,136.82,616.261,136.543Z",
    transform: "translate(-541.317 -105.202)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M581.149,238.05l-.344.339-.509.167c-.2.066-.313-.035-.372-.22.328-.456.688-.772,1.229-.282Z",
    transform: "translate(-515.32 -178.37)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M578.732,239.6l.339.172c-.227.289-.552.128-.83.185l-.014-.2C578.309,239.427,578.5,239.465,578.732,239.6Z",
    transform: "translate(-514.094 -179.589)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M563.259,236.863c-.182.008-.375-.019-.5.159a2.075,2.075,0,0,0-1,.533.83.83,0,0,1-.614.256c-.176.057-.295.223-.481.257a.447.447,0,0,0-.309.212.485.485,0,0,1-.118.148.61.61,0,0,1-.676.323c-.33.722-.491.759-1.511.349-.1-.174-.211-.193-.34-.032a.263.263,0,0,1-.2.089c-.5-.024-.581-.429-.7-.8a.63.63,0,0,1,.223-.531.491.491,0,0,1,.455-.022c.093.044.164.2.272.131a.2.2,0,0,0,.024-.3c-.1-.129-.281-.2-.28-.4.115-.2.341-.277.5-.435a1.3,1.3,0,0,1,.508-.214,1.772,1.772,0,0,1,2.387.56c.047-.628,1.4-1.383,2.527-1.46a.552.552,0,0,1,.2.11c.172.017-.212.308.11.24a.927.927,0,0,1,.647.057l.081.087q0,.174,0,.348A1.179,1.179,0,0,0,563.259,236.863Z",
    transform: "translate(-498.622 -176.848)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M572.041,242.5l.684-.182q0,.166,0,.331l-.674.007c-.05-.032-.067-.066-.053-.1S572.025,242.5,572.041,242.5Z",
    transform: "translate(-509.591 -181.617)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M569.992,242.97c0,.052.007.1.007.156s0,.113,0,.169l-.347.314-.5.051c0-.062,0-.125,0-.188.029-.2.22-.235.345-.336Z",
    transform: "translate(-507.542 -182.082)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M537.507,78.289c-.032.278.112.676-.379.666-.52-.011-.321-.385-.3-.664Z",
    transform: "translate(-484.161 -63.68)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M529.467,81.929c.263.006.527.018.482.4-.031.263-.243.314-.434.275-.415-.085-.959.295-1.23-.331a.23.23,0,0,1,0-.339Z",
    transform: "translate(-477.978 -66.297)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M521.194,80.527c.225-.168.45-.007.676,0h.168l.169.171a.376.376,0,0,1,0,.512.507.507,0,0,1-.388.61c-.228.066-.262-.1-.288-.268C521.661,81.127,521.285,80.875,521.194,80.527Z",
    transform: "translate(-472.91 -65.234)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M524.838,81.837q0-.256,0-.512a1.725,1.725,0,0,0,1.013.173q0,.17,0,.339c-.4-.01-.263.424-.47.592C525.057,82.364,525.267,81.791,524.838,81.837Z",
    transform: "translate(-475.542 -65.862)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M379.112,68.606v-.5c.863-1.406,2.4-1.686,3.742-2.3a.287.287,0,0,1,.307.078h2.7c.424.5.256,1.09.263,1.654.018.5-.26,1.026.146,1.486a.4.4,0,0,1,.187.275,1.384,1.384,0,0,1-.359.744.4.4,0,0,1-.423.133c-.139-.131-.148-.326-.232-.482-.749.1-.294.693-.421,1.044.065.225.171.451-.029.663a.853.853,0,0,1-.461.152c-.122.013-.244.015-.366.018a1.119,1.119,0,0,0-.743.313c-.187.163-.384.34-.656.148a.835.835,0,0,1-.146-.49,1,1,0,0,1,.108-.5c.214-.268.587-.291.813-.549.183-.209.445-.42.241-.712s-.371-.746-.884-.452c-.295.155-.493-.031-.7-.2-.055-.044-.108-.091-.159-.138a.488.488,0,0,0-.475-.09,3.186,3.186,0,0,0-.646.024,1.432,1.432,0,0,1-.544,0,1.508,1.508,0,0,0-.608.046C379.466,69,379.417,68.575,379.112,68.606Z",
    transform: "translate(-370.311 -54.691)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M373.834,46.686c.337,0,.674-.014,1.009.009a.644.644,0,0,1,.662.64c.017.61-.03,1.223-.055,1.834-.013.314-.262.238-.438.244-.392.013-.785,0-1.177,0-.036-.085-.028-.2.041-.224a1.392,1.392,0,0,0,.93-1.2c.031,1-.972,1.077-1.767,1.394a2.13,2.13,0,0,1-.188.137c-.166.105-.325.222-.5.318a.85.85,0,0,1-.236.066c-.631-.2-1.468-.007-1.715-.929.193-.429.734-.124.961-.473a2.844,2.844,0,0,1,1.854-1.633C373.409,46.793,373.656,46.85,373.834,46.686Z",
    transform: "translate(-364.022 -40.955)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M396.638,43.351a7.761,7.761,0,0,1-2.839-.1c-.394-.047-.155-.793-.184-1.222a.338.338,0,0,1,.438-.371c.877.154.97-.361.9-1.035a2.366,2.366,0,0,1,1.9,1.308c.142.664-.363.448-.679.481-.616.081-1.185-.256-1.8-.174.612-.065,1.18.254,1.793.182a.329.329,0,0,1,.225.109C396.52,42.785,396.734,43.02,396.638,43.351Z",
    transform: "translate(-380.751 -36.595)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M399.891,39.7c.167-.121.707.044.3-.5A4,4,0,0,0,398.542,38c.089-.47.325-.332.6-.167.3.178.482.579.917.51.2.042.3.259.552.3.32-.509-.1-1.174.293-1.669l.337,0,0,0c.425.6.192,1.268.128,1.9-.043.422-.273.811.343.993.207.061.044.38.2.524a11.782,11.782,0,0,0,.1,2.408c.082.309-.194.438-.268.665a.725.725,0,0,1,.283.973c-.137.211-.312.34-.551.169a.705.705,0,0,1-.257-.76,9.758,9.758,0,0,0,.08-1.9c.05-.921-.15-1.548-1.145-1.7-.1-.016-.184-.122-.268-.2,0-.057,0-.114,0-.171-.062-.038-.082-.076-.062-.114S399.871,39.7,399.891,39.7Z",
    transform: "translate(-384.342 -33.973)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M365.245,54.4c.4.774,1.213.619,1.854.851.216.248.131.474-.052.691a.745.745,0,0,1-.319.16,3.962,3.962,0,0,0-.639.17c-.348.052-.563-.173-.811-.366a.849.849,0,0,0-.979-.214c.3.158.542.286.784.418a.755.755,0,0,1,.325,1.016c-.277.48-.521-.212-.831-.171a2.221,2.221,0,0,1-.9.192.531.531,0,0,1-.495-.253c-.018-.2.146-.345.181-.531a1.077,1.077,0,0,1,.144-.307c.245-.368.243-.918.771-1.078.56-.04.953.357,1.42.531-.348-.309-1.112-.361-.793-1.158A.284.284,0,0,1,365.245,54.4Z",
    transform: "translate(-358.809 -46.444)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M403.394,47.912c1.578.252,1.531.253,1.592,1.913a5.143,5.143,0,0,1-.046,1.809c-.077.247-.268.886.478.717.267.887-.109,1.466-.957,1.476-.28-.189-.548-.387-.442-.8.843-.775.493-1.706.327-2.612-.159-.323-.114-.7-.253-1.027-.008-.038-.016-.076-.024-.115l-.337-.683C403.637,48.358,403.369,48.209,403.394,47.912Z",
    transform: "translate(-387.845 -41.839)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M404.312,53.8c.351.043.337.307.337.565,0,.5-.028,1.011.008,1.513.038.534-.195.713-.682.654a.217.217,0,0,1-.265.069l-.073-.07c0-.113-.037-.255.016-.334a2.089,2.089,0,0,0-.225-2.459c-.345-.578-.149-.871.546-.963h0C404.283,53.046,404,53.522,404.312,53.8Z",
    transform: "translate(-387.75 -45.333)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M382.832,63.709c-.969.253-1.736,1-2.751,1.15-.263.039-.415.271-.518.516a.873.873,0,0,1-.78.554h0a.434.434,0,0,1-.1-.47,1.923,1.923,0,0,1,1.111-1.067c1.122-.443,2.4-.561,3.227-1.632C383.426,63.189,382.8,63.38,382.832,63.709Z",
    transform: "translate(-369.983 -52.515)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M355.389,45.262l.325-.008a.709.709,0,0,1,.517-.047c.374.14.975.018.843.744l-.169.189a.8.8,0,0,1-.494.3.821.821,0,0,1-.455-.039c-.072-.046-.084-.029-.206.3-.47.269-.775.848-1.427.773a.624.624,0,0,1-.108-.49.655.655,0,0,1,.154-.353l.024,0c.332-.357.758-.648.83-1.191Z",
    transform: "translate(-352.326 -39.876)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M373.643,57.418a.51.51,0,0,1,.508-.34,1.16,1.16,0,0,0,.725.07.419.419,0,0,1-.392-.074,1.089,1.089,0,0,0,.169-.677l0,0c.16-.127.375-.169.505-.341h0a.472.472,0,0,1,.675,0c.427,1.624-1.252,1.39-1.8,2.155C373.645,58.043,373.961,57.576,373.643,57.418Z",
    transform: "translate(-366.363 -47.59)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M404.411,62.445c.93-.005.874-.759,1.011-1.365a1.764,1.764,0,0,0-.167-1.025l.5,0c.019.037.037.075.057.112a1.6,1.6,0,0,1,0,.376c-.017.371-.014.743,0,1.114a2.665,2.665,0,0,1,.013.618c-.478.838-1.354.977-2.153,1.252l-.115-.044c-.228-.556-.039-1.153-.164-1.719h.338A1.408,1.408,0,0,0,404.411,62.445Z",
    transform: "translate(-387.849 -50.568)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M367.09,50.91c.053.9.93.809,1.52,1.272-.935.341-1.473-.526-2.2-.563-.345-.017-.187-.22-.13-.375.065-.175.355-.157.345-.4.09-.3-.074-.552-.117-.828a.51.51,0,0,1,.261-.38,2.592,2.592,0,0,1,.966-.073c.3-.213.441.215.7.176.183.3-.034.378-.243.476-.269.127-.608.067-.826.322A1.506,1.506,0,0,1,367.09,50.91Z",
    transform: "translate(-360.985 -42.981)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M376.42,68.567l-1.012,1.025c-.337.325-.538-.155-.823-.139a.737.737,0,0,1-.525-.2l0-.342a.233.233,0,0,1,0-.341Z",
    transform: "translate(-366.607 -56.69)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M369.4,48.352a1,1,0,0,1,.883-.345c.241.006.441-.043.465-.34h0c.133-.168.353-.2.505-.341a2.072,2.072,0,0,1,1.856-.683A25.47,25.47,0,0,0,371,48.06c-.589.458.245.311.085.475C370.5,48.666,369.91,48.9,369.4,48.352Z",
    transform: "translate(-363.3 -40.912)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M379.785,50.681h-.675c.015-.311.243-.338.473-.361a1.4,1.4,0,0,0,1.392-1.557c0-.138.032-.283.205-.324.246,1.029,0,1.543-1.058,2.242Z",
    transform: "translate(-370.31 -42.217)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M404.849,36.752c-.129.692.308,1.451-.265,2.142-.227-.252-.52-.416-.579-.776a1.428,1.428,0,0,0,.506-1.365C404.624,36.737,404.736,36.562,404.849,36.752Z",
    transform: "translate(-388.287 -33.752)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M381.336,35.581c-.629-.671-.489-1.675-1.012-2.391.547-.2.724.194.91.577.011.155.208.266.1.448Z",
    transform: "translate(-371.187 -31.215)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M383.53,35.318l-.169-.341c.056-.084.113-.08.169,0,.371-.04.733.059,1.1-.224.406-.314.5.369.889.286l-.056.279Z",
    transform: "translate(-373.38 -32.318)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M395.078,34.007c-.573-.1-1.05.258-1.34-.3a.253.253,0,0,1,.158-.344C394.386,33.206,394.736,33.378,395.078,34.007Z",
    transform: "translate(-380.856 -31.34)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M381.139,33.14h-.169c-.21-.318-.416-.642-.844-.684h0a.23.23,0,0,1,0-.341h.844A3.067,3.067,0,0,1,381.139,33.14Z",
    transform: "translate(-370.989 -30.481)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M369.395,45.214a3.677,3.677,0,0,0,2.025-.341c-.011.228,0,.509-.316.493C370.533,45.338,369.937,45.561,369.395,45.214Z",
    transform: "translate(-363.295 -39.654)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M362.095,48.741l.508-.149c.289.329.71-.072,1.012.186a.2.2,0,0,1,0,.225C363.04,49.3,362.493,49.463,362.095,48.741Z",
    transform: "translate(-358.024 -42.328)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M362.347,45.919c-.034-.537-.618-.383-.841-.684a.924.924,0,0,1,.838,0,1.714,1.714,0,0,1,.346.453C362.822,46.1,362.674,46.171,362.347,45.919Z",
    transform: "translate(-357.598 -39.844)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M366.509,66.356l-.182-.164c.462-.126,1.015-.581,1.19.336h-.166A1.021,1.021,0,0,1,366.509,66.356Z",
    transform: "translate(-361.08 -54.821)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M367.51,49.079c0-.038,0-.077-.006-.115.4-.054.814-.285,1.161.13a1.751,1.751,0,0,1-.988.173C367.52,49.3,367.434,49.262,367.51,49.079Z",
    transform: "translate(-361.913 -42.515)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M364.932,63.437c.286.047.57-.268.858-.007a.351.351,0,0,1-.361.371.549.549,0,0,1-.509.006A.3.3,0,0,1,364.932,63.437Z",
    transform: "translate(-360.022 -52.921)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M363.335,64.643l.49.052c-.113.159-.352.234-.323.49l-.29.014a.6.6,0,0,0-.55-.191h0c-.062-.14.016-.228.111-.311A.465.465,0,0,1,363.335,64.643Z",
    transform: "translate(-358.416 -53.815)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M360.995,44.615l-.838,0-.519-.013.181-.157c.448-.086.938.171,1.353-.173C361.426,44.548,361.2,44.577,360.995,44.615Z",
    transform: "translate(-356.249 -39.22)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M372.5,68.567v.341l-.673,0C371.884,68.448,372.238,68.6,372.5,68.567Z",
    transform: "translate(-365.052 -56.69)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M366.531,31.6c-.153-.137-.264-.316-.028-.432.163-.08.171.134.2.253Z",
    transform: "translate(-361.108 -29.79)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M374.758,49.126a.508.508,0,0,1-.505.341C374.268,49.121,374.513,49.123,374.758,49.126Z",
    transform: "translate(-366.803 -42.711)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M364.541,30.918c.464.033.26.289.166.509h-.084l-.084,0Q364.54,31.172,364.541,30.918Z",
    transform: "translate(-359.789 -29.621)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M355.709,46.113c.548.985-.493.837-.83,1.191q.074-.258.148-.516a1.021,1.021,0,0,1,.2-.673Z",
    transform: "translate(-352.813 -40.546)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M462.288,52.622c-.12.466.178.811.338,1.2-.208.431.029.973-.336,1.365h0a7.882,7.882,0,0,1-1.544.23c-.751.068-1.2-.334-1.35-1.2a1.344,1.344,0,0,0-.577-.94.639.639,0,0,1-.035-.265A2.108,2.108,0,0,1,462.288,52.622Z",
    transform: "translate(-427.842 -44.672)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M442.969,50.6a3.246,3.246,0,0,0-1.694-.539,1.669,1.669,0,0,0-1.68,1.052.307.307,0,0,1-.328.075.855.855,0,0,1-.2-.131,4.41,4.41,0,0,0-2.01-1,1.544,1.544,0,0,0-1.82.5,1.208,1.208,0,0,1-1.169.387c-.23.013-.44-.488-.689-.025-.515.076-1.07.285-1.352-.414a.569.569,0,0,1,.14-.413c.56,0,1.12,0,1.679,0,.518,0,1.136.142,1.046-.742a.238.238,0,0,1,.064-.151c.2-.237,2.475-.2,2.546.081.146.575.544.466.92.469.616.006,1.231,0,1.847,0,.633,0,1.27.047,1.9-.012C442.862,49.668,443.055,49.976,442.969,50.6Z",
    transform: "translate(-408.523 -42.648)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M471.316,60.214c.143-.447-.338-1.052.336-1.365l.338.342C471.954,59.659,472.208,60.322,471.316,60.214Z",
    transform: "translate(-436.869 -49.703)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M423.952,44.018c.234-.3.212-.51-.248-.642-.422-.12-.217-.22-.089-.383a1.866,1.866,0,0,1,1.353.342c.22.3.578.076.838.226a.954.954,0,0,1,.551.442.248.248,0,0,1-.184.272,2.046,2.046,0,0,0-1.353.518.653.653,0,0,1-.457.018.676.676,0,0,1-.192-.127,1.418,1.418,0,0,1-.293-.352A.289.289,0,0,1,423.952,44.018Z",
    transform: "translate(-402.33 -38.286)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M429.755,43.889c-.243-.209-.814.4-.843-.347l.336-.027a1.128,1.128,0,0,1,.53-.253.507.507,0,0,1,.526.246.391.391,0,0,1-.007.248C430.15,43.942,429.98,44.032,429.755,43.889Z",
    transform: "translate(-406.273 -38.492)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M430.637,42.745a.555.555,0,0,1-.521.119q0-.159,0-.317c.156-.1.29-.259.507-.17h0A.279.279,0,0,1,430.637,42.745Z",
    transform: "translate(-407.141 -37.841)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M430.5,42.007l-.507.17c-.174-.231.193-.186.169-.34A.344.344,0,0,1,430.5,42.007Z",
    transform: "translate(-407.019 -37.471)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M431.953,41.063l-.017-.368c.256-.026.545.082.692-.281s.489-.4.827-.4h0c.213.3.242.591-.162.71-.3.088-.42.344-.63.513a.218.218,0,0,1-.222,0Z",
    transform: "translate(-408.456 -36.159)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M428.262,47.484c.382-.354.7-.88,1.348-.5.338.093.644.269.975.38.289.128.658.014.9.3a2.154,2.154,0,0,1-2.042-.156,1.407,1.407,0,0,1-.624.26.648.648,0,0,1-.345-.016A.356.356,0,0,1,428.262,47.484Z",
    transform: "translate(-405.803 -41.078)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M439.878,43.962c0,.112,0,.224,0,.336-.375.305.1.986-.515,1.187-.1-.117-.3-.037-.379-.194a3.491,3.491,0,0,0-.015-.9,2.082,2.082,0,0,1,.059-.449C439.32,43.735,439.6,43.893,439.878,43.962Z",
    transform: "translate(-413.536 -38.91)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M426.194,49.663l.34-.011a.41.41,0,0,1,.494.189c.267.424-.306.277-.333.5a2.919,2.919,0,0,1-1.115.028.563.563,0,0,1-.424-.227c-.048-.212.115-.278.245-.368a.986.986,0,0,1,.219-.086A3.7,3.7,0,0,1,426.194,49.663Z",
    transform: "translate(-403.554 -43.075)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M426.474,51.547a2.026,2.026,0,0,1,1.178.167c0,.056,0,.113,0,.17a.562.562,0,0,1-.247.169C427.011,52.039,426.44,52.358,426.474,51.547Z",
    transform: "translate(-404.511 -44.446)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M429.932,52.774l.164-.008.509,0q0,.17,0,.341a.5.5,0,0,1-.65.045A.262.262,0,0,1,429.932,52.774Z",
    transform: "translate(-406.959 -45.329)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M430.631,49.48l-.494-.189c.177-.24.427-.141.655-.146A.323.323,0,0,1,430.631,49.48Z",
    transform: "translate(-407.157 -42.714)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M437.034,48.649a.351.351,0,0,1,.33.168l-.154.012c-.337-.059-.714.135-1.013-.165A.569.569,0,0,1,437.034,48.649Z",
    transform: "translate(-411.533 -42.243)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M434.375,40.743c.182-.3.1-.862.757-.68.136.038.041-.327.084-.5a1.371,1.371,0,0,1,.843-.17c.083.547-.358.891-.506,1.349A.83.83,0,0,1,434.375,40.743Z",
    transform: "translate(-410.218 -35.71)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M433.924,44.2H435.1a.457.457,0,0,0,.161,0c.153.108.2.223.019.351l-.123.031c-.484.041-1.03.522-1.405-.2q0-.067,0-.135Z",
    transform: "translate(-409.766 -39.166)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M481.2,81.217c.35.626-.2,1.252,0,1.878.08.173-.009.417.223.525,1.07.332,1.12.428.77,1.518a2.271,2.271,0,0,0-.092.485,1.919,1.919,0,0,1-.029.249,1.222,1.222,0,0,1-1.4,1.031,6.426,6.426,0,0,0-.75.021c-.866.052-1.077-.216-.882-1.086a4.016,4.016,0,0,1,.737-1.391c-.322.193-.418.562-.635.834a1.437,1.437,0,0,1-.256.23c-.215.156-.159.392-.17.608,0,.4-.014.8.007,1.191a1.346,1.346,0,0,1-.716,1.486.565.565,0,0,0-.378.678,1.791,1.791,0,0,1-.248,1.221,14.109,14.109,0,0,0-.48,1.407c-.627.4-.485-.361-.758-.511-.209.094-.126.336-.229.485a.547.547,0,0,1-.155.18c-.83.246-.867.225-.857-.6a4.336,4.336,0,0,1,.066-1.341c.2-.572-.07-.751-.537-.846a28.094,28.094,0,0,0-.781-2.984.686.686,0,0,1,.35-.642,1.985,1.985,0,0,1,1.075-.409c.268,0,.5-.071.565-.379a12.9,12.9,0,0,0,.95-3.2,8.265,8.265,0,0,0-.672,2.468c.028.551-.489.536-.879.3a2.131,2.131,0,0,1-1.146-1.858c-.012-.412.045-.864-.31-1.189-.41.121-.223.469-.248.714a6.6,6.6,0,0,1-.126,1.606,1.781,1.781,0,0,0-.242,1.065,7.665,7.665,0,0,1-.625,2.01c-.123.244-.2.565-.6.416-.1-.462-.13-.935-.212-1.4-.012-.414.005-.828-.01-1.242-.009-.246.019-.513-.295-.61a.888.888,0,0,1-.194-.146.747.747,0,0,1-.061-.726c.47-1.168.193-1.5-.961-2.107a1.817,1.817,0,0,1,.836,2.26,1.686,1.686,0,0,0,.086.748,5.094,5.094,0,0,1-.182,2.534.606.606,0,0,1-.84-.079,7.4,7.4,0,0,1-1.685-1.967,1.966,1.966,0,0,0-.575-.707.956.956,0,0,1-.169-.509,8.323,8.323,0,0,0-.057-1.047c-.148-.4-.6-.24-.843-.468-.169-.157-.344-.306-.3-.565.04-.239.243-.3.437-.329a1,1,0,0,0,.9-.516,2.2,2.2,0,0,1,1.052-.464,4.077,4.077,0,0,0,.824-.349,1.112,1.112,0,0,1,.911.068,1.775,1.775,0,0,0,2.695-.093h0a3.338,3.338,0,0,1,3.131.481c.357.309.926.051,1.382.178a5.23,5.23,0,0,1,.886.2h0c.363.56.931.438,1.461.447C480.373,81.077,480.825,80.945,481.2,81.217Z",
    transform: "translate(-433.256 -64.559)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M541.177,92.336c.016.346.261.344.506.342a10.262,10.262,0,0,0,1.856,1.707c.359.1.742.186.487.715a.555.555,0,0,1-.148.19c-.437.143-.648-.4-1.054-.355A1.58,1.58,0,0,1,541.641,94a1.96,1.96,0,0,0-1.794-1.185c-.243,0-.509.077-.707-.149-.073-.2.047-.419-.06-.616a.479.479,0,0,1,0-.315l.072-.08Z",
    transform: "translate(-485.807 -73.288)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M519.222,90.212c-.643-.17-.027-.341,0-.512a7.317,7.317,0,0,0,1.75-.707c.789-.583,1.535-.121,2.3-.106,0,0,0,.2,0,.3l-.091.094a1.832,1.832,0,0,1-.972.141,3.1,3.1,0,0,0-2.236.685C519.77,90.278,519.507,90.431,519.222,90.212Z",
    transform: "translate(-471.276 -71.165)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M535.564,84.568c-.507.695.107,1.162.338,1.708h0c-.549.287-1.041.343-1.35-.341v0c.41.037.546-.186.5-.559a3.389,3.389,0,0,1,.171-1.147C535.581,84.1,535.695,84.207,535.564,84.568Z",
    transform: "translate(-482.555 -67.911)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M536.7,82.856a.309.309,0,0,0-.337-.341c.151-.244-.539-.415-.076-.649.195-.1.563-.132.667.122C537.075,82.284,537.236,82.706,536.7,82.856Z",
    transform: "translate(-483.691 -66.198)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M516.473,84.176h-1.35c.1-.239.008-.674.506-.512.236.285.56.128.844.171Z",
    transform: "translate(-468.526 -67.519)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M559.077,98.914a.747.747,0,0,0,.431.9c.574.137.668.566.843,1.009-.5.4-.888.123-1.273-.2-.189-.42-.791-.491-.845-1.025A.657.657,0,0,1,559.077,98.914Z",
    transform: "translate(-499.658 -78.499)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M556.041,101.372c.235.38,1.033.287.845,1.025h0a.667.667,0,0,1-.616.161,1.805,1.805,0,0,1-.733-.5c.192-.382-.092-.523-.338-.683Z",
    transform: "translate(-497.464 -80.276)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M411.883,55.627c.036-.3-.075-.619.1-.909a.991.991,0,0,0,1.751-.268c.269-.608.66-.693,1.19-.361a.241.241,0,0,1,.053.24,3.577,3.577,0,0,1-.615,1.151,3.75,3.75,0,0,1-2.471.153Z",
    transform: "translate(-393.974 -46.142)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M407.506,40.373c-.2-.468-.581-.615-1.223-.466a4.672,4.672,0,0,0,.55-2.948c.936-.09.8.686.619,1.056a1.958,1.958,0,0,0,.039,2.025C407.54,40.125,407.5,40.261,407.506,40.373Z",
    transform: "translate(-389.932 -33.959)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M418.1,49.52c-.441-.059-.915.173-1.324-.156.014-.079.184-.1.12-.155s-.2.041-.3-.024l-.165,0a.427.427,0,0,1-.105-.456,1.245,1.245,0,0,1,1.792-.154,1.712,1.712,0,0,1,.1.766A.3.3,0,0,1,418.1,49.52Z",
    transform: "translate(-397.164 -42.091)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M415.875,47.374q0,.255,0,.51l-.341.008h0c0-.028,0-.055,0-.083,0-1.488.3-1.656,1.687-.945-.123.3-.341.15-.547.135C416.351,46.974,416.02,46.988,415.875,47.374Z",
    transform: "translate(-396.613 -40.793)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M416.748,48.167c-.006-.377-.064-.767.554-.54a.838.838,0,0,0,.793.029l.342-.006.1.07a.469.469,0,0,1,.1.446.152.152,0,0,1-.206.007A1.83,1.83,0,0,0,416.748,48.167Z",
    transform: "translate(-397.486 -41.585)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M413.847,51.561c-.034.278.113.669-.388.658a.257.257,0,0,1-.262-.266c-.012-.508.375-.359.65-.393Z",
    transform: "translate(-394.924 -44.462)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M417.36,51.124a1.429,1.429,0,0,1,1.213-.062c-.384.346-.731.19-1.034.24Z",
    transform: "translate(-397.931 -44.03)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M423.5,46.7v.337a.473.473,0,0,1-.676.01l0-.016C422.886,46.577,423.239,46.734,423.5,46.7Z",
    transform: "translate(-401.876 -40.967)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M422.771,52.048c.008-.054.016-.108.022-.162a.388.388,0,0,1,.383-.091.379.379,0,0,1,.146.589.266.266,0,0,1-.371.019Z",
    transform: "translate(-401.838 -44.62)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M422.98,53.978l.342-.008.068.1a.306.306,0,0,1-.134.318.354.354,0,0,1-.446-.08c0-.056,0-.112,0-.169Z",
    transform: "translate(-401.867 -46.195)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M379.473,31.242v.341a.316.316,0,0,1-.326-.382c.013-.209.145-.279.325-.3C379.46,31.015,379.287,31.128,379.473,31.242Z",
    transform: "translate(-370.337 -29.608)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M561.276,246.929c.5-.119,1.147.385,1.511-.349-.027.4.686.341.5.835-.49-.015-.979-.027-1.468-.048C561.541,247.354,561.242,247.349,561.276,246.929Z",
    transform: "translate(-501.852 -184.677)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M566.105,252.429l0,.34h-.943C565.626,251.956,565.658,251.948,566.105,252.429Z",
    transform: "translate(-504.658 -188.65)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M559.859,252.708h-1.01c.031-.162.068-.324.092-.488.039-.255.229-.208.375-.171.181.045.369.054.119.354C559.3,252.571,559.808,252.458,559.859,252.708Z",
    transform: "translate(-500.101 -188.588)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M556.338,249.044q0,.6-.008,1.209c-.84-.209-.39-.737-.285-1.179a.549.549,0,0,1,.114-.219l.122-.013.091.083Z",
    transform: "translate(-497.921 -186.304)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M558.04,247.62l.183,0a.335.335,0,0,1,.155.353.954.954,0,0,1-.839.02h0c-.085-.274.139-.3.3-.385A.2.2,0,0,1,558.04,247.62Z",
    transform: "translate(-499.14 -185.397)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M557.6,248.984l.839-.02c-.224.308-.543.14-.823.168C557.607,249.083,557.6,249.033,557.6,248.984Z",
    transform: "translate(-499.197 -186.391)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M597.837,167.993h1.351c-.442.724-1.138.158-1.687.341h0a.293.293,0,0,1-.024-.368A.275.275,0,0,1,597.837,167.993Z",
    transform: "translate(-527.955 -128.117)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M597.812,166.21h-.337a.3.3,0,0,1-.07-.317.555.555,0,0,1,.149-.174c.3-.129.559-.444.933-.194h.675C598.782,165.9,598.158,165.771,597.812,166.21Z",
    transform: "translate(-527.931 -126.334)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M570.894,114.685c.527-.06.988-.023,1.2.6a.526.526,0,0,0,.569.416c.53-.086.881.256,1.267.518.11.172.086.434.337.511.172.61-.419.7-.676,1.024-.126-.094-.254-.185-.259-.366s0-.356-.2-.421c-1.016-.34-1.336-1.466-2.2-1.983A.227.227,0,0,1,570.894,114.685Z",
    transform: "translate(-508.775 -89.833)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M585.9,112.116c.225-.006.45-.165.674,0-.105.129-.289.249-.3.388a5.706,5.706,0,0,1-1.567,3.4c-.049.051.008.2.016.31-.063.156-.158.248-.337.171-.1-.33-.427-.3-.687-.408C584.75,115.685,585.893,113.666,585.9,112.116Z",
    transform: "translate(-518.041 -87.946)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M568.9,113.862c1,.491,1.27,1.834,2.455,2.132.263.066.341.359.077.6-.329.239-.494-.107-.73-.2a3.345,3.345,0,0,1-1.235-1.248c-.32-.442-.854-.612-1.225-.989a.567.567,0,0,1-.126-.2.666.666,0,0,1-.013-.237.4.4,0,0,1,.125-.2C568.456,113.618,568.6,113.885,568.9,113.862Z",
    transform: "translate(-506.778 -89.009)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M558.59,105.02h.676c-.013.381.092.648.534.685.61.051.848.435.816,1.024-.676.247-.982-.337-1.413-.641-.159-.162-.314-.327-.485-.476a.646.646,0,0,1-.221-.391A.284.284,0,0,1,558.59,105.02Z",
    transform: "translate(-499.847 -82.899)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M581.843,115.523c-.148.033-.3.234-.443.036s.045-.368.106-.547a4.225,4.225,0,0,0,1.012-1.877.449.449,0,0,1,.674,0A12.8,12.8,0,0,0,581.843,115.523Z",
    transform: "translate(-516.348 -88.622)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M573.97,127.244a.39.39,0,0,1-.164.377,1.5,1.5,0,0,1-1.212.127.844.844,0,0,1-.353-.214.6.6,0,0,1-.16-.368c.246-.419.6-.215.934-.172a2.537,2.537,0,0,1,.867.156Z",
    transform: "translate(-509.657 -98.635)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M573.2,129.276l1.349.048c0,.04,0,.08-.005.119a.246.246,0,0,1-.007.36l-.163,0c-.274-.129-.462.254-.736.127a.787.787,0,0,1-.506-.308A.313.313,0,0,1,573.2,129.276Z",
    transform: "translate(-510.395 -100.338)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M577.143,123.241l.674.341.168.341c-.474,0-.22.545-.506.684h0c-.11-.135-.38-.052-.405-.3a2.235,2.235,0,0,0-.007-.63C577.083,123.529,576.731,123.315,577.143,123.241Z",
    transform: "translate(-513.167 -95.999)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M585.357,110.863h-.338c-.085-.4-.465-.556-.674-.853C585.286,109.665,585.35,109.719,585.357,110.863Z",
    transform: "translate(-518.513 -86.352)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M560.96,108.065a2.6,2.6,0,0,0,1.349.853q0,.169,0,.338l-.087.084a.532.532,0,0,1-.468-.01c-.332-.283-.732-.5-.912-.934A.372.372,0,0,1,560.96,108.065Z",
    transform: "translate(-501.539 -85.088)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M578.243,129.263c0-.12,0-.24.007-.359a3.377,3.377,0,0,0,1.521-.328.151.151,0,0,1,.2-.022.167.167,0,0,1-.033.207A6.622,6.622,0,0,1,578.243,129.263Z",
    transform: "translate(-514.106 -99.797)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M583.912,127.422l-.172-.024a.921.921,0,0,1,.674-.34l.337-.171c.263.035.618-.118.674.339-.283.3-.681.09-1,.23A.754.754,0,0,1,583.912,127.422Z",
    transform: "translate(-518.075 -98.62)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M584.3,110.485c.336.194.964.153.674.853h-.336C584.622,111.015,584.186,110.86,584.3,110.485Z",
    transform: "translate(-518.465 -86.828)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M566.591,112.639l0,.174a.633.633,0,0,1-.716-.151.306.306,0,0,1,.041-.361l0,0A.6.6,0,0,1,566.591,112.639Z",
    transform: "translate(-505.143 -88.129)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M591.243,220.237q0,.083-.005.166c-.408-.1-.636.34-1.01.34a.324.324,0,0,1-.035-.363.856.856,0,0,1,.74-.469C591.1,219.954,591.294,219.978,591.243,220.237Z",
    transform: "translate(-522.706 -165.503)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M588.352,224.665a.549.549,0,0,1,.346.525c.127.2.051.326-.144.41a.473.473,0,0,1-.452-.227.727.727,0,0,1-.079-.393C588.069,224.809,588.1,224.615,588.352,224.665Z",
    transform: "translate(-521.167 -168.915)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M589.662,226.881c.167-.047.206-.18.214-.332.247-.026.306.245.491.318.219-.066.254.07.256.241-.066.259-.283.168-.448.2a.762.762,0,0,1-.4-.144A.266.266,0,0,1,589.662,226.881Z",
    transform: "translate(-522.345 -170.275)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M587.116,223.872a.392.392,0,0,0-.181.362.42.42,0,0,1-.521.024.481.481,0,0,1-.043-.535.47.47,0,0,1,.736,0A1.366,1.366,0,0,0,587.116,223.872Z",
    transform: "translate(-519.931 -168.122)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M588.17,222.128c-.05-.01-.1-.018-.15-.025a.473.473,0,0,1-.223-.507.589.589,0,0,1,.626-.241l.093.074v.34Z",
    transform: "translate(-520.995 -166.529)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M595.3,222.912h.659c0,.113,0,.226.007.339C595.714,223.207,595.36,223.359,595.3,222.912Z",
    transform: "translate(-526.426 -167.661)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M592.406,227.679a.361.361,0,0,0-.186-.329c.138-.158.321-.132.5-.123a.508.508,0,0,0,.015.135l-.176.351A.091.091,0,0,1,592.406,227.679Z",
    transform: "translate(-524.199 -170.758)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M592.217,231.827c.171-.26.408-.493.344-.851a.279.279,0,0,1-.036-.351.145.145,0,0,1,.22.013l.136,0,.189.185A.969.969,0,0,1,592.217,231.827Z",
    transform: "translate(-524.196 -173.174)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M592.042,229.252l-.181.029a.37.37,0,0,1-.511-.536c.1-.19.234-.026.351-.035.05.013.1.024.152.033Z",
    transform: "translate(-523.494 -171.788)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M351.512,51.685l.318-.189a.312.312,0,0,1,.243.238,1.05,1.05,0,0,1-.57.888.309.309,0,0,1-.333-.089Z",
    transform: "translate(-350.135 -44.416)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M350.845,55.189l.331,0c.1.133.036.256-.025.378a.321.321,0,0,1-.156.122,1.169,1.169,0,0,0-.136.025C350.585,55.548,350.79,55.367,350.845,55.189Z",
    transform: "translate(-349.809 -47.071)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M353.72,50.856l-.175-.192q.014-.158.029-.315l.318-.01c0,.107,0,.213,0,.319C353.842,50.732,353.829,50.836,353.72,50.856Z",
    transform: "translate(-351.849 -43.584)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M567.9,233.078c-.848.016-1.469.731-2.313.775-.1.005-.125.126,0,.24.22.207.043.406-.107.53-.191.159-.279-.048-.376-.18a1.631,1.631,0,0,0-2.092-.512c-.157-.613.3-.6.66-.623a1.8,1.8,0,0,0,1.167-.293.406.406,0,0,1,.333,0c.14.129.249.329.488.254.15-.047.1-.171.08-.278a.937.937,0,0,1-.012-.341c.123-.47.508-.469.862-.451a1.022,1.022,0,0,0,.89-.324.267.267,0,0,1,.309.035c.121.121.226.267.422.27a1.39,1.39,0,0,0,.925-.151.555.555,0,0,1,.315-.083.52.52,0,0,1,.2.082,3.215,3.215,0,0,1,.315.312.661.661,0,0,1,.1.2.631.631,0,0,1-.136.534q0,.08,0,.159a2.931,2.931,0,0,1-1.009.18l0-.006c-.134-.185-.377-.146-.544-.265C568.222,233.031,568.1,232.819,567.9,233.078Z",
    transform: "translate(-503.082 -174.08)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M587.982,231.659q0-.341,0-.682c.364-.27.421-.738.676-1.079a.288.288,0,0,1,.339.057c.118.2.331.149.507.2,0,.1,0,.206,0,.309A9.089,9.089,0,0,1,587.982,231.659Z",
    transform: "translate(-521.138 -172.663)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M382.8,85.476l.3.19a.167.167,0,0,1,.2-.032c.134.3.183.642.464.859a1.492,1.492,0,0,1,.254.645c.055.268.28.475.276.765a.641.641,0,0,1-.26.537.551.551,0,0,1-.238.059,1.05,1.05,0,0,1-.672-.26c0-.444.02-.888-.005-1.33-.027-.472-.205-.06-.317-.041Q382.8,86.171,382.8,85.476Z",
    transform: "translate(-372.971 -68.847)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M384.631,96.232c-.233-.089-.508-.1-.662-.342q0-.083,0-.165c.284-.186.486.04.711.146A.3.3,0,0,1,384.631,96.232Z",
    transform: "translate(-373.819 -76.164)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M384.627,95.641l-.659-.173c0-.056,0-.112,0-.169.236.024.507-.086.682.18A.1.1,0,0,1,384.627,95.641Z",
    transform: "translate(-373.817 -75.908)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M381.675,81.724a.32.32,0,0,1-.305.182c-.061-.234-.228-.464-.02-.705a.571.571,0,0,1,.638.156C382.111,81.677,381.75,81.576,381.675,81.724Z",
    transform: "translate(-371.855 -65.742)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M382.245,80.4l-.631-.2c0-.057.007-.114.011-.17a.692.692,0,0,1,.328-.257.509.509,0,0,1,.214,0,.379.379,0,0,1,.214.459A.3.3,0,0,1,382.245,80.4Z",
    transform: "translate(-372.118 -64.735)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M381.813,79.424a.315.315,0,0,1-.316.173l-.059-.173c.008-.056.016-.112.024-.168l.028.021a.211.211,0,0,1,.16-.114.337.337,0,0,1,.19.076A.145.145,0,0,1,381.813,79.424Z",
    transform: "translate(-371.991 -64.308)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M382.155,78.513l.307-.322.015-.074c.216-.138.187-.336.128-.541-.111-.233-.357-.234-.549-.328a.3.3,0,0,1-.142-.191.313.313,0,0,1,.144-.2,3.32,3.32,0,0,1,.888-.064c.287-.067.6.073.872-.095a.383.383,0,0,1,.353.1l0,0c.22.269-.077.458-.1.686,0,.107-.041.257.163.148.118-.279.639-.038.613-.495.034-.287.149-.576.459-.327.354.283.916.546.831,1.065a1.352,1.352,0,0,1-.957.957,1.156,1.156,0,0,1-.333.013c-.433.069-.509.366-.462.742a1.107,1.107,0,0,1-.139.6.322.322,0,0,1-.328.094c-.229-.123-.36-.39-.635-.447a1.364,1.364,0,0,1-.509-.446c-.145-.227-.108-.529-.3-.737Z",
    transform: "translate(-372.335 -62.531)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M383.89,83.675a.63.63,0,0,1,.341.712l-.056.051-.069-.032-.233-.035Q383.881,84.023,383.89,83.675Z",
    transform: "translate(-373.75 -67.552)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M432.827,118.682l-.19,0a.268.268,0,0,1-.22-.047.632.632,0,0,1-.184-.55.4.4,0,0,1,.249-.242.684.684,0,0,1,.457.024,2.623,2.623,0,0,0,.481.271.7.7,0,0,1,.467.469.2.2,0,0,1-.072.2q-.065,0-.129.013l-.7-.143A.113.113,0,0,1,432.827,118.682Z",
    transform: "translate(-408.665 -92.1)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M437.946,120.315a1.348,1.348,0,0,1,.018-.152.761.761,0,0,1,.51-.257.508.508,0,0,1,.236.05.524.524,0,0,1,.215.3c0,.212.044.457-.295.435Z",
    transform: "translate(-412.796 -93.601)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M440.409,121.043c.215-.121.179-.32.157-.515a.338.338,0,0,1,.567.043.691.691,0,0,1-.369.787l-.338-.172C440.421,121.138,440.416,121.09,440.409,121.043Z",
    transform: "translate(-414.575 -93.952)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M434.391,120.844a.173.173,0,0,1,.161,0,.325.325,0,0,1-.021.128Z",
    transform: "translate(-410.229 -94.262)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M441.684,116.89l.329-.676c.143-.161.143-.408.322-.548a.28.28,0,0,1,.21.008c.108.114.212.269.364.045a.972.972,0,0,1,.155-.149c.256-.131.285-.416.417-.632.2-.209.183-.557.461-.711a.591.591,0,0,1,.64.108,1.537,1.537,0,0,1-.128,1.741,6.286,6.286,0,0,0-.505.379,10.6,10.6,0,0,1-.8.707.553.553,0,0,1-.463-.073c-.288.23-.564-.016-.846-.023Z",
    transform: "translate(-415.496 -89.485)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M428.548,119.526l-.313.129a.387.387,0,0,1-.485.122.419.419,0,0,1-.228-.461.649.649,0,0,1,.851-.244C428.529,119.184,428.662,119.307,428.548,119.526Z",
    transform: "translate(-405.261 -92.957)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M427.8,121.331l.514-.023-.007.515-.471-.017-.193-.289C427.579,121.357,427.651,121.311,427.8,121.331Z",
    transform: "translate(-405.339 -94.609)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M430.718,119.387l-.149-.351a.124.124,0,0,1-.051-.117c.008-.044.017-.065.029-.065a1.075,1.075,0,0,1,.516-.012l.178.494c0,.033,0,.065,0,.1a1.79,1.79,0,0,0-.168.1l-.019.019Z",
    transform: "translate(-407.431 -92.818)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M433.033,120.666l.163.067-.157.143.005.005q-.061-.053-.04-.105c.014-.035.028-.052.041-.052Z",
    transform: "translate(-409.224 -94.148)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M432.712,120.873c0,.052,0,.1,0,.157l-.174-.019Z",
    transform: "translate(-408.89 -94.297)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M452.9,125.482c-.512.345-1.023-.006-1.534,0l.02-.04c-.036-.293.193-.356.381-.456a2.444,2.444,0,0,1,.908-.062.733.733,0,0,1,.564.306.2.2,0,0,1-.04.243Z",
    transform: "translate(-422.483 -97.199)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M457.96,125.509c.007-.052.013-.1.016-.156-.065-.35.218-.317.411-.384a1.141,1.141,0,0,1,.266,0,.686.686,0,0,1,.364.15.308.308,0,0,1,0,.369c-.19.113-.189.293-.166.481C458.567,125.785,458.1,125.98,457.96,125.509Z",
    transform: "translate(-427.248 -97.236)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M448.614,124.344l-.323.345-.35,0c-.137-.516-.564-.239-.859-.321.006-.437.4-.325.624-.455a1.363,1.363,0,0,1,.367-.053.669.669,0,0,1,.544.252A.225.225,0,0,1,448.614,124.344Z",
    transform: "translate(-419.393 -96.446)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M446.477,124.092c-.155.259-.529.054-.677.327a1.219,1.219,0,0,0-.166.014l-.167-.028-.16-.3.505-.041a.494.494,0,0,1,.582-.063Z",
    transform: "translate(-418.112 -96.495)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M423.033,115.5c-.133-.207-.243.029-.367.018-.018-.171-.025-.347-.193-.453a.413.413,0,0,1,.024-.575v-.045a.371.371,0,0,1,.3-.076,1.293,1.293,0,0,1,.393.185.619.619,0,0,1,.24.357.65.65,0,0,1-.011.218.937.937,0,0,1-.2.38A.146.146,0,0,1,423.033,115.5Z",
    transform: "translate(-401.548 -89.616)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M421.94,114.785q-.012.288-.025.576c-.359-.066-.349-.313-.283-.588Z",
    transform: "translate(-400.99 -89.911)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M424.621,109.879l.183-.812a.347.347,0,0,1,.4-.1c.573.547.569.662-.037,1.1A.567.567,0,0,1,424.621,109.879Z",
    transform: "translate(-403.174 -85.717)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M423.8,112.211l.522.007c.193.417-.122.629-.346.877-.137-.022-.288-.017-.35-.184a.587.587,0,0,1-.123-.537.441.441,0,0,1,.122-.19Z",
    transform: "translate(-402.357 -88.05)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M424.623,107.875l-.344.005-.348-.194a.176.176,0,0,1,.028-.246,1.122,1.122,0,0,1,1.062-.031.329.329,0,0,1,.141.227A.365.365,0,0,1,424.623,107.875Z",
    transform: "translate(-402.649 -84.532)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M421.878,107.321c0,.048,0,.1-.005.144l-.83.157q0-.245,0-.49c.224-.237.454-.147.685-.013A.391.391,0,0,1,421.878,107.321Z",
    transform: "translate(-400.59 -84.31)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M422.272,110.638l-.226-.327c.114-.141.209-.375.43-.269.254.122.089.383.11.583v.021A.184.184,0,0,1,422.272,110.638Z",
    transform: "translate(-401.315 -86.491)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M419.869,104l-.174-.174a.8.8,0,0,1-.256-.773c.161-.259.412-.138.632-.153.276.1.37.362.514.581a.441.441,0,0,1-.168.412A.678.678,0,0,1,419.869,104Z",
    transform: "translate(-399.418 -81.363)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M417.142,105.66l-.482.016a.827.827,0,0,1-.273-.648.345.345,0,0,1,.184-.288.457.457,0,0,1,.433.117.388.388,0,0,1,.137.309Z",
    transform: "translate(-397.228 -82.685)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M421.037,106.182l.494-.177a.311.311,0,0,1,.3-.076.305.305,0,0,1,.137.159.473.473,0,0,1-.01.214c-.051.105-.156.14-.249.189l-.663-.125C421.041,106.305,421.039,106.244,421.037,106.182Z",
    transform: "translate(-400.586 -83.546)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M418.654,104.095l-.171-.178c.043-.264-.1-.623.342-.684l.194.843Z",
    transform: "translate(-398.742 -81.614)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M422.843,112.231l.315.008q0,.353,0,.706l-.321-.033Q422.839,112.572,422.843,112.231Z",
    transform: "translate(-401.885 -88.083)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M413.063,107.9h-.353l-.331-.009a1.153,1.153,0,0,1-.363.019c-.264-.064-.475-.169-.376-.508a1.017,1.017,0,0,1,.661-.263.827.827,0,0,1,.464.1.5.5,0,0,1,.289.356l.182.287Z",
    transform: "translate(-393.781 -84.42)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M412.961,109.3l.16.15q-.012.344-.025.689h-.323a.494.494,0,0,1,.008-.674A1.832,1.832,0,0,1,412.961,109.3Z",
    transform: "translate(-394.525 -85.974)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M415.709,106.4l-.36-.241a.541.541,0,0,1,.125-.66.179.179,0,0,1,.213.029,1.035,1.035,0,0,1,.183.689Z",
    transform: "translate(-396.438 -83.227)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M407.688,110.154l-.664-.009c.075-.327-.821-.154-.345-.687a.5.5,0,0,1,.21-.13.654.654,0,0,1,.482.075C407.562,109.616,407.793,109.813,407.688,110.154Z",
    transform: "translate(-390.117 -85.985)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M404.953,108.2l-.176.022c-.257-.175-.562-.1-.841-.163a1.173,1.173,0,0,0-.031-.168.809.809,0,0,0,.028-.167c.164-.17.394-.037.575-.127a.66.66,0,0,1,.244.016C404.959,107.756,405.373,107.831,404.953,108.2Z",
    transform: "translate(-388.216 -84.745)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M409.8,110.11c-.092-.238-.361-.387-.334-.684a.523.523,0,0,1,.368-.175,6.848,6.848,0,0,1,.8.16l-.158.693q0,.164,0,.329C410.181,110.482,410.036,110.2,409.8,110.11Z",
    transform: "translate(-392.231 -85.941)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M381.654,76.455a1.284,1.284,0,0,1,0,.139l-.071.08-.091-.055q-.011-.156-.022-.313c.131-.183.208-.514.525-.2C382.109,76.447,381.73,76.3,381.654,76.455Z",
    transform: "translate(-372.014 -62.016)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M381.13,78.424l-.146-.162c.053,0,.1-.008.157-.013l.01-.006A.115.115,0,0,1,381.13,78.424Z",
    transform: "translate(-371.664 -63.646)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M381.51,78.376c.007-.06.014-.12.021-.18a.835.835,0,0,0,.151-.019l.179.038a.139.139,0,0,1,.047.166c-.056.085-.158.1-.232.16a.727.727,0,0,0-.136.027Z",
    transform: "translate(-372.043 -63.599)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M366.961,67.34a1.394,1.394,0,0,1,.842.17l-.193.193-.658-.02Q366.956,67.512,366.961,67.34Z",
    transform: "translate(-361.531 -55.804)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M426.085,119.854l-.157.187-.675.008a1.034,1.034,0,0,1,.165-.687l.065-.076a.411.411,0,0,1,.195-.031.434.434,0,0,1,.177.091.35.35,0,0,1,.086.18Z",
    transform: "translate(-403.625 -93.132)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M424.759,118.133a.71.71,0,0,1,.094,0,.311.311,0,0,1,.276-.1.283.283,0,0,1,.157.124.247.247,0,0,1-.044.193l-.182.095.006.037A.536.536,0,0,1,424.759,118.133Z",
    transform: "translate(-403.274 -92.249)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M353.4,59.8l.348-.056a3.52,3.52,0,0,1,1.045-.111c.359.373.013.4-.228.469l-.128.024-.691.008-.342-.064A.173.173,0,0,1,353.4,59.8Z",
    transform: "translate(-351.7 -50.265)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M352.29,60.177c0,.09,0,.18,0,.27l-.33.051c-.055-.012-.109-.021-.164-.029C351.8,60.1,352.054,60.15,352.29,60.177Z",
    transform: "translate(-350.589 -50.644)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M356.787,62.4c-.02-.13-.277-.209-.153-.318.1-.089.32-.039.486-.051a.615.615,0,0,1,.625-.142.386.386,0,0,1,.271.272c-.048.223-.088.455-.4.4l-.08,0-.078.02A.83.83,0,0,0,356.787,62.4Z",
    transform: "translate(-354.056 -51.869)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M361.182,64.622l-.163.186-.5,0-.155-.355C360.673,64.33,361.008,64.087,361.182,64.622Z",
    transform: "translate(-356.774 -53.614)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M361.093,63.452c-.234-.247-.544-.124-.818-.173q-.02-.072-.034-.144l.347-.352a.345.345,0,0,1,.314-.12.372.372,0,0,1,.2.122c.12.192.317.158.5.174,0,.1,0,.208.007.312Z",
    transform: "translate(-356.685 -52.444)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M374.26,71h.672a.287.287,0,0,1,0,.393.57.57,0,0,1-.669-.05Z",
    transform: "translate(-366.808 -58.437)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M374.265,72.216h.671a.23.23,0,0,1,0,.338l-.005.007-.664-.167Q374.267,72.3,374.265,72.216Z",
    transform: "translate(-366.812 -59.312)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M391.294,104.668c-.152.325-.471.007-.663.177a2.092,2.092,0,0,1-.672.005l-.332.019a.5.5,0,0,1-.4-.215.444.444,0,0,1,.226-.233,7.542,7.542,0,0,0,.755-.089,2.174,2.174,0,0,1,.474-.029C390.939,104.331,391.193,104.368,391.294,104.668Z",
    transform: "translate(-377.614 -82.381)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M391.867,105.973a.577.577,0,0,1,.672-.005.362.362,0,0,1-.335.175A.376.376,0,0,1,391.867,105.973Z",
    transform: "translate(-379.522 -83.504)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M386.39,102.524c-.074-.4.221-.534.49-.683a.188.188,0,0,1,.212-.012,1.013,1.013,0,0,1,.215.537.576.576,0,0,1-.264.488C386.748,102.9,386.614,102.621,386.39,102.524Z",
    transform: "translate(-375.559 -80.584)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M388.769,103.441l.181-.491c-.1-.123-.1-.3.032-.325.254-.043.258.185.266.372a.377.377,0,0,1-.133.227l-.219.222-.064,0Z",
    transform: "translate(-377.285 -81.172)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M358.263,61.2l-.672-.005-.327-.3-.012-.049c.207-.109.451-.039.659-.144C358.2,60.746,358.67,60.66,358.263,61.2Z",
    transform: "translate(-354.526 -51.033)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M406.433,103.348l.169-.853c.269-.3.72-.173,1-.442a.756.756,0,0,1,.6-.016c.349.234.052.583.151.863a.5.5,0,0,1-.258.38,1.961,1.961,0,0,1-.809.1c-.074,0-.148,0-.222,0-.18,0-.358.035-.539.017Z",
    transform: "translate(-390.04 -80.715)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M402.807,101.509l-.676,0a.272.272,0,0,1-.327.059.465.465,0,0,1-.14-.2.6.6,0,0,1,.138-.591.768.768,0,0,1,.353-.142,2.483,2.483,0,0,1,.763.018.709.709,0,0,1,.226.107.382.382,0,0,1,.084.345C403.161,101.322,402.928,101.355,402.807,101.509Z",
    transform: "translate(-386.579 -79.734)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M405.838,102.416a.308.308,0,0,1,.336-.339.776.776,0,0,1,.647-.189.546.546,0,0,1,.361.193c-.17.618-.675.221-1.009.34Z",
    transform: "translate(-389.611 -80.641)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M403.92,106.539l-.677.036c.046-.164-.558-.023-.155-.32.077-.056.266-.506.427-.077.134.36.271.045.4.054h0A.194.194,0,0,1,403.92,106.539Z",
    transform: "translate(-387.524 -83.599)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M402,103.8h.339c-.035.268.112.628-.339.684l0-.34A.243.243,0,0,1,402,103.8Z",
    transform: "translate(-386.784 -82.024)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M394.922,104.2l-.668-.173a.233.233,0,0,1,.086-.241,1.272,1.272,0,0,1,1.061-.037.431.431,0,0,1,.251.452q-.01.091-.019.182A1.02,1.02,0,0,1,394.922,104.2Z",
    transform: "translate(-381.242 -81.917)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M398.695,103.814l-.232-.306c.016-.463.368-.363.643-.4a.757.757,0,0,1,.391.194h0q0,.172,0,.344Z",
    transform: "translate(-384.285 -81.526)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M386.725,98.845l-.34-.173.013-.511c.067-.088.1-.2.205-.261a.473.473,0,0,1,.432.021.3.3,0,0,1,.1.193,1.377,1.377,0,0,1-.107.431A.559.559,0,0,1,386.725,98.845Z",
    transform: "translate(-375.564 -77.749)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M386.525,96.457l-.158.16c-.007-.115-.015-.23-.022-.345s0-.223,0-.334q.013-.08.021-.162l.161-.012a.145.145,0,0,1,.207-.02.475.475,0,0,1,.086.348C386.794,96.273,386.641,96.349,386.525,96.457Z",
    transform: "translate(-375.533 -76.204)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M387.607,99.839l.176-.347c.155-.216.318-.388.562-.1a.492.492,0,0,1,.024.237.538.538,0,0,1-.425.379l-.176-.008Z",
    transform: "translate(-376.446 -78.743)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M376.683,71.676l0-.338V71c.3-.027.321.491.676.341q0,.256,0,.511C377.058,72.077,376.935,71.621,376.683,71.676Z",
    transform: "translate(-368.555 -58.435)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M356.077,53.88c0-.056,0-.112-.005-.168a.723.723,0,0,1-.169-.271c-.492-.785-.342-1.231.515-1.541.425.186.808-.1,1.209-.148a2.281,2.281,0,0,1,1.216.1c.268.369.15.594-.256.713a2,2,0,0,0-.883,1.089c-.129.311-.268.61-.69.522C356.746,53.93,356.37,54.042,356.077,53.88Z",
    transform: "translate(-353.351 -44.574)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M353.246,56.5q0,.167,0,.335l-1.351.005-.185-.523c.012-.05.022-.1.03-.151.238-.2.479-.071.721-.012C352.708,56.294,352.99,56.367,353.246,56.5Z",
    transform: "translate(-350.522 -47.694)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M355.5,59.283c.252.186.648-.328.835.176a.283.283,0,0,1-.163.108.294.294,0,0,1-.186-.058l-1.164-.055C355,59.21,355.265,59.321,355.5,59.283Z",
    transform: "translate(-352.769 -49.977)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M476.759,140.242c.056,0,.111,0,.167,0a.618.618,0,0,1,.286.565c.015.333.284.225.465.27a1.051,1.051,0,0,1,.463.12.411.411,0,0,1,.184.321c-.145.249-.337.216-.544.094-.821.489-1.207-.021-1.527-.681l.337-.344C476.487,140.389,476.455,140.23,476.759,140.242Z",
    transform: "translate(-440.459 -108.22)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M481.733,144.473c.183-.012.384.03.505-.169.24-.164.4-.061.526.16-.123.212-.341.171-.532.2l-.506-.041A1.02,1.02,0,0,1,481.733,144.473Z",
    transform: "translate(-444.41 -111.085)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M504.175,180.3a10.032,10.032,0,0,0-1,.009c-.477.049-.39-.244-.351-.525a.269.269,0,0,1-.044-.228c.187-.274.177-.75.69-.693.264.169.364.488.606.678.093.124.2.246.1.419Q504.177,180.133,504.175,180.3Z",
    transform: "translate(-459.605 -135.989)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M515.719,182.3a.447.447,0,0,1-.5,0c-.322-.233-1.095.009-.85-.823a.173.173,0,0,1,.177-.077,6.4,6.4,0,0,0,.672.277c.206.144.439.259.539.516Z",
    transform: "translate(-467.946 -137.814)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M513.244,179.424a.509.509,0,0,0-.164.024c-.142-.026-.292-.038-.364-.2-.168-.17-.258-.352-.085-.574a.6.6,0,0,1,.625-.028c.211.166.419.334.406.645C513.57,179.493,513.436,179.556,513.244,179.424Z",
    transform: "translate(-466.66 -135.784)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M511.285,179.07c.061.16.161.313.092.5l-.135.162a.377.377,0,0,1-.451.086c-.178-.133-.1-.285-.031-.436a.926.926,0,0,1,.314-.352A.2.2,0,0,1,511.285,179.07Z",
    transform: "translate(-465.32 -136.099)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M510.435,181.458l.506,0a.315.315,0,0,1-.377.332c-.207-.012-.278-.144-.3-.327A.11.11,0,0,1,510.435,181.458Z",
    transform: "translate(-465.02 -137.831)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M509.341,180.291l-.168.007h-.331a.312.312,0,0,1-.09-.237.291.291,0,0,1,.148-.207.489.489,0,0,1,.6.108Z",
    transform: "translate(-463.926 -136.663)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M507.741,180.753c0,.056.009.113.016.169a.314.314,0,0,1-.344.339l-.164-.341C507.356,180.694,507.5,180.574,507.741,180.753Z",
    transform: "translate(-462.84 -137.287)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M501.229,180.574q-.006.087-.011.175a.486.486,0,0,1-.624.024l-.045-.2.5-.335a.174.174,0,0,1,.216,0A.275.275,0,0,1,501.229,180.574Z",
    transform: "translate(-458.002 -136.952)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M520.2,183.731c-.276-.1-.618.095-.85-.2l.017,0a.658.658,0,0,1,.307-.4.453.453,0,0,1,.208-.011.793.793,0,0,1,.363.216.365.365,0,0,1,.026.313Z",
    transform: "translate(-471.582 -139.047)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M522.232,184.974c-.231.309-.568.144-.857.2-.053-.005-.107-.009-.16-.012l.333-.31,0-.05C521.821,184.663,522.1,184.536,522.232,184.974Z",
    transform: "translate(-472.926 -140.166)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M476.754,139.673a.369.369,0,0,0-.169.341h-.339a.587.587,0,0,1,.37-.559C476.734,139.41,476.744,139.573,476.754,139.673Z",
    transform: "translate(-440.454 -107.65)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M543.8,199.025c-.2.015-.135-.176-.2-.268l.328-.535a.388.388,0,0,1,.475-.041.3.3,0,0,1,.057.433A3.093,3.093,0,0,1,543.8,199.025Z",
    transform: "translate(-489.093 -149.835)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M545.349,195.772l.038-.212a.294.294,0,0,1,.2-.248.95.95,0,0,1,.642.18.356.356,0,0,1,.069.216.683.683,0,0,1-.218.4.388.388,0,0,1-.333.032C545.583,196.056,545.377,196.012,545.349,195.772Z",
    transform: "translate(-490.353 -147.814)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M541.778,194.213l-.328-.023a.53.53,0,0,1-.122-.581.368.368,0,0,1,.172-.173c.347-.044.521.195.692.437a.284.284,0,0,1-.093.332Z",
    transform: "translate(-487.423 -146.463)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M544.766,196.957l.386.275.052.1-.077.087-.517-.037C544.511,197.187,544.486,197.015,544.766,196.957Z",
    transform: "translate(-489.77 -148.999)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M544.027,194.335l-.006-.363a.281.281,0,0,1-.02-.314c.242-.141.322.077.443.2a.494.494,0,0,1,.1.315l-.158.163Z",
    transform: "translate(-489.351 -146.594)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M544.517,202.233l-.1-.722a.326.326,0,0,1,.355-.235.333.333,0,0,1,.187.126.62.62,0,0,1,.03.455.919.919,0,0,1-.236.39.149.149,0,0,1-.2-.031Z",
    transform: "translate(-489.682 -152.103)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M544.791,200.309l-.447.14-.029-.218a.443.443,0,0,1,.474-.434A.332.332,0,0,1,544.791,200.309Z",
    transform: "translate(-489.606 -151.041)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M540.81,193.634q0,.338,0,.676h-.341q-.005-.172-.011-.345a.173.173,0,0,1-.051-.132c0-.049.01-.073.02-.073C540.528,193.637,540.639,193.542,540.81,193.634Z",
    transform: "translate(-486.784 -146.584)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M525.538,184.283l-.176-.19a.5.5,0,0,1,.185-.587.539.539,0,0,1,.708.12.419.419,0,0,1,.03.25,1.019,1.019,0,0,1-.407.46A.32.32,0,0,1,525.538,184.283Z",
    transform: "translate(-475.897 -139.271)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M523.4,183.511l-.158.495h-.08l-.079-.013c-.183-.248-.462-.1-.688-.174q0-.157.01-.313a.55.55,0,0,1,.359-.193A.667.667,0,0,1,523.4,183.511Z",
    transform: "translate(-473.779 -139.184)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M526.078,186.059l.353-.048a.511.511,0,0,1,.466-.094.364.364,0,0,1,.183.158.321.321,0,0,1-.167.317C526.625,186.305,526.189,186.6,526.078,186.059Z",
    transform: "translate(-476.437 -141.047)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M532.434,185.823c-.2-.04-.355-.128-.336-.373,0-.034,0-.068.005-.1.064-.168.142-.317.362-.273a1.387,1.387,0,0,0,.45.214.494.494,0,0,1,.27.179.424.424,0,0,1-.007.346C532.934,186.13,532.685,186.028,532.434,185.823Z",
    transform: "translate(-480.783 -140.451)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M529.243,185.219l-.16-.06a.371.371,0,0,1,.267-.443c.317,0,.743-.131.562.474h0Z",
    transform: "translate(-478.6 -140.19)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M533.312,187.705c.225-.049.457.129.678-.02a.223.223,0,0,1,.006.327l-.016.015a.523.523,0,0,1-.335.137.4.4,0,0,1-.325-.15Z",
    transform: "translate(-481.661 -142.333)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M532.737,188.858l.322.01c.121.2-.07.237-.158.331l-.336,0C532.482,189.015,532.44,188.85,532.737,188.858Z",
    transform: "translate(-481.077 -143.176)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M535.755,186.883c0-.109,0-.218-.005-.328s0-.215,0-.322a.26.26,0,0,1,.289-.114,3.325,3.325,0,0,0,.505.24.79.79,0,0,1,.319.172c.1.152.2.3,0,.454a.672.672,0,0,1-.773-.089Z",
    transform: "translate(-483.42 -141.203)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M536.967,188.844l.843-.019a.263.263,0,0,1,.036.236.523.523,0,0,1-.282.243.555.555,0,0,1-.588-.128Z",
    transform: "translate(-484.3 -143.153)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M537.659,191.244l-.671-.008q0-.172,0-.343a.545.545,0,0,1,.607-.095.3.3,0,0,1,.135.337Z",
    transform: "translate(-484.315 -144.535)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M537.664,190.41l-.666,0q0-.168,0-.336l.669.017A.233.233,0,0,1,537.664,190.41Z",
    transform: "translate(-484.322 -144.049)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M533.934,189.224l.158-.331.338,0C534.423,189.252,534.166,189.219,533.934,189.224Z",
    transform: "translate(-482.11 -143.202)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M540.085,192.452l-.34.17c-.167-.057-.209-.242-.338-.34,0-.057,0-.114,0-.171l0-.005a.535.535,0,0,1,.609-.1.3.3,0,0,1,.15.205.328.328,0,0,1-.082.243Z",
    transform: "translate(-486.059 -145.402)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M539.42,193.125a.308.308,0,0,1,.338.339c0,.054-.008.108-.012.162h-.326Z",
    transform: "translate(-486.072 -146.244)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M560.663,216.848h-.341a.25.25,0,0,1-.319.042c-.135-.258.087-.331.225-.448a3.162,3.162,0,0,0,.357-.222c.173-.127.125-.4.329-.509.246-.1.515-.118.767-.2a2.719,2.719,0,0,1,.593-.07,2.348,2.348,0,0,1,.243,0,1.609,1.609,0,0,1,.484.073c.117.055.209.128.2.277a.466.466,0,0,1-.176.16,7.939,7.939,0,0,0-2.243.889Z",
    transform: "translate(-500.904 -162.287)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M556.672,218.35l-.342.337c-.067.157-.228.219-.331.339l0,.179a1.145,1.145,0,0,1-1.016-.118c-.245-.416.148-.531.342-.739.055-.455.412-.306.674-.345l.106.03c.162.086.344.129.5.231Z",
    transform: "translate(-497.25 -164.132)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M553.921,227.831a3.4,3.4,0,0,0,0-.495c-.1-.677.159-.986.849-.87.271.2.4.4.007.605-.429.184-.141.552-.2.831a.451.451,0,0,1-.148.322c-.378.145-.372-.211-.5-.392Z",
    transform: "translate(-496.527 -170.199)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M561.821,225.317c0-.055,0-.109.005-.164.2-.144.344-.052.461.127.182.465.3.922-.14,1.321a1.31,1.31,0,0,1-.842.1c-.245-.06-.429-.181-.439-.467C560.945,225.678,561.728,225.864,561.821,225.317Z",
    transform: "translate(-501.558 -169.221)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M559.7,225.919c.207.78-.544.588-.845.853-.116.212-.149.521-.509.451a.518.518,0,0,1-.347-.336c-.093-.368-.186-.733.422-.635a.457.457,0,0,0,.437-.162A1.391,1.391,0,0,0,559.7,225.919Z",
    transform: "translate(-499.44 -169.823)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M561.6,223.848a.333.333,0,0,0-.34-.149c-.39-.082-.829.165-1.177-.186.074-.143.367-.043.333-.307l0-.044a1.068,1.068,0,0,1,.584-.094,1.6,1.6,0,0,0,.867.24C562.113,223.657,562.007,223.83,561.6,223.848Z",
    transform: "translate(-500.994 -167.766)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M561.985,221.863l-.688-.054c.134-.2.427-.229.5-.493.248-.24.519-.109.787-.052a.384.384,0,0,1,.162.436.447.447,0,0,1-.4.276A.561.561,0,0,1,561.985,221.863Z",
    transform: "translate(-501.869 -166.413)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M557.651,226.527c-.031.354-.265.356-.527.314-.574-.093-.109.241-.147.368a.534.534,0,0,1-.328.159.544.544,0,0,1-.352-.105.178.178,0,0,1,.007-.224c.439-.041.261-.291.169-.511Z",
    transform: "translate(-498.232 -170.26)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M554.956,221.657a1.67,1.67,0,0,1,1.011.173.361.361,0,0,1-.177.347.27.27,0,0,1-.185.083c-.291.018-.584.04-.734-.3A.31.31,0,0,1,554.956,221.657Z",
    transform: "translate(-497.222 -166.756)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M563.33,220.349c-.227.171-.453-.084-.679,0a.366.366,0,0,1-.165-.343h0a.976.976,0,0,1,.939-.1C563.642,220.112,563.5,220.235,563.33,220.349Z",
    transform: "translate(-502.728 -165.446)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M554.971,222.886c.18.222.482,0,.672.191.093.189-.091.24-.168.344a.338.338,0,0,1-.332.144q0-.08,0-.16c-.1-.1-.246-.158-.257-.327A.294.294,0,0,1,554.971,222.886Z",
    transform: "translate(-497.237 -167.642)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M558.854,220.776a.3.3,0,0,1,.332-.339l.337,0C559.468,220.9,559.12,220.753,558.854,220.776Z",
    transform: "translate(-500.105 -165.881)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M560.417,223.563c.064.081.2.217.181.235-.14.179-.339.048-.514.072C560.079,223.639,560.18,223.526,560.417,223.563Z",
    transform: "translate(-500.993 -168.124)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M557.013,223.874l.168-.344c.054-.007.108-.012.162-.013.055.108.294.19.187.282S557.19,223.855,557.013,223.874Z",
    transform: "translate(-498.776 -168.096)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M553.985,231.388c.177.1.243.369.5.341a6.217,6.217,0,0,1-.091,2.285l-.079.1-.329,0q0-.255,0-.51a.948.948,0,0,0,0-.841Q553.988,232.075,553.985,231.388Z",
    transform: "translate(-496.589 -173.755)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M554,236.279a.575.575,0,0,1,0,.841Q553.994,236.7,554,236.279Z",
    transform: "translate(-496.594 -177.271)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M555.867,241.565l-.17.511c-.036.248.2.492.008.742a.446.446,0,0,1-.331.061.346.346,0,0,1-.182-.137q0-.931,0-1.861h0C555.959,240.689,556.053,240.784,555.867,241.565Z",
    transform: "translate(-497.458 -180.519)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M555.7,248.937c.195.437-.54.99.167,1.362-.069.1.177.612-.274.218-.14-.123-.267-.261-.4-.392q0-.511,0-1.021a.357.357,0,0,0,.339-.16A.124.124,0,0,1,555.7,248.937Z",
    transform: "translate(-497.463 -186.35)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M555.478,248.085l-.17.007c-.184-.057-.61.113-.338-.37a1.151,1.151,0,0,0,.161.024c.066.151.44-.018.326.321Z",
    transform: "translate(-497.236 -185.498)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M497.484,170.048c-.737-.147-.783-.827-1-1.361-.068-.166.007-.39-.179-.523.292-.212.516-.45.337-.852.092-.26-.005-.7.512-.559.263.29.17.623.115.951a.561.561,0,0,0,.156.573c.147.208.428.206.593.386a.293.293,0,0,1-.1.291c-.211.15-.166.381-.181.593A.836.836,0,0,1,497.484,170.048Z",
    transform: "translate(-454.936 -127.264)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M497.122,162.269c-.368-.03-.284.4-.5.513-.279-.658-.13-1.39-.345-2.06l.058-.119a.525.525,0,0,1,.725-.061.956.956,0,0,1,.28.627C497.332,161.55,497.433,161.951,497.122,162.269Z",
    transform: "translate(-454.914 -122.735)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M494.488,159.141l-.014-.339a.362.362,0,0,1,.165-.34l.094.064c.121.248.477.422.244.784h0Z",
    transform: "translate(-453.616 -121.322)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M502.112,177.389l-.173-.005-.158-.5a1.156,1.156,0,0,1,.355-.6.532.532,0,0,1,.661.157.364.364,0,0,1,.048.232C502.572,176.882,502.38,177.176,502.112,177.389Z",
    transform: "translate(-458.892 -134.098)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M501.23,176.393c0,.248,0,.5-.337.517h-.341c0-.191-.032-.394.168-.519a.389.389,0,0,1,.2-.119A.345.345,0,0,1,501.23,176.393Z",
    transform: "translate(-458.004 -134.126)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M495.066,156.878c0-.052.009-.1.013-.157.161-.128.206-.4.471-.4a.332.332,0,0,1,.343-.028.907.907,0,0,1,.3.377,1.32,1.32,0,0,1,.158.468c-.014.186-.079.327-.292.335-.389-.1-.865-.044-.992-.592Z",
    transform: "translate(-454.043 -119.738)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M496.66,153.222l-.366-.031-.154-.3a.7.7,0,0,1,.554-.983.6.6,0,0,1,.353.077.622.622,0,0,1,.234.668.5.5,0,0,1-.215.274C496.726,152.736,496.813,153.148,496.66,153.222Z",
    transform: "translate(-454.786 -116.608)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M493.764,152.135q-.014-.072-.029-.144c-.088-.2.034-.308.167-.414a.348.348,0,0,1,.247.014.518.518,0,0,1,.229.3c-.035.243.088.522-.153.72l-.283,0C493.917,152.441,493.983,152.233,493.764,152.135Z",
    transform: "translate(-453.061 -116.36)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M495.577,152.259l.011-.794c.17-.265.374-.464.723-.372a.267.267,0,0,1-.027.345c-.449.111-.3.594-.519.851Z",
    transform: "translate(-454.412 -116.008)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M480.472,133.506l.181-.337.08-.076a.307.307,0,0,1,.291.041c.046,0,.054.169.137.028a.575.575,0,0,1,.123-.353.29.29,0,0,1,.21-.049.878.878,0,0,1,.42.534c.043.3.342.372.506.566a.718.718,0,0,1-.1.807.58.58,0,0,1-.2.128.663.663,0,0,1-.229.008,1.984,1.984,0,0,1-.577-.3c-.138-.1-.3-.151-.438-.243l-.061-.08C480.84,133.882,480.58,133.734,480.472,133.506Z",
    transform: "translate(-443.505 -102.841)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M478.847,139.855l-.173-.689c0-.11.007-.22.01-.33a.278.278,0,0,1,.341-.054,3.556,3.556,0,0,1,.416.773.383.383,0,0,1-.1.363A.39.39,0,0,1,478.847,139.855Z",
    transform: "translate(-442.206 -107.148)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M479.044,138.139l-.333.005c.1-.562.538-.276.834-.349l.007.008a.21.21,0,0,1,.021.229C479.423,138.2,479.262,138.314,479.044,138.139Z",
    transform: "translate(-442.233 -106.456)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M476.825,130.819a1.51,1.51,0,0,1-.848-.205.374.374,0,0,1-.064-.488.5.5,0,0,1,.228-.134.864.864,0,0,1,.893.459C477.07,130.634,477.1,130.814,476.825,130.819Z",
    transform: "translate(-440.169 -100.843)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M473.453,130.642c-.6.363-.626-.236-.843-.515l0,0a.551.551,0,0,1,.331-.159.59.59,0,0,1,.354.1A.737.737,0,0,1,473.453,130.642Z",
    transform: "translate(-437.827 -100.833)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M479.352,131.944l.142-.313c.3-.2.416-.022.489.244a.492.492,0,0,1-.146.39l.008.031C479.613,132.275,479.359,132.286,479.352,131.944Z",
    transform: "translate(-442.696 -101.968)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M475.166,130.049c-.2-.115-.157-.32-.183-.5a.48.48,0,0,1,.175-.4.257.257,0,0,1,.213.028.242.242,0,0,1-.022.31q0,.261,0,.521Z",
    transform: "translate(-439.541 -100.24)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M548.209,212.046h-.142a1.33,1.33,0,0,1-.208-.82l.025-.207a.517.517,0,0,1,.391-.118c.293.072.6.031.892.074s.634.027.617.478c-.336.515-.975.119-1.368.465A.7.7,0,0,1,548.209,212.046Z",
    transform: "translate(-492.164 -159.025)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M546.331,206.029l-.33.345c-.342-.014-.186-.278-.218-.447a.494.494,0,0,1,.348-.3.412.412,0,0,1,.23.015.276.276,0,0,1,.063.319Z",
    transform: "translate(-490.66 -155.226)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M547.824,207.713q-.023-.336-.046-.673l.046-.007c.261-.058.316.156.411.318a.619.619,0,0,1,.023.234.375.375,0,0,1-.122.2A.246.246,0,0,1,547.824,207.713Z",
    transform: "translate(-492.107 -156.237)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M547.942,209.476l.325.006a.352.352,0,0,1,.122.316.383.383,0,0,1-.116.2l-.328,0Q547.943,209.736,547.942,209.476Z",
    transform: "translate(-492.225 -158)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M559.852,214.215a.348.348,0,0,1-.337.169l0,0c-.163-.235-.5-.11-.671-.339l0,0q0-.167,0-.334a.529.529,0,0,1,.16-.152c.291-.1.31-.386.394-.626a.706.706,0,0,1,.459-.4,1.309,1.309,0,0,1,.652.015,2.621,2.621,0,0,1,1.075.485.407.407,0,0,1-.037.5l-.677,0c-.4-.309-.748-.382-.922.234A.448.448,0,0,1,559.852,214.215Z",
    transform: "translate(-500.093 -160.166)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M553,220.182c0,.049,0,.1,0,.148-.089.127-.194.117-.308.037-.572-.042-.364-.574-.534-.869.442.056.709-.5,1.181-.343l-.337.685Z",
    transform: "translate(-495.271 -164.938)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M555.8,213.494l-.167,0a3.18,3.18,0,0,1-1.181-.175l-.053-.106c.008-.039.016-.078.023-.116.235-.4.75-.384,1.034-.712a.672.672,0,0,1,.293-.183.525.525,0,0,1,.229.023.455.455,0,0,1,.221.259.736.736,0,0,1-.154.416C555.921,213.08,555.972,213.334,555.8,213.494Z",
    transform: "translate(-496.892 -159.96)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M549.766,216.788c.229-.3.608.143.833-.173a.226.226,0,0,1,.331.006C550.568,216.858,550.262,217.5,549.766,216.788Z",
    transform: "translate(-493.542 -163.083)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M553.1,215.629l-.331-.006q0-.169,0-.339l.085-.08a.342.342,0,0,1,.422.081v.17Z",
    transform: "translate(-495.707 -162.091)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M553.96,223.449l.308-.036.171.37C554.284,223.666,553.754,224.1,553.96,223.449Z",
    transform: "translate(-496.537 -168.021)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M492.685,143.109l-.193-.015-.031-.566a.372.372,0,0,1-.033-.216,1.66,1.66,0,0,0,.066-.752c-.019-.11-.035-.221-.05-.332-.037-.3,0-.547.355-.6.4.1.847.11.988.624a.638.638,0,0,1-.039.454c-.224.248-.562.427-.49.85a.926.926,0,0,1-.183.52.379.379,0,0,1-.188.1A.326.326,0,0,1,492.685,143.109Z",
    transform: "translate(-452.135 -108.496)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M487.709,144.068a1.512,1.512,0,0,0-.733-.374c-.079-.2.017-.327.187-.416a1.148,1.148,0,0,1,.506-.064.741.741,0,0,1,.36.123.466.466,0,0,1,.129.351.388.388,0,0,1-.3.364A.516.516,0,0,1,487.709,144.068Z",
    transform: "translate(-448.181 -110.356)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M490.225,145.191l.185-.338a.317.317,0,0,1,.349-.013.512.512,0,0,1,.133.561.324.324,0,0,0-.019.125C490.522,145.683,490.421,145.343,490.225,145.191Z",
    transform: "translate(-450.547 -111.496)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M493.268,149.419l.106-.02c.313.141.423.348.207.66l-.188.379-.161-.185Q493.249,149.835,493.268,149.419Z",
    transform: "translate(-452.718 -114.806)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M461.684,125.481l-.026-.315a.772.772,0,0,1,.9-.127.349.349,0,0,1,.187.342l-.065.122Z",
    transform: "translate(-429.919 -97.231)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M466.007,126.827l-.665.022c0-.11,0-.22,0-.33l0,0a.486.486,0,0,1,.633-.056A.254.254,0,0,1,466.007,126.827Z",
    transform: "translate(-432.579 -98.248)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M467.737,126.506l.008-.306.086-.094c.491-.081,1.072-.521,1.331.338l-.07.106Z",
    transform: "translate(-434.309 -97.926)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M472.952,128.539l-.338.008v-.319q0-.175,0-.349v-.048a.336.336,0,0,1,.326-.032.438.438,0,0,1,.246.365A.581.581,0,0,1,472.952,128.539Z",
    transform: "translate(-437.829 -99.256)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M549.124,214.052c0-.055,0-.11,0-.166.414-.129.909-.5,1.007.336h0C549.8,214.167,549.419,214.365,549.124,214.052Z",
    transform: "translate(-493.079 -161.03)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M608.229,109.879c-.187.367-.21.845-.675,1.024C607.228,109.993,607.281,109.913,608.229,109.879Z",
    transform: "translate(-535.141 -86.392)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M588.247,128.654l-.346-.017a.15.15,0,0,1,.072-.23,2.879,2.879,0,0,1,1.116.064l.173,0a.383.383,0,0,1,.49.016c.007.051.016.1.026.152-.079.135-.263.056-.351.175l-.339,0A1.549,1.549,0,0,1,588.247,128.654Z",
    transform: "translate(-521.059 -99.696)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M587.827,128.25l-1.185.008a.4.4,0,0,1-.515-.019c.307-.274.681-.106,1.022-.157C587.381,128.107,587.646,128.006,587.827,128.25Z",
    transform: "translate(-519.798 -99.475)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M593.461,129.462a.385.385,0,0,1,.35-.175l.651.022-.331.32c-.171.1-.238-.051-.331-.141Z",
    transform: "translate(-525.095 -100.346)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M593.358,128.281l-.49-.016c.145-.219.368-.157.571-.157.081,0,.142.046.066.128C593.474,128.269,593.408,128.267,593.358,128.281Z",
    transform: "translate(-524.667 -99.492)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M599.259,128.813l-.344-.161c.032-.117.021-.308.206-.247S599.236,128.667,599.259,128.813Z",
    transform: "translate(-529.034 -99.703)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M594.677,130l.331.141c.285.049.611-.1.849.177a.351.351,0,0,1-.34.173,1.457,1.457,0,0,1-.84-.174Z",
    transform: "translate(-525.973 -100.861)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M476.259,70.085c.248,0,.5.009.745,0,1.106-.053,1.555-.726,1.153-1.763a2.083,2.083,0,0,1-.211-.966,4.037,4.037,0,0,1,1.012,3.584c-.6.506-1.236.027-1.85.083A1.349,1.349,0,0,1,476.259,70.085Z",
    transform: "translate(-440.462 -55.817)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M496.235,79.532c-.618,0-1.237,0-1.855,0-.38,0-.664.014-.938-.461-.265-.46-1.022-.332-1.543-.332-.359,0-.709-.086-1.064-.06a2.653,2.653,0,0,1,3.171-.052,2.445,2.445,0,0,0,.878.224Z",
    transform: "translate(-450.988 -63.557)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M483.791,79.969c.089.632-.119.948-.809.863a6.073,6.073,0,0,0-1.244,0c-.527.044-.705-.2-.646-.688a2.317,2.317,0,0,1,1.349,0C482.9,80.16,483.31,79.774,483.791,79.969Z",
    transform: "translate(-443.944 -64.848)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M479.84,80.1l-1.349,0h-1.012c0-.284.141-.286.338-.171h2.023C479.841,79.983,479.841,80.04,479.84,80.1Z",
    transform: "translate(-441.343 -64.806)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M512.1,83.263c-.346-.008-.258.422-.506.512a6.822,6.822,0,0,0-.731,0c-.531.058-.67-.221-.618-.687C510.856,83.181,511.5,82.9,512.1,83.263Z",
    transform: "translate(-464.993 -67.117)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M460.513,71.7c-.292.253-.677.222-1.013.341a1.352,1.352,0,0,1-1.16.183c-.576-.112-.864-.768-1.481-.808-.023-.544.295-1.108-.1-1.629-.046-.057-.09-.116-.138-.172-.285-.287-.591-.553-.868-.848-.231-.286-.8-.146-.839-.671a1.691,1.691,0,0,1,.979-.4.746.746,0,0,1,.565.559c.066.294.23.259.428.21.136-.035.269-.077.4-.118a5.7,5.7,0,0,1,.592-.056l.1-.009h.608l-.876.674c.8-.149,1.239.61,2.007.471.287-.052.339.567.454.9a.414.414,0,0,1-.451.1,3.73,3.73,0,0,0-.628-.314,4.019,4.019,0,0,1-.7-.275c-.182-.107-.391-.319-.593-.094-.17.189-.018.424.034.64.228.946,1,.926,1.72,1C459.869,71.51,460.254,71.4,460.513,71.7Z",
    transform: "translate(-425.052 -56.063)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M472.282,78.44c-.338-.057-.718.138-1.015-.17a.167.167,0,0,1-.049-.14c.007-.05.017-.075.027-.075.268-.334.713-.178,1.039-.39s-.119-.164-.065-.268a.281.281,0,0,1,.061-.321l.336,0c.209.3.782.3.677.853a.348.348,0,0,0-.338.171C472.9,78.552,472.548,78.407,472.282,78.44Z",
    transform: "translate(-436.821 -62.806)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M472.218,77.065l0,.333c-.338.447-.441.455-1.038.079-.064-.2-.117-.4.2-.418l.506,0Z",
    transform: "translate(-436.758 -62.795)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M465.989,67.352a.585.585,0,0,1,.537.17c-.186.258-.475.142-.716.2l-.035-.11C465.8,67.485,465.9,67.423,465.989,67.352Z",
    transform: "translate(-432.892 -55.815)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M464,68.067l.011.313h0c-.158.084-.308-.008-.463-.021a.341.341,0,0,1-.275-.358c.258-.323.5-.1.749.021Z",
    transform: "translate(-431.085 -56.16)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M458.983,56.939c.409-.081.573-.05.622.508.115,1.331.7,1.7,1.86,1.239.323-.127.591.119.893.131a1.192,1.192,0,0,0,1.057.67c.749.13,1.041.721,1.49,1.242a.694.694,0,0,1-.911-.217,3.864,3.864,0,0,0-2.04-1.225,3.8,3.8,0,0,0-2.128.211.84.84,0,0,1-.3.289c-.149.1-.263.252-.449.294a.24.24,0,0,1-.174-.127c-.092-.758.113-1.516-.014-2.273C459.017,57.447,458.8,57.166,458.983,56.939Z",
    transform: "translate(-427.911 -48.305)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M460.993,66.307a.36.36,0,0,1,.342-.176.344.344,0,0,1,.346.2c.1.16-.149.311-.012.473a.349.349,0,0,0,.341.184c.1.331-.26.191-.337.34a.347.347,0,0,1-.338.172.446.446,0,0,1-.292-.468C461.325,66.769,460.855,66.56,460.993,66.307Z",
    transform: "translate(-429.42 -54.938)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M463.12,67.309c-.288-.165-.068-.317.012-.473a1.486,1.486,0,0,0,.836.146l-.16.322Z",
    transform: "translate(-430.871 -55.445)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M579.8,192.476c.007.682.484.956,1.009,1.187-.25.231-.638.3-.773.666a.265.265,0,0,1-.2.073.405.405,0,0,1-.158-.146c-.063-.1-.121-.222-.251-.059-.4.4-.422-.026-.54-.245-.165-.305-.4.156-.578-.055-1.071-.11-.885-.966-.966-1.665a.576.576,0,0,1,.295-.385,1.552,1.552,0,0,1,.973-.039c.265.079.291.405.523.518a1.477,1.477,0,0,0,.584.094Z",
    transform: "translate(-513.45 -145.255)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M579.72,190.83c-.328-.024-.523-.138-.335-.509-.375-.248-.831.063-1.207-.176.5-.1-.18-.486.149-.631a2.386,2.386,0,0,1,1.224.12c.245.214.25-.066.34-.169l1.012.341v.173c-.17.128-.206.348-.333.505a.386.386,0,0,1-.165.35l0,0C580.174,190.617,579.947,190.83,579.72,190.83Z",
    transform: "translate(-514.059 -143.613)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M586.73,199.226c-.11-.726.371-.7.847-.681l.672,0c.128.083.154.331.128.324-.741-.2-.087.421-.3.515a1.767,1.767,0,0,0-1.007.016.149.149,0,0,1-.171.061A.306.306,0,0,1,586.73,199.226Z",
    transform: "translate(-520.223 -150.137)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M588.641,194.06c-.416-.058-.866.12-1.376-.155a1.19,1.19,0,0,1,1.2-.013C588.649,193.82,588.676,193.908,588.641,194.06Z",
    transform: "translate(-520.621 -146.682)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M591.771,193.884l-.171-.167c.153-.162.316-.316.552-.167a.227.227,0,0,1,.052.213C592.11,193.949,591.928,193.887,591.771,193.884Z",
    transform: "translate(-523.751 -146.506)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M586.779,191.8c-.006-.247-.007-.492.333-.505A.49.49,0,0,1,586.779,191.8Z",
    transform: "translate(-520.268 -144.928)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M587.918,205.559c.082-.073.171-.139.245-.219.252-.27.45-.787.879-.566.407.21.258.722.206,1.126-.176.784-.662.427-1.085.3a.7.7,0,0,1-.19-.171C587.888,205.882,587.8,205.733,587.918,205.559Z",
    transform: "translate(-521.051 -154.581)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M587.987,209.086c.388-.1.872.48,1.184-.169l.342.343a.5.5,0,0,1-.124.539c-.444-.1-.3.408-.533.524a.675.675,0,0,1-.537-.107,1.736,1.736,0,0,1-.536-.555.515.515,0,0,1,.114-.514Z",
    transform: "translate(-520.973 -157.598)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M581.815,205.373c.294.079.736-.208.836.347a1.261,1.261,0,0,1-.926.226c-.139,0-.278,0-.417-.005a.972.972,0,0,1-.658-.2.22.22,0,0,1,0-.265A.842.842,0,0,1,581.815,205.373Z",
    transform: "translate(-515.811 -154.914)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M584.351,207.1l1-.008q.013.086.026.172l.145.339C584.63,207.991,584.294,207.847,584.351,207.1Z",
    transform: "translate(-518.512 -156.287)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M581.572,204.463a3.178,3.178,0,0,0-1.183.173.411.411,0,0,1-.062-.508.612.612,0,0,1,.356-.189,1.3,1.3,0,0,1,.791.089l.094.1Z",
    transform: "translate(-515.568 -154.004)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M593.463,210.19l.173-.483.318-.169a1.2,1.2,0,0,1-.141.686l-.032.18C593.6,210.444,593.5,210.36,593.463,210.19Z",
    transform: "translate(-525.096 -158.045)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M585.745,203.022c-.1.568-.549.267-.845.35l.005-.006c-.077-.218.042-.341.207-.445A.579.579,0,0,1,585.745,203.022Z",
    transform: "translate(-518.899 -153.25)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M585.248,202.114l-.672.014a.273.273,0,0,1-.328.04c-.117-.172-.026-.3.092-.415a.514.514,0,0,1,.215-.065,1.11,1.11,0,0,0,.53-.081l.164,0q0,.083,0,.166l0,.176C585.247,202.007,585.247,202.06,585.248,202.114Z",
    transform: "translate(-518.403 -152.343)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M580.5,173.155h-.839c-.257.127-.556.116-.813.245a.634.634,0,0,1-.219,0c-.251-.125-.509.063-.762-.016a.571.571,0,0,1-.245-.53.894.894,0,0,1,.081-.367.471.471,0,0,1,.4-.249,1.036,1.036,0,0,1,.393.242c.33.21.718.071,1.065.178a1.855,1.855,0,0,0,.431.077c.313.051.7-.238.931.2C580.879,173.206,580.757,173.318,580.5,173.155Z",
    transform: "translate(-513.657 -131.23)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M576.545,179.653l-.34.511-.337,0c-.461.052-1.052.443-1.155-.449a.568.568,0,0,1,.179-.325,2.979,2.979,0,0,1,1.484-.248.467.467,0,0,1,.17.165Z",
    transform: "translate(-511.557 -136.19)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M580.383,176.8l-.171,0a.962.962,0,0,1-.185-.608.814.814,0,0,1,.056-.254c.066-.118.142-.217.3-.159.056,0,.112,0,.168,0,.282-.006.562-.28.846,0l-.334.35c.056.4-.314.476-.518.678Z",
    transform: "translate(-515.393 -133.678)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M587.977,173.58a.311.311,0,0,0,.341-.336.365.365,0,0,1,.167-.1c.2-.047.329-.233.52-.306a.326.326,0,0,1,.209.05.449.449,0,0,1,.112.525.6.6,0,0,0-.338.349h-1.007Z",
    transform: "translate(-521.135 -131.655)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M582.759,175.36c-.283-.2-.562.338-.846,0a.579.579,0,0,1,.846-.171C582.758,175.249,582.758,175.3,582.759,175.36Z",
    transform: "translate(-516.756 -133.268)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M581.892,178.008l.518-.678C582.654,177.614,582.525,177.783,581.892,178.008Z",
    transform: "translate(-516.741 -134.888)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M586.171,179.006l-.337.171c-.033-.149-.245-.329-.028-.438C585.98,178.651,586.094,178.849,586.171,179.006Z",
    transform: "translate(-519.497 -135.885)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M594.792,173.061h.675c.162.478-.393.749-.339,1.2l-.336-.173A.8.8,0,0,1,594.792,173.061Z",
    transform: "translate(-525.923 -131.818)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M568.326,180.05c.022.24-.039.572.387.4a.708.708,0,0,1,.624.116c.215.185.024.476.171.679.106.226-.047.364-.168.513-.106.239-.237.482.2.51a1.557,1.557,0,0,1,.978.341H569.17c-.836.37-1.142.3-1.578-.374a.862.862,0,0,1-.455-.32c-.1-.029.189-.288-.112-.2a1.241,1.241,0,0,1-.865-.032,1.408,1.408,0,0,1-.414-.417.547.547,0,0,1-.055-.446.3.3,0,0,1,.146-.151c.323-.06.264-.487.547-.59a2.478,2.478,0,0,1,1.411-.371A.812.812,0,0,1,568.326,180.05Z",
    transform: "translate(-505.025 -136.586)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M578.88,185.29l.168-.513.506-.171A.9.9,0,0,1,578.88,185.29Z",
    transform: "translate(-514.566 -140.119)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M593.095,172.519v1.021l-.678-.51-.16-.509a.369.369,0,0,1,.5-.172A.346.346,0,0,0,593.095,172.519Z",
    transform: "translate(-524.226 -131.276)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M594.706,166.609v.683c-.41.064-.547.474-.843.682a.379.379,0,0,1-.283-.251.736.736,0,0,1,.054-.525C593.888,166.81,594.01,166.172,594.706,166.609Z",
    transform: "translate(-525.162 -127.074)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M592.3,171.078l.169.171-.166.173-.5.172-.174,0C591.636,171.125,591.819,170.9,592.3,171.078Z",
    transform: "translate(-523.773 -130.349)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M589.387,211.855l.318.214,0,.32c-.088.334.106.52.35.679a.555.555,0,0,1-.323.346c-.192.18-.374.073-.558-.017a1.732,1.732,0,0,0-.98-.306.649.649,0,0,1-.327-.135.276.276,0,0,1-.038-.225c.3-.306.716-.208,1.074-.313C588.95,212.129,588.994,211.837,589.387,211.855Z",
    transform: "translate(-521.02 -159.71)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M591.709,216.688l.517.16c0,.042.007.083.012.124l-.021.218c.081.379-.231.327-.428.4a.3.3,0,0,1-.184-.115c-.092-.156-.2-.3-.3-.453a.4.4,0,0,1,.007-.318C591.437,216.553,591.576,216.686,591.709,216.688Z",
    transform: "translate(-523.516 -163.146)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M594.59,214.435c-.417-.068-.656-.23-.35-.679l.37.527A1.215,1.215,0,0,0,594.59,214.435Z",
    transform: "translate(-525.558 -161.078)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M592.739,218.965l.5-.345c.2.121.163.32.167.507l-.332.182a.354.354,0,0,0-.342-.178c-.041-.04-.053-.078-.036-.113S592.724,218.965,592.739,218.965Z",
    transform: "translate(-524.534 -164.575)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M549.016,136.473v.171a3.387,3.387,0,0,0,1.483,2.565c.54.339.425,1,.416,1.567-.057.6-.464.709-.953.709-.513,0-1.041.026-1.164-.667-.015-.089-.027-.18-.039-.269-.482-.688-1.21-.5-1.836-.434-.415.041-.454.511-.192.8.433.484.7.948.068,1.424a1.61,1.61,0,0,1-1.964-.386,4.12,4.12,0,0,0-.2-.371c-.359-.18-.835.031-1.134-.347a15.315,15.315,0,0,0-1.285-1.218,3.123,3.123,0,0,1-.525-.659c-.37-.7-.216-1,.547-1.056.5-.034,1.008,0,1.511-.023a2.149,2.149,0,0,0,.694-.216,1.271,1.271,0,0,1,.354-.073,1.533,1.533,0,0,1,.467.049,1.243,1.243,0,0,0,.854.038c.058-.044.117-.085.173-.131a10.161,10.161,0,0,0,1.391-.916C548.179,136.977,548.389,136.213,549.016,136.473Z",
    transform: "translate(-487.571 -105.474)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M579.9,157.178c-.652-.25-.573.609-1.012.683-.259.313-.593.247-.933.205-.232-.028-.415-.4-.731.055-.216.312-.438-.083-.482-.388,0-.084.021-.167.021-.253-.657.933-1.513.478-2.325.345a1.329,1.329,0,0,1-1.367-.975.6.6,0,0,1-.008-.268c.231-.565.708-.641,1.233-.658,1.241-.04,1.241-.047,1.281-1.255a.387.387,0,0,1,.106-.223c.537.156.906.7,1.518.683.2,0,.383.073.577.092.921.09,1.149-.1,1.223-1.02a1.313,1.313,0,0,1,.194-.805.3.3,0,0,1,.368.026h.338a4.022,4.022,0,0,1,1.348,3.074c-.451.224-1.071.106-1.349.682Z",
    transform: "translate(-510.36 -117.643)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M568.176,153.205v.341c.417.956.309,1.365-.615,1.685-.718.249-1.234.87-2,1a1.148,1.148,0,0,1-.278.04,1.272,1.272,0,0,1-.9-.349c-.3-.658.162-1.158.349-1.715a4.622,4.622,0,0,1,1.925-.462c.379-.115.542-.528.9-.673A.584.584,0,0,1,568.176,153.205Z",
    transform: "translate(-504.03 -117.425)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M587.038,134.178a7.189,7.189,0,0,0,1.687,1.708l-.169.341a5.146,5.146,0,0,0,.223,1.752,2.184,2.184,0,0,1-.22,1.718.422.422,0,0,1-.509-.056V139.3c-.306-.328-.184-.743-.229-1.126-.037-.313.124-.867-.26-.856-.466.013-.25.576-.287.906-.045.394.092.782.083,1.178a.639.639,0,0,1-.087.235.337.337,0,0,1-.344.08c-.176-.083-.1-.305-.222-.416a1.152,1.152,0,0,0-.339-1.026,1.162,1.162,0,0,1,.169-1.366c.206-.219.4-.456.619-.655.7-.625.707-.767-.006-1.414-.207-.188-.44-.341-.445-.661h.338Z",
    transform: "translate(-519.856 -103.863)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M570.95,141.829h-.675c-.262-.152-.171-.482-.337-.683.215-.9-.371-1.369-.991-1.743a1.209,1.209,0,0,1-.668-1.231c.032-.327-.323-.631-.029-.952.181.033.365.053.541.1.279.077.651.019.6.535-.029.287.109.461.506.415a1.158,1.158,0,0,1,1.392.827c.168.133.2.359.338.512v.512c-.378.224-.56-.058-.758-.3a2.583,2.583,0,0,1-.161-.6c-.324-.482-.8-.162-1.214-.218a3.692,3.692,0,0,1,.857.692,1.8,1.8,0,0,1,.213.421c.2.436-.117,1.02.388,1.367Z",
    transform: "translate(-506.805 -106.049)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M568.555,156.513a25.892,25.892,0,0,1,2.471-1.269c.5-.14.128-.848.229-1.286.175-.1.245-.369.507-.341a7.515,7.515,0,0,1,.626,1.566c.106.412,0,.839-.444.847a12.364,12.364,0,0,0-2.931.788A.6.6,0,0,1,568.555,156.513Z",
    transform: "translate(-507.11 -117.838)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M589.336,153.5h.506a.1.1,0,0,1,.169,0q0,.381,0,.761a1.217,1.217,0,0,1-1.933,1.174c-.055-.028-.062-.15-.091-.228a.4.4,0,0,1,.348-.41C589,154.632,589.173,154.072,589.336,153.5Z",
    transform: "translate(-521.141 -117.726)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M589.363,146.622a8.3,8.3,0,0,1-.177-2.177c0-.391.141-.563.54-.554.371.008.481.191.476.531-.008.621,0,1.241,0,1.862l-.338.342A.346.346,0,0,1,589.363,146.622Z",
    transform: "translate(-522.008 -110.846)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M569.593,156.7c.933-.207,1.742-.827,2.752-.8.537.012.679-.257.526-.835-.127-.481-.538-.884-.413-1.434.525.139.394.72.675,1.024.051.189.118.375.15.567.144.864-.07,1.115-.954,1.14-.62.017-1.3-.163-1.727.511a.961.961,0,0,1-.8.3.364.364,0,0,1-.28-.232A.284.284,0,0,1,569.593,156.7Z",
    transform: "translate(-507.807 -117.843)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M576.951,148.037c-.388.183-.492-.04-.5-.371s0-.663,0-.995a.971.971,0,0,1,.506-.342c.234.1.381.366.675.341C577.23,147.041,576.75,147.367,576.951,148.037Z",
    transform: "translate(-512.805 -112.6)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M564.839,134.386c-.56.01-.727.8-1.349.691a.319.319,0,0,1-.081-.21,2.374,2.374,0,0,1,.66-.787c.267-.163.522-.348.8-.5a1.03,1.03,0,0,1,.364-.069.551.551,0,0,1,.455.188Z",
    transform: "translate(-503.394 -103.387)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M584.837,132.03a4.477,4.477,0,0,1-.984-.071c-.4-.119-.066-.454-.218-.67-.072-.1.261-.126.388-.071.369.16,1.1-.022.814.811Z",
    transform: "translate(-517.993 -101.714)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M570.185,131.683l-.513,0a.176.176,0,0,1,.011-.22c.482-.266,1.1-.205,1.515-.627.223.06.444-.311.669,0A1.515,1.515,0,0,1,570.185,131.683Z",
    transform: "translate(-507.893 -101.365)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M588.387,152.748l.5,0c-.252.335-.3,1.07-.761.939-.546-.156-.139-.842-.249-1.28a.357.357,0,0,1,.169.341.191.191,0,0,0,.333,0Z",
    transform: "translate(-521.032 -116.971)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M585.964,143.9l-.169,1.366C585.234,144.738,585.309,144.129,585.964,143.9Z",
    transform: "translate(-519.287 -110.852)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M589.219,129.313c.286.021.6-.11.84.16.07.2.122.428-.2.3A3.205,3.205,0,0,1,589.219,129.313Z",
    transform: "translate(-522.032 -100.355)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M595.675,133.3H595c-.162-.157-.139-.291.082-.323C595.342,132.936,595.634,132.9,595.675,133.3Z",
    transform: "translate(-526.13 -102.981)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M594.565,131.121a1.391,1.391,0,0,1,.84.175c-.3.36-.574-.023-.861-.038-.009,0-.026-.047-.022-.069S594.55,131.143,594.565,131.121Z",
    transform: "translate(-525.861 -101.662)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M584.844,128.653l.515.019c0,.053,0,.106,0,.159l-1.006.021c0-.053,0-.107,0-.16Z",
    transform: "translate(-518.517 -99.89)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M579.822,144.412a.517.517,0,0,1-.338-.512C579.827,143.915,579.825,144.164,579.822,144.412Z",
    transform: "translate(-515.002 -110.852)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M594.308,144.885h-.169c.287-1.043-.21-2.036-.2-3.064,0-.194-.034-.329.2-.35l.169.171a7.527,7.527,0,0,1,.337,3.244Z",
    transform: "translate(-525.439 -109.105)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M597.7,165.161c-.024-1.186.882-.489,1.349-.682l-.337.339Z",
    transform: "translate(-528.156 -125.626)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M555.813,233.051c.076-.534-.156-.756-.678-.685a6.838,6.838,0,0,1,.17-2.387q0-.17,0-.34l.138-.163c.156-.149.2-.382.369-.52l.335,0a.357.357,0,0,0,.17.342c-.106.359.352.267.4.507.132.382-.163.6-.322.872a.6.6,0,0,0,0,.4,2.409,2.409,0,0,1-.115.653,1.163,1.163,0,0,0,.224,1.233c.007.01-.019.048-.035.068a.114.114,0,0,1-.146.025Z",
    transform: "translate(-497.405 -172.004)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M562.117,235.76c-.169.665-.744.381-1.109.4s-.653,0-.75.431l-.506.171c-.208.169-.416.182-.546-.073a.325.325,0,0,1,.222-.463,1.7,1.7,0,0,0,.749-.488c.243-.1.508-.106.758-.182a2.076,2.076,0,0,1,.448-.007A1.683,1.683,0,0,1,562.117,235.76Z",
    transform: "translate(-500.331 -176.743)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M559.732,236.035c-.06.362-.208.638-.63.611-.195-.012-.356.038-.3.257s.272.126.426.147c-.015.346-.26.344-.506.342-.453-.128-.235-.425-.17-.684a.969.969,0,0,1,.173-.658.223.223,0,0,1,.191-.079,1.015,1.015,0,0,0,.623-.03A.291.291,0,0,1,559.732,236.035Z",
    transform: "translate(-499.809 -177.029)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M558.307,238.671c.025.236-.078.5.17.684.638.369.738.753.27,1.047-.112.071-.27.173-.351.018-.046-.089.049-.252.081-.382C558.425,239.582,557.782,239.2,558.307,238.671Z",
    transform: "translate(-499.562 -178.991)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M581.17,236.048c.236,0,.488-.016.5.334a5.582,5.582,0,0,1-.817,0c-.454-.063,0-.22-.019-.333A.222.222,0,0,1,581.17,236.048Z",
    transform: "translate(-515.843 -177.05)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M556.7,246.035c.056-.228-.3-.455,0-.683.305.136.276.612.662.666a.917.917,0,0,1-.153.033A.431.431,0,0,1,556.7,246.035Z",
    transform: "translate(-498.459 -183.795)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M581.2,235.259l-.336,0-.171,0c.014-.172.037-.4.228-.384C581.026,234.882,581.112,235.124,581.2,235.259Z",
    transform: "translate(-515.878 -176.262)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M569.329,243.564l-.345.336C568.753,243.424,569.154,243.613,569.329,243.564Z",
    transform: "translate(-507.369 -182.509)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M404.645,71.434l-.173-.173a.185.185,0,0,1-.048-.136c0-.049.011-.074.02-.074.205-.33.663.025.854-.324-.034-.234-.29-.148-.391-.28a.483.483,0,0,1-.166-.464,1.282,1.282,0,0,1,1.52-.579c.1.1.152.284.285.3a8.407,8.407,0,0,0,3.951-.149,2.648,2.648,0,0,1,2.03-.78,22.19,22.19,0,0,1,4.714.492,9.2,9.2,0,0,1,3.1,1.145h0c.145.193.091.434.146.649a.661.661,0,0,1-.66.928,6.618,6.618,0,0,1-2.244-.118,2.844,2.844,0,0,0-2.781.293c-.316.258-.749.172-1.135.219a1.948,1.948,0,0,0-1.11.29.531.531,0,0,0-.02.378,1.652,1.652,0,0,1,.627,1.55,8.256,8.256,0,0,1-.145,2.245c-.431.353-.915.275-.914-.256,0-.979-.641-1.419-1.232-1.947a1.328,1.328,0,0,1-.254-.448c-.109-.5-.43-.623-.8-.34a4,4,0,0,1-1.576.549c-.411.086-.5.388-.509.755-.015.425-.045.853-.483,1.089a1.289,1.289,0,0,0-.9.024c-.276.034-.55.163-.827.012a.624.624,0,0,1-.278-.732c.335-.748-.027-1.4-.2-2.076a1.48,1.48,0,0,1-.07-.588c.016-.37.318-.674.239-1.063-.064-.189-.242-.2-.392-.255A.547.547,0,0,1,404.645,71.434Z",
    transform: "translate(-388.589 -56.824)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M392.049,86.192c.512-.1.7-.863,1.35-.683.327.264.067.793.457,1.029a1.057,1.057,0,0,1,.329.373.753.753,0,0,1-.033.641.725.725,0,0,1-1.032.118c-.3-.187-.641-.318-.94-.519a.807.807,0,0,1-.249-.318A.578.578,0,0,1,392.049,86.192Z",
    transform: "translate(-379.537 -68.851)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M403.537,78.629c.341.409-.111.683-.169,1.024a1.087,1.087,0,0,1-.594.309,1.416,1.416,0,0,1-.341.036.881.881,0,0,1-.338-.069.3.3,0,0,1-.14-.178.4.4,0,0,1,.07-.218c.144-.214.5-.244.5-.583-.018-.288.244-.431.337-.662h.167C403.154,78.47,403.414,78.444,403.537,78.629Z",
    transform: "translate(-386.806 -63.68)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M389.838,77.419c.236.02.363.151.316.387-.074.371-.259.073-.409.077a1.844,1.844,0,0,0-.581.219c-.168-.058-.21-.244-.339-.342l.34-.68Z",
    transform: "translate(-377.326 -62.81)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M399.061,79.588c-.358-.035.533-.391-.106-.4-.249,0-.143-.289-.1-.467.456.25.466-1,1.05-.319-.127.426-.09.92-.489,1.236A.3.3,0,0,1,399.061,79.588Z",
    transform: "translate(-384.524 -63.613)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M389.983,84.539a1.871,1.871,0,0,0,0-.253c-.092-.658.133-.8.677-.431v.513c-.1.123-.175.271-.354.292A.389.389,0,0,1,389.983,84.539Z",
    transform: "translate(-378.145 -67.538)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M403.7,73.607q-.005.085-.01.17c-.119.022-.323.138-.31-.079.029-.482-.177-.992.141-1.444v.019a.459.459,0,0,1,.333.4A1.112,1.112,0,0,1,403.7,73.607Z",
    transform: "translate(-387.808 -59.34)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M397.62,86.769c-.64-.239-.236-.793-.35-1.19h.34a1.29,1.29,0,0,1,.248.8A.385.385,0,0,1,397.62,86.769Z",
    transform: "translate(-383.407 -68.921)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M390.8,86.36l.34-.173v1.194c.017.332-.185.247-.369.2a.6.6,0,0,1-.134-.251A1.425,1.425,0,0,1,390.8,86.36Z",
    transform: "translate(-378.628 -69.358)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M400.976,80.115c0-.468.371-.773.5-1.184q0,.338.009.676c.1.22-.1.342-.164.506-.005.055-.01.11-.015.165C401.124,80.375,400.968,80.416,400.976,80.115Z",
    transform: "translate(-386.1 -64.141)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M386.436,76.3c-.25.277-.556.121-.843.11a.181.181,0,0,1,0-.284c.228-.364.443.125.668.011A.177.177,0,0,1,386.436,76.3Z",
    transform: "translate(-374.943 -62.028)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M398.7,86.442c-.285-.242-.132-.572-.169-.863h.5l.063.091a.669.669,0,0,1,0,.221C398.991,86.1,399.1,86.454,398.7,86.442Z",
    transform: "translate(-384.328 -68.921)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M383.144,76.448c0,.095,0,.189,0,.284l-1.011.054.34-.35Z",
    transform: "translate(-372.493 -62.347)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M400.093,83.146a.316.316,0,0,0,.33.163l.008.008a.467.467,0,0,1-.161.567.3.3,0,0,1-.348-.05l0,0-.166-.683Z",
    transform: "translate(-385.217 -67.172)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M402.219,81.348l.164-.506.334-.194C403.016,81.22,402.415,81.136,402.219,81.348Z",
    transform: "translate(-386.997 -65.376)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M388.35,76.218l-.175-.163c.271-.286.443-.231.517.155Z",
    transform: "translate(-376.856 -61.943)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M379.833,50.143c-.231-.035-.631.09-.594-.34a.734.734,0,0,1,.791-.687c.4-.013.529.175.523.56C380.545,50.206,380.183,50.134,379.833,50.143Z",
    transform: "translate(-370.402 -42.705)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M369.4,52.778a6.074,6.074,0,0,0,1.678.182,1.746,1.746,0,0,1-1.343.334l-.331-.028Q369.4,53.022,369.4,52.778Z",
    transform: "translate(-363.3 -45.338)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M377.8,56.416c-.015.346-.26.345-.505.341A.506.506,0,0,1,377.8,56.416Z",
    transform: "translate(-368.997 -47.953)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M398.462,46.252v.171a5.244,5.244,0,0,1-1.9-.261C397.24,45.9,397.838,46.36,398.462,46.252Z",
    transform: "translate(-382.913 -40.521)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M362.182,55.182a1.931,1.931,0,0,1,.849-1.193.3.3,0,0,1,.092.189,1.155,1.155,0,0,1-.3.9c-.077.371-.362.716-.13,1.124a.308.308,0,0,1-.336.347l-.177-.016C361.776,56.083,362.1,55.633,362.182,55.182Z",
    transform: "translate(-357.942 -46.208)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M364.29,55.205c.025-.321.39-.5.34-.855a.651.651,0,0,1,.67,0c.1.21.16.352-.193.328-.236-.016-.271.169-.139.363-.037.282-.566.347-.277.817.139.227-.244.156-.4.2A1,1,0,0,1,364.29,55.205Z",
    transform: "translate(-359.54 -46.4)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M363.9,57.634q0,.427,0,.854c0,.112,0,.224,0,.336C363.453,58.427,363.719,58.031,363.9,57.634Z",
    transform: "translate(-359.15 -48.829)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M375.8,60.05h.481c-.28.174-.557.265-.814,0Z",
    transform: "translate(-367.682 -50.566)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M405.252,66.82q-.787.113-.675-.683h.338Z",
    transform: "translate(-388.69 -54.942)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M406.118,53.8c-.612-.173-.224-.683-.338-1.024C406.391,52.944,406,53.454,406.118,53.8Z",
    transform: "translate(-389.556 -45.333)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M360.659,49.978c-.217.619-.61-.008-.951.092-.4.116-.932.428-1.412.078-.222-.439.178-.454.395-.593.127.006.155-.1.112-.431h.5a1.4,1.4,0,0,0,1.525.151l.167.188-.17.342A.2.2,0,0,1,360.659,49.978Z",
    transform: "translate(-355.234 -42.71)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M355.621,50.466c-.216.124-.5.177-.51.513-.769.521-.814.736-.262,1.233.01.009,0,.055-.016.078a.257.257,0,0,1-.061.055,1.352,1.352,0,0,1-.846-.175.838.838,0,0,1,.174-1.02c.453-.282.793-.748,1.353-.857Q355.689,50.229,355.621,50.466Z",
    transform: "translate(-352.048 -43.541)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M352.652,52.01a3.037,3.037,0,0,1-.174,1.02l-.664-.16.152-.349.5-.849.169-.2Q352.645,51.742,352.652,52.01Z",
    transform: "translate(-350.6 -44.401)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M359.814,49.632l-.167-.173c.071-.1-.173-.365.164-.338C359.752,49.292,360.336,49.458,359.814,49.632Z",
    transform: "translate(-356.242 -42.707)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M411.476,59.182a15.716,15.716,0,0,0,2.523-.35c.415.136.1.313.027.477a2.089,2.089,0,0,1-1.27.329c-.693.073-1.023.355-.832,1.094a.98.98,0,0,1-.037.741c-.178.189-.307.106-.418-.077l-.161-.516a2.4,2.4,0,0,0,.005-1.35Z",
    transform: "translate(-393.561 -49.69)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M406.188,67.954l.332.173.04.1a.82.82,0,0,1-.247.33,2.223,2.223,0,0,1-.279.3.153.153,0,0,1-.181-.043,3.423,3.423,0,0,0-1.355.667.21.21,0,0,1-.326.014l-.177-.316C404.686,68.7,405.582,68.593,406.188,67.954Z",
    transform: "translate(-388.279 -56.249)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M411.314,61.313a1.314,1.314,0,0,1-.005,1.35Q411.311,61.988,411.314,61.313Z",
    transform: "translate(-393.561 -51.474)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M366.092,51.722l.168-.173c.349.226.224.546.166.852l-.67,0c0-.056,0-.113,0-.169C366.238,52.313,366.148,52.006,366.092,51.722Z",
    transform: "translate(-360.666 -44.454)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M458.07,56.587c-.21.228.691.455,0,.683-.4-.168-.6-.416-.337-.854h.337Z",
    transform: "translate(-426.997 -47.953)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M412.51,58.075c.065-.654-.526-1.442,0-1.909a2.95,2.95,0,0,1,1.821-.33,1.155,1.155,0,0,0,.381-.155c.449-.266.1-1.084.793-1.181.48-.132,1,.062,1.465-.19a2.324,2.324,0,0,1,.184-.273l.089-.064.675,0c.309.684.907.2,1.349.341a2.619,2.619,0,0,1,.384,3.106c-.4.307-.9.117-1.325.271a1.329,1.329,0,0,1-.277.053,1.615,1.615,0,0,1-.567-.055,2.467,2.467,0,0,0-1.649.339,4.1,4.1,0,0,1-3.3.039Z",
    transform: "translate(-394.269 -46.196)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M444.172,53.382c-.071.359.185.585.337.854.427.8.076,1.593,0,2.389-.056.075-.112.072-.17,0a1.943,1.943,0,0,1-1.013.342c-.174.04-.256-.078-.336-.2-.145-.466-.529-.406-.888-.423a14.579,14.579,0,0,1-2.73-.1c-.337-.228-.247-.54-.118-.821a1.354,1.354,0,0,0-.207-1.622.562.562,0,0,1-.109-.759c.461.123.8-.178,1.182-.341,1.222-1,2.33-.289,3.44.25A2.222,2.222,0,0,1,444.172,53.382Z",
    transform: "translate(-413.437 -44.92)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M437.86,54.634c.063.183.072.43.2.539a1.5,1.5,0,0,1,.173,2.2c-.052.083-.023.219-.032.33a.347.347,0,0,1-.507,0c.061-.425-.143-.883.229-1.272.234-.244-.033-.453-.16-.657a1.555,1.555,0,0,1-.407-1.144C437.522,54.107,437.691,54.69,437.86,54.634Z",
    transform: "translate(-412.355 -46.512)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M447.523,52.81a9.418,9.418,0,0,1-1.575-.758,3.4,3.4,0,0,0-2.475.075c.336-.823,1.06-.8,1.687-.629C446.031,51.739,447.024,51.848,447.523,52.81Z",
    transform: "translate(-416.788 -44.347)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M434.808,46.471l-.837.015a1.175,1.175,0,0,1-.857-.512l.179-.178c.47-.283,1.038-.127,1.521-.347l.008-.005A.753.753,0,0,1,434.808,46.471Z",
    transform: "translate(-409.307 -40.065)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M433.97,45.011c-.409.555-1,.282-1.521.347l-.5-.335.505-.189C432.9,45.36,433.5,44.629,433.97,45.011Z",
    transform: "translate(-408.462 -39.627)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M422.824,47.91l.676-.01c.126.022.259.035.307.188a1.923,1.923,0,0,1-.513.406.27.27,0,0,1-.3-.1Z",
    transform: "translate(-401.876 -41.83)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M424.622,48.867c.02-.326.24-.341.484-.318l.049.177a.225.225,0,0,1-.018.323l0,0C424.922,49.118,424.671,49.29,424.622,48.867Z",
    transform: "translate(-403.175 -42.292)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M426.473,49.448l.017-.323.48-.028.181.182C426.971,49.524,426.708,49.428,426.473,49.448Z",
    transform: "translate(-404.511 -42.691)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M424.075,51.661c0-.189.026-.388-.171-.509-.128-.357-.014-.47.338-.343a.36.36,0,0,0,.341.177c.169.62.679.216,1.011.345v.331l0,0a1.278,1.278,0,0,1-1.5.006Z",
    transform: "translate(-402.619 -43.885)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M423.167,50.017a.31.31,0,0,0-.338.343H422.5a.509.509,0,0,1-.009-.68l.176-.024.325.012c.118.218.326.172.516.178A.369.369,0,0,1,423.167,50.017Z",
    transform: "translate(-401.545 -43.094)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M446.207,81.852h1.35c.061.5-.121.732-.649.694-.21-.015-.595-.155-.6.214-.006.291.3.437.611.456.261.016.591-.084.641.343a.835.835,0,0,1-.58.216,1.829,1.829,0,0,1-1.414-.387c-.167-.16-.42-.225-.478.153-.047.531-.158.975-.843.634-.069-.05-.085-.166-.136-.195-.186-.1-.073.089-.074.113-.016.425.18.9-.286,1.213-.414-.038-.816.345-1.239.039-.376-.618-.724-1.252-1.145-1.967.334.841,1.036,1.4,1.015,2.281-.112.5.375.917.208,1.427-.426.213-.988.266-1.052.911a.341.341,0,0,1-.22.069c-.391-.172-.861-.248-.943-.794.052-.32-.2-.279-.384-.327-.3-.109-.648-.053-.9-.294-.134-.454.2-.48.491-.564.244-.07.551.114.729-.189a1.038,1.038,0,0,0-.956-.42.853.853,0,0,1-.841-.576,2.93,2.93,0,0,1,1.62-3.452c1.576-.015,3.161.4,4.726-.106C445.343,81.406,445.732,81.748,446.207,81.852Z",
    transform: "translate(-413.109 -65.877)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M492.194,85.578a2.566,2.566,0,0,1,.335,1.45,2.085,2.085,0,0,0,1.079,1.838c.34.239.584.128.608-.324a.489.489,0,0,0,0-.169c-.309-.937.651-1.552.6-2.431a.3.3,0,0,1,.4-.306c.223.093.061.285.036.439a11.872,11.872,0,0,1-1.042,3.431,1.751,1.751,0,0,1-1.278.257c-.19-.134-.2-.3-.056-.554-.2.162,0,.523-.336.5a.555.555,0,0,1-.207-.308c-.06-.253-.145-.5-.183-.757-.026-.132-.031-.266-.054-.4A2.621,2.621,0,0,1,492.194,85.578Z",
    transform: "translate(-451.672 -68.92)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M510.262,97.354c.024-.236-.078-.5.169-.683.112.139.224.133.337,0,.016-.425.36-.692.492-1.059.1-.275.29-.383.51-.244.285.179.2.443-.018.631a2.309,2.309,0,0,0-.795,1.444c-.057.393-.126.84.564.622a2.3,2.3,0,0,1,.916-.022.969.969,0,0,0,1.2-.86c.554.062.572.115.3.84a1.564,1.564,0,0,1-1.055.642,2.227,2.227,0,0,0-1.837,1.115c-.344-.2-.445-.6-.691-.889A5.708,5.708,0,0,0,510.262,97.354Z",
    transform: "translate(-465.015 -75.916)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M491.662,114.59a5.148,5.148,0,0,0,.579-.046c.308-.058.491.092.343.352-.45.8-.115,1.661-.315,2.51l.742-.085a.588.588,0,0,1,.141.6c-.38.843-.884.131-1.336.111a3.667,3.667,0,0,1-1.261-.057c-.327-.2-.631-.408-.306-.847a.508.508,0,0,1,.237-.083c.414.044.552-.169.635-.565A7.348,7.348,0,0,1,491.662,114.59Z",
    transform: "translate(-450.465 -89.737)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M524.03,90.434a1.889,1.889,0,0,0,1.351.341v.341c-.776.453-1.618.159-2.427.223a3.179,3.179,0,0,1-.554-.156c-.573-.157-.918.174-.775.743a1.706,1.706,0,0,1-.032.989c-.2.371-.325.883-.938.591,0-.14-.044-.312.019-.414.486-.784.463-1.319-.609-1.41-.034,0-.057-.147-.084-.225.132-.039.3-.038.389-.124C521.419,90.307,522.74,90.441,524.03,90.434Z",
    transform: "translate(-472.034 -72.41)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M498.677,120.774q0-.342,0-.683c.431-.21.46.148.52.4a9.033,9.033,0,0,1,.062,1.127c.382-.465.018-1.112.43-1.528-.171-.576.259-1.017.338-1.537.389-.358.466-.09.414.243a5.609,5.609,0,0,0-.194,1.4c0,.13,0,.261,0,.391,0,.085,0,.17,0,.255a4.5,4.5,0,0,1-.069.976c-.028.175-.261.337-.031.531a.989.989,0,0,1,.142.153.836.836,0,0,1,.149.413.616.616,0,0,1-.27.5c-.968.034-1.439-.827-2.167-1.229a.353.353,0,0,1-.043-.229C498.15,121.526,498.6,121.267,498.677,120.774Z",
    transform: "translate(-456.131 -92.507)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M492.619,107.313c.2.81-.369,1.489-.384,2.279-.007.363-.384.608-.8.282a1.722,1.722,0,0,0,.032-.6,1.073,1.073,0,0,1,.025-.439,4.17,4.17,0,0,1,.3-.747c.543-.5-.415-.916-.079-1.4-.445-.308.079-.476.1-.716,0-.068,0-.135,0-.2.021-.231-.169-.35-.272-.515-.029-.357-.211-.79.4-.835A5.007,5.007,0,0,1,492.619,107.313Z",
    transform: "translate(-451.422 -82.46)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M487.654,98.335v.34c-.141.415-.656.358-.855.7-.042.063-.087.124-.13.187-.474.589-.211,1.256-.2,1.9a.925.925,0,0,1-.536.687c-.612-.112-.825-.564-.9-1.114-.024-.167.022-.334.259-.306.741-.622.723-1.572,1.012-2.39A1.078,1.078,0,0,1,487.654,98.335Z",
    transform: "translate(-446.795 -77.922)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M482.231,98.6c-.227.683.214,1.03.674,1.366.258.368.07.6-.236.8a1.094,1.094,0,0,1-.394.084.979.979,0,0,1-.5-.1.374.374,0,0,1-.137-.2.434.434,0,0,1,.041-.226c.063-.077.15-.032.227-.043-.065-.071-.177-.065-.238-.148a.518.518,0,0,1-.043-.329c.31-.8-.482-.868-.813-1.243a.369.369,0,0,1,.062-.35.762.762,0,0,1,.6-.1c.435.135.478-.016.323-.4a6.823,6.823,0,0,1-.438-2.524.15.15,0,0,1,.206,0h.168c.593.576.288,1.378.507,2.049C482.208,97.693,482.587,98.148,482.231,98.6Z",
    transform: "translate(-443.733 -75.8)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M474.269,98.369h-.674c-1.151.117-1.587-.126-1.99-1.128a1.466,1.466,0,0,0-.454-.588.99.99,0,0,1-.353-1.258l.1-.1c.348-.007.533.041.712.479a4.179,4.179,0,0,0,2.156,2.254c.177.133.3-.112.45-.074C474.572,98.04,474.511,98.2,474.269,98.369Z",
    transform: "translate(-436.448 -75.906)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M479.073,87.639H478.9c-.056.088-.112.084-.168,0s-.173-.212-.15-.279a1.853,1.853,0,0,0-1.235-2.59c.773-.257,1.126-.137,1.828.548a1.131,1.131,0,0,1,.141,1.265A2.462,2.462,0,0,0,479.073,87.639Z",
    transform: "translate(-441.251 -68.25)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M501.561,121.9c-.049.738.223,1.56-.675,2.253,0-.624.005-1.113,0-1.6,0-.269.077-.593-.335-.651,0-.168,0-.336,0-.5.007-.225-.009-.474.307-.5s.359.193.363.438S501.2,121.862,501.561,121.9Z",
    transform: "translate(-458.002 -94.314)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M481.882,95.3h.168c.3.828.187,1.768.666,2.549.149.243.19.461-.058.674s-.34.039-.441-.149c.239-.729-.587.151-.5-.342A9.427,9.427,0,0,0,481.882,95.3Z",
    transform: "translate(-444.397 -75.909)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M491.482,85.551a3.841,3.841,0,0,0,.168,2.731.631.631,0,0,1-.747.1l-.1-.095c0-.7.027-1.393-.009-2.087C490.77,85.66,491,85.494,491.482,85.551Z",
    transform: "translate(-450.96 -68.893)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M461.69,87.348c.009-.848.645-.379.754-.242a1.34,1.34,0,0,0,1.27.413,1.675,1.675,0,0,1,.675,1.2q0,.256,0,.511l0,0a.193.193,0,0,1-.223.017,2.724,2.724,0,0,0-1.753-1.367A1.366,1.366,0,0,1,461.69,87.348Z",
    transform: "translate(-429.942 -69.837)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M506.919,102.587c.344.54.092,1.14.169,1.707.449.36.289.785.116,1.2-.223.536-.674.585-1.166.531l-.132-.024c-.413-.078-.3-.316-.066-.417C507.266,104.965,506.891,103.706,506.919,102.587Z",
    transform: "translate(-461.673 -81.149)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M490.674,102.1c-.479.135-.151.6-.338.852.17.13.2.354.337.509v.173c-.4.495-.638.227-.843-.189a2.162,2.162,0,0,1,.169-1.859h0c.208-.163.388-.378.682-.39.178.07.4.1.33.388A.519.519,0,0,0,490.674,102.1Z",
    transform: "translate(-450.152 -80.154)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M505.379,117.451a2.992,2.992,0,0,1,.228-1.469c.13-.3.045-.352-.229-.241.162-.384.459-.729.337-1.194l0,0a.318.318,0,0,1,.319-.055,1.22,1.22,0,0,1,.323,1.233,1.317,1.317,0,0,1-.039.216,2.483,2.483,0,0,1-.194.5,1.119,1.119,0,0,0-.2.365c-.02.107-.039.213-.064.318a.738.738,0,0,1-.091.205C505.661,117.44,505.55,117.547,505.379,117.451Z",
    transform: "translate(-461.481 -89.695)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M522.409,99.625c.548.109.549-.472.842-.683a2.949,2.949,0,0,1,.432,2.319c-.527.09-.7-.471-1.106-.611-.08-.28.5-.694-.169-.853Z",
    transform: "translate(-473.788 -78.529)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M493.6,100.375l-.337-.335a1.935,1.935,0,0,1,.677-.346,3.454,3.454,0,0,1,1.349-.171c.02.336-.106.568-.467.5A1.978,1.978,0,0,0,493.6,100.375Z",
    transform: "translate(-452.74 -78.938)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M490.924,96.322h-1.35c.114-.341-.273-.851.337-1.025.183.363.51.359.843.342Z",
    transform: "translate(-450.064 -75.909)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M484.659,97.338l-.507-2.049c.4-.033.524.177.511.554C484.645,96.341,484.659,96.84,484.659,97.338Z",
    transform: "translate(-446.162 -75.9)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M469.649,90.418c-.158-.437-.589-.717-.675-1.2h.675Z",
    transform: "translate(-435.202 -71.541)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M511.2,100.159c-.018.155-.02.374-.2.37-.226-.005-.1-.24-.135-.37Z",
    transform: "translate(-465.451 -79.403)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M515.039,96.6c.6-.166.831.219,1.012.683a1.039,1.039,0,0,1,.073,1.653c-.55.406-.469.94-.226,1.686-.18-.655-.329-1.12.125-1.5.873-.473.433-1.212.357-1.865a15.435,15.435,0,0,1-.5-2.621c-.073-.664.175-1.039.879-1a1.62,1.62,0,0,0,.554-.077,2.211,2.211,0,0,1,2.278.139c.116.168.268.139.446.122a2.238,2.238,0,0,1,2.325,1.466,1.006,1.006,0,0,0,.941.633c.2.761-.21,1.359-.865,1.118-.737-.271-1.685.061-2.226-.769-.03-.046-.124-.091-.143-.071-.4.428-1.243.49-1.363.894a2.049,2.049,0,0,0,.19,1.975.99.99,0,0,0,.234-.009c.254-.08.2-.306.226-.489.145-.931.235-1.006,1.19-.931a9.315,9.315,0,0,0,1.655.09c.668-.03,1.176-.536,1.822-.632a1.7,1.7,0,0,1,.913.072c.524.494.76,1.3,1.577,1.481l.5,0c0,.112,0,.225,0,.338.167.229.486.154.672.344q0,.084,0,.168c.343.485.907.674,1.349,1.027a5.929,5.929,0,0,0,1.182,1.194c-.176.23.192.189.166.344a.506.506,0,0,1-.586.121c.155.184.4.286.419.561l.337.341-1.005-.025c-.313-.475-.717-.422-1.169-.232a.616.616,0,0,1-.823-.194c-.184-.272-.115-.467.112-.733.352-.413-.135-.518-.368-.587a9.006,9.006,0,0,0-1.326-.172c-.337-.089-.653-.243-.99-.334a3.728,3.728,0,0,0-1.354-.529,4.412,4.412,0,0,0-1,.612,2.321,2.321,0,0,1-2.311.128c-.34-.106-.293-.478-.466-.726a2.247,2.247,0,0,1-.959,2.52c-.392.264-.493.739-.688,1.142a1.481,1.481,0,0,1-.461.585,1.238,1.238,0,0,1-.486.12c-.243,0-.494.092-.728-.051a.458.458,0,0,1-.081-.453.8.8,0,0,0,.159-.712c-.042-.246.035-.493-.011-.738-.029-.149.016-.325-.155-.421-.1-.033-.192-.056-.288-.084a.715.715,0,0,1-.19-.1.877.877,0,0,1-.258-.472c-.482-.381-1.053-.255-1.594-.29a.841.841,0,0,0-.6,0c-.231.068-.21.386-.44.454a.416.416,0,0,1-.226-.05,3.4,3.4,0,0,1-.165-2.128c.025-.33.312-.433.58-.531a.345.345,0,0,0,.258-.453.366.366,0,0,0-.274-.287c-.239-.05-.343.12-.443.3-.151.271-.066.714-.535.757a.3.3,0,0,1-.211-.156.838.838,0,0,1,.108-.945c.356-.726.719-1.4,1.731-1.219C514.335,97.17,514.6,96.639,515.039,96.6Z",
    transform: "translate(-466.249 -74.482)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M535.35,105.46c-.226-.011-.469,0-.5-.319a14.69,14.69,0,0,0-.122-2.109c-.084-.366.325-.277.554-.3.311-.033.667.105.751-.429.107-.683.574-.52.769-.131.279.557.679.582,1.169.562a1.578,1.578,0,0,1,.579.052c.89.316,1.074.208,1.183-.739.5-.165.6.482,1.012.512l.05.114a.53.53,0,0,1-.1.221,2.966,2.966,0,0,1-3.31.61c.362.3,1.057-.042,1.333.591-.663-.046-1.332-.051-1.987-.149-.587-.087-.748.137-.723.687.017.359.166.861-.5.828a3.839,3.839,0,0,1-.073-1.246C535.356,104.584,535.537,105.037,535.35,105.46Z",
    transform: "translate(-482.678 -80.608)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M532.246,93.379c-.745-.125-1.507-.47-2.194.17-.192-.21-.742-.148-.506-.683h2.7C532.509,93.038,532.777,93.209,532.246,93.379Z",
    transform: "translate(-478.9 -74.161)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M556.409,104.113v-.171c0-.057,0-.113,0-.17.315-.071.485.154.672.341,0,.056,0,.112,0,.167C556.794,104.487,556.591,104.344,556.409,104.113Z",
    transform: "translate(-498.339 -81.992)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M421.833,55.521c-.606.069-.221.968-.84,1.025.019-.114.189-.231,0-.343.127-.363.1-.8.507-1.025l.51,0,.038.1A.457.457,0,0,1,421.833,55.521Z",
    transform: "translate(-400.552 -47.062)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M424.664,54l1.5-.006c0,.114,0,.228,0,.341a1.574,1.574,0,0,1-1.51,0l-.009,0Q424.656,54.16,424.664,54Z",
    transform: "translate(-403.194 -46.209)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M556.125,247.784l.508.015-.352.335-.175-.022-.327-.321Z",
    transform: "translate(-497.885 -185.543)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M569.908,116.365c-.558-.2-1.193-.289-1.349-1.027A2.649,2.649,0,0,1,569.908,116.365Z",
    transform: "translate(-507.113 -90.317)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M566.8,113.848c-.265-.033-.621.117-.672-.344a1.135,1.135,0,0,1,.673.175C566.8,113.735,566.8,113.792,566.8,113.848Z",
    transform: "translate(-505.36 -88.995)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M555.518,105.018l.673.168.171.343-.025.084a.244.244,0,0,1-.144.088h-1.012c-.052-.31.214-.46.336-.683Z",
    transform: "translate(-497.448 -82.897)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M559.85,107.177v.341c-.413-.043-.642-.226-.507-.685h0C559.606,106.806,559.676,107.07,559.85,107.177Z",
    transform: "translate(-500.43 -84.2)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M564.385,128.946c0,.053,0,.106-.007.159l-.333.009a.68.68,0,0,1-.185-.131,4.957,4.957,0,0,1-1.554-.92c.068-.5.268-.878.822-.938a3.187,3.187,0,0,0,1.728.312c.138.006.227.148.372.14l.169.152c0,.117,0,.235,0,.353C564.988,128.286,564.826,128.783,564.385,128.946Z",
    transform: "translate(-502.598 -98.792)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M562.484,120.7c.891-.1,1.754-.124,2.277.862a.949.949,0,0,1-.167.139c-.183.094-.6-.1-.491.344.094.391.408.46.722.26.594-.379.983-.241,1.209.42-.28-.056-.569-.317-.831.038l-.115.036a1.354,1.354,0,0,1-1.765-1.04C563.188,121.268,562.515,121.247,562.484,120.7Z",
    transform: "translate(-502.726 -94.136)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M572.186,128.258c-.069.143-.135.105-.2,0-.044-.044-.056-.086-.037-.126s.035-.057.052-.057l.031.023Z",
    transform: "translate(-509.555 -99.472)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M569.785,131.306c.3-.332.263-1.066,1.009-.864l.51.176C571.078,131.482,570.351,131.211,569.785,131.306Z",
    transform: "translate(-507.998 -101.152)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M575.325,125.147c-.3-.117-.422-.494-.9-.465.416-.33.756-.171,1.068-.218C575.471,124.7,575.571,124.967,575.325,125.147Z",
    transform: "translate(-511.348 -96.878)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M559.007,106.841a.819.819,0,0,0,.507.685c.279.287.668.461.847.85-1.031.144-1.229-.665-1.522-1.363Z",
    transform: "translate(-500.094 -84.208)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M590.712,219.016q-.008.083-.011.166l-.672.344h0a.714.714,0,0,1-.141-.24.523.523,0,0,1,.156-.517.549.549,0,0,1,.656.07Z",
    transform: "translate(-522.508 -164.625)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M584.9,227.948c-.034.473.05,1.025-.68,1.026h0c.123-.353-.27-.182-.338-.341h0c-.333-.264-.973.09-1.111-.567a.64.64,0,0,1,.123-.343.376.376,0,0,1,.3-.166.65.65,0,0,0,.617-.047,1.415,1.415,0,0,0,.412-.314.5.5,0,0,1,.173-.115l.3.183.181.233A.445.445,0,0,1,584.9,227.948Z",
    transform: "translate(-517.377 -170.659)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M587.222,226.216l-.016.2c-.185.107-.364.148-.517-.053.068-.158-.047-.33.032-.488l.488.026Q587.215,226.06,587.222,226.216Z",
    transform: "translate(-520.205 -169.792)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M590.188,229.012c-.076-.146-.154-.292-.026-.45l.358.118q0,.169,0,.337Z",
    transform: "translate(-522.664 -171.723)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M584.4,224.21c-.006.12.178.254-.026.36a.578.578,0,0,1-.473.173.62.62,0,0,1-.361-.137.855.855,0,0,1,0-.645.517.517,0,0,1,.477-.4.441.441,0,0,1,.355.154Z",
    transform: "translate(-517.885 -168.126)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M585.726,222.547l-.307-.016a.169.169,0,0,1-.064-.194.789.789,0,0,1,.4-.388.3.3,0,0,1,.311.082l.193.5Z",
    transform: "translate(-519.235 -166.96)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M585.666,220.731l-.316-.019a.588.588,0,0,1-.542-.133.354.354,0,0,1,.165-.409.567.567,0,0,1,.233-.04,6.333,6.333,0,0,0,.707.063.661.661,0,0,1,.436.2c0,.057.005.115.008.172Z",
    transform: "translate(-518.834 -165.66)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M570.171,230.573c-.12.426-.321.637-.828.532-.294-.06-.768-.222-.883.346-.471.317-.991.081-1.485.14a.921.921,0,0,1-.261-.052c-.205-.121-.148-.281-.064-.446a.684.684,0,0,1,.265-.233,2.275,2.275,0,0,0,.714-.2.685.685,0,0,1,.21-.012,1.312,1.312,0,0,0,.721-.06c.34-.137.775.09,1.05-.286.08-.131.156-.266.326-.293a.466.466,0,0,1,.29.342A.254.254,0,0,1,570.171,230.573Z",
    transform: "translate(-505.68 -172.767)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M579.262,229.347l-.012-.176c-.226-.415.025-.621.34-.8.475-.22.526.193.673.463.116.565.818.237,1.014.681l-.34,0c-.256.226-.56.157-.854.145a.755.755,0,0,0-.663-.154Z",
    transform: "translate(-514.771 -171.541)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M567.136,235.129h1.683c0,.1-.008.2-.013.3a.442.442,0,0,1-.655.033h-.327c-.238.123-.461.006-.688-.047A.187.187,0,0,1,567.136,235.129Z",
    transform: "translate(-506.037 -176.444)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M570.716,236.228l.656-.033c.132.082.368.162.23.347-.235.314-.595,0-.907.085C570.536,236.668,570.688,236.371,570.716,236.228Z",
    transform: "translate(-508.604 -177.211)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M581.28,232.588l1.01.007c-.255.617-.788.225-1.183.334C581.005,232.732,580.979,232.575,581.28,232.588Z",
    transform: "translate(-516.124 -174.617)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M580.6,232.014a.364.364,0,0,0-.173.341.305.305,0,0,1-.333-.343C580.258,231.887,580.428,231.579,580.6,232.014Z",
    transform: "translate(-515.439 -174.043)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M586.771,232.6c.213.012.525-.077.338.341A.309.309,0,0,1,586.771,232.6Z",
    transform: "translate(-520.264 -174.625)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M386.766,91.339c.031-.3-.383-.386-.323-.7.136-.108.169-.317.358-.373.21.014.3.184.4.327a5.149,5.149,0,0,1,.331.446.52.52,0,0,1-.034.459.4.4,0,0,1-.211.113A.647.647,0,0,1,386.766,91.339Z",
    transform: "translate(-375.601 -72.291)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M384.506,86.222a.805.805,0,0,0,.125-.019c.26-.025.323.237.492.345a.286.286,0,0,1,.086.341c-.1.153-.227.25-.422.175A.586.586,0,0,1,384.506,86.222Z",
    transform: "translate(-374.15 -69.369)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M385.723,88.8l.321-.184a.315.315,0,0,1,.28.187.288.288,0,0,1-.076.325c-.016.2-.089.342-.32.326A1.132,1.132,0,0,0,385.723,88.8Z",
    transform: "translate(-375.086 -71.102)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M387.173,94.08l.512.175c0,.37-.221.416-.514.349l-.17-.011Z",
    transform: "translate(-376.008 -75.033)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M383.854,79.227c.012.278.152.625-.333.636,0-.176.026-.359-.161-.468C383.41,78.993,383.635,79.119,383.854,79.227Z",
    transform: "translate(-373.379 -64.277)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M383.271,78.628c-.181.006-.376-.027-.494.168H382.7l-.079,0a1.376,1.376,0,0,1-.023-.157.123.123,0,0,1-.037-.124c.013-.041.026-.061.039-.061q.011-.079.018-.158C382.9,78.273,383.175,78.27,383.271,78.628Z",
    transform: "translate(-372.796 -63.677)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M382.278,78.873c0,.062,0,.123,0,.185-.055,0-.11-.01-.165-.017Z",
    transform: "translate(-372.478 -64.099)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M386.6,79.142c.054.133.122.215.106.273-.076.271.259.536.012.793a.238.238,0,0,1-.226-.026A.874.874,0,0,1,386.6,79.142Z",
    transform: "translate(-375.552 -64.293)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M390.239,86.8l0,1.022c-.354.133-.466.019-.339-.34q0-.341,0-.683Z",
    transform: "translate(-378.067 -69.799)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M388.911,89.217a.312.312,0,0,0,.339.34c0,.056,0,.112,0,.169a.146.146,0,0,1,.05.132c-.008.048-.019.071-.031.071a.379.379,0,0,1-.326.061.934.934,0,0,1-.411-.375.368.368,0,0,1-.034-.32l.074-.082Z",
    transform: "translate(-377.075 -71.533)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M387.065,87.917l-.187-.178c0-.11.01-.221.015-.331.38-.054.562.106.527.5v0A.249.249,0,0,1,387.065,87.917Z",
    transform: "translate(-375.92 -70.229)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M388.8,79.5a.311.311,0,0,1,.339.342c-.035.115-.036.324-.211.234C388.707,79.96,388.838,79.7,388.8,79.5Z",
    transform: "translate(-377.305 -64.551)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M433.783,115.535a.3.3,0,0,1-.336-.326c-.094-.147-.151-.321-.314-.415a.553.553,0,0,1-.271-.5.4.4,0,0,1,.143-.21,1.063,1.063,0,0,1,.51-.133,1.66,1.66,0,0,1,.931.143.6.6,0,0,1,.143.619.4.4,0,0,1-.15.184c-.119.126-.241-.292-.359,0C434.255,115.248,433.947,115.356,433.783,115.535Z",
    transform: "translate(-409.124 -89.318)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M436.689,116.931l.2-.008c.329.021.327.31.418.525a.485.485,0,0,1-.067.353c-.143.193-.356.137-.547.158-.175-.107-.247-.37-.509-.345-.012-.23.395-.456.005-.688A.4.4,0,0,1,436.689,116.931Z",
    transform: "translate(-411.521 -91.397)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M430.912,117.237a.333.333,0,0,1-.47-.008.361.361,0,0,1-.132-.2.406.406,0,0,1,.121-.345.642.642,0,0,1,.367-.1.519.519,0,0,1,.347.152.272.272,0,0,1-.066.348Z",
    transform: "translate(-407.281 -91.212)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M433.072,117.112l0-.323c.081-.162.263-.086.379-.166.455.048.194.311.15.509Z",
    transform: "translate(-409.274 -91.24)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M439.712,117.463l-.082-.327a.309.309,0,0,1,0-.221c.129-.189.206-.419.416-.546.329,0,.551.121.565.49a.818.818,0,0,1-.357.482.885.885,0,0,1-.456.115l-.042-.005Z",
    transform: "translate(-413.997 -91.059)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M440.277,119.44c.07-.176.233-.175.381-.2.235-.107.469-.2.687.035-.007.244-.012.49-.348.5-.131-.208-.333-.165-.527-.154Z",
    transform: "translate(-414.479 -93.042)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M450.779,117.554l-.508-.184a.787.787,0,0,1,0-1.012c.646-.461.214-1.14.339-1.707l.107-.035c.216.058.41.18.627.237a5.141,5.141,0,0,1,.7.4c.221.2.586.311.479.733-.581.117-.549.637-.674,1.053a.77.77,0,0,1-.369.264,1.828,1.828,0,0,0-.514.157A.918.918,0,0,1,450.779,117.554Z",
    transform: "translate(-421.563 -89.797)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M442.335,114.185l-.687-.035.345-.329c.3-.217.137-.538.179-.815a1.114,1.114,0,0,1,.056-.23,1.348,1.348,0,0,1,.25-.422c.228-.185.433-.479.768-.17a1.278,1.278,0,0,1,.148.672c-.075.456.109.991-.392,1.317h0a.385.385,0,0,1-.509.018l-.077-.024Z",
    transform: "translate(-415.469 -87.953)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M446.518,115.9c.29-.423.083-.917.192-1.365a.258.258,0,0,1,.229-.083.293.293,0,0,1,.191.16.558.558,0,0,1-.107.6C447.03,115.571,447.062,115.95,446.518,115.9Z",
    transform: "translate(-418.986 -89.675)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M449.332,112.846h-.676a.227.227,0,0,1-.338,0v0c-.052-.767.541-.656.988-.742a.488.488,0,0,1,.167.5.536.536,0,0,1-.141.238Z",
    transform: "translate(-420.283 -87.993)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M449.529,120.816q0,.506,0,1.012l-.342.025.014-.022a.478.478,0,0,1-.007-.672A.311.311,0,0,1,449.529,120.816Z",
    transform: "translate(-420.82 -94.256)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M447.8,122.034q0,.336.007.672l-.679-.009A.883.883,0,0,1,447.8,122.034Z",
    transform: "translate(-419.424 -95.131)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M444.684,119.628l.509-.018c-.046.238-.071.581-.34.568S444.735,119.821,444.684,119.628Z",
    transform: "translate(-417.661 -93.388)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M448.325,114.739h.338c-.031.268.117.627-.336.682Q448.326,115.081,448.325,114.739Z",
    transform: "translate(-420.291 -89.886)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M427.963,117.658a.3.3,0,0,1,.033.126l-.023.2a1.175,1.175,0,0,0-.822.175l-.19-.163c.036-.172-.09-.338-.018-.511a.377.377,0,0,1,.4-.118A.793.793,0,0,0,427.963,117.658Z",
    transform: "translate(-404.835 -91.768)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M457.08,123.6c-.187.026-.4-.026-.514.2l-.5-.188a.191.191,0,0,1-.06-.14c0-.053.007-.079.017-.08a2.1,2.1,0,0,1,.533-.511.452.452,0,0,1,.6.071A.539.539,0,0,1,457.08,123.6Z",
    transform: "translate(-425.838 -95.683)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M453.59,124.421v.172l-1.008-.031c0-.047,0-.095,0-.142l.018-.206c.238-.139.457.066.689.039A.41.41,0,0,1,453.59,124.421Z",
    transform: "translate(-423.363 -96.663)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M459.765,123.131q0-.339-.005-.678a.168.168,0,0,1,.007-.214.5.5,0,0,1,.444-.062.646.646,0,0,1,.255.184c.12.188.29.031.435.062a.45.45,0,0,1,.251.494c-.362.321-.838-.015-1.217.215Z",
    transform: "translate(-428.523 -95.216)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M460.482,124.725c.328-.358.861.044,1.185-.329a.166.166,0,0,1,.208.015.376.376,0,0,1,.026.23l-.069.1-1.023.008Z",
    transform: "translate(-429.07 -96.809)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M426.552,113.585l-.325.136q-.061.115-.161.032l0-.009a.384.384,0,0,1-.123-.119.4.4,0,0,1-.047-.166l.01-.087a.727.727,0,0,1,.012-.144.96.96,0,0,1,.563-.954,3.372,3.372,0,0,0,.6-.307.394.394,0,0,1,.334.037.443.443,0,0,1,.1.326.913.913,0,0,0,.126.748.283.283,0,0,1-.074.312l-.324.056C427.051,113.659,426.771,113.463,426.552,113.585Z",
    transform: "translate(-404.099 -87.878)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M426.047,110.1a2.41,2.41,0,0,0-.645.841l-.2-.3c-.119-.387.315-.551.346-.877.636-.271.253-.549,0-.825l.483-.17a.312.312,0,0,1,.275.186,2.238,2.238,0,0,1-.005.8C426.293,109.922,426.164,110.006,426.047,110.1Z",
    transform: "translate(-403.577 -85.59)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M425.468,117.225l.026.171-.392.018.232-.39-.016.039C425.365,117.119,425.415,117.174,425.468,117.225Z",
    transform: "translate(-403.521 -91.529)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M428.44,107.788l-.182-.179c.005-.059.011-.118.017-.178l.071-.095a2.627,2.627,0,0,1,.92-.178.38.38,0,0,1,.391.376.5.5,0,0,1-.189.3,1.548,1.548,0,0,1-.661.2C428.63,108.034,428.539,107.9,428.44,107.788Z",
    transform: "translate(-405.8 -84.436)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M423.444,105.966l.164-.145c.182-.187.453-.261.6-.492a.479.479,0,0,1,.578-.076.462.462,0,0,1,.139.223.513.513,0,0,1-.141.5l.013.044-1.187.015Z",
    transform: "translate(-402.324 -83.02)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M421.378,98.791c-.186,0-.385-.028-.507.171-.347-.441-.385.364-.671.17l-.016-.171a2.553,2.553,0,0,1,.031-1.424l-.067,0c-.122.35.079.744-.12,1.086-.367.031-.283-.4-.511-.511a.975.975,0,0,1-.755-.353.569.569,0,0,1,.3-.731,1.739,1.739,0,0,1,.319-.135,2.847,2.847,0,0,0,.481-.253,1.25,1.25,0,0,0,.527-.356.664.664,0,0,1,.177-.136.521.521,0,0,1,.328,0,.835.835,0,0,0,.8.129,1.238,1.238,0,0,1,.424-.111c.389.137.511.784,1.08.58.076-.006.152-.012.228-.02a.93.93,0,0,1,.448.1.32.32,0,0,1,.136.3.307.307,0,0,1-.116.18c-.235.05-.488-.028-.713.1-.235.089-.415.3-.681.319-.257-.176-.387-.133-.639.121C421.569,98.13,421.628,98.527,421.378,98.791Z",
    transform: "translate(-398.914 -76.498)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M417.418,101.694l.666.346c-.169.27-.346.01-.52.008-.245.162-.042.551-.342.684l-.31-.187a.589.589,0,0,1-.175-.366.648.648,0,0,1,.173-.514A.392.392,0,0,1,417.418,101.694Z",
    transform: "translate(-397.481 -80.43)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M422.985,102.039v-1.163l.156,0v1.507l-.325,0Z",
    transform: "translate(-401.871 -79.918)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M414.956,103.34q.009.169.018.339l-.183.185c-.048,0-.1-.006-.145-.006a.454.454,0,0,1-.574-.224.33.33,0,0,1,.1-.377A.645.645,0,0,1,414.956,103.34Z",
    transform: "translate(-395.542 -81.563)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M424.037,105.838c.209-.117.3-.709.671-.17-.052.465-.41.3-.673.336C424.036,105.949,424.036,105.894,424.037,105.838Z",
    transform: "translate(-402.751 -83.204)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M408.87,106.133l1.013-.006a.461.461,0,0,1,.533.143.191.191,0,0,1-.027.216c-.188.225-.45.115-.68.153a.3.3,0,0,1-.331.079C409.188,106.542,408.826,106.518,408.87,106.133Z",
    transform: "translate(-391.798 -83.67)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M409.749,107.8l.33.026c.017.357.278.346.525.354a.815.815,0,0,0-.03.147l-.834.012c-.113-.18-.474-.21-.326-.55A.3.3,0,0,1,409.749,107.8Z",
    transform: "translate(-392.168 -84.857)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M414.028,105.717l-.013-.195a.353.353,0,0,1-.071-.418l.079-.081.517.174-.193.637Z",
    transform: "translate(-395.437 -82.9)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M407.7,107.725c.125.153.391.2.349.478l-.335,0-.5-.035c.193-.248-.054-.309-.176-.423.1-.2.27-.209.456-.184A.352.352,0,0,1,407.7,107.725Z",
    transform: "translate(-390.479 -84.72)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M407.1,106.722l-.5.078-.165-.089c0-.1,0-.2,0-.306l.5-.17C407.033,106.385,407.189,106.512,407.1,106.722Z",
    transform: "translate(-390.042 -83.773)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M426.35,118.3a.6.6,0,0,0,.161-.032c.19.13.166.258,0,.386a1.176,1.176,0,0,1-.164-.035c-.043-.028-.058-.058-.046-.09s.026-.048.039-.048Z",
    transform: "translate(-404.382 -92.422)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M426.013,119.027c0,.046.007.092.007.138l-.175,0Z",
    transform: "translate(-404.058 -92.969)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M357.739,60.125a.806.806,0,0,1,.158-.038.2.2,0,0,1,.017.329l-.662-.012Z",
    transform: "translate(-354.526 -50.593)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M359.592,59.084q-.008-.164-.017-.329l.19-.012c.438.12.482-.3.678-.509q0,.676,0,1.352l-.334.014-.167-.171C360.137,58.992,359.789,59.116,359.592,59.084Z",
    transform: "translate(-356.204 -49.261)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M392.521,102.073q-.012.068-.026.136L392,102.16a.468.468,0,0,1-.157-.223c-.034-.364-.141-.768.422-.817.316.2.269.518.267.823C392.529,101.986,392.525,102.029,392.521,102.073Z",
    transform: "translate(-379.483 -80.095)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M390.692,103.807c0,.042.007.084.01.126-.234.234-.46.088-.688-.015a.571.571,0,0,0,.02-.114.524.524,0,0,1,.447-.216C390.588,103.625,390.62,103.735,390.692,103.807Z",
    transform: "translate(-378.184 -81.867)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M389.658,101.612l-.487.156-.089-.352-.1.192c-.2-.124-.159-.327-.167-.513l.332-.342C389.678,100.824,389.771,101.157,389.658,101.612Z",
    transform: "translate(-377.322 -79.831)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M412.763,100.59q0,.173,0,.346h0a.224.224,0,0,1-.338,0c-.694-.227.212-.46,0-.688a.519.519,0,0,1-.155-.315.759.759,0,0,1,.063-.356.506.506,0,0,1,.265-.237.3.3,0,0,1,.221.065.752.752,0,0,1,.128.333C412.951,100.037,413.133,100.374,412.763,100.59Z",
    transform: "translate(-394.174 -78.814)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M410.325,100.857q0,.171,0,.341l-.676.006-.332-.007c-.185-.352.074-.429.312-.52A.792.792,0,0,1,410.325,100.857Z",
    transform: "translate(-392.077 -79.764)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M408.411,106.722l-.158-.486h.174c.11.224.513.132.509.48l-.357.062Z",
    transform: "translate(-391.355 -83.773)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M412.688,105.02l.338,0q0,.25-.009.5l-.494-.164Z",
    transform: "translate(-394.438 -82.897)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M405.2,99.025a.307.307,0,0,0-.336.337l-.676,0q0-.168,0-.336c-.042-.2-.2-.161-.341-.175-.249-.019-.515.049-.719-.167a.39.39,0,0,1,.039-.4,1.576,1.576,0,0,1,.956-.18,4.98,4.98,0,0,1,.694.022.846.846,0,0,1,.388.141.561.561,0,0,1,.154.377A.6.6,0,0,1,405.2,99.025Z",
    transform: "translate(-387.627 -77.929)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M400.214,101.655h-.339c-.188-.2-.557-.308-.367-.711a.552.552,0,0,1,.614-.064l.1.091Z",
    transform: "translate(-385.002 -79.876)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M402,97.621l-.006.344a.232.232,0,0,1,0,.339h-.339a.831.831,0,0,1-.2-.607.716.716,0,0,1,.216-.584.258.258,0,0,1,.23.055A.4.4,0,0,1,402,97.621Z",
    transform: "translate(-386.439 -77.209)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M403.4,100.5c0-.113,0-.226,0-.339l.841.006a.227.227,0,0,1,0,.333Z",
    transform: "translate(-387.85 -79.406)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M406.435,100.507v-.333c.149.012.351-.058.413.126s-.131.178-.247.213Z",
    transform: "translate(-390.042 -79.412)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M395.761,99.4l.334.685c-.245.021-.523-.073-.7.2l-1.14,0-.022-.039a.612.612,0,0,1,.134-.547,1.126,1.126,0,0,0,.654-.678.856.856,0,0,1,.6-.386.308.308,0,0,1,.216.136A.545.545,0,0,1,395.761,99.4Z",
    transform: "translate(-381.222 -78.308)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M388.74,98.693c-.164-.271-.332-.043-.5,0a.344.344,0,0,1,.182-.345,1.566,1.566,0,0,1,1.247-.176.689.689,0,0,1,.259.132.372.372,0,0,1,.031.416.509.509,0,0,1-.256.132A1.078,1.078,0,0,1,388.74,98.693Z",
    transform: "translate(-376.904 -77.94)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M387,96.721l.172-.347c.089-.116.16-.253.318-.294a1.12,1.12,0,0,1,.73.157.327.327,0,0,1,.009.318c-.132.158-.332.139-.5.2a.2.2,0,0,1-.2-.019Z",
    transform: "translate(-376.007 -76.469)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M388.878,97.918a1.019,1.019,0,0,1,.139-.03c.388.049.859-.49,1.162.166l-1.3,0A.693.693,0,0,1,388.878,97.918Z",
    transform: "translate(-377.362 -77.655)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M387.95,95.209l-.336.176c0-.112,0-.223,0-.335l.514-.349.153.008C388.531,95.043,388.531,95.043,387.95,95.209Z",
    transform: "translate(-376.45 -75.479)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M390.022,100.152h1.013a.242.242,0,0,1,0,.345c-.542.1-.261.548-.341.842l-.171-.159c.009-.394-.27-.614-.506-.859Q390.022,100.237,390.022,100.152Z",
    transform: "translate(-378.185 -79.399)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M484.376,142.752c-.151.04-.173.167-.193.3l-.442.04-.526-.16-.13-.127a.3.3,0,0,1,.151-.312,1.955,1.955,0,0,1,.836-.179C484.276,142.385,484.473,142.466,484.376,142.752Z",
    transform: "translate(-445.388 -109.709)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M481.638,141.755l-.166.221-.533-.047a.219.219,0,0,1-.038-.327l.01-.351a.285.285,0,0,1,.185-.089c.2.022.3.175.4.314A.659.659,0,0,1,481.638,141.755Z",
    transform: "translate(-443.774 -108.885)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M479.771,142.7l.037.327c-.219-.041-.571.127-.524-.337Z",
    transform: "translate(-442.644 -109.983)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M505.215,176.787q0-.081,0-.162a.545.545,0,0,1,.373-.271c.407-.038.5.332.7.558a.684.684,0,0,1,.072.23.431.431,0,0,1-.131.327c0,.06-.006.121-.009.181l-.492.167c-.408-.048-.452-.374-.514-.687A.233.233,0,0,1,505.215,176.787Z",
    transform: "translate(-461.316 -134.184)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M503.651,177.9c0,.114,0,.229,0,.343-.443,0-.281.617-.668.676,0-.111,0-.221-.007-.332C503.142,178.3,503.195,177.9,503.651,177.9Z",
    transform: "translate(-459.752 -135.3)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M515.08,180.883a.414.414,0,0,0,.375-.2c.312-.184.56-.028.8.153a.272.272,0,0,1,.044.244.362.362,0,0,1-.544.149C515.535,181.114,515.158,181.295,515.08,180.883Z",
    transform: "translate(-468.495 -137.243)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M517.526,182.348l.518-.185c.312-.053.31.176.334.382l-.327.3Z",
    transform: "translate(-470.262 -138.357)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M513.163,175.436l-.588.008-.054-.018a.216.216,0,0,1-.051-.139c0-.051.005-.076.013-.077a1.372,1.372,0,0,1,.7-.566,1.045,1.045,0,0,0,.526-.351,1.4,1.4,0,0,1,.147-.171.5.5,0,0,1,.422-.144.4.4,0,0,1,.237.479.8.8,0,0,1-.146.3c-.1.105-.1.261-.181.381C513.856,175.275,513.592,175.645,513.163,175.436Z",
    transform: "translate(-466.611 -132.473)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M514.965,177.814l1.059-.513a.157.157,0,0,1,.2.031c.111.349-.447.7.008,1.05l-.039.108-.82-.193C515.25,178.123,514.966,178.091,514.965,177.814Z",
    transform: "translate(-468.412 -134.85)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M510.055,178.213a1.113,1.113,0,0,1,0,.143l-.334.347-.666-.014.008-.36a1.27,1.27,0,0,1,.491-.255.657.657,0,0,1,.337-.008A.315.315,0,0,1,510.055,178.213Z",
    transform: "translate(-464.143 -135.403)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M519.7,181.818l-.334-.382q0-.084,0-.168l-.006-.019a.43.43,0,0,1,.341-.1c.4.184.891-.128,1.263.228a.549.549,0,0,1,.027.24.314.314,0,0,1-.354.239,2.359,2.359,0,0,0-.765-.084Z",
    transform: "translate(-471.582 -137.63)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M521.2,182.928a.426.426,0,0,1,.681,0q.085.058.054.111c-.02.034-.04.052-.06.052l-.33.024A.374.374,0,0,1,521.2,182.928Z",
    transform: "translate(-472.911 -138.789)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M546.024,199.317q0-.256,0-.512c.153-.059.168-.193.174-.332l.024-.009c.575-.221.464.4.7.587a.633.633,0,0,1,.066.228.458.458,0,0,1-.331.436.606.606,0,0,1-.417-.126,1.708,1.708,0,0,1-.188-.26Z",
    transform: "translate(-490.839 -150.049)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M545.393,190.5l-.172-.19c-.136-.268.02-.563-.081-.835a.5.5,0,0,1,.189-.39.646.646,0,0,1,.21-.083c.346-.014.463-.388.752-.49.328-.1.413.37.724.312a.428.428,0,0,1,.312.116.767.767,0,0,1,.121.347,1.235,1.235,0,0,1-.045.5c-.335.194-.186.532-.233.812a.247.247,0,0,1-.2.108c-.223-.073-.435-.341-.677-.035a.231.231,0,0,1-.209.021Z",
    transform: "translate(-490.202 -142.919)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M549.368,195.763a.355.355,0,0,0,.165-.016.494.494,0,0,1,.323-.1.5.5,0,0,1,.211.091.408.408,0,0,1,.069.221.47.47,0,0,1-.184.3.952.952,0,0,1-.323.163,1.05,1.05,0,0,1-.489-.013c-.226-.122-.613-.024-.612-.456,0-.042,0-.084.006-.125l.163-.058A.507.507,0,0,1,549.368,195.763Z",
    transform: "translate(-492.649 -148.052)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M547.374,198.617c-.464.015-.162-.709-.641-.679,0-.061,0-.122,0-.183l.319-.032a.4.4,0,0,1,.386.025.682.682,0,0,1,.135.521A.479.479,0,0,1,547.374,198.617Z",
    transform: "translate(-491.352 -149.523)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M548.236,197.1l-.35-.051a.325.325,0,0,1,.178-.3c.151.278.523.074.688.322l-.077.092A.362.362,0,0,1,548.236,197.1Z",
    transform: "translate(-492.185 -148.85)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M541.858,192.894l.006-.2a.522.522,0,0,1,.637-.045.2.2,0,0,1,.046.247l-.046.32Z",
    transform: "translate(-487.832 -145.842)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M543.976,191.878a.594.594,0,0,1-.024-.165.409.409,0,0,1-.064-.481c.188-.176.3-.058.4.106.463.3.068.585-.009.876Z",
    transform: "translate(-489.261 -144.82)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M545.2,204.849q-.078,0-.156,0c-.084-.162-.217-.309-.16-.516.051.006.1.009.153.01a.522.522,0,0,1,.216-.125.4.4,0,0,1,.344.124.292.292,0,0,1-.055.35A.365.365,0,0,1,545.2,204.849Z",
    transform: "translate(-490.008 -154.215)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M545.653,203.687l-.181.01a.359.359,0,0,1,.167-.346.119.119,0,0,1,.172.011C545.888,203.536,545.749,203.6,545.653,203.687Z",
    transform: "translate(-490.442 -153.574)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M546.227,202.157l-.153,0c.005-.166.011-.332.017-.5l.161.148a.259.259,0,0,1,.087.181l-.03.1Z",
    transform: "translate(-490.877 -152.383)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M529.482,184.159c-.052-.48-.407-.3-.671-.314a.253.253,0,0,1-.331-.024l0-.173a.871.871,0,0,1,.571-.356.981.981,0,0,1,.8.147.3.3,0,0,1-.04.389Z",
    transform: "translate(-478.17 -139.159)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M525.479,182.937l-.509.172c-.184-.241-.443-.164-.684-.163l-.665-.029c0-.054,0-.108.007-.162.132,0,.263,0,.343-.134a2,2,0,0,1,1.438.072A.22.22,0,0,1,525.479,182.937Z",
    transform: "translate(-474.663 -138.619)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M527.664,185.229l.331.024-.159.283-.489,0C527.341,185.31,527.483,185.248,527.664,185.229Z",
    transform: "translate(-477.354 -140.567)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M534.823,183.683l-.334,0-.334-.049a.614.614,0,0,1,.058-.862.7.7,0,0,1,.592-.194c.265.221.119.522.15.789A.386.386,0,0,1,534.823,183.683Z",
    transform: "translate(-482.16 -138.658)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M533.814,181.9a1.368,1.368,0,0,0-.182.83.288.288,0,0,1-.353-.311q.011-.175.023-.351c-.034-.311-.07-.622.311-.76a.31.31,0,0,1,.291.22A.444.444,0,0,1,533.814,181.9Z",
    transform: "translate(-481.637 -137.747)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M539.577,186.613c-.006-.062-.011-.124-.017-.186l-.169-.326a2.181,2.181,0,0,1,.189-.4.643.643,0,0,1,.143-.172.453.453,0,0,1,.219-.038,1.185,1.185,0,0,1,.531.407.8.8,0,0,1,.079.563.827.827,0,0,1-.087.218.858.858,0,0,1-.449.362C539.716,187.06,539.588,186.9,539.577,186.613Z",
    transform: "translate(-486.05 -140.754)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M536.951,185.351l.01-.368c.218-.181.377-.06.526.106.1.235-.024.394-.176.545C537.094,185.667,536.964,185.585,536.951,185.351Z",
    transform: "translate(-484.289 -140.326)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M538.249,186.153l.161-.477a.225.225,0,0,1,.181-.061.6.6,0,0,1,.315.235c.012.241-.127.328-.339.34Z",
    transform: "translate(-485.226 -140.845)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M539.581,189.489c.166.1.228.358.477.344a.347.347,0,0,1,.129.194.331.331,0,0,1-.125.318l-.659-.01q0-.172-.007-.343c0-.107,0-.215,0-.322Z",
    transform: "translate(-486.054 -143.63)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M541.791,191.258l.018-.345a.469.469,0,0,1,.465-.14.372.372,0,0,1,.2.147q0,.258,0,.515l-.658-.037A.881.881,0,0,0,541.791,191.258Z",
    transform: "translate(-487.784 -144.544)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M563.505,217.832h-1.01a3.337,3.337,0,0,1,2.364-1.02.928.928,0,0,1,.238.622.587.587,0,0,1-.259.459,3.162,3.162,0,0,0-.257.333.561.561,0,0,1-.263.183c-.223.011-.448.027-.6-.192A2.547,2.547,0,0,0,563.505,217.832Z",
    transform: "translate(-502.734 -163.273)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M562.485,215.04c0-.334-.051-.684.466-.687.374,0,.58.111.548.517-.236.284-.56.13-.844.174Q562.567,215.163,562.485,215.04Z",
    transform: "translate(-502.727 -161.507)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M571.153,217.465c-.247-.177-.148-.441-.165-.675l.165-.007.113-.008c.2.019.378.064.444.29a.486.486,0,0,1-.15.3C571.438,217.462,571.319,217.567,571.153,217.465Z",
    transform: "translate(-508.863 -163.248)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M571.069,215.537l-.172-.177a.169.169,0,0,1,.047-.239.529.529,0,0,1,.641.061.339.339,0,0,1,.007.389.553.553,0,0,1-.524-.032Z",
    transform: "translate(-508.779 -162.003)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M569.609,214.5c0,.056,0,.112-.007.169l-.5.006a.524.524,0,0,1,.156-.565.332.332,0,0,1,.354.046A.256.256,0,0,1,569.609,214.5Z",
    transform: "translate(-507.484 -161.308)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M568.9,214.176l-.158.506a1.47,1.47,0,0,1-.168-.005q0-.252,0-.5l.07-.068A.217.217,0,0,1,568.9,214.176Z",
    transform: "translate(-507.12 -161.319)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M562.486,216.8l.17,0c.1.223.263.469-.17.512Q562.486,217.055,562.486,216.8Z",
    transform: "translate(-502.728 -163.264)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M558.844,218.019c.265.03.618-.119.671.339C559.252,218.326,558.9,218.479,558.844,218.019Z",
    transform: "translate(-500.098 -164.143)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M555.714,229.2l-.166,0c-.057-.308-.267-.647.169-.855,0,.057,0,.114,0,.171A.5.5,0,0,1,555.714,229.2Z",
    transform: "translate(-497.645 -171.569)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M568.615,225.125c-.311.678-.908.193-1.35.339-.224.011-.449.154-.673,0h-.17a.438.438,0,0,1-.48.07.534.534,0,0,1-.2-.3c-.044-.417-.5-.224-.668-.457.211-.4,0-.805.008-1.208.2-.121.466-.213.191-.513-.193.118-.362.178-.37-.155a.356.356,0,0,0,.341-.173.209.209,0,0,1,.215-.044c.326.434.978.409,1.259.909a3.832,3.832,0,0,0,1.889.533.353.353,0,0,1,.229.263.411.411,0,0,1-.2.285c-.128.113-.324.071-.448.2C568.33,224.957,568.5,224.984,568.615,225.125Z",
    transform: "translate(-504.471 -167.489)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M559.62,229.81c-.175-.128-.54-.131-.331-.513.261.026.329-.236.5-.341a.315.315,0,0,0,.34.343c.159.163.447.14.547.388a.3.3,0,0,1-.041.213c-.137.255-.448.053-.613.239a.216.216,0,0,1-.178.052C559.644,230.142,559.779,229.887,559.62,229.81Z",
    transform: "translate(-500.373 -172.006)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M562.993,230.4l-.508-.511.843,0c.258.173.866-.535.843.344-.269.261-.621.2-.946.254A.39.39,0,0,1,562.993,230.4Z",
    transform: "translate(-502.727 -172.601)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M564.086,223.491a.4.4,0,0,0,.37.155c-.271.216-.531.36-.683-.119Z",
    transform: "translate(-503.657 -168.077)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M565.86,221.132h-.167a.346.346,0,0,0-.168-.338l.168-.343a.309.309,0,0,1,.337.341C565.931,220.885,566,221.06,565.86,221.132Z",
    transform: "translate(-504.921 -165.891)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M556.406,229.637q0-.34,0-.681h.337C556.713,229.224,556.859,229.585,556.406,229.637Z",
    transform: "translate(-498.337 -172.006)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M498.9,163.7q0-.6,0-1.194c.214-.174.374-.064.525.1.116.222.008.458.04.684.016.239.231.358.326.549a4.894,4.894,0,0,1,.011.892.646.646,0,0,1-.227.4.355.355,0,0,1-.329-.008c-.031-.318-.376-.217-.516-.392A1.77,1.77,0,0,0,498.9,163.7Z",
    transform: "translate(-456.689 -124.17)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M502.779,173.918a.366.366,0,0,1-.332.167,1.085,1.085,0,0,0-.671-.173l-.342,0a.521.521,0,0,1-.006-.671l.171-.187a.137.137,0,0,1-.041-.129c.011-.044.022-.066.034-.067a.373.373,0,0,1,.216-.033c.248.083.49.185.735.281a.636.636,0,0,1,.183.149C502.847,173.466,502.991,173.678,502.779,173.918Z",
    transform: "translate(-458.55 -131.645)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M500.57,172.126a1.4,1.4,0,0,0-.005.16c-.276-.006-.607.1-.679-.333-.037-.166.036-.219.19-.192l.322.009a.2.2,0,0,1,.115.115A.439.439,0,0,1,500.57,172.126Z",
    transform: "translate(-457.516 -130.88)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M499.247,170.907l-.19.192a.522.522,0,0,1-.328-.513C498.9,170.689,499.363,170.325,499.247,170.907Z",
    transform: "translate(-456.688 -130.025)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M500.893,174.312q0,.336.006.671h-.167C500.652,174.726,500.329,174.41,500.893,174.312Z",
    transform: "translate(-458.016 -132.718)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M499.227,159.993l-.5-.169-.176-.509c-.055-.041-.073-.081-.053-.119s.039-.057.058-.057a.347.347,0,0,0,.168-.329.373.373,0,0,1,.322-.123,1.216,1.216,0,0,1,1.105,1.419.269.269,0,0,1-.263.156c-.144-.115-.306-.033-.461-.038C499.315,160.185,499.285,160.076,499.227,159.993Z",
    transform: "translate(-456.514 -121.482)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M496.046,158.985c0,.059,0,.117,0,.176a1.2,1.2,0,0,0-.673.156c-.021-.318-.444-.474-.334-.844C495.248,158.893,495.721,158.79,496.046,158.985Z",
    transform: "translate(-454.007 -121.33)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M499.329,157.54l-.346-.01c-.136-.079-.133-.212-.133-.345a.325.325,0,0,1,.3-.278,2.41,2.41,0,0,1,.627.138.957.957,0,0,0,.319.027.747.747,0,0,1,.677.11c.111.164.179.323-.041.457C500.251,157.836,499.8,157.565,499.329,157.54Z",
    transform: "translate(-456.775 -120.204)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M498.631,155.8l-.3.183c-.168-.065-.187-.214-.2-.366.009-.214-.063-.511.33-.324a.467.467,0,0,1,.211.223c.012.033.023.067.034.1A.193.193,0,0,1,498.631,155.8Z",
    transform: "translate(-456.252 -118.999)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M500.316,151.262c-.1.046-.143-.017-.169-.1-.192-.176-.48-.169-.663-.361l0,0c-.1-.172.035-.344,0-.516a1.255,1.255,0,0,0-.178-.709c.212-.885.978-.9,1.644-1.07a.306.306,0,0,1,.139.184c-.121.395.128.714.217,1.067.075.123-.295.568.249.346a.794.794,0,0,1,.445.1c.179.127.243.383.485.438.385.173.946-.337,1.208.314a2.662,2.662,0,0,1-1.212.219c.507.134.8-.2,1.143-.106.282.058.43.329.681.437.624.393.256.928.2,1.421a.561.561,0,0,1-.574.011c-.1-.364-.192-.706-.676-.736-.328-.021-.627-.083-.677.37a.854.854,0,0,0,.105.418.644.644,0,0,1,.076.563.589.589,0,0,1-.387.278.537.537,0,0,1-.349-.061.532.532,0,0,1-.132-.183c-.1-.247,0-.569-.282-.747a.664.664,0,0,1-.126-.128.328.328,0,0,0-.049-.144c0,.054,0,.108,0,.164a.57.57,0,0,1-.181.361.473.473,0,0,1-.423.144c-.137-.1-.254-.2-.158-.392a1.673,1.673,0,0,0-1.005-1.342l1.513-.06a.723.723,0,0,1,.487-.026c.054.007.1.128.165.01a.3.3,0,0,0-.127-.205c-.414-.252-.968.018-1.338-.374-.08-.073-.033-.18-.065-.267-.134.134.074.178.072.28A.316.316,0,0,1,500.316,151.262Z",
    transform: "translate(-457.101 -114.161)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M500.15,147.7c-.563.344-1.307.375-1.7,1.009l-.328.02v-.334a.5.5,0,0,1,.139-.286,1.163,1.163,0,0,1,.253-.2c.355-.178.7-.373,1.044-.573a.536.536,0,0,1,.427.033.61.61,0,0,1,.176.13A.208.208,0,0,1,500.15,147.7Z",
    transform: "translate(-456.248 -113.297)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M499.488,154.833c.273.171.043.344,0,.516a.376.376,0,0,1-.176-.345Z",
    transform: "translate(-457.11 -118.713)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M496.045,149.014l-.163.17c-.246.092-.4.365-.7.36l-.166-.175a3.415,3.415,0,0,1,.081-.809.357.357,0,0,1,.166-.149.5.5,0,0,1,.219,0,1.787,1.787,0,0,1,.415.333A.412.412,0,0,1,496.045,149.014Z",
    transform: "translate(-454.01 -114.086)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M494.286,148.679c-.045.294.121.634-.187.871a1.085,1.085,0,0,0-.147-.03.947.947,0,0,0-.207-.66l.206-.017C494.043,148.747,494.1,148.582,494.286,148.679Z",
    transform: "translate(-453.089 -114.267)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M484.272,129.516l-.34-.51a.369.369,0,0,1-.081-.232,2.477,2.477,0,0,1,.4-1.194.793.793,0,0,1,.624-.1.583.583,0,0,1,.226.116.4.4,0,0,1,.092.222c0,.246-.3.271-.361.491.252.031.449-.191.7-.133a.466.466,0,0,1,.384.306.593.593,0,0,1-.073.511c-.311.289-.832.2-1.08.608A.424.424,0,0,1,484.272,129.516Z",
    transform: "translate(-445.945 -99.029)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M478.908,129.083c0,.057,0,.114,0,.17l-.193.016a.436.436,0,0,1-.641-.037.283.283,0,0,0-.355-.294c-.306-.077-.476-.418-.816-.43a.32.32,0,0,1,.1-.317c.232-.119.515-.127.705-.337a.471.471,0,0,1,.217-.056,1.354,1.354,0,0,1,.675.556.932.932,0,0,0,.262.449C478.925,128.888,479,128.97,478.908,129.083Z",
    transform: "translate(-440.919 -99.276)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M486.19,140.544a.51.51,0,0,0-.309-.343.764.764,0,0,1-.166-.174c-.089-.224-.222-.448-.006-.675h.148a1.028,1.028,0,0,1,.754-.084.6.6,0,0,1,.35.455,1.085,1.085,0,0,1-.238.8Z",
    transform: "translate(-447.202 -107.501)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M481.771,139.147l-.3-.3c-.31-.271,0-.561-.027-.842,0-.053,0-.105,0-.158.2,0,.4-.028.52.191a2.059,2.059,0,0,0,.175.576.4.4,0,0,1,.032.212A.408.408,0,0,1,481.771,139.147Z",
    transform: "translate(-444.128 -106.5)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M487.242,136.86c-.228.177-.463.026-.695.013a1.337,1.337,0,0,0,.186-.841.285.285,0,0,1,.19-.242.271.271,0,0,1,.2.065.629.629,0,0,1,.09.193c.036.206.053.416.1.622A.241.241,0,0,1,487.242,136.86Z",
    transform: "translate(-447.891 -105.021)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M485.791,135.141l-.176.171c-.282-.063-.845.155-.514-.524h.5A.376.376,0,0,1,485.791,135.141Z",
    transform: "translate(-446.775 -104.301)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M483.219,139.218c-.511-.147-.29-.425-.121-.693a.739.739,0,0,1,.495.313C483.659,139.158,483.43,139.178,483.219,139.218Z",
    transform: "translate(-445.259 -106.988)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M481.108,132.9l.641.036q0,.249.008.5c-.178.081-.225-.071-.3-.172l-.361-.02C481.1,133.129,481.1,133.016,481.108,132.9Z",
    transform: "translate(-443.954 -102.945)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M484.042,140.02l.373-.38h.175l.129.71a.584.584,0,0,1-.653-.333Z",
    transform: "translate(-446.083 -107.79)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M482.321,134.186l.3.172c-.017.167.1.48-.191.411C482.188,134.713,482.346,134.39,482.321,134.186Z",
    transform: "translate(-444.82 -103.868)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M480.41,138.409c.344.27-.044.563.026.842l-.209.021c-.452-.061-.3-.418-.326-.685Z",
    transform: "translate(-443.09 -106.905)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M476.4,128.27l-.158.286-.173.017q-.008-.143-.015-.286a.265.265,0,0,1-.07-.235.245.245,0,1,1,.416.219Z",
    transform: "translate(-440.261 -99.322)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M473.835,129.466a.364.364,0,0,1,.183-.363.218.218,0,0,1,.317.062.338.338,0,0,1-.181.329Z",
    transform: "translate(-438.711 -100.183)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    d: "M474.349,128.166l-.317-.062-.178-.312.073-.075a.467.467,0,0,1,.305-.034.5.5,0,0,1,.291.282q0,.092,0,.183Z",
    transform: "translate(-438.726 -99.185)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M552,209.928l-.168.173a1.186,1.186,0,0,1-1.079.1l-.1-.1c-.056-.423-.384-.315-.647-.343-.293-.032-.622.113-.869-.167,0-.056,0-.112,0-.168a3.668,3.668,0,0,1,.7-.453.782.782,0,0,1,.588-.011,4.16,4.16,0,0,0,.713.359,1.612,1.612,0,0,0,.392.216C551.712,209.63,552.031,209.564,552,209.928Z",
    transform: "translate(-493.086 -157.591)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M550.147,213.763c-.172-.614-.67-.228-1.007-.336.378-.686,1.018-.19,1.514-.345h0c.2.227.068.455,0,.682h-.507Z",
    transform: "translate(-493.09 -160.571)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M547.254,204.423l-.014-.336a.352.352,0,0,1,.1-.192.321.321,0,0,1,.213-.05.426.426,0,0,1,.307.316.329.329,0,0,1-.124.314.28.28,0,0,1-.324-.061C547.361,204.416,547.307,204.419,547.254,204.423Z",
    transform: "translate(-491.718 -153.95)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M547.868,205.864l.337-.006a.433.433,0,0,1,.161.347.4.4,0,0,1-.174.338l-.3-.348Q547.879,206.029,547.868,205.864Z",
    transform: "translate(-492.172 -155.399)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M549.794,208.668c-.051.456-.406.32-.674.354,0-.117-.005-.233-.008-.35q.008-.089.016-.178a.523.523,0,0,1,.443-.139.569.569,0,0,1,.219.1A.172.172,0,0,1,549.794,208.668Z",
    transform: "translate(-493.07 -157.19)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M549.541,207.362l-.469,0q-.014-.081-.036-.161c.009-.115.017-.23.026-.344a.337.337,0,0,1,.371-.052C549.611,206.96,549.763,207.125,549.541,207.362Z",
    transform: "translate(-493.015 -156.053)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M565.924,212.383a1.652,1.652,0,0,1-1.018-.341c.015-.036.03-.073.045-.11a.6.6,0,0,1,1.01-.108.576.576,0,0,1,.088.225.428.428,0,0,1-.129.33Z",
    transform: "translate(-504.476 -159.528)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M559.138,214.861c.078-.223-.411-.594.173-.686a.227.227,0,0,1,.334,0C559.659,214.545,559.676,214.914,559.138,214.861Z",
    transform: "translate(-500.225 -161.327)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M560.4,212.44l-.334,0,.171-.331c.091-.32.266-.5.621-.386.155.192,0,.28-.125.379Z",
    transform: "translate(-500.982 -159.589)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M562.467,211.971l.176-.339.092-.085a.393.393,0,0,1,.46.08.288.288,0,0,1-.048.344l0,0Z",
    transform: "translate(-502.714 -159.461)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M557.534,209.9c-.179-.249-.446-.141-.679-.174-.181-.4.125-.45.382-.532a1.474,1.474,0,0,0,.827-.237.891.891,0,0,1,.748-.016.262.262,0,0,1,.137.206.462.462,0,0,1-.192.317c-.412,0-.642.446-1.057.438Z",
    transform: "translate(-498.621 -157.56)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M554.4,213.839c-.163-.228-.006-.455,0-.682h1.18C555.323,213.629,554.749,213.538,554.4,213.839Z",
    transform: "translate(-496.833 -160.646)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M560.039,211.214c.341-.162.544-.606,1.012-.507.1.189-.068.246-.166.337l0,0c-.3-.027-.445.235-.671.345Z",
    transform: "translate(-500.961 -158.875)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M557.138,215.382a.593.593,0,0,1-.188.074c-.077,0-.174-.036-.11-.142a.282.282,0,0,1,.187-.113C557.114,215.193,557.171,215.255,557.138,215.382Z",
    transform: "translate(-498.635 -162.116)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M496.8,142.694l0-.514a.473.473,0,0,1,.215-.152,1,1,0,0,1,.775.074.462.462,0,0,1,.156.355.573.573,0,0,1-.074.253.985.985,0,0,1-.565.307.654.654,0,0,1-.5-.094A.161.161,0,0,1,496.8,142.694Z",
    transform: "translate(-455.263 -109.475)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M494.885,139.807h-.164c-.14-.412-.693-.1-.845-.5a.436.436,0,0,1,.143-.286,1.388,1.388,0,0,1,.436-.336.371.371,0,0,1,.322.084C494.868,139.112,495.325,139.411,494.885,139.807Z",
    transform: "translate(-453.184 -107.101)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M490.786,142.294l-.316-.04c-.005-.1-.011-.209-.016-.313a.535.535,0,0,1-.068-.646c.436-.36.486.229.743.309l0,.344C491.019,142.072,490.961,142.241,490.786,142.294Z",
    transform: "translate(-450.608 -108.897)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M491.3,140.286l-.674-.343a.265.265,0,0,1-.082-.2.48.48,0,0,1,.288-.339.617.617,0,0,1,.221-.053c.223.033.452.055.586.281l-.168.162C491.173,139.871,491.18,140.059,491.3,140.286Z",
    transform: "translate(-450.777 -107.578)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M495.284,144.512c0,.056,0,.113,0,.169a.31.31,0,0,1,.066.336c-.149.185-.269.42-.571.349C494.5,144.81,494.739,144.569,495.284,144.512Z",
    transform: "translate(-453.751 -111.293)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M494.656,146.661c.174-.106.238-.373.5-.346a.344.344,0,0,1,.1.2.6.6,0,0,1-.278.479c-.052,0-.1,0-.155,0l-.335.165Z",
    transform: "translate(-453.625 -112.587)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M492.027,144.259c.021-.208.1-.356.339-.346a.7.7,0,0,1-.172.855Z",
    transform: "translate(-451.849 -110.862)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M489.962,140.777l0,.175q0,.34,0,.68l-.325-.022a1.108,1.108,0,0,1,.164-.8A.1.1,0,0,1,489.962,140.777Z",
    transform: "translate(-450.118 -108.587)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M466.007,125.651l-.671,0q0-.17,0-.341l0-.008a.533.533,0,0,1,.531-.11c.191.106.292.242.145.457Z",
    transform: "translate(-432.57 -97.377)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M467.306,123.925a.365.365,0,0,0-.17-.346c-.043-.312.18-.288.37-.29.1,0,.282.091.086-.12a.471.471,0,0,1,.387-.4,1.189,1.189,0,0,1,.9.3.87.87,0,0,1,.2.426c.008.255.131.524-.077.758l0,.009-.344-.033C468.355,123.458,467.735,124.123,467.306,123.925Z",
    transform: "translate(-433.871 -95.658)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M433.9,81.814l0-.344c.168-.889-.265-1.794.1-2.691a1,1,0,0,0-.1-.891,2.32,2.32,0,0,1-.131-.194c-.248-.511-.916-.4-1.212-.833.029-.239.108-.334.391-.42.84-.255,1.778.213,2.6-.678.378-.411,1.58-.295,2.328.033a6.844,6.844,0,0,0,2.46.191c.243.019.315-.195.318-.412,0-.311,0-.623.005-.934a1.058,1.058,0,0,1,0,1.707l-.1.105a4.313,4.313,0,0,1-2.676.292,2.2,2.2,0,0,0-1.241.017.669.669,0,0,1-.707-.073c-.517.241-.606.957-1.212,1.115-.071.019-.124.239-.129.368a7.691,7.691,0,0,1-.143,1.5c-.086.363.067.807.544.753a1.9,1.9,0,0,1,1.615.7.946.946,0,0,1-.872.156,1.485,1.485,0,0,0-1.466.581A.332.332,0,0,1,433.9,81.814Z",
    transform: "translate(-408.895 -61.057)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M427.689,66.742l.168,0,.11.042a2.431,2.431,0,0,0,2.352.179c.693.322,1.369.61,2.1.037a.574.574,0,0,1,.772.138,2.3,2.3,0,0,0,1.586.8c.153.448.742.528.844,1.02a4.724,4.724,0,0,1-2.747-.881.461.461,0,0,0-.3-.128c-1.864.1-3.673-.575-5.552-.378-.559.058-.7.642-1.189.7a.541.541,0,0,1-.185-.277.927.927,0,0,1-.061-.338c.055-.291.186-.507.514-.526a3.017,3.017,0,0,0,.764-.072A1.091,1.091,0,0,0,427.689,66.742Z",
    transform: "translate(-403.872 -55.376)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M466.08,75.522c0,.056,0,.112,0,.167-1.345,0-1.812-.327-2-1.43-.041-.239-.115-.534.114-.71.207-.16.433.025.626.107.32.137.619.327.926.5-.248.289-.623.153-.926.273.343.266.795.181,1.145.4A.862.862,0,0,1,466.08,75.522Z",
    transform: "translate(-431.635 -60.226)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M446.746,67.877a1.634,1.634,0,0,1-1.638-.616c-.133-.2-.466-.359-.674-.158-.794.766-1.511.346-2.243-.082a.2.2,0,0,1,.021-.23.722.722,0,0,1,.6-.068c.189.056.348.206.563.187,1.056-.418,1.708-.334,2.191.28l.168.171Z",
    transform: "translate(-415.841 -55.313)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M467.532,76.514c-.507.168-1.276-.052-1.267-.308.02-.619.691-.294,1.091-.379.243,0,.489-.006.506.339a.361.361,0,0,0-.172.339A.093.093,0,0,1,467.532,76.514Z",
    transform: "translate(-433.245 -61.901)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M462.845,81.166a1.865,1.865,0,0,1-1.351-.341.233.233,0,0,1,0-.341h0C462.226,80.141,462.442,80.842,462.845,81.166Z",
    transform: "translate(-429.747 -65.191)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M458.651,67.956h.17l.167,0a.5.5,0,0,1,.508.336l.169.517c-.315.115-.7.427-.636-.316C459.042,68.327,458.784,68.136,458.651,67.956Z",
    transform: "translate(-427.747 -56.25)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    d: "M463.511,69.515l.337-.34.336.169C464.076,69.871,463.713,69.37,463.511,69.515Z",
    transform: "translate(-431.257 -57.127)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M470.8,78.276l.158-.009c.338.164.676.333,1.013,0,.108.012.251-.015.317.044.18.163-.037.208-.117.289-.339.343-.821.2-1.213.36C470.708,78.778,470.813,78.513,470.8,78.276Z",
    transform: "translate(-436.512 -63.664)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M460.369,67.433l-.508-.336a.306.306,0,0,1,.333-.339C460.29,66.973,460.587,67.135,460.369,67.433Z",
    transform: "translate(-428.621 -55.389)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M561.97,187.2c.334.692.963.492,1.519.513.106.214.348.123.518.232-.12.2-.429.041-.518.279q.093.057.062.114c-.02.038-.041.057-.062.057l-.169.342c-.089.16-.07.408-.338.42-.434-.313-.583-.013-.706.337-.126.429.352.19.428.393.23.338.656.3.953.517-.211.522-.9.594-1.069,1.154a.761.761,0,0,1-.447.163.964.964,0,0,1-.549-.216c-.267-.39.107-.7.122-1.061a1.287,1.287,0,0,0-.172-.366c-.031-.062-.045-.2-.077-.188-.109.058-.124.2-.184.307a1.015,1.015,0,0,1-.339.469,1.084,1.084,0,0,1-.807-.162c-.129-.481.495-.663.432-1.118-.042-.535.331-.76.742-.981-.453.373-.9.112-1.345.06-.695-.5-.267.35-.487.419a2.286,2.286,0,0,0-.165.961c-.034.29-.011.632-.431.675-.341-.09-.371-.362-.346-.646a.654.654,0,0,0-.432-.706.808.808,0,0,1-.266-.4.924.924,0,0,1-.037-.242,6.8,6.8,0,0,1,.16-.828,2.263,2.263,0,0,1,.249-.667.751.751,0,0,1,.411-.2,1.128,1.128,0,0,1,.441-.034,1.146,1.146,0,0,1,.313.28,1.222,1.222,0,0,0,.357.2c.461.184.943-.073,1.405.072C561.448,187.486,561.744,187.537,561.97,187.2Z",
    transform: "translate(-499.344 -141.687)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M574.627,199.347a1.279,1.279,0,0,1,1.182-1.027c.112-.225.257-.354.505-.172a.738.738,0,0,0,.5-.243c.071-.062.163-.3.279-.056.032.066-.068.2-.107.3-.248.639-.925.618-1.385.929-.155.146-.236.36-.421.479a.423.423,0,0,1-.21.033A.518.518,0,0,1,574.627,199.347Z",
    transform: "translate(-511.495 -149.565)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M577.66,200l1.519-.853c.2-.119,0,.576.338.171.23-.128.363.036.506.171v.166a.34.34,0,0,1-.181.341l-.156,0a1.856,1.856,0,0,1-1.168.237A1.049,1.049,0,0,1,577.66,200Z",
    transform: "translate(-513.685 -150.564)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M576.753,195.254l-.505.172c-.4-.044-.931.175-1.013-.513.108-.106.279-.166.253-.366-.008-.17-.076-.349.085-.487l.337-.341c.014.184.232.245.211.5-.029.349-.256.978.574.732C576.878,194.893,576.775,195.137,576.753,195.254Z",
    transform: "translate(-511.934 -146.671)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M583.728,193.405c.227-.26.455-.658.68,0C584.181,193.519,583.953,193.728,583.728,193.405Z",
    transform: "translate(-518.067 -146.188)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M585.513,201.33a.4.4,0,0,1,.181-.341l.169,0,.174.175C585.963,201.536,585.791,201.6,585.513,201.33Z",
    transform: "translate(-519.356 -151.896)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M584.849,199.171l-.506-.171c.024-.175.076-.348.294-.3C584.9,198.75,584.829,198.988,584.849,199.171Z",
    transform: "translate(-518.511 -150.245)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M578.271,192.063v-.171c.39.01.78.019,1.17.033.015,0,.039.04.04.062a.226.226,0,0,1-.029.079Z",
    transform: "translate(-514.126 -145.358)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M583.112,207.111c.076.919.787.324,1.173.5q0,.085,0,.17l0,0a1.464,1.464,0,0,1-1.209.193c-.466-.158-.573-.447-.306-.869Z",
    transform: "translate(-517.273 -156.296)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M585.972,211.159a1.116,1.116,0,0,1,.5.493c-.107.182-.3.228-.473.311a.835.835,0,0,1-.57.091.463.463,0,0,1-.224-.521.824.824,0,0,1,.547-.443A.232.232,0,0,1,585.972,211.159Z",
    transform: "translate(-519.127 -159.158)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M587.8,213.28c.127-.188.338-.128.512-.179l.531.212a1.208,1.208,0,0,1-1.008.32A.238.238,0,0,1,587.8,213.28Z",
    transform: "translate(-520.961 -160.607)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M585.15,210.027l-.173.01a1.089,1.089,0,0,1-.873-.157.3.3,0,0,1,.037-.366l1.18,0Z",
    transform: "translate(-518.305 -158.026)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M577,207.768l0,.324c-.07.124-.2.155-.312.212-.078.087-.032.172,0,.26a.368.368,0,0,1,0,.219.876.876,0,0,1-.74.508.531.531,0,0,1-.33-.119c-.231-.125.255-.822-.447-.57a1.118,1.118,0,0,1-.866-.081.466.466,0,0,1-.125-.473.383.383,0,0,1,.141-.183.938.938,0,0,0,.659-.481.4.4,0,0,1,.318-.036c.273.165.457.059.593-.2l.087-.068.68.007C576.681,207.36,576.547,207.711,577,207.768Z",
    transform: "translate(-511.16 -156.278)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M578.548,204.267q0,.255,0,.511c0,.057,0,.114,0,.17h0a.543.543,0,0,1-.7.041.6.6,0,0,1-.083-.593A.477.477,0,0,1,578.548,204.267Z",
    transform: "translate(-513.728 -154.146)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M577.572,202.9c-.235.023-.5-.079-.68.173a.309.309,0,0,1-.213.088c-.206-.066-.373-.16-.291-.427l.338-.519.847,0c.112.151.33.181.411.368a.289.289,0,0,1-.072.311Z",
    transform: "translate(-512.752 -152.781)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M581.924,203.406v-.337a.479.479,0,0,1,.679-.011l.334.015-.168.33Z",
    transform: "translate(-516.764 -153.288)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M581.726,202.555l-.68.011a.31.31,0,0,1-.338-.342h1.179Z",
    transform: "translate(-515.887 -152.786)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M571.451,165.575a2.189,2.189,0,0,0,1.35.853,3.746,3.746,0,0,0,1.246.382c.5.138.77-.241,1.053-.562a.18.18,0,0,1,.065.038c.038.034.036.083,0,.141l.153.377c.557-.689,1.274.111,1.872-.2v.511a.806.806,0,0,0-.675.512c-.167.113-.065.648-.506.328-.107-.258-.328-.282-.563-.28-.762-.156-1.574.236-2.307-.218l-.318.167c-.185.141-.349.022-.518-.04a4.209,4.209,0,0,0-.576-.27,1.713,1.713,0,0,0-.611-.109c-.284-.042-.544-.1-.353-.491.018-.177.4.008.285-.3a.425.425,0,0,1-.016-.3c.112-.118.07-.234,0-.351C571.087,165.513,571.214,165.418,571.451,165.575Z",
    transform: "translate(-508.655 -126.382)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M579.483,172.456l2.541.006c.029.472-.593.277-.656.655a.325.325,0,0,1-.365-.149c-.421-.271-.9-.028-1.337-.152Z",
    transform: "translate(-515.001 -131.384)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M577.005,174.813v.174c-.244.7-.775.583-1.305.472l-.078-.085a.422.422,0,0,1-.033-.221,1.674,1.674,0,0,0,.161-.736.368.368,0,0,1,.1-.2c.156-.088.305-.247.491-.053,0,.179-.027.366.164.477C576.582,174.966,576.894,174.583,577.005,174.813Z",
    transform: "translate(-512.187 -132.547)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M586.239,173.125c-.089-.534.463-.41.656-.655.381-.021.565.092.329.492l-.168.019Z",
    transform: "translate(-519.873 -131.392)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M580.138,173.346c.455-.032.948-.406,1.337.152A2.41,2.41,0,0,1,580.138,173.346Z",
    transform: "translate(-515.474 -131.914)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M576.606,173.025l-.485.107a.416.416,0,0,1-.019-.645l.518.159C576.615,172.772,576.61,172.9,576.606,173.025Z",
    transform: "translate(-512.456 -131.406)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M579.37,175.632c-.143-.133-.561.574-.5-.169.225-.071.452-.525.675,0Z",
    transform: "translate(-514.552 -133.367)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M575.563,177.662c.451-.1,1.007.215,1.348-.34q0,.34,0,.68l-1.345.17A.353.353,0,0,1,575.563,177.662Z",
    transform: "translate(-512.093 -134.882)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M573.776,178.218l0,.51-.173.175-.5-.177a.4.4,0,0,1-.088-.452c.234-.278.5-.178.76-.056Z",
    transform: "translate(-510.306 -135.438)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M567.151,177.716v.509c-.561-.115-.985.388-1.529.348-.2.109-.365,0-.539-.07a.7.7,0,0,1-.342-.3c.009-.342.28-.452.513-.6a1.689,1.689,0,0,1,.548-.2.6.6,0,0,1,.329.064c.18.187.322,0,.479-.055C566.851,177.4,567.131,177.32,567.151,177.716Z",
    transform: "translate(-504.356 -134.938)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M567.138,186.11c.531.128,1.052-.248,1.609-.081-.087.377-.494.154-.594.419l-.088.091a.941.941,0,0,1-.491.1.678.678,0,0,1-.475-.171A.311.311,0,0,1,567.138,186.11Z",
    transform: "translate(-506.03 -141.111)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M563.966,180.191a.357.357,0,0,1,.33.18c.174.195.379.382.171.676l-.171.012a.181.181,0,0,1-.193.046,1.915,1.915,0,0,1-.439-.476.315.315,0,0,1,.1-.48A.188.188,0,0,1,563.966,180.191Z",
    transform: "translate(-503.526 -136.906)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M563.626,183.375q.083,0,.166.009,0,.252,0,.5c-.016.036-.031.071-.046.108-.182.214-.361.436-.687.251a.506.506,0,0,1,0-.752A.78.78,0,0,1,563.626,183.375Z",
    transform: "translate(-503.022 -139.23)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M570.47,187.8c-.02.794-.456.513-.852.337a.168.168,0,0,1-.047-.135c.006-.048.014-.073.025-.073.1-.119.251-.168.351-.284l.019-.019Z",
    transform: "translate(-507.843 -142.294)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M566.3,181.649l-.172-.676.5.17C566.564,181.345,566.663,181.65,566.3,181.649Z",
    transform: "translate(-505.355 -137.507)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M566.076,185.556l0,.331a.277.277,0,0,1-.39,0,.531.531,0,0,1,.055-.673h0A.308.308,0,0,1,566.076,185.556Z",
    transform: "translate(-504.967 -140.557)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M586.1,215.3l.3.032a.247.247,0,0,1,.081.3.443.443,0,0,1-.157.157c-.312.141-.6.57-.969.09a.377.377,0,0,1,0-.229,1.1,1.1,0,0,1,.417-.4A.376.376,0,0,1,586.1,215.3Z",
    transform: "translate(-519.227 -162.138)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M589.172,215.91q-.005-.168-.011-.336a1.252,1.252,0,0,1,1.021.344c-.117.176-.243,0-.364.01A.446.446,0,0,1,589.172,215.91Z",
    transform: "translate(-521.99 -162.375)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M586.176,214.231l-.374.028a.247.247,0,0,1-.323.037c-.1-.194,0-.3.165-.372l.5-.185c.012.117.023.235.035.353A.2.2,0,0,0,586.176,214.231Z",
    transform: "translate(-519.302 -161.065)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M588.9,216.8l.647.019c.01.108.02.215.03.323a.682.682,0,0,1-.4.254.41.41,0,0,1-.241-.038.361.361,0,0,1-.031-.558Z",
    transform: "translate(-521.714 -163.267)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M590.239,218.221a.366.366,0,0,1,.361-.2.306.306,0,0,1,.336.337l-.685.011-.049-.069Z",
    transform: "translate(-522.742 -164.142)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M537.86,141.755c-.617,0-1.235.019-1.852.005-.466-.011-.526.167-.337.563a4.209,4.209,0,0,0,1.3,1.4c.251.2.619.33.541.772-.379.388-.617.393-.97-.11a1.678,1.678,0,0,0-1.116-.793,4.625,4.625,0,0,0,.614,2.025c-.223.3.315.405.178.686a.362.362,0,0,1-.174.143,5.744,5.744,0,0,0-.751.248,8.15,8.15,0,0,0-1,.068c-.253-.173-.578-.164-.833-.333a.343.343,0,0,1-.068-.312.467.467,0,0,1,.115-.158c.045-.051.148-.076.086-.186a1.115,1.115,0,0,1-.128-.141c-.107-.286-.3-.523-.42-.8a.483.483,0,0,1,.232-.391,6.061,6.061,0,0,0,1.283-1.528.493.493,0,0,0-.043-.165c-.208-.4-.761-.729-.422-1.264.284-.448.814-.271,1.247-.288a8.884,8.884,0,0,1,1.426.019.41.41,0,0,0,.469-.22.512.512,0,0,1,.718.2A.623.623,0,0,1,537.86,141.755Z",
    transform: "translate(-481.466 -108.716)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M549.829,149.824c.381,1,.649,1.158,1.637,1.025.279-.037.5-.119.537-.429a.5.5,0,0,0-.292-.611.879.879,0,0,1-.161-1.318,2.637,2.637,0,0,1,2.5.479c-.022.017-.043.044-.067.048-1.371.2-1.37.2-1.4,1.713a1.691,1.691,0,0,1-.143.9c-.148.2-.5.024-.6.333a.358.358,0,0,1-.493.1c-.111-.008,0-.287-.163-.173a.912.912,0,0,1-.784.114c-.438-.167.01.244-.156.257-.1.263-.33.32-.556.388a.6.6,0,0,1-.235-.011c-.133.1-.067-.327-.219-.1s-.233.565-.568.187a1.649,1.649,0,0,1-.205-.826c.065-.483.212-.87.819-.7.291-.128.1-.342.071-.5A.77.77,0,0,1,549.829,149.824Z",
    transform: "translate(-492.602 -114.045)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M543.881,150.165c-.226.348-.5.659-.176,1.129.215.309,0,.513-.33.578a1.87,1.87,0,0,0-1.322-1.04,1.4,1.4,0,0,1-.86-.655c.026.338.267.6.229.939a.31.31,0,0,1-.242.245c-.756-.568-.567-1.535-.928-2.272a.179.179,0,0,1,.272-.228c.426.4,1.147.4,1.377,1.1a.459.459,0,0,0,.8.207C543.093,150.314,543.487,150.128,543.881,150.165Z",
    transform: "translate(-486.654 -114.386)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M566.279,150.851a.941.941,0,0,1,.337.683c-.206.246-.277.63-.675.683a1.913,1.913,0,0,0-1.381.064c-.38.185-.762,0-1.141-.082-.495-.306-.363-.745-.244-1.181a1.319,1.319,0,0,1,1.416-.167c-.108.762.409.673.885.69C565.973,151.558,566.379,151.521,566.279,150.851Z",
    transform: "translate(-503.146 -115.755)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M563.26,150.321l-1.35.171c-.272.728.135,1.422.1,2.137a2.174,2.174,0,0,1-.043.551c-.076.308-.06.705-.565.6a.629.629,0,0,1-.184-.522.52.52,0,0,1,.182-.378c.335-.424.15-.919.158-1.376.027-1.54.259-1.74,1.7-1.355Z",
    transform: "translate(-501.815 -115.225)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M547.171,140.339c-.176-.254-.438-.157-.674-.169a.349.349,0,0,1-.327.113.271.271,0,0,1-.219-.253.453.453,0,0,1,.166-.17,2.222,2.222,0,0,1,.451-.171,1.5,1.5,0,0,1,.838.087c.269.107.56.183.683.5a.29.29,0,0,1-.074.229l-.344.016C547.426,140.687,547.3,140.512,547.171,140.339Z",
    transform: "translate(-490.788 -107.804)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M559.6,138.389l0,.185c-.238.634-.962.587-1.361,1a.513.513,0,0,1-.156-.168.344.344,0,0,1,.037-.433C558.617,138.77,559.009,138.317,559.6,138.389Z",
    transform: "translate(-499.511 -106.885)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M554.892,141.418c0,.053,0,.107-.008.16l.009.025a1.567,1.567,0,0,1-.991.018l-.525-.033v-.172A1.307,1.307,0,0,1,554.892,141.418Z",
    transform: "translate(-496.149 -108.892)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M555.27,142.721l.991-.018A.757.757,0,0,1,555.27,142.721Z",
    transform: "translate(-497.517 -109.992)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M550.341,142.077l.5.177-.49.327Q550.346,142.329,550.341,142.077Z",
    transform: "translate(-493.958 -109.542)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M580.634,166.864a1.537,1.537,0,0,1-2.363,0c.585-.093,1.16.438,1.778,0,.111-.079.238-.049.255-.251s-.106-.588.231-.493C580.893,166.22,580.889,166.573,580.634,166.864Z",
    transform: "translate(-514.126 -126.818)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M588.057,164.377c-.112-.423-.249-.742.1-.979a.266.266,0,0,1,.411.143C588.707,163.979,588.341,164.086,588.057,164.377Z",
    transform: "translate(-521.104 -124.837)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M571.22,165.332a.31.31,0,0,0-.338.341c-.292.074-.513.04-.506-.341l.843-.172Z",
    transform: "translate(-508.425 -126.138)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M561.844,162.274l.506.341c.115.057.115.114,0,.171-.43.242-.795.006-1.169-.161-.32-.21-.6-.514-1.042-.408-.081.129-.056.283-.107.415a1.218,1.218,0,0,1-.386.376.841.841,0,0,1-.531-.11,1.47,1.47,0,0,1-.383-.241,13.026,13.026,0,0,1-.172-1.494l.078-.085.5-.172.084.076c.119.188.047.459.257.609.45-.057.3-.415.336-.682.488-.015.219.543.506.681l.843.172c.127.175.374.168.5.339Z",
    transform: "translate(-499.893 -123.08)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M564.691,154.764c.411-.017.8.244,1.252-.1a.7.7,0,0,1,1.111.271,9.537,9.537,0,0,1-2.025.342.4.4,0,0,1-.423-.311A.264.264,0,0,1,564.691,154.764Z",
    transform: "translate(-504.258 -118.472)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M563.6,155.889l.337.341c.162.624-.5,1.082-.337,1.707-.475.006-.221-.542-.505-.681l.167-.344a1.4,1.4,0,0,1-.065-.823C563.214,155.835,563.368,155.756,563.6,155.889Z",
    transform: "translate(-503.167 -119.426)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M568.45,164.273c-.246.006-.489.007-.5-.339l.169-.006a.368.368,0,0,1,.342.177C568.454,164.162,568.451,164.218,568.45,164.273Z",
    transform: "translate(-506.67 -125.253)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M588.926,153.625c-.034.16.081.44-.208.41-.173-.018-.118-.259-.125-.412Z",
    transform: "translate(-521.578 -117.843)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M572.575,143.62l-1.257-.78c.673-.135,1.343-.605,1.931.1A3.915,3.915,0,0,0,572.575,143.62Z",
    transform: "translate(-509.105 -109.89)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M575.805,144.547c-.073-.529.15-.759.674-.683q0,.342,0,.683c-.015.347-.261.344-.506.342A.357.357,0,0,1,575.805,144.547Z",
    transform: "translate(-512.336 -110.816)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M553.077,132.24l-1.516,0a1.048,1.048,0,0,0-.673-.337c-.1-.294.118-.475.238-.69a.538.538,0,0,0,.165-.478c.05-.446-.12-.873-.106-1.313.01-.324-.034-.674.307-.886a1.688,1.688,0,0,1,1.7.216,5.65,5.65,0,0,0,2.584,1.11c0,.059,0,.118,0,.177-.133.3-.426.372-.688.488-.288-.1-.365.191-.527.311a12.716,12.716,0,0,1-1.655,1.071Z",
    transform: "translate(-494.334 -99.713)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M558.234,137.01c.442-.745,1.369-.867,1.9-1.5.02-.024.183.076.279.119l-.667.693A4.181,4.181,0,0,1,558.234,137.01Z",
    transform: "translate(-499.657 -104.818)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M559.684,231.962c.315-.094.124.336.343.34.17.013.352.07.344.256-.011.248-.247.32-.441.4-.2-.015-.466.264-.593-.124C559.194,232.442,559.771,232.336,559.684,231.962Z",
    transform: "translate(-500.437 -174.158)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M558.728,235.051c.178.192.34-.071.514-.018.16.373,0,.448-.328.358l-.084-.008-.083.009c-.114-.044-.3-.018-.273-.214C558.489,235.053,558.619,235.046,558.728,235.051Z",
    transform: "translate(-499.828 -176.37)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M562.759,231.992c.054,0,.107,0,.161,0a.408.408,0,0,1,.289.263,1.477,1.477,0,0,1,.067.191.933.933,0,0,1,.045.4.64.64,0,0,1-.209.328c-.231.029-.459.167-.7.023h-.176c-.127-.159-.1-.327.07-.393a.454.454,0,0,0,.3-.5.909.909,0,0,1,.145-.311Z",
    transform: "translate(-502.492 -174.188)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M565.565,235.352c-.022-.144,0-.268.151-.328a.26.26,0,0,0,.169.006.37.37,0,0,1,.158.024v.285Z",
    transform: "translate(-504.946 -176.369)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M561.239,232.957c-.011.235.378.687-.311.555-.157-.03-.183.17-.2.309-.216.233-.433.47-.663.014.215-.021.362-.1.328-.358.23-.113.563-.191.176-.518h0A.633.633,0,0,1,561.239,232.957Z",
    transform: "translate(-500.979 -174.814)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M416.58,86.086c.532-.129,1.1-.068,1.528-.6.185-.229.7-.174,1.016-.007.248.132-.056.4-.013.606a1.875,1.875,0,0,1-.233,2.027,1.712,1.712,0,0,1-1.013.311.766.766,0,0,1-.358-.1c-.449-.175-.875-.407-1.336-.558C415.841,87.09,416.221,86.59,416.58,86.086Z",
    transform: "translate(-396.981 -68.745)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M415.04,70.407v.343c-.058.417-.378.338-.644.339-1.029.005-2.058-.021-3.086.012-.519.017-.719-.18-.658-.685a1.61,1.61,0,0,1,.164-.014.643.643,0,0,1,.575-.149,1.931,1.931,0,0,1,.239.049,3.933,3.933,0,0,0,1.679-.03,1.594,1.594,0,0,1,.257-.06A2.243,2.243,0,0,1,415.04,70.407Z",
    transform: "translate(-393.08 -57.848)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M429.1,91.954c-.633.2-.8-.429-1.181-.682a1.284,1.284,0,0,1-.937-.139c-.387-.657.149-1.269.093-1.91.7.456,1.6.744,1.364,1.916-.1.5.327.473.66.474A.239.239,0,0,1,429.1,91.954Z",
    transform: "translate(-404.779 -71.541)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M433.219,87.946v-.341c0-.676,0-1.351,0-2.026,0-.605.188-1.291-.623-1.582-.048-.017-.035-.209-.05-.319a1.539,1.539,0,0,1,1.35.513h0a1.494,1.494,0,0,1,.141,1.225A2.546,2.546,0,0,0,434,86.934c.175.442-.3.735-.614,1.011Z",
    transform: "translate(-408.895 -67.533)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M405.4,85.577a1.914,1.914,0,0,1,.354,1.674,2.454,2.454,0,0,0-.016,1.057l-.094.069c-.7-.06-.895-.516-.874-1.141.1-.421.029-.857.1-1.281C405.037,85.818,405.259,85.757,405.4,85.577Z",
    transform: "translate(-388.837 -68.919)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M415.342,88.008c.092.61-.661,1.05-.337,1.707.093.184-.016.3-.138.407a.521.521,0,0,1-.345.058.381.381,0,0,1-.192-.131,1.492,1.492,0,0,0,.342-1.16A.729.729,0,0,1,415.342,88.008Z",
    transform: "translate(-395.743 -70.667)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M404.63,73.411l.326-.014.175.35c.1.221.224.4.505.342-.168.62-.646.3-1.006.34Q404.631,73.92,404.63,73.411Z",
    transform: "translate(-388.738 -60.162)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M433.894,83.394c-.5-.035-.879-.4-1.35-.513V82.54C433,82.812,433.8,82.533,433.894,83.394Z",
    transform: "translate(-408.895 -66.736)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M426.373,88.351c.111.624-.2,1.248,0,1.873a.262.262,0,0,1-.3.079.321.321,0,0,1-.2-.246,4.544,4.544,0,0,0,.337-2.047A.354.354,0,0,1,426.373,88.351Z",
    transform: "translate(-404.074 -70.669)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M405.212,83.816c-.083.243-.214.412-.5.343l-.062-.08a.844.844,0,0,1-.023-.2c.047-.2-.2-.359-.086-.571a1.1,1.1,0,0,1,.674-.175Q405.211,83.474,405.212,83.816Z",
    transform: "translate(-388.65 -67.159)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M407.157,94.859,408,94.69a.232.232,0,0,1,.067.207.7.7,0,0,1-.247.385,2.266,2.266,0,0,1-.9.16l-.11-.037a.357.357,0,0,1-.076-.215c.022-.266.3-.2.423-.33Z",
    transform: "translate(-390.258 -75.471)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M406.908,74.985c-.281.056-.584.145-.505-.342.184,0,.369,0,.553.01.115,0,.227.066.2.179C407.132,74.9,406.993,74.936,406.908,74.985Z",
    transform: "translate(-390.009 -61.058)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M411.29,94.764c0-.056,0-.113,0-.17.29.008.614-.163.844.164q.083.007.165.008c.046.166-.056.234-.184.285A.885.885,0,0,1,411.29,94.764Z",
    transform: "translate(-393.548 -75.376)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M406.33,78.564c-.246,0-.49,0-.508-.34C405.989,78.341,406.5,77.929,406.33,78.564Z",
    transform: "translate(-389.599 -63.615)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M390.858,90.772c0-.055,0-.111,0-.166a.343.343,0,0,0,.335-.169l.171.169c.217.406.776.427.96.871a.485.485,0,0,1-.09.369,1.023,1.023,0,0,1-.628.173,2.056,2.056,0,0,1-.26,0,1,1,0,0,1-.481-.132C390.528,91.519,390.816,91.145,390.858,90.772Z",
    transform: "translate(-378.682 -72.414)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M396.095,91.672l.006-.323c.292-.243.77.059,1-.352l0-.671a.2.2,0,0,1,.189-.038,1.646,1.646,0,0,1,.365.5.493.493,0,0,1,.024.205,3.7,3.7,0,0,1-.1.4,1.4,1.4,0,0,1-.071.2,1.137,1.137,0,0,1-.378.507.531.531,0,0,1-.309.042,1.123,1.123,0,0,1-.285-.109,1.544,1.544,0,0,1-.171-.1A.65.65,0,0,1,396.095,91.672Z",
    transform: "translate(-382.575 -72.3)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M394.928,91.544c-.158.633-.672.229-1,.352-.345-.221-.871-.26-.843-.857C393.738,91.051,394.167,91.923,394.928,91.544Z",
    transform: "translate(-380.398 -72.847)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M399.071,87.328q-.082,0-.163.006l-.321-.178.159-.327c.274-.159.066-.549.334-.712.347,0,.322.279.368.5C399.439,86.921,399.407,87.208,399.071,87.328Z",
    transform: "translate(-384.375 -69.308)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M401.563,84.259l.176-.506h.332a.654.654,0,0,1,.176.345.737.737,0,0,1-.108.5.353.353,0,0,1-.354.084A.437.437,0,0,1,401.563,84.259Z",
    transform: "translate(-386.524 -67.608)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M403.391,84.1q0-.174,0-.348l.34,0c.125.208.562.335.17.676A1.188,1.188,0,0,1,403.391,84.1Z",
    transform: "translate(-387.842 -67.61)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M400.693,85.555a.381.381,0,0,1,.177.348c.1.175-.012.278-.129.379a.172.172,0,0,1-.2-.036c-.026-.19.023-.406-.182-.533,0-.05,0-.1,0-.149Z",
    transform: "translate(-385.653 -68.904)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M416.274,66.622c-.326.006-.378.292-.5.5-.486.242-1.034-.058-1.52.18l0,0a4.4,4.4,0,0,1-1.859,0l0,0c-.095-.226-.563.112-.506-.343l.348-.345,2.334,0a1.192,1.192,0,0,0,1.122-.479c.345-.437,1.05-.295,1.6-.036l-.062.1A2.209,2.209,0,0,1,416.274,66.622Z",
    transform: "translate(-393.979 -54.745)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M411.446,69.781l.506.343-.682-.008A.366.366,0,0,1,411.446,69.781Z",
    transform: "translate(-393.533 -57.562)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M436.789,66.438h-.672a1.8,1.8,0,0,1-2.363-.171h0c.415-.339.9-.095,1.351-.171h.507c1.079,0,2.159.024,3.237-.008.528-.016.7.2.643.693-.786-.682-1.574-.255-2.362,0C437.266,66.406,436.865,66.59,436.789,66.438Z",
    transform: "translate(-409.768 -54.9)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M424.208,55.194l1.51,0c-.445.722-1.14.163-1.692.337Z",
    transform: "translate(-402.744 -47.075)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M430.894,66.737c-.045.57-.465.508-.845.511-.108-.321.207-.355.34-.512l0,0Z",
    transform: "translate(-407.078 -55.371)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M458.516,88.614c.965.458,2.249.477,2.53,1.878a.96.96,0,0,1-1.3-.073c-.634-.5-.767-.435-1.247.219-.4.546-.271,1.274-.7,1.793-.417.052-.463-.249-.512-.548a22.534,22.534,0,0,1,.547-2.585C458.468,89.476,458.608,89.162,458.516,88.614Z",
    transform: "translate(-426.768 -71.103)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M451.43,87.927a11.866,11.866,0,0,1-.338,2.56.563.563,0,0,1-.49.237.988.988,0,0,1-.305-.149,2.074,2.074,0,0,1-.891-1.112c.1-.677-.415-1.077-.7-1.573a1.039,1.039,0,0,1-.157-1.183,9.564,9.564,0,0,1,1.2,2.414c.061.055.152.078.2.136.4.47.722.417.98-.136.328-.391.1-.857.17-1.283.039-.23-.118-.515.163-.676.044-.025.162.026.211.077C451.695,87.477,451.526,87.7,451.43,87.927Z",
    transform: "translate(-420.357 -69.733)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M451.878,96.514l1.015,1.029a2.559,2.559,0,0,1,.006,1.338c.21-.364-.055-.813.164-1.171l.5-.172c0,.248-.005.5.337.513a.717.717,0,0,1,.107.814,1.151,1.151,0,0,1-.785.574.967.967,0,0,1-.672-.121,2.263,2.263,0,0,1-.337-1.267C452.234,97.509,451.7,97.092,451.878,96.514Z",
    transform: "translate(-422.83 -76.783)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M441.3,101.33c-.039.612.716.411.847.849a.493.493,0,0,1-.164.415.667.667,0,0,1-.208.086c-.409.078-.753-.293-1.169-.174a1.513,1.513,0,0,1-.644-.156.475.475,0,0,1-.226-.22c-.013-.225-.353-.382-.136-.657.237-.1.536.048.739-.188a1.049,1.049,0,0,1,.268-.191.342.342,0,0,1,.213.006C440.979,101.179,441.188,101.153,441.3,101.33Z",
    transform: "translate(-413.939 -80.066)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M449.413,80.717v.341a4.7,4.7,0,0,1-2.783.228,2.474,2.474,0,0,0-1.311.044c-.274.094-.562.154-.631-.271C446.245,80.7,447.872,81.309,449.413,80.717Z",
    transform: "translate(-417.665 -65.425)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M450.537,101.652c.42.3.34.739.334,1.159-.184.284-.492.232-.76.287a.516.516,0,0,1-.226-.045,1.219,1.219,0,0,1-.369-.559C449.557,101.423,449.576,101.408,450.537,101.652Z",
    transform: "translate(-421.152 -80.385)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M438.616,98.259c.091-.609.531-.738,1.034-.74.443,0,.885.038,1.328.059-.1.515-.513.278-.8.343-.311.069-.756-.214-.886.34A.454.454,0,0,1,438.616,98.259Z",
    transform: "translate(-413.28 -77.505)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M454.372,95.165a2.355,2.355,0,0,1-.261.975,2.4,2.4,0,0,1-.92-.975C453.585,95.267,453.978,95.009,454.372,95.165Z",
    transform: "translate(-423.805 -75.776)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M437.659,100.146h.674a1.667,1.667,0,0,1,1.025.182c.009.148-.011.261-.2.16h-.07l-.07,0a2.3,2.3,0,0,1-1.65-.09.184.184,0,0,1-.05-.252l0,0Z",
    transform: "translate(-412.323 -79.393)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M448.661,104.981c.332.022.355.258.348.515l-.089.087c-.278.092-.492.041-.587-.272a.338.338,0,0,1,.172-.327A1.174,1.174,0,0,0,448.661,104.981Z",
    transform: "translate(-420.296 -82.871)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M444.017,100.9l.2-.16c.2.019.463-.127.577.116.083.177-.134.175-.251.211C444.357,101.04,444.141,101.117,444.017,100.9Z",
    transform: "translate(-417.18 -79.801)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M491.678,95.639c-.19.139-.313.426-.62.309-.322-.123-.188-.419-.223-.651h.843C491.678,95.411,491.678,95.525,491.678,95.639Z",
    transform: "translate(-450.988 -75.908)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M492.184,98.749a.961.961,0,0,1-.677.346c-.236.089-.382.363-.675.336.1-.583.691-.433,1.012-.685.2-.112.153-.339.211-.55C492.263,98.381,492.145,98.581,492.184,98.749Z",
    transform: "translate(-450.986 -77.993)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M508.318,109.252q0,.511,0,1.022c-.264.287-.091.677-.227.994a3.754,3.754,0,0,0-.235.508.775.775,0,0,1-.207.411c-.382.02-.481-.231-.512-.547,0-.056,0-.113,0-.169.643-.5,0-.81-.166-1.192l-.337-.006c1.273-.482,1.4-.665,1.179-1.706C508.529,108.378,508.238,108.956,508.318,109.252Z",
    transform: "translate(-462.395 -85.422)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M489.08,127.373a.351.351,0,0,0-.339-.171,1.163,1.163,0,0,1-.338-.512c0-.057,0-.113,0-.17l.08-.089a1.416,1.416,0,0,1,.438-.163c.589-.275,1.278.171,1.846-.261.108-.133.213-.155.309.011.06.1-.034.269.127.336.029-.1.03-.265.092-.293.254-.116.1.132.149.2.192.27.21-.113.335-.086a1.065,1.065,0,0,1-.667,1.192,4.348,4.348,0,0,0-.831.124,1.772,1.772,0,0,1-.631.118C489.485,127.473,489.178,127.675,489.08,127.373Z",
    transform: "translate(-449.231 -97.911)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M487.274,124.022l-.169,0c-.112-.093-.25-.165-.265-.336a1.192,1.192,0,0,1,.151-.529c.063-.134.128-.267.2-.4.1-.164.2-.334.432-.332.181.072.391.12.331.4-.208.287.042.454.167.655-.072.15-.216.184-.354.226a.8.8,0,0,0-.492.317Z",
    transform: "translate(-448.102 -95.414)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M489.532,126.206l.495-.034,1.518.031c.036.365-.068.476-.469.4a1.8,1.8,0,0,0-1.361.1C489.553,126.577,489.4,126.445,489.532,126.206Z",
    transform: "translate(-450.01 -98.106)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M489.9,120.64l-.334-.334a1.414,1.414,0,0,1,.058-.784.28.28,0,0,1,.176-.133.262.262,0,0,1,.19.108c.106.2.065.455.242.625.306.293.019.391-.168.522C490.013,120.64,489.958,120.639,489.9,120.64Z",
    transform: "translate(-450.053 -93.229)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M525.186,92.172c-.016.368.432.383.505.683h-.505c-.23-.156-.484-.331-.74-.118-.324.27-.219.631-.1.972a8.992,8.992,0,0,0,.575,2.516c.295.962.128,1.693-.575,2.093-.2-.121-.046-.363-.168-.511.747-.435.34-1,.168-1.537.2-.842-.423-1.565-.339-2.39-.011-.5.123-1.039-.553-1.367C524.116,92.4,524.478,91.445,525.186,92.172Z",
    transform: "translate(-474.539 -73.466)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M497.891,131.756c.9.083,1.292,1.106,2.185,1.2a.212.212,0,0,1,.05.135c0,.05,0,.075-.012.075a.689.689,0,0,1-.973.221c-.213-.014-.441.083-.634-.084a.815.815,0,0,1-.135-.422,3.007,3.007,0,0,0-.047-.315c-.078-.224-.336-.234-.464-.4a.363.363,0,0,1-.045-.322Z",
    transform: "translate(-456.016 -102.121)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M505.187,128.038l.007-1.2c.4-.074.612.063.553.5-.116.223.126.278.2.416a.854.854,0,0,1-.078.6c-.119.2-.248.373-.507.192h0C505.18,128.421,505,128.292,505.187,128.038Z",
    transform: "translate(-461.294 -98.574)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M505.751,126.73c.283-.433-.207-.353-.333-.514,0-.057,0-.115,0-.173.414-.262.632.107.91.287a1.576,1.576,0,0,1,.174.158.555.555,0,0,1,.162.432c-.1.3-.192.612-.528.744a.273.273,0,0,1-.21-.081l.165-.509C505.987,126.951,505.646,127.065,505.751,126.73Z",
    transform: "translate(-461.518 -97.949)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M506.25,125.379a1.2,1.2,0,0,0-.835-.513q0-.169,0-.338l.326-.169c.212.106.407-.032.612-.044a.392.392,0,0,1,.208.4A.987.987,0,0,1,506.25,125.379Z",
    transform: "translate(-461.515 -96.771)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M494.986,130.62a.629.629,0,0,1,.855.037c0,.058,0,.117,0,.175h0a.826.826,0,0,1-.506.307.486.486,0,0,1-.334-.089C494.838,130.91,495.189,130.759,494.986,130.62Z",
    transform: "translate(-453.962 -101.197)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    d: "M506.353,131.751h.17a.465.465,0,0,1-.085.744.277.277,0,0,1-.265-.056.369.369,0,0,1-.162-.346A.315.315,0,0,0,506.353,131.751Z",
    transform: "translate(-461.947 -102.117)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M504.605,131.148l.172.512c-.18-.021-.413.048-.467-.214C504.265,131.227,504.432,131.172,504.605,131.148Z",
    transform: "translate(-460.713 -101.684)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M506.134,134.193l.18,0a.47.47,0,0,1,.114.464.751.751,0,0,1-.266.414c-.144.012-.237-.026-.194-.2,0-.055,0-.11,0-.165Z",
    transform: "translate(-461.908 -103.872)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M489.579,102.585a1.237,1.237,0,0,1-.122.852c-.249.729.169,1.31.8,1.2.114.067.305.22.175.283-.624.3-.32.632-.074.972s.1.663-.1.969c-.224-.228-.312-.572-.616-.732-.4-.426-.037-1.057-.4-1.494C489.132,103.911,488.846,103.163,489.579,102.585Z",
    transform: "translate(-449.731 -81.148)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M490.385,114.739a.687.687,0,0,1,.517.856l-.337.678c-.192-.229-.019-.476-.083-.672-.123.1.18.514-.256.5l0,0C489.92,115.607,489.857,115.137,490.385,114.739Z",
    transform: "translate(-450.378 -89.886)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M490.833,118.125c.213-.1.112-.355.3-.576.016.293.028.519.041.745q0,.252,0,.5C490.852,118.678,490.826,118.409,490.833,118.125Z",
    transform: "translate(-450.985 -91.907)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M492.381,107.951c-.344-.013-.343-.26-.337-.509C492.374,107.464,492.567,107.58,492.381,107.951Z",
    transform: "translate(-451.86 -84.64)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M487.419,111.234a2.886,2.886,0,0,0-.161,1.367h-.082l-.082,0c-.362.17-.221.618-.462.855a.291.291,0,0,1-.214.052,3.166,3.166,0,0,1-.532-1.515.723.723,0,0,1,.362-.761c.306-.129.352-.391.336-.683l.34-.687C487.585,110.137,487.146,110.817,487.419,111.234Z",
    transform: "translate(-447.412 -86.381)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M458.533,96.065v-.853a3.3,3.3,0,0,1,.74-2.344c.277-.425,1.045-.357,1.155-.07.293.766.841.466,1.311.536h.169a1.132,1.132,0,0,0,.591,1.328.683.683,0,0,1,.243.22,2.9,2.9,0,0,0,1.866,1.524l0,.341a1.233,1.233,0,0,1,.233.811,3.68,3.68,0,0,0,.609,1.068q0,.083,0,.165c-.1.181-.315.305-.254.56a1.315,1.315,0,0,1,.008.218,1.9,1.9,0,0,1-.186.627c-.036.065-.076.126-.118.188-.142.273-.05.623-.281.866a.791.791,0,0,1-.346.131,2.047,2.047,0,0,1-.631-.018,1.121,1.121,0,0,1-.231-.078c-.6-.246-1.189-.777-1.84-.1l-.343.336c-.334.1-.668.241-1.007.016-.055,0-.109-.006-.163-.007l-.371-.33a.193.193,0,0,1-.3-.007l-.185-.169a1.189,1.189,0,0,1,.29-.347c.3-.443.149-.921.144-1.382-.307-.151-.345.282-.584.219-.187-.114-.258-.334-.425-.467A3.555,3.555,0,0,1,458.533,96.065Z",
    transform: "translate(-427.46 -73.944)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M481.092,117.1c.057-.333-.143-.712.177-1,.051.09.1.17.158,0a1.194,1.194,0,0,1,.176-.695,1.5,1.5,0,0,0,.114-.122c-.038.04-.075.082-.114.121-.338-.451-.191-.66.332-.683l.511.005c.16.26.044.548.079.82a7.042,7.042,0,0,0,.061.83c.039.457-.245.678-.6.85a1.166,1.166,0,0,1-.407.081A.552.552,0,0,1,481.092,117.1Z",
    transform: "translate(-443.944 -89.875)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M481.125,108.472q0-.513,0-1.026c.845.089,1.182.569.841,1.2C481.7,108.539,481.4,108.566,481.125,108.472Z",
    transform: "translate(-443.976 -84.643)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M481.125,110.619c.311-.1.673-.448.842.171l0,.343q.086.056.057.112c-.019.037-.039.055-.058.055v.173C481.527,111.35,481.392,110.918,481.125,110.619Z",
    transform: "translate(-443.976 -86.79)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    d: "M484.158,113.093q0-.084,0-.167l.658.138C484.563,113.391,484.36,113.161,484.158,113.093Z",
    transform: "translate(-446.166 -88.583)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M485.975,115.592l0-.853h.336a1.408,1.408,0,0,0-.171.853Q486.06,115.709,485.975,115.592Z",
    transform: "translate(-447.478 -89.886)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M507.3,121.306a.36.36,0,0,0-.166-.341.523.523,0,0,1-.511-.171v-.344c.095-.13.3-.143.336-.338.006-.188-.03-.39.169-.514l.5.514a.7.7,0,0,1,.161.668,1.041,1.041,0,0,1-.07.227C507.62,121.156,507.565,121.384,507.3,121.306Z",
    transform: "translate(-462.39 -93.379)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M507.842,114.753c.88.626.9.8.166,1.192C508.125,115.523,507.818,115.162,507.842,114.753Z",
    transform: "translate(-463.267 -89.896)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M506.6,123.853c.187,0,.386-.025.51.171-.026.136-.037.289-.215.311-.225.028-.274-.135-.306-.309Z",
    transform: "translate(-462.362 -96.439)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M506.962,121.425c.072.07.218.173.2.2-.115.264-.359.082-.541.135A.307.307,0,0,1,506.962,121.425Z",
    transform: "translate(-462.391 -94.693)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M538.1,123.174c.014.282-.245.42-.335.648a1.313,1.313,0,0,0-.841-.157c-.461-.02-.416-.376-.42-.676-.011-.719-.008-1.439,0-2.03-.128.724.19,1.6-.162,2.442a1.889,1.889,0,0,1-2.089-.319c-.278-.281-.687-.173-1.031-.267-.273-.115-.6-.182-.516-.611a1.181,1.181,0,0,0,.23-.717,1.477,1.477,0,0,1,.259-.507,2.216,2.216,0,0,1,1.177-1.364.586.586,0,0,0,.349-.354c.181-.828.686-.878,1.427-.814a2.468,2.468,0,0,0,2.46-1.278c.469.19,1.018.217,1.35.683.363.24.723.486,1.074.743.221.162.475.314.3.661-.616.262-1.192.337-1.611-.346a.506.506,0,0,0-.576-.255,3.983,3.983,0,0,0-1.439.673c-.465.335-.314.869.286,1.232a.893.893,0,0,1,.111.558c.013.533-.179,1.078.1,1.593C538.258,122.886,537.6,122.9,538.1,123.174Z",
    transform: "translate(-481.211 -91.634)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M507.062,120.525q0-.259,0-.518c.241-.182.142-.45.17-.686l.5-.684c.117-.29-.113-.588.016-.878.074-.156.045-.346.159-.489l0,0a.717.717,0,0,0,.136-.176c.168-.5.032-1.037.2-1.535-.021-.27-.039-.539-.065-.808-.039-.408.19-.293.4-.215h0c.394.557.16,1.2.231,1.8.043.368.032.792.612.593h.169a.479.479,0,0,1,.417.173c.2.419.477.8.707,1.2a1.209,1.209,0,0,1,.082.344,1.705,1.705,0,0,0,.222,1,.469.469,0,0,1-.025.36.73.73,0,0,1-.31.2,2.139,2.139,0,0,1-.6.143c-.492-.019-1-.243-1.465.11-.53.137-.4.86-.888,1.031a.681.681,0,0,1-.259.018C506.976,121.341,506.928,120.971,507.062,120.525Z",
    transform: "translate(-462.659 -89.688)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M539.514,116.522c.076.92-.749,1.074-1.274,1.308a2.244,2.244,0,0,1-1.786.136c-.3-.125-.5-.056-.444.334a.69.69,0,0,1-.4.678,3.685,3.685,0,0,0-1.5,1.47q-.085.107-.169,0a1.834,1.834,0,0,1,.76-1.353,1.87,1.87,0,0,0,.786-2.245c-.046-.192-.148-.513.147-.574s.261.288.376.461c.143.217-.092.613.421.679.633.081,1.274.34,1.837-.094A7.582,7.582,0,0,1,539.514,116.522Z",
    transform: "translate(-482.119 -90.986)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M513.532,113.738a.484.484,0,0,1-.614.307c-.291-.087-.224-.357-.226-.573-.007-.708,0-1.416,0-2.124.425-.052.293-.4.348-.656.085-.391.315-.717.728-.664a.735.735,0,0,1,.607.715c.043.433-.126.639-.569.611-.21-.013-.43.057-.418.308A4.662,4.662,0,0,0,513.532,113.738Z",
    transform: "translate(-466.767 -86.495)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M560.191,120.924c-.043-.472-.556-.416-.765-.7-.178-.239-.568-.287-.585-.668a1.257,1.257,0,0,1,1.012.341,2.475,2.475,0,0,1,1.2,1.295c.165.542.475.87,1.108.614.095-.038.253.083.381.131,0,.061-.009.122-.014.183-.626-.03-1.324.337-1.831-.345A2.123,2.123,0,0,1,560.191,120.924Z",
    transform: "translate(-500.095 -93.34)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M545.625,105.019c.071.32-.155.49-.336.683a10.136,10.136,0,0,1-1.687.683l-2.093-.636-.034-.234C542.952,105.9,544.392,106.066,545.625,105.019Z",
    transform: "translate(-487.555 -82.898)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M527.011,126.505q0,.261.007.523l-.083.112c-.229.142-.337,0-.422-.187a4.7,4.7,0,0,1-.073-1.121,9.309,9.309,0,0,1,.031-.992.823.823,0,0,1,.2-.378H527c.2.177.072.4.088.6.136.281-.128.571.019.853A.53.53,0,0,1,527.011,126.505Z",
    transform: "translate(-476.698 -96.876)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M525.16,112.917c.2.123.163.324.168.511-.256.229-.174.508-.11.783s.255.5.123.8A1.474,1.474,0,0,1,525.16,112.917Z",
    transform: "translate(-475.526 -88.576)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M522.649,122.223l.169.508a1.037,1.037,0,0,1-.487.3.715.715,0,0,1-.567.055c-.11-.333-.678-.53-.293-1.012A2.24,2.24,0,0,1,522.649,122.223Z",
    transform: "translate(-473.015 -95.151)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M521.147,121.531l-1.346.007a.3.3,0,0,1-.345.048c-.143-.1-.258-.219-.165-.418.6-.2,1.188.091,1.788.049C521.3,121.2,521.17,121.413,521.147,121.531Z",
    transform: "translate(-471.512 -94.459)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M526.212,94.994c-.187-.133-.157-.335-.169-.528a.684.684,0,0,1,.4-.751c.333-.123.461.2.611.425Q526.049,93.975,526.212,94.994Z",
    transform: "translate(-476.41 -74.751)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M559.64,113.7a1.637,1.637,0,0,1,1.349.016A1.381,1.381,0,0,1,559.64,113.7Z",
    transform: "translate(-500.672 -89.044)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M524.291,124.622c.121-.2.324-.16.509-.175.055,0,.11,0,.164,0q-.006.173-.012.345a1.162,1.162,0,0,0-.13.168c-.13.266-.149.572-.3.831a.243.243,0,0,1-.223.06.455.455,0,0,1-.153-.205A1.075,1.075,0,0,1,524.291,124.622Z",
    transform: "translate(-474.996 -96.866)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M531.56,132.759c.292.291.019.392-.172.52a.656.656,0,0,1-.7-.13.262.262,0,0,1,.03-.344l.5-.031A.233.233,0,0,1,531.56,132.759Z",
    transform: "translate(-479.73 -102.795)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M516.4,122.093a.352.352,0,0,1-.339-.172c-.229-.4-.079-.541.332-.514a.8.8,0,0,1,.392.352.38.38,0,0,1-.185.38A.175.175,0,0,1,516.4,122.093Z",
    transform: "translate(-469.123 -94.679)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M517.873,121.373a.33.33,0,0,1-.343-.363c.164-.2.335-.219.514-.019l.162.333-.056.086A.224.224,0,0,1,517.873,121.373Z",
    transform: "translate(-470.264 -94.281)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M536.988,111.745v-1.164l.167-.005v1.17h-.167Z",
    transform: "translate(-484.315 -86.893)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M528.491,129.868q0-.339,0-.678c.054-.069.109-.067.166,0C528.88,129.482,528.976,129.747,528.491,129.868Z",
    transform: "translate(-478.178 -100.239)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M528.489,127.41l-.166,0c-.177-.229.077-.458,0-.687q.085-.119.166,0C528.793,126.956,528.43,127.183,528.489,127.41Z",
    transform: "translate(-478.012 -98.463)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M529.173,133.028l-.007.307a.445.445,0,0,1-.35.148c-.167-.04-.364-.05-.307-.314h0A.846.846,0,0,1,529.173,133.028Z",
    transform: "translate(-478.185 -103.017)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M528.639,125.142c-.056,0-.111,0-.166,0q0-.34-.005-.679C529.063,124.549,528.557,124.922,528.639,125.142Z",
    transform: "translate(-478.162 -96.876)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M533.069,131.643l-.34.016.338-.518h.169Z",
    transform: "translate(-481.24 -101.679)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M552.927,122.267a.815.815,0,0,1,.506.854c-.524.039-.571.56-.844.854a.817.817,0,0,1-1.012,0c-.441-.726-1.139-.158-1.688-.341a.225.225,0,0,1-.337,0c-.272-.066-.775.162-.769-.233.008-.456-.088-1.146.457-1.336.386-.134.715-.362,1.094-.483.529-.171,1.018-.424,1.309.442C551.823,122.556,552.492,122.162,552.927,122.267Z",
    transform: "translate(-492.832 -94.683)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M558.841,130.533h1.012a5.368,5.368,0,0,1,1.687.854,1.157,1.157,0,0,1-1.436-.277C559.766,130.683,559.046,131.2,558.841,130.533Z",
    transform: "translate(-500.095 -101.242)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M588.838,218.709c0,.048.008.1.012.145q0,.252.006.5l-.518-.03a.316.316,0,0,1-.055-.326.607.607,0,0,1,.465-.307A.441.441,0,0,0,588.838,218.709Z",
    transform: "translate(-521.34 -164.629)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M579.934,225.414c-.336.143-.2-.439-.513-.339-.281.157-.442-.009-.588-.221a1.25,1.25,0,0,1-.047-.99.55.55,0,0,1,.7-.282c.31.132.3.484.477.709a.471.471,0,0,1,.037.223.752.752,0,0,0,.1.7Z",
    transform: "translate(-514.441 -168.12)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M582.639,227.786c-.438-.122-.579-.319-.162-.657a.3.3,0,0,0,.174.006l.344.013a.3.3,0,0,1,.066.3.335.335,0,0,1-.249.194Z",
    transform: "translate(-516.983 -170.693)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M584.97,227.479c0-.1,0-.207.005-.31l.479-.012c.13.176.325.167.511.182-.078.245-.281.3-.5.341A.422.422,0,0,1,584.97,227.479Z",
    transform: "translate(-518.964 -170.713)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M584.511,228.3l.5.2c-.227.1-.461.587-.674-.013Z",
    transform: "translate(-518.504 -171.537)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M573.92,220.443c-.236.023-.5-.081-.681.173a.48.48,0,0,1-.362.115c-.737-.161-1.542-.164-2.038-.888.111-.218.521-.247.386-.624a1.265,1.265,0,0,1,1.345-.023.852.852,0,0,0,.772.359,6.737,6.737,0,0,0,.751.065.956.956,0,0,1,.432.03.306.306,0,0,1,.148.152,1.424,1.424,0,0,1,.249.48l.019.148a.335.335,0,0,0-.355.356c-.144.1-.258,0-.376-.061A2.1,2.1,0,0,1,573.92,220.443Z",
    transform: "translate(-508.759 -164.858)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M582.855,224.706l.333.172-.16.515c-.062.121-.12.111-.174-.006v-.171A.359.359,0,0,1,582.855,224.706Z",
    transform: "translate(-517.36 -168.95)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M584.682,222.094c-.328-.016-.346-.242-.323-.493a.1.1,0,0,1,.159-.044c.184.015.387-.028.516.165A.634.634,0,0,1,584.682,222.094Z",
    transform: "translate(-518.517 -166.671)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M586.354,217.148l-.4.343a.948.948,0,0,1-.679.148H585.2l-.076,0a.446.446,0,0,1-.168-.305.882.882,0,0,1,.025-.358.431.431,0,0,1,.14-.19c.192.089.389.241.536-.066.113-.235.289-.193.474-.1C586.13,216.825,586.118,217.04,586.354,217.148Z",
    transform: "translate(-518.946 -163.082)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M583.191,218.759q0,.173.008.345l-.176.332a.57.57,0,0,0-.16.043l-.021-.045c-.273-.111-.57-.2-.561-.587a.3.3,0,0,1,.159-.2A.681.681,0,0,1,583.191,218.759Z",
    transform: "translate(-517.022 -164.549)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M586.126,220.046c.182-.258.451-.106.679-.148,0,.1-.006.193-.01.29C586.564,220.185,586.3,220.329,586.126,220.046Z",
    transform: "translate(-519.798 -165.489)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M575.965,230c-.318-.073-.9.159-.885-.287s.582-.133.888-.232c.176-.069.194.013.149.158Z",
    transform: "translate(-511.821 -172.368)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M578.425,228.84l-.149-.157.171-.175a.309.309,0,0,1,.168-.163l.5.176c-.2.2-.608.243-.5.676Z",
    transform: "translate(-514.13 -171.566)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M565.546,232.413l0-.184c.107-.5.382-.412.691-.2a.16.16,0,0,1-.026.211l-.167.168A.386.386,0,0,1,565.546,232.413Z",
    transform: "translate(-504.937 -174.094)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M567.95,232.654v-.171a.1.1,0,0,1,.167-.007l.507.006C568.476,232.847,568.232,232.826,567.95,232.654Z",
    transform: "translate(-506.673 -174.509)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M565.546,233.816l.5,0-.17.346c-.061.128-.116.11-.169-.006Z",
    transform: "translate(-504.937 -175.497)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M570.987,232.406c.224-.008.449-.167.673,0A.405.405,0,0,1,570.987,232.406Z",
    transform: "translate(-508.866 -174.432)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M389.5,91.63c.166.044.381.1.185.313a.977.977,0,0,0-.186.711.237.237,0,0,1,.066.286l-.077.074c-.224.154-.442-.009-.663-.012.026-.224.588-.086.329-.5q0-.26.006-.52a.24.24,0,0,1,0-.343Z",
    transform: "translate(-377.327 -73.271)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M388.977,90.782c0,.114,0,.229,0,.343-.227,0-.331-.126-.333-.349a.228.228,0,0,1,0-.336A.581.581,0,0,1,388.977,90.782Z",
    transform: "translate(-377.137 -72.417)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M387.905,89.564q0,.168,0,.336l-.34-.338c-.006-.112-.011-.223-.017-.335l.354-.006Z",
    transform: "translate(-376.406 -71.539)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M438.955,115.436l-.051.2c-.208-.125-.028-.443-.27-.551l-.032-.66a.364.364,0,0,1,.188-.133.452.452,0,0,1,.337.07.469.469,0,0,1,.1.211.622.622,0,0,1-.031.229C439.075,115,439.145,115.269,438.955,115.436Z",
    transform: "translate(-413.271 -89.563)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M435.957,113.49l-.182.016-1.021-.049a.271.271,0,0,1-.019-.333c.245-.2.537-.056.8-.116a.546.546,0,0,1,.456.131A.307.307,0,0,1,435.957,113.49Z",
    transform: "translate(-410.443 -88.64)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M431.009,114.056c-.4-.174-.454-.425-.163-.753.3-.2.4.006.5.236,0,.038,0,.077,0,.116a1.2,1.2,0,0,1,.008.159C431.28,113.956,431.2,114.087,431.009,114.056Z",
    transform: "translate(-407.536 -88.796)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M431.914,115.57l.343-.242a.635.635,0,0,0,.357.364l-.379.166-.317-.036C431.917,115.738,431.915,115.654,431.914,115.57Z",
    transform: "translate(-408.44 -90.31)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M433.481,113.284c0,.091,0,.183,0,.274l-.5.041.012,0c-.167-.306-.006-.412.268-.45A.314.314,0,0,1,433.481,113.284Z",
    transform: "translate(-409.167 -88.74)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M436.7,116.524l-.5-.005c0-.14.009-.252.21-.245C436.592,116.281,436.723,116.3,436.7,116.524Z",
    transform: "translate(-411.535 -90.99)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M428.245,117.341c.192-.259.455-.151.7-.139q-.013.161-.026.322A.579.579,0,0,1,428.245,117.341Z",
    transform: "translate(-405.791 -91.634)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M441.758,115.2c-.079.291.406.791-.308.846-.026-.3-.32-.345-.481-.517a.131.131,0,0,1-.071-.128c.007-.051.018-.077.032-.078A.871.871,0,0,1,441.758,115.2Z",
    transform: "translate(-414.927 -90.175)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M440.118,115.826a.6.6,0,0,1,.047.153c-.046.225.006.52-.358.522-.01-.248-.1-.515.154-.7A.1.1,0,0,1,440.118,115.826Z",
    transform: "translate(-414.123 -90.628)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M457.125,120.325c0,.054,0,.108-.005.162-.175.013-.364-.026-.5.139-.245.216-.393.094-.507-.149.093-.426-.431-1.273.673-1.009a.138.138,0,0,1,.185.061c-.236.3-.075.463.2.59A.18.18,0,0,1,457.125,120.325Z",
    transform: "translate(-425.883 -93.25)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M454.765,114.307c-.293.024-.44-.246-.674-.342-.233-.34-.105-.577.21-.76a.521.521,0,0,1,.245,0,1.728,1.728,0,0,1,.582.869A.36.36,0,0,1,454.765,114.307Z",
    transform: "translate(-424.368 -88.771)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M452.989,112.445c-.308.129-.354.39-.339.683-.315.07-.484-.157-.674-.341,0-.057,0-.114,0-.171a.985.985,0,0,1,.839-.592.342.342,0,0,1,.218.088A.273.273,0,0,1,452.989,112.445Z",
    transform: "translate(-422.927 -87.935)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M455.145,123.186l.507.149c-.078.253-.342.253-.511.382l-.35-.028a.255.255,0,0,1,.01-.35Z",
    transform: "translate(-424.914 -95.96)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M456.827,116.734a.347.347,0,0,1,.338-.171l.117,0a.52.52,0,0,1,.306.768l-.084.083-.169,0C457.351,117.046,456.9,117.033,456.827,116.734Z",
    transform: "translate(-426.43 -91.198)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M453.3,123.6q-.005.175-.01.35l-.644-.178C452.77,123.357,453.085,123.678,453.3,123.6Z",
    transform: "translate(-423.41 -96.225)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M448.392,109.54c-.32.256-.832.221-1.014.686h-.311l-.054-.677c.021-.03.042-.06.063-.09a1.483,1.483,0,0,0,.571-.627,1.562,1.562,0,0,1,.427-.366c.521-.068.364.384.475.633A.5.5,0,0,1,448.392,109.54Z",
    transform: "translate(-419.344 -85.372)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M442.917,110.889c-.295-.047-.355.382-.652.329a1.2,1.2,0,0,1-.725-.056.373.373,0,0,1-.2-.315.532.532,0,0,1,.3-.425,1.567,1.567,0,0,1,1.082-.005.414.414,0,0,1,.249.455Z",
    transform: "translate(-415.247 -86.711)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M441.145,112.92c.233.03.5-.1.681.161,0,.142-.008.278-.157.35l-.107,0c-.271-.031-.564.207-.816-.066C440.671,113.029,440.935,113,441.145,112.92Z",
    transform: "translate(-414.809 -88.575)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M440.581,114.917a.459.459,0,0,1-.157-.029.741.741,0,0,1,.014-.143.252.252,0,0,1,.2-.09c.259-.015.49-.24.768-.106l.041.027c-.01.055-.019.11-.03.165A1.29,1.29,0,0,1,440.581,114.917Z",
    transform: "translate(-414.586 -89.719)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M451.974,110.837v-.511c.487-.176.748.03.843.513l-.841.512Q451.975,111.094,451.974,110.837Z",
    transform: "translate(-422.926 -86.669)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M459.865,120.347l0-.175c-.009-.327.4-.367.443-.658a.24.24,0,0,1,.216-.061c.31.175.417.4.187.72a.379.379,0,0,1-.34.18Z",
    transform: "translate(-428.622 -93.272)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M462.125,123.269l.3.007c.018.194-.04.355-.259.307S462.09,123.381,462.125,123.269Z",
    transform: "translate(-430.195 -96.019)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M465.331,124.456l1.007-.016c.051.013.12.01.147.043.073.087.005.121-.074.129-.2.021-.43-.045-.576.17h-.506Z",
    transform: "translate(-432.57 -96.861)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M431.956,110c-.224.018-.353.127-.341.368-.178-.1-.232-.394-.51-.347l-.006-.338c-.25-.437.148-.612.344-.869l.153-.155.111.024a.446.446,0,0,1,.151.161c.074.312-.045.654.141.95A.233.233,0,0,1,431.956,110Z",
    transform: "translate(-407.794 -85.518)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M430.4,109.215l-.344.869-.327,0a.416.416,0,0,1-.141-.213.489.489,0,0,1,.136-.477Z",
    transform: "translate(-406.75 -85.915)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M428.806,111.614c0,.059,0,.117.005.176-.018.344-.26.346-.507.338l.17-.333C428.532,111.636,428.619,111.531,428.806,111.614Z",
    transform: "translate(-405.834 -87.618)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M426.029,117.325l-.151-.162C425.975,117.172,426.032,117.219,426.029,117.325Z",
    transform: "translate(-404.082 -91.629)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M428.944,110.042l-.333.181c-.31-.275.108-.55,0-.824l.333.13Z",
    transform: "translate(-405.971 -86.046)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M428.271,106.262l.006-.49a.7.7,0,0,1,.632-.164.641.641,0,0,1,.436.3.263.263,0,0,1-.036.257C428.978,106.372,428.619,106.25,428.271,106.262Z",
    transform: "translate(-405.81 -83.31)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M431.9,105.411l-.021-.226c-.089-.26.141-.326.268-.456a.938.938,0,0,1,.431-.19.458.458,0,0,1,.336.1.343.343,0,0,1,.023.233c-.25.262-.191.8-.713.822H432.2C432.161,105.538,432.08,105.421,431.9,105.411Z",
    transform: "translate(-408.402 -82.552)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M428.762,101.6l-.69.01q0-.085,0-.17c-.373-.8.648-1,.681-1.639.226.086.173.5.507.442.206.112.477-.071.659.149a.24.24,0,0,1,.027.217c-.118.265-.558-.038-.605.353a.463.463,0,0,1-.018.3A1.131,1.131,0,0,1,428.762,101.6Z",
    transform: "translate(-405.604 -79.144)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M435.584,89.332a8.679,8.679,0,0,0,.5-3.755c.654.39.352,1,.241,1.478a1.331,1.331,0,0,0,.007,1.1c.256.441-.091.8-.247,1.176Z",
    transform: "translate(-411.091 -68.919)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M417.884,96.648h-.333a1.735,1.735,0,0,1-.638-.068.738.738,0,0,1-.186-.131c-.175-.212-.408-.41-.194-.729.522-.239,1.033-.367,1.474.161A.841.841,0,0,1,417.884,96.648Z",
    transform: "translate(-397.271 -76.064)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M421.618,96.481v-.853c0-.111.108-.116.167-.169a1.685,1.685,0,0,1,1.013-.174l.176.166c-.081.127-.259.06-.345.178l0,.171c-.192.179-.5.117-.673.342Z",
    transform: "translate(-401.006 -75.898)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M417.295,98.941c.235.023.5-.08.68.17-.185.19-.412.358-.343.68l-.511,0-.071-.1A.775.775,0,0,1,417.295,98.941Z",
    transform: "translate(-397.696 -78.527)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M425.26,96.059a.364.364,0,0,1,.345-.178h.327a1.421,1.421,0,0,1,.846.176.35.35,0,0,1-.339.171c-.331.209-.578-.012-.838-.167Z",
    transform: "translate(-403.636 -76.327)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M433.236,100.645c-.232-.038-.5.075-.679-.181.188-.186.357-.409.671-.342l.081.087a.432.432,0,0,1,0,.347Z",
    transform: "translate(-408.905 -79.368)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M422.833,97.469c.051-.462.407-.311.673-.342C423.379,97.437,423.12,97.481,422.833,97.469Z",
    transform: "translate(-401.883 -77.223)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M435.644,99.749q0,.077-.012.153a.324.324,0,0,1-.306.137c-.18-.017-.258-.163-.353-.287l0,0C435.2,99.439,435.42,99.662,435.644,99.749Z",
    transform: "translate(-410.647 -78.994)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M426.49,96.53l.838.167C426.977,97.007,426.709,96.9,426.49,96.53Z",
    transform: "translate(-404.524 -76.794)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M414.307,101.395c.185-.287-.063-.573,0-.86.418-.233.6.126.83.346l.008.007q-.006.255-.012.509Z",
    transform: "translate(-395.718 -79.619)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M393.664,100.387v-.345a.855.855,0,0,1,.154-.005.173.173,0,0,1,.246.03.537.537,0,0,1-.058.657l-.175.5C393.55,100.994,393.709,100.67,393.664,100.387Z",
    transform: "translate(-380.816 -79.289)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M415.14,99.295l-.83-.345q0-.167-.007-.334c-.022-.264.177-.3.357-.354a.814.814,0,0,1,.66.186h0Z",
    transform: "translate(-395.722 -78.034)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M413.41,97.376a.369.369,0,0,0-.346.169h-.13c-.169.125-.238-.006-.312-.124a.647.647,0,0,1,0-.414.388.388,0,0,1,.453-.235C413.326,96.891,413.6,97,413.41,97.376Z",
    transform: "translate(-394.484 -76.963)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M411.343,98.587l.187.154-.21.188a.482.482,0,0,1-.666-.02l-.013-.322A.468.468,0,0,1,411.343,98.587Z",
    transform: "translate(-393.08 -78.16)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M410.687,100.14l.666.02q0,.162.008.323l-.673,0Q410.687,100.313,410.687,100.14Z",
    transform: "translate(-393.112 -79.39)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M406.489,96.665a1.654,1.654,0,0,1,.987-.153.3.3,0,0,1,.076.3c-.075.188-.286.217-.405.353l-.66.008c-.131-.067-.262-.135-.241-.32A.3.3,0,0,1,406.489,96.665Z",
    transform: "translate(-389.904 -76.778)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M403.817,97.206l.2.314-1.025.013-.169-.35A.689.689,0,0,1,403.817,97.206Z",
    transform: "translate(-387.435 -77.121)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    d: "M409.5,97.653c0-.23.144-.313.346-.33a.488.488,0,0,1,.676-.013q0,.189,0,.379h-.7Z",
    transform: "translate(-392.252 -77.262)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M399.763,99.247v-.667a.378.378,0,0,1,.2-.146.461.461,0,0,1,.464.14q0,.337,0,.674Z",
    transform: "translate(-385.224 -78.153)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M400.588,96.622l-.494-.011a.324.324,0,0,1-.112-.307.947.947,0,0,1,.313-.586.458.458,0,0,1,.323.046.568.568,0,0,1,.169.139c.006.036.012.073.018.109l-.073.082C400.566,96.237,400.6,96.436,400.588,96.622Z",
    transform: "translate(-385.381 -76.201)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M403.72,96.738l-.992-.022-.038-.17.053.013a.865.865,0,0,1,1.157-.008l.022-.012Z",
    transform: "translate(-387.338 -76.653)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M394.908,100.462l0-.678a.444.444,0,0,1,.668,0C395.655,100.32,395.431,100.542,394.908,100.462Z",
    transform: "translate(-381.716 -79.026)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    d: "M395.08,98.507l-.668,0-.186-.009c0-.113,0-.226,0-.339.278-.113.6-.071.859-.267a.737.737,0,0,1,.237-.035c.159.041.331.07.271.308C395.417,98.273,395.342,98.53,395.08,98.507Z",
    transform: "translate(-381.224 -77.746)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M398.153,97.2a.4.4,0,0,0-.358-.19.407.407,0,0,1,.193-.492l.333,0a.388.388,0,0,1,.176.345c0,.111,0,.222,0,.334l-.173.016Z",
    transform: "translate(-383.788 -76.784)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M391.586,97.255c-.2.483-.523.359-.857.176l-.182-.01c-.353-.3-.778-.089-1.163-.166.132-.192.333-.151.52-.158A1.247,1.247,0,0,1,391.586,97.255Z",
    transform: "translate(-377.728 -77.021)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M392.906,96.569a4.8,4.8,0,0,0-1.683-.158l-.012-.334.01-.01a.608.608,0,0,1,.367-.162c.451-.019.9,0,1.352-.014a.319.319,0,0,1,.31.178l-.193.492A1.181,1.181,0,0,1,392.906,96.569Z",
    transform: "translate(-379.049 -76.335)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M483.243,140.984l.653.333a1.143,1.143,0,0,1,.043.139,1.241,1.241,0,0,1-.815.171l-.221-.224Z",
    transform: "translate(-445.26 -108.756)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M506.146,174.639l-.175-.685a.427.427,0,0,1,.5-.091,1.135,1.135,0,0,1,.509.632.638.638,0,0,1-.153.648C506.439,175.2,506.543,174.573,506.146,174.639Z",
    transform: "translate(-461.918 -132.366)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M509.05,176.631l0-.715a.273.273,0,0,1,.228,0,.667.667,0,0,1,.305.726c-.136.2-.337.149-.527.136A1.172,1.172,0,0,0,509.05,176.631Z",
    transform: "translate(-464.141 -133.853)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M518.878,172.227c-.005-.184.032-.383-.163-.5-.1-.272.093-.37.277-.472a1.464,1.464,0,0,1,.344-.074,1.7,1.7,0,0,0,.837-.21,1.931,1.931,0,0,1,.4-.206.75.75,0,0,1,.339-.029.679.679,0,0,1,.212.087c.2.185.416.346.6.547a.872.872,0,0,1,.176.693,2.16,2.16,0,0,1-1.629,1.63.326.326,0,0,1-.224-.054,1.1,1.1,0,0,1-.083-.8.265.265,0,0,1,.158-.14c.07-.1.255.221.272-.076-.226-.221-.429.011-.642.029a.711.711,0,0,1-.421-.107C519.17,172.445,518.981,172.4,518.878,172.227Z",
    transform: "translate(-471.101 -130.138)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M511.929,176.79l-.178-.027a.451.451,0,0,1-.055-.492.565.565,0,0,1,.457-.2.732.732,0,0,1,.369.086l.09.091Z",
    transform: "translate(-466.016 -133.981)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M517.977,172.329l-.329.344-.338.172a.342.342,0,0,1-.1-.232.59.59,0,0,1,.452-.568C517.836,172.062,518.025,172.061,517.977,172.329Z",
    transform: "translate(-470.034 -131.088)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M515.676,173.943q0,.086,0,.173c0,.057,0,.114-.005.171a.61.61,0,0,1-.479.125.317.317,0,0,1-.241-.272.449.449,0,0,1,.242-.294A.427.427,0,0,1,515.676,173.943Z",
    transform: "translate(-468.404 -132.359)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M515.236,175.5l.485,0c-.124.32-.386.356-.675.337h0C514.954,175.637,515.1,175.575,515.236,175.5Z",
    transform: "translate(-468.451 -133.572)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M518.9,176.074c.189.026.4-.018.528.186l-.086.081a.516.516,0,0,1-.453.011.227.227,0,0,1-.171-.138Z",
    transform: "translate(-471.121 -133.985)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    d: "M518.48,176.572l.177.045.068.081-.06.087-.169.008C518.355,176.729,518.359,176.655,518.48,176.572Z",
    transform: "translate(-470.885 -134.343)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M518.318,176.712l.3.162a.41.41,0,0,1,.148.184c.091.275-.124.626.206.841h0c-.2.441-.529.242-.832.166l-.354-.009c-.078-.311-.452-.255-.6-.485.1-.332.624-.274.611-.692l-.016-.034c.152-.115.382.057.51-.143Z",
    transform: "translate(-470.014 -134.437)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M510.328,175.575c-.012.168-.025.336-.037.5l-.291.006-.375-.685C509.99,174.922,510.2,175.094,510.328,175.575Z",
    transform: "translate(-464.556 -133.297)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M520.63,177.091c.281-.036.6.116.832-.166a2.441,2.441,0,0,0,1.689-1.541.238.238,0,0,1,.294.039.349.349,0,0,1,.095.189c-.03.19-.2.291-.277.451a1.67,1.67,0,0,1-1.053,1.183c-.133.1-.268.158-.41.016C521.427,177.089,520.973,177.477,520.63,177.091Z",
    transform: "translate(-472.503 -133.463)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M524.843,181.5a.35.35,0,0,0,.339-.156c.307-.089.63-.029.939-.105a.536.536,0,0,1,.279.323.455.455,0,0,1,.024.216l-.06.091a4.967,4.967,0,0,1-1.511-.168C524.85,181.632,524.846,181.565,524.843,181.5Z",
    transform: "translate(-475.545 -137.697)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    d: "M548.1,200.739l-.337-.177a.229.229,0,0,1,.019-.346l.307-.317a1.032,1.032,0,0,1,.633-.528,3.23,3.23,0,0,1,.587-.169.7.7,0,0,1,.477.1.776.776,0,0,1,.189.314c.049.265.331.474.186.787a.569.569,0,0,1-.309.163,1.447,1.447,0,0,0-.549.172,1.4,1.4,0,0,1-.337.154A.921.921,0,0,1,548.1,200.739Z",
    transform: "translate(-492.048 -150.609)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    "data-name": "Path 1567",
    d: "M549.731,198.6l-.667.366-.022-.2c.008-.109.017-.218.026-.327.08-.248.189-.465.483-.5l.035-.045.474,0C550.227,198.264,549.89,198.387,549.731,198.6Z",
    transform: "translate(-493.02 -149.673)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    d: "M547.075,202.368q-.01.173-.019.347l-.025-.017c-.1.1-.161.024-.219-.055a.439.439,0,0,0-.092-.265q0-.094-.007-.189A.378.378,0,0,1,547.075,202.368Z",
    transform: "translate(-491.338 -152.761)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    d: "M547.033,186.553c-.219.191-.129.816-.7.511-.215-.3-.079-.58.047-.861.131-.227.24-.477.529-.547.268.085.287.308.292.539A.685.685,0,0,1,547.033,186.553Z",
    transform: "translate(-490.981 -140.874)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1570",
    "data-name": "Path 1570",
    d: "M543.174,188.861a.642.642,0,0,0-.159-.031c-.209-.108-.364-.237-.175-.491h.015c.139-.13.171-.355.372-.431a.377.377,0,0,1,.338.066.908.908,0,0,1,.117.7l-.173.327Z",
    transform: "translate(-488.479 -142.484)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    d: "M549.148,187.052v-.34c.222-.157.371-.484.731-.317a.732.732,0,0,1,.133.368.787.787,0,0,1-.2.63c-.045.208-.12.436-.3.108C549.414,187.32,549.443,187.064,549.148,187.052Z",
    transform: "translate(-493.096 -141.372)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    d: "M545.628,188.2a1.133,1.133,0,0,1-.168-.68c-.05-.248.121-.266.29-.285a.382.382,0,0,1,.213.117q-.093.424-.186.848h-.149Z",
    transform: "translate(-490.426 -142.009)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    d: "M552.415,193.723l-.349,0c.021-.282-.158-.607.175-.82a.272.272,0,0,1,.35-.025A.793.793,0,0,1,552.415,193.723Z",
    transform: "translate(-495.182 -146.032)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M549.806,195.007l-.67.005c.015-.157-.051-.4.155-.42A.436.436,0,0,1,549.806,195.007Z",
    transform: "translate(-493.088 -147.296)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    d: "M553.11,191.484h-.336q0-.246.006-.493a.362.362,0,0,1,.33-.139.443.443,0,0,1,.218.12A.354.354,0,0,1,553.11,191.484Z",
    transform: "translate(-495.714 -144.609)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M552.9,189.355l-.314.022q0-.181-.008-.362a.278.278,0,0,1,0-.378c.308-.1.43.065.479.339A.487.487,0,0,1,552.9,189.355Z",
    transform: "translate(-495.522 -142.996)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    d: "M551.895,187.78l0,.339-.337,0v-.687a.287.287,0,0,1,.361-.018A.29.29,0,0,1,551.895,187.78Z",
    transform: "translate(-494.834 -142.1)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M553.539,189.529l.177-.506c-.014-.319.224-.477.414-.668.149-.106.26-.345.5-.148a.849.849,0,0,1,.047.7c-.151.282-.423.517-.344.891a.919.919,0,0,1-.449.659.37.37,0,0,1-.344-.032l-.159-.078A1.306,1.306,0,0,1,553.539,189.529Z",
    transform: "translate(-496.144 -142.654)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M553.652,197.407l-.5,0a.643.643,0,0,1,.01-.654l.169-.182c.237-.2.382-.04.522.139A.634.634,0,0,1,553.652,197.407Z",
    transform: "translate(-495.923 -148.653)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M552.042,197.448c0,.218.156.439-.01.654l-.513.174c-.018-.295.271-.441.33-.7Z",
    transform: "translate(-494.808 -149.353)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M554.479,196.382c-.163-.077-.287-.248-.5-.214q-.009-.072-.011-.144l.345-.06a.145.145,0,0,1,.177-.024.337.337,0,0,1,.091.277A.3.3,0,0,1,554.479,196.382Z",
    transform: "translate(-496.578 -148.255)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M549.619,198.017l-.483.5q0-.258,0-.515Z",
    transform: "translate(-493.088 -149.751)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M546.45,203.336l.154.158-.172.2-.311-.024.14-.339h.026A.106.106,0,0,1,546.45,203.336Z",
    transform: "translate(-490.911 -153.557)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M546.874,203.024q-.081,0-.162,0a.6.6,0,0,1,.005-.158Z",
    transform: "translate(-491.335 -153.245)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M529.8,177.172l-.2-.325a1.162,1.162,0,0,0,.537-1.141.939.939,0,0,0-.17-.4l-.006-.015c-.009-.34.238-.3.45-.309a.59.59,0,0,1,.332.189,1.09,1.09,0,0,1,.19.333c.082.28.1.575.176.857a.489.489,0,0,1-.137.465l-.328.695-.849,0c0-.049,0-.1,0-.148v-.034C529.907,177.279,529.952,177.225,529.8,177.172Z",
    transform: "translate(-478.979 -133.198)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M537.381,174.288l-.16,0-.511-.174c-.178-.226.08-.453,0-.68a1.522,1.522,0,0,1,.416-1.651,1.4,1.4,0,0,0,.5-1.487.368.368,0,0,1,.18-.5c.183-.072.315.023.346.23a.827.827,0,0,1,.418-.155c.4.157.921-.131,1.251.322-.2.615-.112,1.289-.335,1.891a2.682,2.682,0,0,1-.994,1.235c-.253.2-.662.015-.857.359-.014.072-.03.142-.046.213A.59.59,0,0,1,537.381,174.288Z",
    transform: "translate(-484.037 -129.46)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M535.964,175.886a3.2,3.2,0,0,0-.508,1.539l-.493.172q0-.173-.008-.347a.479.479,0,0,0,.07-.3,2.659,2.659,0,0,0-.139-.627c-.006-.037-.01-.073-.016-.109a.36.36,0,0,1,.071-.2.451.451,0,0,1,.2-.061c.355.005.164-.287.231-.439.159-.316.363-.173.566-.059C536.085,175.592,535.988,175.741,535.964,175.886Z",
    transform: "translate(-482.786 -133.447)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M534.694,179.373l-.166.175-.176-.179q0-.245,0-.49c-.1-.194-.152-.364.167-.357l.01.011A3.219,3.219,0,0,1,534.694,179.373Z",
    transform: "translate(-482.359 -135.744)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M541.592,183.707c-.261.024-.327-.24-.5-.347-.122-.2-.031-.389.043-.578a.751.751,0,0,1,.475-.346.389.389,0,0,1,.344.009c.21.177.43.35.4.675a.711.711,0,0,1-.3.325A1.034,1.034,0,0,1,541.592,183.707Z",
    transform: "translate(-487.237 -138.534)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M543.043,186.165a.6.6,0,0,1,.338-.345.41.41,0,0,1,.138.212.5.5,0,0,1-.136.475.307.307,0,0,1-.321.34Q543.053,186.507,543.043,186.165Z",
    transform: "translate(-488.688 -140.992)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M539.4,184.439q0-.256,0-.511c.556-.13.455.19.345.516,0,.057-.009.115-.013.173A.369.369,0,0,1,539.4,184.439Z",
    transform: "translate(-486.059 -139.61)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M539.762,183.779c-.016-.239.006-.505-.344-.516,0-.066.008-.131.013-.2a.414.414,0,0,1,.584.068.754.754,0,0,1-.088.637Q539.844,183.775,539.762,183.779Z",
    transform: "translate(-486.069 -138.946)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M542.135,189.475l.175.491-.51.024c-.006-.056-.013-.112-.021-.167A.6.6,0,0,1,542.135,189.475Z",
    transform: "translate(-487.775 -143.62)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M566.732,222.005a.353.353,0,0,1,.169-.34l.5.17A9.484,9.484,0,0,1,569.991,223a.411.411,0,0,1,.008.36,1.032,1.032,0,0,1-1.018-.019,3.894,3.894,0,0,0-1.067-.309c-.018-.412-.373-.311-.6-.394A1.014,1.014,0,0,1,566.732,222.005Z",
    transform: "translate(-505.794 -166.764)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M571.689,222.842a9.575,9.575,0,0,1-2.532-1.2l.17-.173a.235.235,0,0,1,.338,0c.549.589,1.369.523,2.025.854A.361.361,0,0,1,571.689,222.842Z",
    transform: "translate(-507.545 -166.575)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M572.23,218.349a1.259,1.259,0,0,0-1.351,0,.346.346,0,0,1-.507,0l.34-.341.334-.17c.242-.1.536,0,.752-.2a.753.753,0,0,1,.218-.094.6.6,0,0,1,.47.1c.2.221.487.413.229.771A.39.39,0,0,1,572.23,218.349Z",
    transform: "translate(-508.422 -163.791)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M569.937,220.444h.507c.072.07.218.173.2.2-.115.262-.36.081-.542.137l-.338,0A.355.355,0,0,1,569.937,220.444Z",
    transform: "translate(-507.987 -165.886)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M571.587,216.511l.506-.01c.381-.2.642-.153.675.346h0a.469.469,0,0,1-.671,0Z",
    transform: "translate(-509.299 -162.973)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M572.974,218l.671,0c-.171.618-.534.264-.846.172Z",
    transform: "translate(-510.175 -164.132)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M574.082,215.222c-.126-.314-.39-.351-.675-.346q0-.167,0-.334l.076-.084c.19-.118.43-.107.614-.241a.675.675,0,0,1,.2-.085,1.542,1.542,0,0,1,.549.108.685.685,0,0,1,.2.127.591.591,0,0,1,.148.57c-.133.247-.309.4-.61.287Z",
    transform: "translate(-510.614 -161.348)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M571,214.274l0-.338.08-.084a.722.722,0,0,1,.334-.087.626.626,0,0,1,.437.134c.093.2-.059.281-.177.379h0Z",
    transform: "translate(-508.871 -161.084)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M568.556,213.118v-.342c.361-.157.737-.346.675.345l0,0-.347.006Z",
    transform: "translate(-507.111 -160.266)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M570.9,226.352c.742-.3,1.3.5,2.025.341a.108.108,0,0,1,.038.112c-.012.038-.024.056-.036.056a4.54,4.54,0,0,1-2.024-.371c-.016,0-.036-.042-.035-.064A.206.206,0,0,1,570.9,226.352Z",
    transform: "translate(-508.781 -170.086)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M578.271,225.724c0-.056,0-.112,0-.168v-.341q0-.256,0-.511l.335,0q0,.51.006,1.02l-.168.163Z",
    transform: "translate(-514.124 -168.948)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M565.909,231.694l-.167.007c-.251-.071-.491-.092-.665.16l-.185-.329c.3-.313.677-.118,1.017-.173Q565.91,231.527,565.909,231.694Z",
    transform: "translate(-504.466 -173.727)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M562.536,232.332l-.671,0c-.064-.7.578.031.674-.342Z",
    transform: "translate(-502.276 -174.19)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M501.989,168.276a.708.708,0,0,1-.043-.83.233.233,0,0,1,.191-.078.592.592,0,0,1,.191.1.862.862,0,0,1,.306.778.584.584,0,0,1-.075.193.281.281,0,0,1-.176.085.656.656,0,0,1-.271-.105l-.076-.06Z",
    transform: "translate(-458.929 -127.725)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M501.282,165.893l-.193.013c-.19-.142-.479-.2-.441-.536a.525.525,0,0,1,.362-.144.471.471,0,0,1,.351.172A.391.391,0,0,1,501.282,165.893Z",
    transform: "translate(-458.072 -126.185)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M500.914,164.02l-.32-.006a.918.918,0,0,1,.136-.674l.186.166A.391.391,0,0,1,500.914,164.02Z",
    transform: "translate(-458.017 -124.829)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M501.761,171.111q-.006-.084-.008-.169a.372.372,0,0,1,.179-.34l-.009.007c.072.067.166.112.209.209a.329.329,0,0,1-.036.2C502,171.109,501.915,171.233,501.761,171.111Z",
    transform: "translate(-458.872 -130.051)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    d: "M505.061,171.389l-.533.006-.067,0H504.4c-.218-.166-.279-.433-.414-.654a.2.2,0,0,1,.049-.2l.04-.005a.345.345,0,0,1,.311-.267.9.9,0,0,1,.212.027c.247.074.6-.16.736.245a.523.523,0,0,1-.035.322.3.3,0,0,0-.043.374C505.244,171.353,505.2,171.428,505.061,171.389Z",
    transform: "translate(-460.474 -129.808)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    d: "M503.163,171.791c.464.058.277.444.345.7a.953.953,0,0,1-.708-.369.115.115,0,0,1-.056-.1c0-.04.005-.06.015-.06a.531.531,0,0,1,.143-.111A.875.875,0,0,1,503.163,171.791Z",
    transform: "translate(-459.587 -130.906)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    d: "M502.131,172.036a.924.924,0,0,1-.026.136,1.448,1.448,0,0,1-.159.027l-.164-.186.309-.156.081.033A.107.107,0,0,1,502.131,172.036Z",
    transform: "translate(-458.892 -130.953)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    d: "M502.687,164.955l.007-.51a.385.385,0,0,1,0-.523l.344,0,.17.343a.186.186,0,0,1,.06.19,1.966,1.966,0,0,1-.365.53.131.131,0,0,1-.181-.041Z",
    transform: "translate(-459.477 -125.248)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    d: "M502.129,163.717q0,.261,0,.523l-.32-.006q0-.258,0-.515C501.918,163.708,502.022,163.54,502.129,163.717Z",
    transform: "translate(-458.914 -125.043)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    d: "M502.955,157.127l.007-.468h0c.51.372,1.2-.139,1.685.346a.846.846,0,0,1-1.012-.008A1.192,1.192,0,0,0,502.955,157.127Z",
    transform: "translate(-459.74 -120.026)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M505.4,157.863l1.012.008-.01.309a.2.2,0,0,1-.325.025c-.16-.12-.352.19-.5-.037Z",
    transform: "translate(-461.508 -120.892)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M499.949,156.678a.773.773,0,0,1,.663.361l-.668-.2C499.944,156.784,499.946,156.731,499.949,156.678Z",
    transform: "translate(-457.565 -120.04)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    d: "M511.044,152.4c-.393-.516-.945.252-1.351-.171a.825.825,0,0,1-.177-.54,1.373,1.373,0,0,1,.107-.995.842.842,0,0,1,.8-.164,1.143,1.143,0,0,1,.46.237c.225.378.637.572.893.923.106.509-.248.637-.613.753Z",
    transform: "translate(-464.447 -115.602)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    d: "M510.265,161.406c.016-.271-.083-.606.28-.715a2.36,2.36,0,0,1,1.309.21c.24.065.043.425-.073.638a.687.687,0,0,1-.043.291,2.1,2.1,0,0,1-.179.365.372.372,0,0,1-.163.129.393.393,0,0,1-.208-.037,1.52,1.52,0,0,1-.43-.483C510.654,161.6,510.4,161.57,510.265,161.406Z",
    transform: "translate(-465.018 -122.895)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    d: "M516.893,158.88c-.088-.133-.349-.186-.135-.443.255-.307.116-.549-.2-.717a.561.561,0,0,1-.147-.361c.135-.5.371-.551.648-.117.2.3.369.624.575.923a.709.709,0,0,1,.056.511.669.669,0,0,1-.563.469A.287.287,0,0,1,516.893,158.88Z",
    transform: "translate(-469.456 -120.234)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    d: "M504.986,149.992c-.05-.353-.757-.6-.161-1.057a.553.553,0,0,1,.635-.056.458.458,0,0,1,.154.45c-.321.216.061.455-.019.68a.326.326,0,0,1-.236.228C505.164,150.265,505.079,150.122,504.986,149.992Z",
    transform: "translate(-460.918 -114.379)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    d: "M506.688,168.18c-.134-.438-.605.53-.677-.167a.483.483,0,0,1,.145-.4,1.073,1.073,0,0,1,.277-.135c.178-.049.231-.208.3-.354a.326.326,0,0,1,.142-.136l.32,0a.621.621,0,0,1,.084.881C507.125,168.052,506.994,168.287,506.688,168.18Z",
    transform: "translate(-461.945 -127.451)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    d: "M507.074,151.394c.3-.173-.787-.338,0-.513a.388.388,0,0,1,.447-.082c.2.342.015.767.229,1.107q0,.257,0,.513c-.343-.015-.34-.263-.338-.511C507.189,151.81,507.153,151.587,507.074,151.394Z",
    transform: "translate(-462.503 -115.786)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    d: "M510.264,167.186a1.588,1.588,0,0,0,0-.852l.331-.172a.3.3,0,0,1,.353-.044.483.483,0,0,1,.1.475,1.65,1.65,0,0,1-.366.479.542.542,0,0,1-.311.157Z",
    transform: "translate(-465.018 -126.8)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    d: "M506.084,147.928l-.655-.063c0-.052,0-.1,0-.155s.006-.086.008-.129a1.1,1.1,0,0,1,1.259-.134c.235.193.085.346-.051.5A.5.5,0,0,1,506.084,147.928Z",
    transform: "translate(-461.523 -113.308)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    d: "M506.648,166.087c-.008.056-.015.112-.021.169a.686.686,0,0,1-.36.178.668.668,0,0,1-.514-.146.389.389,0,0,1-.007-.4.644.644,0,0,1,.515-.155.612.612,0,0,1,.358.191A.453.453,0,0,0,506.648,166.087Z",
    transform: "translate(-461.718 -126.55)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    d: "M511.366,164.79l-.342,0-.17-.513a.363.363,0,0,1,.511,0l.339.514A.231.231,0,0,1,511.366,164.79Z",
    transform: "translate(-465.444 -125.425)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    d: "M505.624,165l-.5.035c-.2.092-.351.1-.35-.189l.008-.171.339-.169c.28-.093.378.151.53.294A.171.171,0,0,1,505.624,165Z",
    transform: "translate(-461.053 -125.65)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    d: "M507.481,164.177c0-.053,0-.107,0-.16a.487.487,0,0,1,.012-.676c.543.123.259.56.322.866Z",
    transform: "translate(-462.91 -124.83)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    "data-name": "Path 1631",
    d: "M506.531,163.18q-.006.338-.012.676c-.263.035-.323-.237-.5-.335l.169-.343c.054-.081.11-.079.169,0Z",
    transform: "translate(-461.954 -124.669)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    d: "M511.872,157.419c-.4-.055-.775.317-1.251.083a3.494,3.494,0,0,1,1.252-.254h0l.057.085Z",
    transform: "translate(-465.275 -120.445)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    d: "M505.234,153.031l.336.165a.23.23,0,0,1,0,.342l-.638.23Z",
    transform: "translate(-461.167 -117.418)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    d: "M501.788,155.579c-.155-.1-.372-.121-.458-.383.24.082.478-.18.667.076.024.032-.135.2-.209.307Z",
    transform: "translate(-458.566 -118.945)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M510.942,163.677l-.511,0a.348.348,0,0,1-.163-.339C510.531,163.373,510.884,163.224,510.942,163.677Z",
    transform: "translate(-465.021 -124.83)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M507.226,153.523v-.342l.168-.171.337.513Z",
    transform: "translate(-462.824 -117.402)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M515.627,157.823q0,.17,0,.341c-.33-.007-.384-.293-.5-.512C515.375,157.453,515.5,157.634,515.627,157.823Z",
    transform: "translate(-468.526 -120.678)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M507.837,159.016l.325-.025c-.029.166.105.448-.185.438C507.8,159.423,507.856,159.169,507.837,159.016Z",
    transform: "translate(-463.265 -121.703)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M506.8,162.089l-.169,0c.018-.187-.054-.418.219-.482.047-.011.1.02.157.032Z",
    transform: "translate(-462.393 -123.586)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M515.973,163.817l.2.172a.444.444,0,0,1-.22.184.786.786,0,0,1-.821-.146l.165-.213Z",
    transform: "translate(-468.536 -125.17)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M500.23,145.44l-.349-.174a1.55,1.55,0,0,1-.8.214.9.9,0,0,1-.528-.148.321.321,0,0,1-.051-.373c.209-.1.548-.031.527-.424a.994.994,0,0,1,.58-.164c.43.009.868.009.844.636a.567.567,0,0,1,0,.216C500.411,145.325,500.3,145.36,500.23,145.44Z",
    transform: "translate(-456.499 -111.19)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M504.813,146.786l.168-.178a2.57,2.57,0,0,1,1.748-.327.468.468,0,0,1-.022.512.324.324,0,0,1-.383.021l-1.333-.005Z",
    transform: "translate(-461.081 -112.536)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M499.527,147.547l.836,0a1.938,1.938,0,0,1-1.171.689.253.253,0,0,1-.056-.2A1.3,1.3,0,0,1,499.527,147.547Z",
    transform: "translate(-456.98 -113.475)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M498.24,148.346l0,.188-.176.164-.171-.182a.336.336,0,0,1,.029-.455.36.36,0,0,1,.219-.1C498.342,148.041,498.361,148.175,498.24,148.346Z",
    transform: "translate(-456.026 -113.77)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M496.936,146.118l.008.341c.054.04.072.079.053.117s-.038.057-.057.057v-.008c-.162.08-.283.278-.507.178l-.185-.01.187-.5c.1-.147.194-.314.42-.243Z",
    transform: "translate(-454.897 -112.384)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    d: "M496.913,148.323l.507-.178-.18.506C497.016,148.659,496.917,148.539,496.913,148.323Z",
    transform: "translate(-455.377 -113.905)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    d: "M491.994,131.471l.357.015c.154.1.362.042.509.167.2.168.585-.046.674.341a.8.8,0,0,1-.563.214c-.06.176-.551-.325-.364.243-.124.539-.51.595-.958.534a1.741,1.741,0,0,1-.779-1.224c-.013-.036-.024-.073-.036-.109q0-.256,0-.513l.5.151C491.526,131.456,491.825,131.219,491.994,131.471Z",
    transform: "translate(-450.988 -101.679)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    d: "M487.367,133.794a.378.378,0,0,1-.185-.352c.016-.823.644-.407,1.015-.513h0c.2.285.226.544-.1.754-.191.026-.4-.042-.573.108h-.078Z",
    transform: "translate(-448.35 -102.955)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M486.659,128.709a.514.514,0,0,1,.338.512c-.078.023-.176.024-.231.073-.233.208-.517.473-.72.062-.221-.448.242-.432.495-.537C486.588,128.8,486.62,128.747,486.659,128.709Z",
    transform: "translate(-447.488 -99.93)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    d: "M484.343,126.356l.166.342-.668.01a.531.531,0,0,1-.243.113.342.342,0,0,1-.34-.187.324.324,0,0,1,.135-.376A.816.816,0,0,1,484.343,126.356Z",
    transform: "translate(-445.507 -98.092)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    d: "M483.789,128.109l.174.006a2.688,2.688,0,0,1-.344,1.19l-.162-.178A.957.957,0,0,1,483.789,128.109Z",
    transform: "translate(-445.629 -99.499)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M479.644,125.494l-.177.006-.084-.083a.774.774,0,0,1-.086-.348.892.892,0,0,1,.068-.365.393.393,0,0,1,.181-.174.634.634,0,0,1,.616.064.5.5,0,0,1,.085.489C480.134,125.351,479.876,125.4,479.644,125.494Z",
    transform: "translate(-442.656 -96.889)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M480.545,127.24a.472.472,0,0,1,.488-.332.69.69,0,0,1,.255.757l-.086.087A1.66,1.66,0,0,1,480.545,127.24Z",
    transform: "translate(-443.557 -98.636)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M483.15,128.09l-.331,1.019c-.45-.028-.259-.292-.183-.513l0,0c.178-.13,0-.388.183-.517Z",
    transform: "translate(-444.99 -99.48)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M477.477,128.059l-.006-.34.092-.089a.482.482,0,0,1,.585.09h0C478.137,128.268,477.784,128.116,477.477,128.059Z",
    transform: "translate(-441.337 -99.112)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M489.532,138.991a1.565,1.565,0,0,0-.16.037l-.335-.388c0-.048,0-.1,0-.143.376-.488.6-.1.841.153Z",
    transform: "translate(-449.687 -106.8)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M489.415,134.841c-.311.119-.487-.516-.841-.153-.24-.187-.16-.456-.177-.7.131-.095.173-.281.341-.339.452-.056.3-.415.336-.682l.364.151c-.187.437.259.68.311,1.044a.308.308,0,0,1,.085.319c-.071.209-.257.279-.43.366Z",
    transform: "translate(-449.227 -102.992)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M488.739,134.716a.308.308,0,0,1-.34.339q0-.08,0-.159c.018-.153-.055-.362.125-.43S488.7,134.6,488.739,134.716Z",
    transform: "translate(-449.229 -104.059)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M475.239,126.762l-.343-.178c-.187-.444.174-.472.43-.581a.5.5,0,0,1,.247.028.45.45,0,0,1,.123.216.414.414,0,0,1-.122.343v0A.34.34,0,0,0,475.239,126.762Z",
    transform: "translate(-439.441 -97.982)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M474.517,125.439c-.115.228-.538.135-.515.506l-.322,0c.059-.225-.181-.445-.013-.672a.5.5,0,0,1,.342-.159A.49.49,0,0,1,474.517,125.439Z",
    transform: "translate(-438.547 -97.342)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M556.875,209.455c-.242,0-.489-.005-.513.337a.358.358,0,0,1-.162-.335.3.3,0,0,1-.04-.36.492.492,0,0,1,.227-.126.559.559,0,0,1,.494.125A.27.27,0,0,1,556.875,209.455Z",
    transform: "translate(-498.129 -157.629)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M551.532,208.342q-.005-.083-.013-.167c.036-.453.347-.216.559-.23a.928.928,0,0,1,.464.188.23.23,0,0,1,.016.241.271.271,0,0,1-.346-.01Z",
    transform: "translate(-494.808 -156.864)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M554.014,209.34l.326-.018a.234.234,0,0,1,.341.013v.334C554.425,209.628,554.065,209.805,554.014,209.34Z",
    transform: "translate(-496.61 -157.841)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M549.1,204.509l1.025-.07a.362.362,0,0,1,.065.337.394.394,0,0,1-.149.17,6.457,6.457,0,0,1-.621.219l-.328.013q-.007-.17-.013-.341C549.09,204.728,549.1,204.619,549.1,204.509Z",
    transform: "translate(-493.049 -154.379)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M550.313,206.25c.036-.352.29-.3.525-.293.155.2.4.087.586.16.618.5-.122.455-.258.653-.173-.035-.347-.261-.518,0l-.185,0Z",
    transform: "translate(-493.938 -155.464)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M568.764,210.86c-.054-.458-.409-.312-.675-.345,0-.056,0-.113,0-.169a.618.618,0,0,1-.179-.452.724.724,0,0,1,.091-.35c.534-.251.69.338,1.047.483a.67.67,0,0,1,.147.178.746.746,0,0,1,.06.341.484.484,0,0,1-.151.3Z",
    transform: "translate(-506.644 -158.006)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M565.91,210.126q0,.255,0,.511c-.382-.217-.692.007-1.011.169v-.336a.632.632,0,0,1,.112-.468A.7.7,0,0,1,565.91,210.126Z",
    transform: "translate(-504.465 -158.296)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M563.756,210.293a.354.354,0,0,1-.165.344l-.508-.005.166-.337.172-.173A.357.357,0,0,1,563.756,210.293Z",
    transform: "translate(-503.159 -158.464)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    d: "M564.635,207.642a.351.351,0,0,1-.334-.171c0-.048,0-.1,0-.143.089-.2.3-.313.35-.536a.62.62,0,0,1,.232-.276.726.726,0,0,1,.755.047.59.59,0,0,1-.153.748l0,.331C565.2,207.72,564.918,207.493,564.635,207.642Z",
    transform: "translate(-504.038 -155.813)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    d: "M562.455,207.946c.031.373-.257.329-.477.374l-.847-.026-.052-.1a.329.329,0,0,1,.094-.2c.261-.192.585-.06.863-.172A.443.443,0,0,1,562.455,207.946Z",
    transform: "translate(-501.712 -156.805)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1671",
    "data-name": "Path 1671",
    d: "M558.842,209.471l0-.34.091-.089a.482.482,0,0,1,.584.087l0,0C559.46,209.592,559.105,209.438,558.842,209.471Z",
    transform: "translate(-500.096 -157.645)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1672",
    "data-name": "Path 1672",
    d: "M497,139.662c.155-.374-.327-.645-.16-1.021a.436.436,0,0,1,.321-.161.546.546,0,0,1,.338.1c.136.212.072.532.351.669a.414.414,0,0,1,.086.21.324.324,0,0,1-.095.2Z",
    transform: "translate(-455.298 -106.956)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1673",
    "data-name": "Path 1673",
    d: "M499.043,144.676c.071.481-.229.4-.51.343h0a.229.229,0,0,1,0-.339l.5-.176a.1.1,0,0,1,.045.115C499.071,144.657,499.057,144.676,499.043,144.676Z",
    transform: "translate(-456.494 -111.286)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1674",
    "data-name": "Path 1674",
    d: "M500.549,143.838c0-.058,0-.115,0-.173s0-.112,0-.167a.551.551,0,0,1,.349-.16.518.518,0,0,1,.36.135.3.3,0,0,1-.039.363Z",
    transform: "translate(-458 -110.448)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1675",
    "data-name": "Path 1675",
    d: "M500.877,142.289l-.334.005q0-.172-.007-.345c0-.058.007-.116.011-.173a.378.378,0,0,1,.475-.051C501.2,141.972,501.015,142.124,500.877,142.289Z",
    transform: "translate(-457.993 -109.244)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1676",
    "data-name": "Path 1676",
    d: "M497.411,145.118q0,.169,0,.339l-.5.174q0-.089-.006-.178,0-.17,0-.339Z",
    transform: "translate(-455.367 -111.725)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1677",
    "data-name": "Path 1677",
    d: "M494.609,136l-.327.006-.367.005a.518.518,0,0,1-.652-.21v-.311c.41-.022.872.059,1.014-.51a.476.476,0,0,1,.365-.164.8.8,0,0,1,.646.162q0,.256,0,.511a.151.151,0,0,1,.05.131c-.008.048-.017.072-.028.072C495.122,135.9,494.784,135.755,494.609,136Z",
    transform: "translate(-452.741 -104.316)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1678",
    "data-name": "Path 1678",
    d: "M492.367,138.325a1.121,1.121,0,0,1,.652.21c.073.279-.084.351-.314.358l-.683-.194A.577.577,0,0,1,492.367,138.325Z",
    transform: "translate(-451.845 -106.844)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1679",
    "data-name": "Path 1679",
    d: "M470.179,121.7c-.013-.4-.041-.755.569-.54.44.155,1,0,1.286.527a.477.477,0,0,1-.244.453.777.777,0,0,1-.764-.1A1.661,1.661,0,0,0,470.179,121.7Z",
    transform: "translate(-436.069 -94.454)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1680",
    "data-name": "Path 1680",
    d: "M473.238,124.456l.843,0,.024.111c-.06.176-.268.112-.363.23l-.341,0Z",
    transform: "translate(-438.281 -96.871)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1681",
    "data-name": "Path 1681",
    d: "M433.757,66.743a2.824,2.824,0,0,0,2.363.171v.173C435.066,67.627,434.3,67.515,433.757,66.743Z",
    transform: "translate(-409.771 -55.378)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1682",
    "data-name": "Path 1682",
    d: "M428.689,66.742l-.34.512c-.226-.062-.451.311-.677,0A1.909,1.909,0,0,1,428.689,66.742Z",
    transform: "translate(-405.377 -55.377)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1683",
    "data-name": "Path 1683",
    d: "M420.394,70.518c.473-.35,1.017-.086,1.52-.18l.168.177Z",
    transform: "translate(-400.122 -57.957)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1684",
    "data-name": "Path 1684",
    d: "M444.678,67.324c.173.043.383-.1.515.088.02.029-.112.164-.174.251A.593.593,0,0,1,444.678,67.324Z",
    transform: "translate(-417.657 -55.786)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1685",
    "data-name": "Path 1685",
    d: "M559.875,195.424c.472-.08.31-.459.334-.742.031-.354-.1-.759.34-.965l.085.08a2.2,2.2,0,0,1,.245,1.035c.258-.132.4-.445.7-.543a.365.365,0,0,1,.322.112,1.44,1.44,0,0,1-.675,1.023,1.57,1.57,0,0,1-.307,1.069.57.57,0,0,1-.48.08,6.273,6.273,0,0,0-1.006-.366c-.267-.416.092-.559.324-.758Z",
    transform: "translate(-500.454 -146.67)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1686",
    "data-name": "Path 1686",
    d: "M564.7,200.6a1.324,1.324,0,0,1,.341-1.033,1.4,1.4,0,0,1,.845.169c.121-.183.255-.336.5-.218a1.176,1.176,0,0,1-.146,1.134.77.77,0,0,1-.333.126,1.715,1.715,0,0,0-.892.225.375.375,0,0,1-.35-.054A.284.284,0,0,1,564.7,200.6Z",
    transform: "translate(-504.273 -150.808)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1687",
    "data-name": "Path 1687",
    d: "M556.938,194.9c.569-.085.739.2.661.723-.032.214-.13.429.006.641h0a.637.637,0,0,1-.568.128,2.761,2.761,0,0,1-.783-.68c-.015-.035-.03-.071-.044-.106a.318.318,0,0,1,.009-.219,3.24,3.24,0,0,1,.72-.487Z",
    transform: "translate(-498.184 -147.51)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1688",
    "data-name": "Path 1688",
    d: "M565.821,192.775h-.337a1.794,1.794,0,0,1-.623-.631c-.042-.155-.238-.359.116-.393.354-.37.975.423,1.249-.294.1.09.38.045.258.287-.058.115.18.4-.2.357C565.76,192.041,565.826,192.444,565.821,192.775Z",
    transform: "translate(-504.376 -145.044)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    d: "M560.838,182.855c-.171.225-.007.452,0,.677a.341.341,0,0,1-.337.171l-.336.173c-.284-.157-.257-.492-.407-.727a.551.551,0,0,1,.15-.532.662.662,0,0,1,.418-.212.756.756,0,0,1,.54.234A.177.177,0,0,1,560.838,182.855Z",
    transform: "translate(-500.74 -138.537)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    d: "M574.184,193.7l.16.531c-.4.263-.766.354-1.032-.175.032-.043.1-.091.092-.127-.047-.3-.007-.6.3-.693C574.064,193.119,573.956,193.609,574.184,193.7Z",
    transform: "translate(-510.545 -146.31)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    d: "M564.725,187.458l.336,0,.509.012c-.135.216.088.245.175.345,0,.053-.009.107-.015.16-.49-.2-1.045.3-1.512-.146-.121-.291.129-.326.286-.425A.253.253,0,0,1,564.725,187.458Z",
    transform: "translate(-503.956 -142.126)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    d: "M572.572,196.2a1.266,1.266,0,0,0,1.032.175c-.019.34-.175.462-.5.323-.189-.007-.378-.012-.567-.023-.151-.009-.258-.077-.252-.25S572.442,196.228,572.572,196.2Z",
    transform: "translate(-509.805 -148.454)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    d: "M563.491,185.893l-.189.029a2.138,2.138,0,0,1-.7.148l-.121-.343a.355.355,0,0,1,.337-.171l.677-.336Q563.492,185.556,563.491,185.893Z",
    transform: "translate(-502.722 -140.56)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    d: "M570.383,200.3l.167-1.023a.422.422,0,0,1,.506-.174c.1.459-.432.73-.339,1.186a.238.238,0,0,1-.163.1A.253.253,0,0,1,570.383,200.3Z",
    transform: "translate(-508.43 -150.528)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    d: "M557.583,188.425q.006-.423.012-.846a.346.346,0,0,1,.316-.26l.107.02.084.07c-.03.234.078.5-.163.683-.134.094-.046.35-.268.381Z",
    transform: "translate(-499.187 -142.07)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    d: "M564.09,191.566c-.187.114-.014.228,0,.341a.353.353,0,0,1-.505,0c-.083-.291-.071-.589.233-.7C563.961,191.154,564.007,191.432,564.09,191.566Z",
    transform: "translate(-503.489 -144.861)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1697",
    "data-name": "Path 1697",
    d: "M556.1,191.953c-.262-.414-.016-.58.332-.7l.021.01c.189.124.046.355.158.5l0,.179-.085.081A.358.358,0,0,1,556.1,191.953Z",
    transform: "translate(-498.04 -144.9)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1698",
    "data-name": "Path 1698",
    d: "M570.179,198.665l-.506.174-.5.169.168-.515a1.109,1.109,0,0,1,.507,0A.347.347,0,0,1,570.179,198.665Z",
    transform: "translate(-507.553 -150.084)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1699",
    "data-name": "Path 1699",
    d: "M559.352,185.211c.526.018.112.513.338.683h-.5c-.2-.233-.065-.426.07-.619Z",
    transform: "translate(-500.271 -140.554)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1700",
    "data-name": "Path 1700",
    d: "M573.556,203.447a.358.358,0,0,1,.344.165c.084.27-.14.318-.292.418a.569.569,0,0,1-.229.026.3.3,0,0,1-.236-.229.285.285,0,0,1,.083-.207Z",
    transform: "translate(-510.424 -153.666)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1701",
    "data-name": "Path 1701",
    d: "M570.281,197.1a.451.451,0,0,1-.507,0c.011-.286.237-.393.471-.572C570.259,196.747,570.27,196.925,570.281,197.1Z",
    transform: "translate(-507.99 -148.69)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1702",
    "data-name": "Path 1702",
    d: "M571.471,203.584q-.006.08-.014.159a.5.5,0,0,1-.662.062.283.283,0,0,1,0-.395q.082,0,.165-.014C571.142,203.414,571.349,203.38,571.471,203.584Z",
    transform: "translate(-508.668 -153.628)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1703",
    "data-name": "Path 1703",
    d: "M557.658,194.062c-.015.21-.112.337-.334.339-.251-.3-.117-.507.158-.681h0A.363.363,0,0,1,557.658,194.062Z",
    transform: "translate(-498.905 -146.672)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    d: "M557.8,190.919c-.2-.119-.156-.32-.158-.5l.335-.342A1.421,1.421,0,0,1,557.8,190.919Z",
    transform: "translate(-499.23 -144.05)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1705",
    "data-name": "Path 1705",
    d: "M562.915,187.813c.192-.253.458-.149.7-.149l-.317.34A.421.421,0,0,1,562.915,187.813Z",
    transform: "translate(-503.037 -142.303)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    d: "M574.518,204.374l.344-.339c.054,0,.107,0,.161.008l.336.341c.051.169-.055.24-.18.3a.717.717,0,0,1-.644-.074A.166.166,0,0,1,574.518,204.374Z",
    transform: "translate(-511.386 -154.088)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    d: "M582.085,212.7l-.176.328a.62.62,0,0,1-.378.456.7.7,0,0,1-.372.013c-.3-.187-.775-.241-.616-.795.333-.031.472-.33.694-.514a.435.435,0,0,1,.674.013Z",
    transform: "translate(-515.743 -159.839)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M583.283,211.226l-.674-.014,0-.024c-.084-.155-.284-.269-.168-.494l.507-.017a1.333,1.333,0,0,1,.835.2Z",
    transform: "translate(-517.115 -158.865)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    d: "M572.04,207.53l-.169.006a.49.49,0,0,1-.649.269.631.631,0,0,1-.4-.6,4.211,4.211,0,0,1,.745-.625.675.675,0,0,1,.373-.057.436.436,0,0,1,.411.439A.685.685,0,0,1,572.04,207.53Z",
    transform: "translate(-508.744 -155.875)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M572.214,212.065l.007-.339a.893.893,0,0,1,.7,0l.974.012a.292.292,0,0,1,.068.316c-.124.223-.354.271-.566.348l0,.04a.837.837,0,0,1-.547-.011C572.71,212.182,572.36,212.3,572.214,212.065Z",
    transform: "translate(-509.752 -159.566)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    d: "M579.3,214.384c.092.379.454.467.708.671a.32.32,0,0,1,.032.357.527.527,0,0,1-.335.152.723.723,0,0,1-.352-.066c-.182-.092-.256-.282-.377-.431l-.187-.523a.229.229,0,0,1,.2-.17Z",
    transform: "translate(-514.502 -161.523)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M578.344,211.953l-.195.17-.069,0h-.069a.358.358,0,0,1-.011-.5q0-.173,0-.346c.036-.163.076-.383.29-.2.132.114.432.219.227.519A2.766,2.766,0,0,0,578.344,211.953Z",
    transform: "translate(-513.859 -159.101)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    d: "M578.086,207.078h.674c-.035.228.1.531-.217.643-.25.088-.426-.012-.458-.3A.24.24,0,0,1,578.086,207.078Z",
    transform: "translate(-513.94 -156.276)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M575.216,208.588l.177-.506a.212.212,0,0,1,.262-.073l.073.069C575.69,208.385,575.871,208.915,575.216,208.588Z",
    transform: "translate(-511.92 -156.933)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M572.724,210.636c-.234.158-.468.024-.7,0l-.013.01a.255.255,0,0,1,0-.353l.67-.157Q572.7,210.385,572.724,210.636Z",
    transform: "translate(-509.553 -158.473)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M577.037,205.777q0,.172,0,.343H576.7a.5.5,0,0,1-.009-.676l.175-.173c.056,0,.112,0,.167,0Q577.035,205.523,577.037,205.777Z",
    transform: "translate(-512.891 -154.975)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    d: "M581.868,210.738l.168.494c-.168-.1-.437-.089-.425-.372C581.612,210.816,581.778,210.778,581.868,210.738Z",
    transform: "translate(-516.537 -158.908)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M566.25,170.17q.01.322.019.645l-.047.057a.69.69,0,0,1-.511.281.545.545,0,0,1-.339-.09.8.8,0,0,1-.133-.187c-.262-.565-.54-.267-.817-.013a.323.323,0,0,1-.228.007.957.957,0,0,1-.38-.452c-.412-.418-1.03-.03-1.459-.382-.181-.666.3-.6.69-.643a2.841,2.841,0,0,0,.784-.115c.322-.007.663-.088.892.246-.055.3.291.124.343.3a.657.657,0,0,0,.669,0Z",
    transform: "translate(-502.604 -129.089)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M564.54,165.506l1.182.343v.317c-.4.341-.872.168-1.315.205-.12-.007-.24.01-.36.008-.389-.072-.753-.171-.687-.7-.044-.17-.27-.339,0-.511A3.045,3.045,0,0,1,564.54,165.506Z",
    transform: "translate(-503.264 -126.144)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M567.159,168.741a6.478,6.478,0,0,0,1.343-.032c.147.043.4-.03.414.164.02.282-.234.1-.362.137s-.262.074-.394.111l-1-.058A.2.2,0,0,1,567.159,168.741Z",
    transform: "translate(-506.044 -128.686)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M572.871,171.051c-.224.238-.447.431-.669,0C572.425,170.885,572.648,171.038,572.871,171.051Z",
    transform: "translate(-509.744 -130.318)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M569.69,175.182h.327a1.055,1.055,0,0,1,.327.7c0,.049,0,.1,0,.147-.225.162-.449,0-.673,0-.177-.248-.439-.144-.67-.166a.241.241,0,0,1-.346,0l-.334,0a.337.337,0,0,1-.06-.372c.261-.387.7-.328,1.069-.432A.448.448,0,0,1,569.69,175.182Z",
    transform: "translate(-506.876 -133.253)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M574.954,175.834a.6.6,0,0,1-.327-.7l.477-.146C575.407,175.332,575.328,175.61,574.954,175.834Z",
    transform: "translate(-511.486 -133.202)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M563.782,177.894l-.182.006a.137.137,0,0,1-.2,0,.691.691,0,0,1,.108-.7.631.631,0,0,1,.4-.266.534.534,0,0,1,.237.041c.13.106.242.22.152.411C564.16,177.6,563.849,177.621,563.782,177.894Z",
    transform: "translate(-503.342 -134.608)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M566.309,176.9l-.174-.338a.4.4,0,0,1,.343-.3.374.374,0,0,1,.328.122v.343Z",
    transform: "translate(-505.363 -134.12)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M569.755,177.934h.346c-.04.159.07.441-.213.413C569.719,178.33,569.773,178.085,569.755,177.934Z",
    transform: "translate(-507.977 -135.322)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    d: "M569.168,188c-.284,0-.281-.145-.175-.345l.489.013C569.5,187.892,569.38,187.989,569.168,188Z",
    transform: "translate(-507.379 -142.309)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M562.238,180.264l.174.007c0,.116-.193.232,0,.348.168.242.064.393-.164.5l-.5-.168c-.12-.207,0-.373.09-.544C561.943,180.293,562.06,180.192,562.238,180.264Z",
    transform: "translate(-502.154 -136.98)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M563.691,182.093l.164-.5.347.506c-.121.2-.321.164-.505.173Z",
    transform: "translate(-503.598 -137.95)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M583.161,216.949q0-.172,0-.343h.32a.232.232,0,0,1,.347.008q0,.08,0,.161c0,.057,0,.114,0,.171A.457.457,0,0,1,583.161,216.949Z",
    transform: "translate(-517.657 -163.074)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M584.673,215.919l-.347-.008.338-.346.334.008A.3.3,0,0,1,584.673,215.919Z",
    transform: "translate(-518.498 -162.378)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M534.374,146.581A5.045,5.045,0,0,0,533.3,147.9c-.134.194-.285.1-.438.047l-.114-.043c-.353-.318-.22-.753-.271-1.143-.013-.115-.029-.23-.036-.345a.392.392,0,0,1,.067-.208.411.411,0,0,1,.2-.062c.293-.025.338-.492.7-.4C533.941,145.765,534.109,146.23,534.374,146.581Z",
    transform: "translate(-481.029 -112.168)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M535.633,142.893c-.46-.042-.494-.73-1.012-.683-.229-.368-.608-.691-.36-1.206.247-.243.594-.2.885-.314a3.5,3.5,0,0,1,.812-.075,7.721,7.721,0,0,1,1.7.233l.335,0c.134.178.359.361-.122.347-.778-.023-1.557-.01-2.336,0-.185,0-.406-.054-.516.173-.123.252.017.425.192.584A.99.99,0,0,1,535.633,142.893Z",
    transform: "translate(-482.287 -108.48)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M530.916,160.1c.3.076.734-.2.845.345a.728.728,0,0,0,.449.342.6.6,0,0,1,.2.287c.062.337.126.673-.183.934a1.29,1.29,0,0,1-.862-1.007c-.11-.4-.284-.417-.584-.254a1.306,1.306,0,0,1-.346.065,2.677,2.677,0,0,1-.358,0,.877.877,0,0,1-.459-.129.34.34,0,0,1-.1-.213.437.437,0,0,1,.217-.276.751.751,0,0,1,.343-.046C530.361,160.237,530.622,159.873,530.916,160.1Z",
    transform: "translate(-478.919 -122.445)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M529.732,151.962l-.166.35a.42.42,0,0,1-.181.115.666.666,0,0,1-.217,0,1.687,1.687,0,0,1-.391-.187c-.22-.123-.486-.178-.631-.418a.432.432,0,0,1-.007-.33.345.345,0,0,1,.169-.137.83.83,0,0,1,.217-.021c.245.022.5-.083.735.073.154.189.219.456.472.56Z",
    transform: "translate(-477.904 -116.184)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M537.931,161.208c-.413.184-.328-.128-.337-.346.268-.478.671-.13,1.01-.17a.287.287,0,0,0,.208.381C538.586,161.569,538.238,161.251,537.931,161.208Z",
    transform: "translate(-484.752 -122.864)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M538.811,160.992c.243-.246.623.188.843-.174-.059-.4.231-.449.506-.512h.166l.076.11a.537.537,0,0,1,0,.267c-.323.616-.772.849-1.42.479Z",
    transform: "translate(-485.632 -122.648)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M532.107,154.84l.167.007c.591,0,.287.567.5.8-.3.322-.582.23-.855-.042A.651.651,0,0,1,532.107,154.84Z",
    transform: "translate(-480.612 -118.718)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M532.057,158.988c-.309-.079-.458.633-.845.175a.431.431,0,0,1-.052-.524.712.712,0,0,1,.793-.077l.1.1Q532.054,158.827,532.057,158.988Z",
    transform: "translate(-480.06 -121.335)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M538.13,153.855c.364.26.091.591.426,1.019C537.841,154.525,538.147,154.149,538.13,153.855Z",
    transform: "translate(-485.103 -118.01)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M543.495,157.438l.169-.171a.589.589,0,0,1,.394.74c-.052.2-.22.228-.4.115h0C543.722,157.864,543.269,157.736,543.495,157.438Z",
    transform: "translate(-488.968 -120.463)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M541.743,159.983l-.506.512c-.3.009-.256-.156-.169-.342C541.3,160.14,541.416,159.625,541.743,159.983Z",
    transform: "translate(-487.215 -122.325)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M531.977,157.367a1.459,1.459,0,0,0,.831.1l.154.067c.06.157-.027.229-.156.277l-.174.055.011-.04c-.217-.173-.575.093-.74-.243A.265.265,0,0,1,531.977,157.367Z",
    transform: "translate(-480.642 -120.535)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M535.157,158.237l.156-.277c.126,0,.322-.033.261.176S535.312,158.261,535.157,158.237Z",
    transform: "translate(-482.993 -120.961)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M544.025,160.689l.169.853c-.138.346.4.314.34.619a1.057,1.057,0,0,1-.166.94c-.176.117-.437.159-.54.033-.28-.343-.351.1-.527.1a1.606,1.606,0,0,1-.71.024c-.169-.034-.4.129-.5-.133a.324.324,0,0,1,.2-.467c.54-.133,0-.838.521-.966.347.046.426-.26.584-.462.108-.2.1-.45.3-.6A.279.279,0,0,1,544.025,160.689Z",
    transform: "translate(-487.98 -122.861)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M544.252,154.543h-.337c-.208-.216-.045-.477-.1-.825-.073.38-.084.688-.342.877a.524.524,0,0,1-.355.076.488.488,0,0,1-.212-.128c0-.057,0-.113,0-.169.687-.284-.02-.57,0-.855-.164-.32-.348-.631-.484-.963a.377.377,0,0,1,.085-.465c.19-.116.3.062.387.207a1.486,1.486,0,0,0,1.165.762,1.125,1.125,0,0,1,.873,1.141C544.443,153.791,544.306,154.082,544.252,154.543Z",
    transform: "translate(-488.207 -116.715)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M551.068,163.318h.173c.3-.056.367.187.468.384.069.309.113.614-.178.845-.128.022-.166-.071-.2-.165a.245.245,0,0,0,.181.246c.154.217,0,.292-.163.362-.689.061-.6-.493-.694-.9A.834.834,0,0,1,551.068,163.318Z",
    transform: "translate(-494.183 -124.807)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M549.548,161.347c.029.3-.239.447-.335.682-.056.076-.112.08-.168,0-.134-.08-.274-.152-.4-.244-.093-.069-.139-.2-.053-.278.051-.046.187,0,.284.009.531-.092.2-.813.687-.95C549.875,160.829,549.285,161.088,549.548,161.347Z",
    transform: "translate(-492.662 -122.836)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M555.16,160.5c.26-.032.522.048.784-.1.38-.212.15.177.228.27-.288.386.3.961-.271,1.285-.647.045-.571-.378-.505-.8C555.552,160.854,555.052,160.785,555.16,160.5Z",
    transform: "translate(-497.426 -122.67)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M554.056,160.309c.009.332.753-.077.505.513a.477.477,0,0,1-.325.117.431.431,0,0,1-.35-.289c-.022-.212-.4-.311-.221-.548C553.737,160.01,553.96,160.159,554.056,160.309Z",
    transform: "translate(-496.322 -122.481)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M560.684,159.567l0,.343c-.191.1-.24-.078-.334-.17l0,0c-.031-.149-.24-.329-.024-.436C560.5,159.212,560.6,159.414,560.684,159.567Z",
    transform: "translate(-501.094 -121.909)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M553.278,162.127l.338.171c.045.387-.287.394-.507.513l-.336-.343Z",
    transform: "translate(-495.714 -123.957)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M563.5,152.993c-.611.173-.223.683-.338,1.023a3.09,3.09,0,0,1,0-2.218c.115.341-.273.851.338,1.024Z",
    transform: "translate(-503.067 -116.531)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M560.664,160.919l.334.17q0,.255,0,.511C560.546,161.547,560.691,161.189,560.664,160.919Z",
    transform: "translate(-501.411 -123.089)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M544.539,132.4c.412-.817-.01-1.716.243-2.595.343.982-.3,2.068.436,2.943a.356.356,0,0,1-.348.158c-.2-.151-.482.1-.672-.128C544.077,132.44,544.443,132.546,544.539,132.4Z",
    transform: "translate(-489.504 -100.721)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M540.013,140.011c-.571.369-1.134-.181-1.7-.013-.262-.187-.59.022-.855-.148a.228.228,0,0,1,.041-.244c.587-.106,1.181-.361,1.746.073.176.15.442-.019.605.176Z",
    transform: "translate(-484.639 -107.642)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M544.326,140.408l-.675-.029c-.039-.15.018-.2.163-.163.229.029.494-.086.669.167A1.4,1.4,0,0,0,544.326,140.408Z",
    transform: "translate(-489.119 -108.195)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M555.356,166.682a.346.346,0,0,1,.337.169c-.02.491-.46.658-.723.961-.074.1-.244.176-.149.313.073.106.246.008.37.052a.581.581,0,0,1,.228.383c-.011.241-.187.406-.271.615a.653.653,0,0,1-.323.321c-.331.062-.5-.166-.672-.386-.139-.222.108-.514-.13-.719-.259-.313-.405-.581.071-.872.347-.212.385-.747.8-.933A.488.488,0,0,1,555.356,166.682Z",
    transform: "translate(-496.442 -127.147)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M560.635,166.985c.171.255.316.546.693.519.219.409-.2.362-.353.5-.354-.148-.6-.081-.679.34a.5.5,0,0,1-.339.178.682.682,0,0,1-.493-.12c-.072-.636.338-.892.834-1.081A.309.309,0,0,1,560.635,166.985Z",
    transform: "translate(-500.54 -127.45)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M558.961,167.759l-.85,1.022a.153.153,0,0,1-.179.049.839.839,0,0,1-.327-.39l.849-.852Z",
    transform: "translate(-499.203 -127.884)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M557.947,163.055h-.506a.239.239,0,0,1,0-.341c.383-.32-.046-.875.337-1.2C557.856,162.028,558.2,162.507,557.947,163.055Z",
    transform: "translate(-499.033 -123.52)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M564.874,165.129a1.686,1.686,0,0,1-1.182-.338C564.217,164.434,564.542,164.794,564.874,165.129Z",
    transform: "translate(-503.598 -125.766)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M551.491,129.319h.337l.155,2.246a.229.229,0,0,1-.325-.04A5.692,5.692,0,0,1,551.491,129.319Z",
    transform: "translate(-494.77 -100.369)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M551.123,137.168l.325.04c.03.248-.125.316-.324.344-.13-.074-.393.082-.4-.154C550.721,137.2,550.96,137.2,551.123,137.168Z",
    transform: "translate(-494.235 -106.012)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M423.495,88.093a1.569,1.569,0,0,1-.691,1.928C422.706,89.228,423.292,88.852,423.495,88.093Z",
    transform: "translate(-401.854 -70.728)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M416.422,95.1l-.167.169a3.746,3.746,0,0,0-1.355.005.5.5,0,0,1-.631.059.156.156,0,0,1-.044-.234l.17-.171.337,0c.508-.3,1.015-.044,1.522,0Z",
    transform: "translate(-395.643 -75.535)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M417.659,94.134l-1.522,0,.172-.338C416.885,93.4,417.177,94.151,417.659,94.134Z",
    transform: "translate(-397.048 -74.744)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M413.715,70.994h1.859A2.169,2.169,0,0,1,413.715,70.994Z",
    transform: "translate(-395.299 -58.435)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M402.427,86.58a1.4,1.4,0,0,1,0,1.365,3.8,3.8,0,0,1-.878-.117.409.409,0,0,1-.191-.411.961.961,0,0,1,.653-.791.261.261,0,0,1,.416-.048Z",
    transform: "translate(-386.369 -69.58)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M402.074,90.882a.713.713,0,0,1,.82.17c.128.472.282.921.845,1.025l-.348.364a2.7,2.7,0,0,1-.931.05.369.369,0,0,1-.2-.312.541.541,0,0,1,.061-.239.286.286,0,0,1,.139-.079c.122-.038.2.126.319.073-.12-.024-.172-.13-.246-.207-.077-.111-.131-.237-.21-.346a1.862,1.862,0,0,0-.2-.194A.439.439,0,0,1,402,91.04.158.158,0,0,1,402.074,90.882Z",
    transform: "translate(-386.839 -72.686)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M403.856,85.489a.349.349,0,0,0-.338.175c-.169.051-.214-.019-.17-.177q0-.251,0-.5c.249-.014.486-.01.508.331Q403.857,85.4,403.856,85.489Z",
    transform: "translate(-387.801 -68.49)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M411.689,95.467q0,.086.005.171a.106.106,0,0,1,.037.12c-.016.037-.032.056-.046.056l-.313.141-.676.013c-.006-.109-.011-.218-.017-.327a.365.365,0,0,1,.17-.346Z",
    transform: "translate(-393.106 -75.906)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M402.929,96.365l.979.034a.909.909,0,0,1,.011.145l-1.158.008c-.017-.053-.033-.106-.046-.16A.133.133,0,0,1,402.929,96.365Z",
    transform: "translate(-387.356 -76.646)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M393.775,95.509c-.43.33-.921.118-1.384.162-.085-.184.069-.233.171-.311l.179.006c.315.173.689-.054,1,.149Z",
    transform: "translate(-379.883 -75.953)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M394.715,95.427c-.333-.055-.7.125-1-.149l.662-.04C394.508,95.266,394.662,95.255,394.715,95.427Z",
    transform: "translate(-380.857 -75.865)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M391.755,95.3l-.171.312-.335.014c0-.116,0-.233,0-.349Z",
    transform: "translate(-379.075 -75.893)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M400.867,88.868a.968.968,0,0,0-.024.149.223.223,0,0,1-.18.209.547.547,0,0,1-.334-.534,1.1,1.1,0,0,0,.191-.677l.146.008a.408.408,0,0,1,.028.487Z",
    transform: "translate(-385.633 -70.672)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M399.923,95.554a.362.362,0,0,1-.176-.345l.306-.507.086,0a.428.428,0,0,1,.134.107l.037.079a.162.162,0,0,1-.066.148Z",
    transform: "translate(-385.212 -75.478)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M400.848,94.019l.029-.186a.283.283,0,0,1,.182-.085.374.374,0,0,1,.185.09.411.411,0,0,1,.07.2.354.354,0,0,1-.083.191.161.161,0,0,1-.189-.022l0-.033a1.75,1.75,0,0,0-.161-.155Z",
    transform: "translate(-386.007 -74.794)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M401.113,93.121a.61.61,0,0,1-.161.014c0-.149.016-.293.181-.358l.065.08A.205.205,0,0,1,401.113,93.121Z",
    transform: "translate(-386.083 -74.096)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M401.531,91.791l.18-.208.011.035a.285.285,0,0,1,.086.182l-.023.1-.064.083a.125.125,0,0,1-.171-.05v-.016C401.547,91.876,401.54,91.833,401.531,91.791Z",
    transform: "translate(-386.501 -73.238)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M401.572,87.622q-.014-.244-.028-.487l.182-.351.331,0,.17.177A1.374,1.374,0,0,0,401.572,87.622Z",
    transform: "translate(-386.51 -69.784)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    d: "M455.8,100.34V101.5l-.171,0v-1.332Z",
    transform: "translate(-425.563 -79.414)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M451.634,107.067a1.551,1.551,0,0,0-.843-.513c-.164-.135.055-.531-.338-.511l-.077-.079a.491.491,0,0,1-.039-.216.466.466,0,0,1,.1-.193l.018-.034a1.436,1.436,0,0,0,.151.007c.507-.064,1.045.16,1.524-.166l.684-.345c0,.758.021,1.517-.01,2.274-.013.318.06.522.35.639a.337.337,0,0,1-.2.414.648.648,0,0,1-.48-.081h0a1.265,1.265,0,0,1-.506-.853c-.037-.271.216-.4.324-.639-.159.16-.272.325-.493.3Z",
    transform: "translate(-421.743 -82.897)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M452.838,106.146c-.445.644-.995.311-1.524.166.228-.309.574-.121.855-.205Z",
    transform: "translate(-422.449 -83.68)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M437.523,101.483c-.088.219.287.281.169.51a.376.376,0,0,1-.337.111c-.332-.113-.812-.067-.7-.661a.746.746,0,0,1,.1-.234.526.526,0,0,1,.788.037A.2.2,0,0,1,437.523,101.483Z",
    transform: "translate(-411.849 -80.043)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M437.446,105.03l.729.193a.332.332,0,0,1-.1.4,3.448,3.448,0,0,1-1.6.115c-.189-.046-.369-.106-.414-.334.212-.3.539-.236.836-.266C437.079,105.122,437.282,105.176,437.446,105.03Z",
    transform: "translate(-411.431 -82.906)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M437.055,101.043c-.225-.078-.451-.3-.674,0-.177.1-.28-.014-.378-.139a.179.179,0,0,1,.05-.2l.317-.021a7.376,7.376,0,0,1,1.712.189l-.188.188A.683.683,0,0,1,437.055,101.043Z",
    transform: "translate(-411.384 -79.778)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M443.68,105.707q0-.15,0-.3c.443-.39.712.295,1.11.184a.278.278,0,0,1-.05.3.518.518,0,0,1-.173.119.923.923,0,0,1-.513.009.78.78,0,0,1-.265-.144A.372.372,0,0,1,443.68,105.707Z",
    transform: "translate(-416.937 -83.09)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M438.847,104.585a.313.313,0,0,1-.343.339c-.125-.185-.475.034-.507-.257-.02-.184.174-.238.34-.256h.337Z",
    transform: "translate(-412.832 -82.461)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M439.822,101.972l.838.02c-.178.6-.531.243-.835.155Z",
    transform: "translate(-414.151 -80.707)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M447.1,106.512l.161-.3.183-.061.659.219a.657.657,0,0,1,.009.126A.693.693,0,0,1,447.1,106.512Z",
    transform: "translate(-419.404 -83.714)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M510.6,118.376a1.86,1.86,0,0,1-.172,1.706c-.218-.434.066-.93-.166-1.363A.594.594,0,0,1,510.6,118.376Z",
    transform: "translate(-465.018 -92.501)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M510.26,119.6c.335.42.1.91.166,1.363l-.167,0q0-.427,0-.853Q510.259,119.853,510.26,119.6Z",
    transform: "translate(-465.013 -93.378)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M491.433,128.209a1.233,1.233,0,0,1,1.151.2C492.08,128.78,491.884,128.318,491.433,128.209Z",
    transform: "translate(-451.42 -99.531)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M493.289,131.373c-.228-.031-.494.085-.661-.179l.679-.19C493.887,131.156,493.288,131.249,493.289,131.373Z",
    transform: "translate(-452.283 -101.581)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M488.752,126.292l.182.5-.533.009C488.4,126.546,488.4,126.3,488.752,126.292Z",
    transform: "translate(-449.229 -98.193)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M483.937,125.109l-1,0a.386.386,0,0,1-.222-.527c.329-.287.708-.118,1.069-.121a.438.438,0,0,1,.324.14Z",
    transform: "translate(-445.101 -96.845)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M488.165,119.942a1.116,1.116,0,0,1,.362-1.018c.113-.109.121.086.147.17-.046.287.109.613-.165.855l-.341.336a.275.275,0,0,1-.1-.172A.24.24,0,0,1,488.165,119.942Z",
    transform: "translate(-448.993 -92.873)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M486.785,122.976c0,.056,0,.112,0,.167a.367.367,0,0,1-.172.347h-.338a.381.381,0,0,1-.117-.223.488.488,0,0,1,.057-.249A.379.379,0,0,1,486.785,122.976Z",
    transform: "translate(-447.612 -95.731)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M502.707,136.6l.17.167c.133.358-.074.574-.316.777a.929.929,0,0,1-.378.1.94.94,0,0,1-.509-.108c-.492-.429-.1-.67.194-.934C502.15,136.994,502.429,136.738,502.707,136.6Z",
    transform: "translate(-458.647 -105.605)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M500.87,136.613c.016.293-.5.476-.167.833a.285.285,0,0,1-.2.246.428.428,0,0,1-.382-.211.641.641,0,0,1-.061-.222.407.407,0,0,1,.137-.305v-.171Z",
    transform: "translate(-457.648 -105.613)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M498.606,134.521h-.674a.233.233,0,0,1,0-.341h.673Q498.606,134.35,498.606,134.521Z",
    transform: "translate(-456.059 -103.863)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M496.8,132.093c-.231.138-.406.1-.509-.167l.51-.174Q496.8,131.923,496.8,132.093Z",
    transform: "translate(-454.927 -102.118)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M506.2,128.72l.339.344c-.143.029-.285.208-.428.051S506.055,128.825,506.2,128.72Z",
    transform: "translate(-461.971 -99.938)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M508.926,124.454l0,.5c-.138.157-.051.461-.334.522h-.174a1.184,1.184,0,0,1,.176-.681Z",
    transform: "translate(-463.679 -96.871)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M509.051,126.77l.334-.522c-.038.291.12.623-.171.862Z",
    transform: "translate(-464.142 -98.161)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M505.414,137.045l.331-.685a.338.338,0,0,1,.173-.327c.123.318.046.762.527.853C506.177,137.44,505.806,137.31,505.414,137.045Z",
    transform: "translate(-461.515 -105.196)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    d: "M485.975,117.774h.168l.341,1.357a.3.3,0,0,1-.338.062c-.187-.148,0-.412-.17-.564Z",
    transform: "translate(-447.478 -92.068)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M485.942,122.566l.343,0,.167.007v.175c-.19.006-.392-.025-.519.174-.154.03-.211-.059-.233-.192C485.728,122.594,485.789,122.511,485.942,122.566Z",
    transform: "translate(-447.279 -95.501)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M461.349,116.787c.014-.293-.03-.556-.34-.683-.232-.185-.362-.394-.157-.682.189-.125.11-.371.221-.521a.311.311,0,0,1,.547,0A2.478,2.478,0,0,1,461.349,116.787Z",
    transform: "translate(-429.263 -89.886)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    d: "M460.041,115.885l.157.682h0c-.158.241-.313.277-.465-.005.013-.283-.217-.555-.041-.847l.172-.331C460.066,115.5,460.021,115.7,460.041,115.885Z",
    transform: "translate(-428.452 -90.349)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    d: "M480.256,123.169l.517.043c.106.189.621-.145.468.375a5.983,5.983,0,0,1-1.035.023.3.3,0,0,1-.275-.372Z",
    transform: "translate(-443.109 -95.947)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    d: "M478.1,123.314l.162.286a.337.337,0,0,1-.208.108.54.54,0,0,1-.472-.015c-.138-.105-.246-.223-.167-.417Z",
    transform: "translate(-441.275 -96.024)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M481.91,119.62c.054.148.315.167.245.381a.222.222,0,0,1-.2.09c-.258-.063-.2-.286-.206-.472C481.8,119.617,481.857,119.617,481.91,119.62Z",
    transform: "translate(-444.428 -93.394)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M476.609,123.219l.167.323a.356.356,0,0,1-.191.126.318.318,0,0,1-.308-.122l0,0,.165-.353Z",
    transform: "translate(-440.472 -95.967)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    d: "M483.47,123.336l-.493-.3.325-.016a.382.382,0,0,1,.507,0l.157.172a.728.728,0,0,1,0,.153A.345.345,0,0,1,483.47,123.336Z",
    transform: "translate(-445.313 -95.768)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M482.955,116.023c.028-.171-.088-.419.213-.442a.226.226,0,0,1,.172.142c.024.282-.2.272-.384.3Z",
    transform: "translate(-445.297 -90.492)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M484.655,121.5h-.507c.161-.236.544-.3.508-.688.2.121.163.319.166.5Z",
    transform: "translate(-446.159 -94.255)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M533.04,136.107l-.163.163c-.527-.492-1.136-.039-1.7-.152a2.3,2.3,0,0,1-1.1.333c-.653,0-.732-.767-1.242-.962-.212-.283-.09-.556.022-.83a.409.409,0,0,1,.178-.155c.256-.037.494-.028.6.27.092.255.334.244.532.31.582.107,1.255-.3,1.7.568.185.357.986.071,1.5.116Z",
    transform: "translate(-478.344 -104.086)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M530.768,134.866c-.373.135-.675.17-.752-.368-.028-.2-.272-.122-.426-.142q-.057-.047-.039-.094c.012-.032.024-.048.037-.048l.335-.028.677.167C530.411,134.605,530.662,134.711,530.768,134.866Z",
    transform: "translate(-478.942 -103.868)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M518.023,134.258l.507-.172c.165.224.375.1.573.073.166-.029.319-.2.5-.054a.773.773,0,0,1,.107.2c.059.388.348.723.261,1.146-.1.243-.22.449-.527.419a.419.419,0,0,1-.189-.135.527.527,0,0,0-.625-.318.643.643,0,0,1-.6-.2c-.143-.19.064-.389-.016-.581C517.988,134.512,517.925,134.383,518.023,134.258Z",
    transform: "translate(-470.582 -103.77)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M509.4,136.424c.418-.236.108-1.1.872-1.037a.39.39,0,0,1-.028.53.348.348,0,0,0-.057.019.411.411,0,0,0,.058.032.451.451,0,0,1,.244.047.638.638,0,0,1,.151.146c.284.464-.191.816-.172,1.242a.55.55,0,0,1-.739.507.442.442,0,0,1-.192-.15c-.175-.317.4-.756-.16-1.012A.318.318,0,0,1,509.4,136.424Z",
    transform: "translate(-464.354 -104.729)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M517.554,122.906l.161,0c.247.016.362-.186.517-.323l-.008-.046.347.036c.417.131.36.549.5.846-.022.029-.043.059-.063.089-.14.115-.287.22-.416.348a1.01,1.01,0,0,1-.365.246A1.505,1.505,0,0,1,517.554,122.906Z",
    transform: "translate(-470.281 -95.492)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M512.428,135.259h-.335l.167-.68c.448-.593,1.005-.18,1.519-.169l.168.34C513.415,134.841,512.816,134.728,512.428,135.259Z",
    transform: "translate(-466.338 -103.92)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M505.633,139.073l.049.325a.256.256,0,0,1-.138.3,1.094,1.094,0,0,1-.682.155,1.673,1.673,0,0,1-.435-.178c-.141-.117-.376-.176-.28-.446h.336c.348-.022.726.153,1.031-.159C505.554,139.072,505.594,139.073,505.633,139.073Z",
    transform: "translate(-460.584 -107.379)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M521.65,132.218l-.332.333c-.076-.153-.226-.228-.343-.338l-.01-.343a.3.3,0,0,1-.033-.344.331.331,0,0,1,.34-.06,1.481,1.481,0,0,1,.592.573C521.855,132.175,521.81,132.266,521.65,132.218Z",
    transform: "translate(-472.693 -101.897)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M520.272,129.8l-.013.342c-.595-.183-.213-.683-.326-1.023a.28.28,0,0,1,.391,0A.537.537,0,0,1,520.272,129.8Z",
    transform: "translate(-471.986 -100.171)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M520.315,127.575l-.337,0v-.341a.309.309,0,0,1,.337-.342A.465.465,0,0,1,520.315,127.575Z",
    transform: "translate(-472.032 -98.623)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M520.318,134.18a.315.315,0,0,1,.343.338c-.175-.218-.656.194-.678-.337Z",
    transform: "translate(-472.036 -103.864)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M526.728,133.666c0,.047,0,.095,0,.142l0,0c-.116.212-.159.479-.425.58a1.291,1.291,0,0,1-.415.158.329.329,0,0,1-.21-.082.943.943,0,0,1,.156-1.005.169.169,0,0,1,.214,0c.115.195.238.009.357.008C526.466,133.617,526.6,133.635,526.728,133.666Z",
    transform: "translate(-476.082 -103.32)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M525.668,130.206l-.165,0a.166.166,0,0,1-.236-.032,1.272,1.272,0,0,1-.1-1.158l.026-.027a.373.373,0,0,1,.3-.1.414.414,0,0,1,.179.113Z",
    transform: "translate(-475.702 -100.063)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M526.43,126.7h-.169a.98.98,0,0,1,0-1.011c.053,0,.106,0,.158,0Q526.426,126.2,526.43,126.7Z",
    transform: "translate(-476.466 -97.76)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M522.566,127.46c-.217-.121-.5-.178-.512-.508.009-.035.018-.07.026-.105a.608.608,0,0,0-.052-.617.747.747,0,0,1,.2-.99h0l.5-.17q0,.595.006,1.189a1.5,1.5,0,0,1,.079,1.138A.175.175,0,0,1,522.566,127.46Z",
    transform: "translate(-473.435 -97.315)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M524.844,130.5q0-.6,0-1.2.082,0,.163.012a3.2,3.2,0,0,1,.173,1.189c.03.074.04.158-.049.18C524.989,130.716,524.9,130.628,524.844,130.5Z",
    transform: "translate(-475.546 -100.358)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M525.811,125.7q0,.505,0,1.011l-.306-.014A1.038,1.038,0,0,1,525.811,125.7Z",
    transform: "translate(-476.013 -97.768)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M518.65,122.7c-.011.372-.069.665-.517.323l.176-.321Z",
    transform: "translate(-470.7 -95.61)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M582.255,224.27q0,.255,0,.509c-.456-.053-.307-.411-.335-.68A.347.347,0,0,1,582.255,224.27Z",
    transform: "translate(-516.759 -168.514)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M577.059,220.2h.507a.256.256,0,0,1,.277-.085.287.287,0,0,1,.143.144.266.266,0,0,1-.084.282C577.606,220.468,577.167,220.756,577.059,220.2Z",
    transform: "translate(-513.251 -165.645)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M580.094,220.391l0-.337a.481.481,0,0,1,.659-.056.293.293,0,0,1,.021.4C580.548,220.57,580.322,220.306,580.094,220.391Z",
    transform: "translate(-515.443 -165.491)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M582.416,220.364l-.032-.352a.106.106,0,0,1,.042-.161l.476.495Z",
    transform: "translate(-517.081 -165.46)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M582.091,218.01l.664,0q0,.168,0,.337l-.832.01c-.293.023-.277-.134-.189-.333Z",
    transform: "translate(-516.587 -164.135)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M580.446,218a.367.367,0,0,0,.189.333c0,.057,0,.114.007.171s-.026.108-.041.161l-.648.011-.005,0a.565.565,0,0,1,.177-.7Z",
    transform: "translate(-515.298 -164.113)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M438.922,112.242l-.038-.372a.405.405,0,0,1,.007-.52c.233-.121.44-.132.576.144a2.017,2.017,0,0,1-.244.757Z",
    transform: "translate(-413.408 -87.392)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M440.34,112.834c.061-.238-.041-.516.174-.715a.109.109,0,0,1,.173.008l.174.193c-.09.177-.364.234-.319.5.089.072.081.132-.022.178l-.143,0C440.367,112.945,440.355,112.889,440.34,112.834Z",
    transform: "translate(-414.525 -87.975)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M434.31,109.579c0-.048,0-.1-.007-.144,0-.362-.024-.723-.024-1.085a.613.613,0,0,1,.509-.278.748.748,0,0,1,.353.076,2.983,2.983,0,0,1,.551.448.33.33,0,0,1-.022.338c-.32.11-.419.394-.518.677-.223.2-.463-.1-.688.024A1.379,1.379,0,0,1,434.31,109.579Z",
    transform: "translate(-410.148 -85.093)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M436.9,111.746c-.434-.659-.106-.764.483-.681l.08.065-.035.1-.055.478Z",
    transform: "translate(-411.896 -87.227)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M457.889,119.408c.115.187.226.007.339,0,.133.457-.215.549-.507.683-.215-.164-.466.008-.824-.212l.657-.467h0A.221.221,0,0,1,457.889,119.408Z",
    transform: "translate(-426.481 -93.188)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M455.614,110.315c.057-.061.1-.145.174-.178.266-.125-.093-.559.3-.6a.228.228,0,0,1,.177.132.649.649,0,0,1-.247.748,1.854,1.854,0,0,0-.231.241h-.167Q455.615,110.485,455.614,110.315Z",
    transform: "translate(-425.554 -86.145)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M458.719,117.416h-.334a.85.85,0,0,0-.339-.853h.506Z",
    transform: "translate(-427.311 -91.196)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M446.685,109.832l-.194-.308a.916.916,0,0,1,.046-.43.463.463,0,0,1,.135-.173.477.477,0,0,1,.326-.027.537.537,0,0,1,.339.277C447.36,109.634,447.171,109.882,446.685,109.832Z",
    transform: "translate(-418.963 -85.672)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M448.677,108.709a.362.362,0,0,1-.335-.183.392.392,0,0,1,.668-.169h0A.324.324,0,0,1,448.677,108.709Z",
    transform: "translate(-420.303 -85.209)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M441.334,109.337c.016.137.012.265-.137.331l-1.135,0a1.042,1.042,0,0,1-.868-.035l-.041.018.023-.346.094-.1a1.667,1.667,0,0,1,.789-.131,3.635,3.635,0,0,1,1.072.079A.552.552,0,0,1,441.334,109.337Z",
    transform: "translate(-413.668 -85.817)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M439.3,111.064l.868.035-.231.3-.173-.008c-.113-.178-.292-.139-.458-.144Z",
    transform: "translate(-413.774 -87.244)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M440.99,114.459l.023-.178c.266-.1.529-.314.8-.014A1.946,1.946,0,0,1,440.99,114.459Z",
    transform: "translate(-414.994 -89.437)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M434,106.429l-.51.166q-.09.158-.183,0l-.143-.166c.34-.2.187-.787.674-.867.143-.026.2.034.176.178.056.154.186.177.323.189a.256.256,0,0,1,.059.312C434.305,106.382,434.108,106.3,434,106.429Z",
    transform: "translate(-409.347 -83.285)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M433.368,109.25l.183,0c.136.343.53.685.007,1.033C432.992,110.032,433.373,109.6,433.368,109.25Z",
    transform: "translate(-409.403 -85.938)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    d: "M430.776,105.3a.482.482,0,0,1,.492-.338c.15-.04.208.023.191.172l-.361.346Z",
    transform: "translate(-407.619 -82.849)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    d: "M435.6,103.559l-.176-.178c0-.055-.006-.11-.008-.165-.113-.444-.119-.8.511-.663-.234.585.5.162.506.5-.45.339.132.335.167.513Z",
    transform: "translate(-410.924 -81.103)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M434.946,101.719c-.4.036-.447.358-.511.663l-.333.007c-.175-.174-.09-.344.008-.513l.152-.166c0-.055.009-.11.016-.165l-.008-.015a.468.468,0,0,1,.354-.168l.32.176Q434.945,101.628,434.946,101.719Z",
    transform: "translate(-409.948 -80.268)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M433.213,103.016l-.161.515-.315.165-.191-.172v-.332C432.734,103,432.936,102.862,433.213,103.016Z",
    transform: "translate(-408.897 -81.41)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M432.159,102.76l-.667.176c-.152-.025-.383.049-.4-.171-.018-.18.188-.163.32-.167.25-.007.5,0,.751,0A.873.873,0,0,1,432.159,102.76Z",
    transform: "translate(-407.843 -81.154)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M414.3,96.693q0-.088.009-.176l.67,0,.34.678h-.671C414.673,96.93,414.411,96.864,414.3,96.693Z",
    transform: "translate(-395.721 -76.785)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    d: "M435.323,100.5a.332.332,0,0,1-.354.168q0-.252,0-.5l.343.171A.447.447,0,0,0,435.323,100.5Z",
    transform: "translate(-410.647 -79.409)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M402.358,95.44l-.213.027-.134-.024a.235.235,0,0,1-.033-.333l.036.008a.18.18,0,0,1,.3,0Z",
    transform: "translate(-386.785 -75.72)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M401.7,95.3q.016.166.033.333l-.194-.169a1.055,1.055,0,0,0,0-.145A.729.729,0,0,1,401.7,95.3Z",
    transform: "translate(-386.506 -75.91)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M507.858,171.409l.148-.132a.292.292,0,0,1,.136-.144c.22-.111.321-.355.524-.487.16-.089.334-.146.493-.238a.591.591,0,0,1,.559-.073.735.735,0,0,1,.313.37c.073.235.2.47.006.707l-.166.173c-.327.023-.179.37-.339.507l-.489.014c-.2-.2-.391-.436-.7-.175a.957.957,0,0,1-.158-.04C508.067,171.734,507.781,171.7,507.858,171.409Z",
    transform: "translate(-463.271 -129.827)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M530.128,173.161c-.189.005-.391-.036-.522.16l-.333-.169-.165-.679a.275.275,0,0,1,.226-.23,1.608,1.608,0,0,1,.763.493C530.2,172.871,530.256,173.009,530.128,173.161Z",
    transform: "translate(-478.624 -131.231)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M527.926,170.485l-.162.174c-.2-.13-.5-.146-.517-.478a.533.533,0,0,1,.117-.353.388.388,0,0,1,.227-.108C528.011,169.836,528.187,170.063,527.926,170.485Z",
    transform: "translate(-477.281 -129.417)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    d: "M522.551,178.58c-.81-.02-.144-.61-.329-.872a.237.237,0,0,1,.329.019C522.5,178.011,522.738,178.3,522.551,178.58Z",
    transform: "translate(-473.592 -135.119)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M521.716,171.114c-.1.577-.613.1-.849.338a.43.43,0,0,1-.12-.336.489.489,0,0,1,.106-.218.5.5,0,0,1,.35-.063A.819.819,0,0,1,521.716,171.114Z",
    transform: "translate(-472.586 -130.213)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    d: "M522.705,176.61l-.329-.019a.7.7,0,0,0-.024-.152c.285-.2.571-.659.858,0C523.092,176.645,522.852,176.487,522.705,176.61Z",
    transform: "translate(-473.746 -134.002)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    d: "M524.728,169.677l-.353.063a.25.25,0,0,1-.4-.118.327.327,0,0,1,.133-.318,1.765,1.765,0,0,1,.553-.169.47.47,0,0,1,.222.028.309.309,0,0,1,.1.195.585.585,0,0,1-.06.214A.415.415,0,0,1,524.728,169.677Z",
    transform: "translate(-474.915 -128.993)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    d: "M518.859,171.04c.007.125.015.25.023.375h-.338a.352.352,0,0,0-.34-.174c-.1-.052-.2-.108-.207-.248a.342.342,0,0,1,.368-.219A.735.735,0,0,1,518.859,171.04Z",
    transform: "translate(-470.602 -130.175)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    d: "M523.623,177.479c.123-.193.325-.15.5-.173.026.146.352.2.18.374C524.009,177.979,523.861,177.526,523.623,177.479Z",
    transform: "translate(-474.664 -134.871)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    d: "M522.819,170.364c.075.17.234.162.379.183a.351.351,0,0,1-.33.155c-.186-.008-.389.033-.51-.173-.056-.147.03-.214.145-.266A.3.3,0,0,1,522.819,170.364Z",
    transform: "translate(-473.739 -129.801)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    d: "M526.7,170.735l.177-.132.116.008-.141.2Z",
    transform: "translate(-476.884 -130.051)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M513.276,174.924c.107-.257-.448-.361-.164-.622a.34.34,0,0,1,.5.115l.185.173-.188.335Z",
    transform: "translate(-467.015 -132.66)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M515.967,171.373l.165.169-.331.517h-.506l-.168-.689A.581.581,0,0,1,515.967,171.373Z",
    transform: "translate(-468.529 -130.475)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    d: "M519.836,176.7c-.044.507-.348.065-.51.143a.739.739,0,0,0,.008-.134Z",
    transform: "translate(-471.561 -134.437)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M527.746,177.035c-.032.522.293,1.256-.7,1.212-.328.066-.656.253-.982,0,.388-.36.918-.6,1.012-1.209A.575.575,0,0,1,527.746,177.035Z",
    transform: "translate(-476.427 -134.598)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M530.375,176.463h-.669l.338-.331C530.268,176.126,530.37,176.245,530.375,176.463Z",
    transform: "translate(-479.057 -134.026)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M530.316,182.379c.168-.079.323-.23.528-.117a.151.151,0,0,1,.054.135c-.139.255-.384.106-.581.144C530.316,182.486,530.315,182.432,530.316,182.379Z",
    transform: "translate(-479.497 -138.404)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M552.921,205.4c-.081-.21.549-.211.148-.515-.1-.118-.258-.178-.326-.33q.014-.2.029-.4a.252.252,0,0,1,.075-.11c.29,0,.58,0,.87,0a.772.772,0,0,1,.369.065.75.75,0,0,1,.317.38c0,.362.516.708.037,1.087v0l-.512,0c-.14-.168-.069-.36-.065-.533.029-.123-.19.006-.079-.009.029,0,.026.013.03.046.037.316-.035.5-.392.329Z",
    transform: "translate(-495.692 -154.098)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M555.533,201.2l-.335-.661a.681.681,0,0,1,.625-.167.618.618,0,0,1,.242.116.541.541,0,0,1,.085.515.553.553,0,0,1-.264.289A.309.309,0,0,1,555.533,201.2Z",
    transform: "translate(-497.465 -151.442)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M555.856,198.234h-.673q0-.171,0-.341a.907.907,0,0,1,.172-.626v-.059c.052-.071.107-.077.163,0l.016.024C555.609,197.571,556.089,197.784,555.856,198.234Z",
    transform: "translate(-497.45 -149.138)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    d: "M554.025,203.778c-.307-.016-.642.144-.9-.149.153-.2.365-.167.573-.154C553.776,203.607,554.112,203.454,554.025,203.778Z",
    transform: "translate(-495.964 -153.679)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    d: "M555.514,203.7l-.332-.3.339-.04.339.023a.259.259,0,0,1,.006.346Z",
    transform: "translate(-497.453 -153.601)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    d: "M549.107,184.107c-.188.182-.349.416-.664.343-.017-.184.026-.387-.167-.513a.318.318,0,0,1-.106-.193.521.521,0,0,1,.053-.22.621.621,0,0,1,.446-.321c.275.1.354.373.5.588A.29.29,0,0,1,549.107,184.107Z",
    transform: "translate(-492.39 -139.111)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1890",
    "data-name": "Path 1890",
    d: "M546.786,184.916c0,.056.012.111.022.166l-.349.515-.165,0a.58.58,0,0,1-.157-.366.522.522,0,0,1,.151-.371A.4.4,0,0,1,546.786,184.916Z",
    transform: "translate(-490.922 -140.256)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1891",
    "data-name": "Path 1891",
    d: "M544.938,186.066q0,.173.008.346a.348.348,0,0,0-.339.172l-.337,0v-.513A.474.474,0,0,1,544.938,186.066Z",
    transform: "translate(-489.574 -141.074)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1892",
    "data-name": "Path 1892",
    d: "M551.542,184.439l0-.339c.015-.033.03-.067.043-.1.167-.2.335-.406.644-.31a.464.464,0,0,1,.22.25,1.006,1.006,0,0,1-.108.559.487.487,0,0,1-.462.287l-.335-.009C551.545,184.664,551.544,184.552,551.542,184.439Z",
    transform: "translate(-494.825 -139.443)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    d: "M554.62,187.924l-.5.516-.192-.009q.012-.162.024-.324c.19-.223.07-.6.367-.767a.33.33,0,0,1,.354.082A.541.541,0,0,1,554.62,187.924Z",
    transform: "translate(-496.546 -142.071)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M553.447,186.663a.635.635,0,0,1-.337.676.332.332,0,0,0-.343-.356q0-.169,0-.337l.339-.344C553.478,186.166,553.565,186.314,553.447,186.663Z",
    transform: "translate(-495.706 -141.303)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M556.185,184.309l0-.527c-.242-.406.076-.675.231-.985a2.924,2.924,0,0,1,.411-.425.571.571,0,0,1,.345-.077.524.524,0,0,1,.22.1.154.154,0,0,1-.021.211l-.173.509h0c-.238.159-.2.466-.346.671l-.331.18Z",
    transform: "translate(-498.111 -138.457)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    d: "M556.054,193.72a1.032,1.032,0,0,0-.159.681.335.335,0,0,1-.314.174c-.114.019-.128-.1-.19-.146l-.179-.046.327-.657Z",
    transform: "translate(-497.476 -146.672)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    d: "M555.817,196.241l.189.146c-.013.054-.027.107-.041.16l-.081.007-.082,0Z",
    transform: "translate(-497.901 -148.485)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1898",
    "data-name": "Path 1898",
    d: "M531.185,165.89a.409.409,0,0,0-.182-.366,2.416,2.416,0,0,1-.284-2.165c.158-.4-.145-.839.115-1.227l.338,0a3.336,3.336,0,0,1,.661,3,.746.746,0,0,0-.216.685c-.032.149-.051.312-.271.249Z",
    transform: "translate(-479.681 -123.96)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1899",
    "data-name": "Path 1899",
    d: "M533.353,174.59c.147-.076.149-.216.15-.355.057-.374.236-.246.419-.1a.542.542,0,0,1,.046.373.513.513,0,0,1-.228.29.2.2,0,0,1-.222-.042Z",
    transform: "translate(-481.69 -132.486)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1900",
    "data-name": "Path 1900",
    d: "M533.93,176.675a1.4,1.4,0,0,1,.158-.011c.165.065.27.162.191.36q0,.081-.012.162a.388.388,0,0,0-.167.357C533.813,177.3,533.976,176.967,533.93,176.675Z",
    transform: "translate(-482.103 -134.409)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1901",
    "data-name": "Path 1901",
    d: "M543.322,173.874h-.334l-.031-.115c.6-.743,1.285-1.455,1.032-2.54-.08-.345.4-.291.344-.588a.585.585,0,0,1,.314-.23.373.373,0,0,1,.2.012.579.579,0,0,1,.144.153,2.133,2.133,0,0,1,.219.612c.052.223.128.439.169.665a4.015,4.015,0,0,1-.021,1.227,1.751,1.751,0,0,1-.9,1.089A1.394,1.394,0,0,1,543.322,173.874Z",
    transform: "translate(-488.625 -129.9)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1902",
    "data-name": "Path 1902",
    d: "M539.7,160.91h.169c.121.33.639.594.167,1.024-.593.3-.19.706-.1,1.066-.223.2-.688-.324-.711.256-.007.188.219.058.34.064a.237.237,0,0,1-.027.318c-.185-.135-.387.472-.573-.013-.014-.035-.131-.03-.2-.043-.008.105-.058.231-.018.312.369.748-.042,1.206-.569,1.627-.19-.11-.02-.219,0-.328-.015-.181-.243-.262-.212-.465.421-.457.211-1.066.373-1.585.041-.078.145-.048.193-.114a.511.511,0,0,0-.192.108.257.257,0,0,1-.3.052.279.279,0,0,1-.1-.2.492.492,0,0,1,.239-.376c.305-.3.112-.681.172-1.02C538.937,161.628,539.475,161.579,539.7,160.91Z",
    transform: "translate(-485.008 -123.082)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1903",
    "data-name": "Path 1903",
    d: "M543.705,169.77q.013-.159.027-.318l.795-.014c.212.166.641-.14.712.334-.079.15-.227.15-.365.172C544.506,169.739,544.054,170.106,543.705,169.77Z",
    transform: "translate(-489.166 -129.215)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1904",
    "data-name": "Path 1904",
    d: "M540.433,182.19a.234.234,0,0,0,.031.115c-.07.208-.272.155-.417.216l-.585-.069C539.659,181.884,540.094,182.219,540.433,182.19Z",
    transform: "translate(-486.102 -138.33)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1905",
    "data-name": "Path 1905",
    d: "M536.01,174.207c.216.071.42.145.15.4-.172.029-.333-.2-.511-.021a.365.365,0,0,1-.2.124.328.328,0,0,1-.313-.132l.022-.361a.528.528,0,0,1,.474-.214A.628.628,0,0,1,536.01,174.207Z",
    transform: "translate(-482.982 -132.498)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1906",
    "data-name": "Path 1906",
    d: "M535.719,176.088a.925.925,0,0,1,.165-.01c.1.225.288.465.049.689-.193.181-.24-.143-.385-.171C535.356,176.341,535.531,176.212,535.719,176.088Z",
    transform: "translate(-483.215 -133.988)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    d: "M535.032,176.069l-.171.508c-.053,0-.105,0-.157.006l-.19-.36.174-.172Z",
    transform: "translate(-482.529 -133.969)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1908",
    "data-name": "Path 1908",
    d: "M535.327,179.4a1.291,1.291,0,0,1-.161-.841C535.3,178.824,535.6,179.056,535.327,179.4Z",
    transform: "translate(-482.992 -135.772)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1909",
    "data-name": "Path 1909",
    d: "M544.27,182.782l1.165.174a.21.21,0,0,1,.013.331l-.011.182-.491,0a.229.229,0,0,1-.337,0Z",
    transform: "translate(-489.574 -138.808)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    d: "M544.6,185.2l.337,0c0,.112-.006.223-.009.335l-.668.011c0-.058,0-.117,0-.175A.361.361,0,0,1,544.6,185.2Z",
    transform: "translate(-489.566 -140.546)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    d: "M578.511,217.155a1.233,1.233,0,0,1-.177.7l-.335,0-.34-.681.5-.332C578.388,216.817,578.5,216.93,578.511,217.155Z",
    transform: "translate(-513.684 -163.29)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    d: "M573.767,214.171a.388.388,0,0,1,.5.026c-.134.512-.552.244-.847.316l.165-.334A.11.11,0,0,1,573.767,214.171Z",
    transform: "translate(-510.622 -161.32)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    d: "M576.97,213.192q.005.252.011.5l-.506-.186A.471.471,0,0,1,576.97,213.192Z",
    transform: "translate(-512.83 -160.671)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    d: "M572.893,213.471l-.184.008-.5-.015c0-.116,0-.231,0-.346C572.474,213.163,572.833,213.02,572.893,213.471Z",
    transform: "translate(-509.748 -160.62)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    d: "M503.88,167.22l.5.04a.336.336,0,0,1,0,.484l-.354.01a2.03,2.03,0,0,0-.322.334l-.3.165a1.771,1.771,0,0,0-.353-1.024q.076,0,.153,0A.5.5,0,0,1,503.88,167.22Z",
    transform: "translate(-459.811 -127.529)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    d: "M503.258,171.218l-.185.165a.684.684,0,0,1-.165-.146h-.027c0-.065,0-.13-.005-.2l.1-.048.087.066.178,0A1.145,1.145,0,0,1,503.258,171.218Z",
    transform: "translate(-459.682 -130.333)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    d: "M502.506,170.778l-.142-.15c.049,0,.1,0,.148,0a.125.125,0,0,1,.064.108c0,.045-.008.067-.019.067Z",
    transform: "translate(-459.313 -130.069)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1918",
    "data-name": "Path 1918",
    d: "M502.943,170.81l-.046-.175.18.166A.688.688,0,0,0,502.943,170.81Z",
    transform: "translate(-459.698 -130.074)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    d: "M509.109,170.538c-.176.16-.072.611-.508.5a.423.423,0,0,1-.166-.365q0-.158,0-.316l.5-.342v.007a.411.411,0,0,1,.121.142A.806.806,0,0,1,509.109,170.538Z",
    transform: "translate(-463.695 -129.629)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1920",
    "data-name": "Path 1920",
    d: "M507.32,172.358a.386.386,0,0,1,.166.365l-.171.04c-.159-.064-.462.038-.423-.259C506.917,172.311,507.167,172.388,507.32,172.358Z",
    transform: "translate(-462.581 -131.313)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    d: "M505.413,169.612c.028-.189-.108-.541.322-.334a.315.315,0,0,1-.154.338Z",
    transform: "translate(-461.515 -129.053)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    d: "M502.991,171.859l.166.146c-.05.013-.1.024-.152.032Z",
    transform: "translate(-459.766 -130.954)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    d: "M504.271,166.264l-.673.011a.473.473,0,0,1,.326-.509.385.385,0,0,0,.35.189Q504.272,166.109,504.271,166.264Z",
    transform: "translate(-460.202 -126.573)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    d: "M514.063,146.846c-.334-.231-.858-.269-.844-.852.108-.192.352-.066.489-.2a2.217,2.217,0,0,0-.592-.43.9.9,0,0,1-.291-.2.69.69,0,0,1-.069-.587.452.452,0,0,1,.139-.184.939.939,0,0,0,.8-.631.442.442,0,0,1,.428.056c.349.3.768.092,1.149.157a1.034,1.034,0,0,1,.2.074c.248.156.469,0,.7-.067a.844.844,0,0,1,.351-.017c.226.06.364.184.323.443a10.008,10.008,0,0,1-.721.8,1.648,1.648,0,0,1-.666.193c-.629-.128-.264.558-.559.7C514.669,146.408,514.537,146.822,514.063,146.846Z",
    transform: "translate(-466.792 -110.726)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    d: "M515.8,152.493l.681-.857c.407-.182.435.092.45.382-.031.2-.2.343-.224.549a3.9,3.9,0,0,0-.025.558,1.126,1.126,0,0,0,.2.73.563.563,0,0,1,.041.347c-.046.122-.118.208-.263.182-.434-.166-.543-.57-.714-.948-.154-.34-.262-.16-.313.083l-.505-.171c0-.057,0-.114,0-.171C515.366,152.967,515.746,152.9,515.8,152.493Z",
    transform: "translate(-468.526 -116.373)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    d: "M512.747,148.762c.091.064.217.108.268.2.167.288.783.313.63.673-.161.377-.582-.141-.9-.014a.355.355,0,0,1-.338-.172c-.081-.137-.38-.029-.338-.281.033-.2.231-.214.39-.257A.728.728,0,0,0,512.747,148.762Z",
    transform: "translate(-466.32 -114.348)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    d: "M509.5,148.928c-.062.162-.625.141-.175.49h-.842a.273.273,0,0,0-.172,0l-.507,0q0-.238-.007-.475l.529-.069A1.074,1.074,0,0,1,509.5,148.928Z",
    transform: "translate(-463.238 -114.321)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M509.371,150.971c.056-.113.114-.118.172,0q0,.512,0,1.024A.86.86,0,0,1,509.371,150.971Z",
    transform: "translate(-464.296 -115.874)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    d: "M512.7,166.295l.337,0q.083,0,.167,0c.2-.089.3.028.389.178a.437.437,0,0,1-.213.42.68.68,0,0,1-.482.054.428.428,0,0,1-.2-.142Z",
    transform: "translate(-466.775 -126.929)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    d: "M514.7,164.561l.837,0a.3.3,0,0,1,.025.382.625.625,0,0,1-.243.13.973.973,0,0,1-.787-.177Z",
    transform: "translate(-468.098 -125.704)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1931",
    "data-name": "Path 1931",
    d: "M514.516,165.746l.845.021a.4.4,0,0,1,.087.371c-.222.333-.418.251-.6-.039l-.336-.178C514.513,165.863,514.514,165.8,514.516,165.746Z",
    transform: "translate(-468.085 -126.559)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    d: "M520.6,160.907l.175-.17c.321-.226.42.049.553.249a.688.688,0,0,1,.046.241.557.557,0,0,1-.24.409.455.455,0,0,1-.349.028.33.33,0,0,1-.2-.276Z",
    transform: "translate(-472.47 -122.897)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    d: "M518.826,163.271l.178.2c.073.259-.1.364-.281.469-.188.058-.375.161-.566.009q0-.156-.008-.313l.2-.033Z",
    transform: "translate(-470.711 -124.78)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    d: "M507.832,168.1q0-.242,0-.484l.339-.024C508.167,167.84,508.177,168.091,507.832,168.1Z",
    transform: "translate(-463.258 -127.888)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M511.832,168.184l.172.008a.257.257,0,0,1-.035.3.465.465,0,0,1-.18.123.281.281,0,0,1-.292-.1A.307.307,0,0,1,511.832,168.184Z",
    transform: "translate(-465.908 -128.312)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    d: "M510.609,169.374l.335.011c.057.28-.156.345-.338.435a.351.351,0,0,1-.337-.091c0-.056,0-.111,0-.167Z",
    transform: "translate(-465.02 -129.168)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    d: "M510.879,148.292l-1.174-.056.151-.273.341-.036c.235-.189.37-.033.5.147l.345.026Z",
    transform: "translate(-464.614 -113.686)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    d: "M504,141.059l.669-.153c.347.074.473.24.227.559-.126.3-.538.486-.365.912-.244.309-.611.114-.9.227-.3-.065-.095-.783-.652-.517q0-.169,0-.339a.792.792,0,0,1,.337-.392C503.6,141.4,503.667,140.916,504,141.059Z",
    transform: "translate(-459.753 -108.7)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    d: "M505.32,144.075c.2-.339.662-.018.866-.349a.5.5,0,0,1,.489-.332c.5.145.793-.3,1.191-.443a.346.346,0,0,1,.228.1c.168.52-.17.7-.556.85v.017c-.179.259-.348.235-.509-.018a3.045,3.045,0,0,1-1.682.343A1.091,1.091,0,0,0,505.32,144.075Z",
    transform: "translate(-461.447 -110.17)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1940",
    "data-name": "Path 1940",
    d: "M498.738,147.723q0-.087,0-.174l.5,0a.493.493,0,0,1-.333.5A.331.331,0,0,0,498.738,147.723Z",
    transform: "translate(-456.695 -113.475)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1941",
    "data-name": "Path 1941",
    d: "M511.471,146.325a.466.466,0,0,0,.509.018q0,.321-.008.641l-.5-.147Q511.472,146.581,511.471,146.325Z",
    transform: "translate(-465.889 -112.596)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1942",
    "data-name": "Path 1942",
    d: "M495.674,134.168v.341l-.337,0c-.195-.046-.446.1-.606-.22C495.03,134.077,495.367,134.207,495.674,134.168Z",
    transform: "translate(-453.801 -103.853)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1943",
    "data-name": "Path 1943",
    d: "M482.471,124.981l.187.5c0,.112,0,.224,0,.336-.02.187.031.4-.183.517l-.173-.848q.005-.256.011-.512C482.37,124.909,482.422,124.909,482.471,124.981Z",
    transform: "translate(-444.826 -97.21)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    d: "M480.62,124.605l-.079-.01h-.079l-.677,0a.1.1,0,0,1-.043-.1c.011-.036.023-.055.035-.055l.18-.022,1.173-.007.493,0c0,.062.01.124.016.185Z",
    transform: "translate(-442.976 -96.835)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    d: "M477.47,126.88v-.343a.484.484,0,0,1,.676,0q0,.17,0,.34Z",
    transform: "translate(-441.337 -98.272)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    d: "M477.977,124.45c0,.053.006.105.007.158v.17a.514.514,0,0,1-.638.063.244.244,0,0,1-.038-.363l.169-.051Z",
    transform: "translate(-441.174 -96.852)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    "data-name": "Path 1947",
    d: "M477.353,125.677h.675v.342l-.675,0-.006-.171a.1.1,0,0,1-.035-.113C477.326,125.7,477.34,125.677,477.353,125.677Z",
    transform: "translate(-441.218 -97.751)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    d: "M475.727,124.787c0,.056,0,.112-.006.168l-.159,0-.509-.173.342-.345.33.048C475.726,124.587,475.726,124.687,475.727,124.787Z",
    transform: "translate(-439.591 -96.86)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    d: "M555.188,207.369c.33-.006.346-.279.367-.6.22.3.1.547.138.769q-.083,0-.166.01l-.341-.013C555.188,207.479,555.188,207.424,555.188,207.369Z",
    transform: "translate(-497.457 -156.053)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    d: "M552.278,205.866c.2.016.342.094.326.33-.142-.127-.627.307-.476-.3A.355.355,0,0,1,552.278,205.866Z",
    transform: "translate(-495.227 -155.405)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1951",
    "data-name": "Path 1951",
    d: "M569.558,207.969q0,.177,0,.353c-.477-.007-.619-.527-1.006-.672a.86.86,0,0,1,.157-.649.188.188,0,0,1,.2-.1l.109.052c.151.137.315.268.215.513Z",
    transform: "translate(-507.102 -156.151)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    d: "M566.915,205.74l-.176.046-.844-.027-.069-.1a.319.319,0,0,1,.108-.338.914.914,0,0,1,.73-.05.541.541,0,0,1,.279.239A.265.265,0,0,1,566.915,205.74Z",
    transform: "translate(-505.132 -154.937)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    d: "M563.836,206.957l-.506.02c-.261-.013-.408-.113-.306-.406a.574.574,0,0,1,.231-.117.674.674,0,0,1,.61.157l-.009.027Z",
    transform: "translate(-503.092 -155.815)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    d: "M558.36,206.43c.237-.388-.332-.655-.153-1.035a.515.515,0,0,1,.333-.163.76.76,0,0,1,.477.1.428.428,0,0,1,.146.3,3.244,3.244,0,0,1-.121.619c0,.059,0,.118-.006.177Z",
    transform: "translate(-499.612 -154.947)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    d: "M561.082,207.334a.389.389,0,0,1,0-.485.291.291,0,0,1,.473.006l.334.333C561.672,207.527,561.319,207.1,561.082,207.334Z",
    transform: "translate(-501.652 -156.027)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    d: "M499.219,138.929a.263.263,0,0,0,.029.123.341.341,0,0,1-.015.484c-.659.053-.549-.268-.309-.652C499.037,138.8,499.146,138.744,499.219,138.929Z",
    transform: "translate(-456.694 -107.19)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    d: "M500.523,140.162c0-.161.01-.323.014-.484l.277.162c.3-.134.351.115.441.3,0,.146-.045.246-.217.214l-.5-.007C500.532,140.286,500.528,140.224,500.523,140.162Z",
    transform: "translate(-457.984 -107.817)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    d: "M498.765,138.224l-.3-.045-.361-.014c.061-.452.412-.309.678-.339Z",
    transform: "translate(-456.24 -106.485)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M501.933,141.459l.173-.161a.273.273,0,0,1,.358-.035.279.279,0,0,1-.029.363.31.31,0,0,1-.336.342l-.338,0Z",
    transform: "translate(-458.878 -108.921)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M563.7,193.716h.505c.182.217.472.353.507.683l-1.013,1.12A6.191,6.191,0,0,0,563.7,193.716Z",
    transform: "translate(-503.601 -146.669)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M560.752,202.877l.009.325a.488.488,0,0,1-.328.184,1.289,1.289,0,0,1-.505-.039c-.28-.135-.7-.059-.773-.515a.248.248,0,0,1,.142-.186c.313.082.663,0,.945.216Z",
    transform: "translate(-500.323 -153.089)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M558.241,200.633q0-.25,0-.5a.371.371,0,0,1,.17-.341h.673l-.506.686c.059.034.079.067.06.1s-.038.052-.058.052l0,.037A.237.237,0,0,1,558.241,200.633Z",
    transform: "translate(-499.661 -151.038)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M559.452,202.374c0-.051,0-.1,0-.154.36.032.786-.137,1.005.333A1.485,1.485,0,0,1,559.452,202.374Z",
    transform: "translate(-500.536 -152.781)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M568.911,204.3l-.163-.166a.623.623,0,0,1-.139-.353.534.534,0,0,1,.155-.344l.338,0,.169,0q0,.167,0,.334C569.431,204.142,569.48,204.436,568.911,204.3Z",
    transform: "translate(-507.15 -153.655)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M563.16,204.636l.345-.012h.337l.066.076a.223.223,0,0,1-.07.267q0,.17,0,.341l-.664-.018c-.146-.064-.266-.145-.2-.338C563.014,204.833,563.476,204.97,563.16,204.636Z",
    transform: "translate(-503.067 -154.512)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M566.964,203.417l-.005.348a.663.663,0,0,1-.843,0l.008-.013C566.237,203.2,566.67,203.492,566.964,203.417Z",
    transform: "translate(-505.349 -153.636)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M557.034,198.085a.357.357,0,0,1-.17.341h-.172c-.077-.347-.468-.59-.327-1.009C556.614,197.613,556.981,197.688,557.034,198.085Z",
    transform: "translate(-498.286 -149.329)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    d: "M560.4,181.041l-.006-.173c-.2-.239-.063-.443.065-.649a.319.319,0,0,1,.206-.1.277.277,0,0,1,.23.237l-.161.512Z",
    transform: "translate(-501.144 -136.893)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    d: "M558.816,185.887c.039-.264-.1-.622.346-.671l-.169.681Z",
    transform: "translate(-500.077 -140.558)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    d: "M569.695,205.16c.346-.018.366-.264.36-.528h.667l.178.179c.009.383-.376.4-.553.616a.618.618,0,0,1-.617-.1l-.014,0A.7.7,0,0,0,569.695,205.16Z",
    transform: "translate(-507.933 -154.517)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M572.2,205.757c-.033-.377.389-.288.508-.509.055,0,.111,0,.166-.008v.179a.224.224,0,0,1,0,.336l-.334.005A.232.232,0,0,1,572.2,205.757Z",
    transform: "translate(-509.74 -154.955)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    d: "M574.619,206.212l0-.336.666,0q0,.338.009.676l-.335,0A.32.32,0,0,0,574.619,206.212Z",
    transform: "translate(-511.489 -155.413)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M570.483,207.08l.336,0c-.049.4-.368.446-.669.515l-.33-.514Z",
    transform: "translate(-508.024 -156.278)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M561.053,171.743l.337,0c.548.188,1.247-.385,1.687.345a1.03,1.03,0,0,1-.292.211,2.079,2.079,0,0,1-1.162-.045c-.2-.1-.441-.052-.625-.2A.259.259,0,0,1,561.053,171.743Z",
    transform: "translate(-501.633 -130.841)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M569.766,173.549c-.038-.42.194-.509.556-.5s.475.2.451.526A1.616,1.616,0,0,1,569.766,173.549Z",
    transform: "translate(-507.981 -131.806)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M566.231,173.063h.338l.167.5-.038.113a.532.532,0,0,1-.406.216.7.7,0,0,1-.343-.057.328.328,0,0,1-.138-.176C565.754,173.325,566.158,173.312,566.231,173.063Z",
    transform: "translate(-505.125 -131.82)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M569.328,174.512c.341-.271.672-.04,1.007.021a1.158,1.158,0,0,0,.023.165l-.347,0c-.3.051-.635.272-.841-.168l-.014-.017Z",
    transform: "translate(-507.544 -132.769)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M564.925,169.336c.1-.182.365-.243.352-.5h.326q0,.161,0,.323A.978.978,0,0,1,564.925,169.336Z",
    transform: "translate(-504.489 -128.778)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M567.661,174.92c.237.277.561.11.841.167-.284.29-.726.083-1.022.334l-.337,0a.226.226,0,0,1,0-.337Z",
    transform: "translate(-506.035 -133.155)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M563.669,174.916l-.3.169a.162.162,0,0,1-.237,0,.752.752,0,0,1-.143-.379.946.946,0,0,1,.138-.651c.409-.251.526.138.728.341l.008,0C563.92,174.623,563.544,174.674,563.669,174.916Z",
    transform: "translate(-503.085 -132.478)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M562.326,177.888l.188.008-.2.678-.333.178-.161-.179C561.748,178.162,561.853,177.886,562.326,177.888Z",
    transform: "translate(-502.233 -135.289)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M565.318,176c-.162-.256.081-.358.19-.511l.332,0q0,.169,0,.337l-.334.185Z",
    transform: "translate(-504.734 -133.564)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M533.344,141.848c-.067.449.5.719.332,1.2-.169.019-.315.073-.325.276-.026.534-.223.1-.349.065a.294.294,0,0,1-.1-.168,1.792,1.792,0,0,1,.062-.39,1.1,1.1,0,0,0-.011-.29,1.075,1.075,0,0,1-.053-.61.332.332,0,0,1,.145-.155.4.4,0,0,1,.215,0Z",
    transform: "translate(-481.343 -109.313)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M529.758,148.938c-.225-.083-.45.176-.675,0a.688.688,0,0,1-.215-.671,1.41,1.41,0,0,1,.5-.334c.182-.084.364-.2.555-.021l.174.171C529.808,148.3,530.049,148.725,529.758,148.938Z",
    transform: "translate(-478.438 -113.67)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M532.1,149.612c.074-.3-.2-.743.338-.855a2.722,2.722,0,0,0,.17,1.366A.478.478,0,0,1,532.1,149.612Z",
    transform: "translate(-480.783 -114.345)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M530.833,147l-.5.17a.436.436,0,0,1-.206-.518.38.38,0,0,1,.332-.093.549.549,0,0,1,.371.275C530.835,146.894,530.834,146.949,530.833,147Z",
    transform: "translate(-479.35 -112.763)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M531.742,146.451a.354.354,0,0,1-.333-.17.16.16,0,0,1,0-.217c.243-.11.4-.006.5.215,0,.056,0,.113,0,.169Z",
    transform: "translate(-480.257 -112.377)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M537.471,140.85c.279.041.6-.117.831.16l-.841.018-.036-.092Z",
    transform: "translate(-484.63 -108.653)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    d: "M535.384,141.012c-.235.273-.55.12-.829.16h-.006c.181-.551.524-.328.851-.183Z",
    transform: "translate(-482.554 -108.638)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M528.659,162.119a2.239,2.239,0,0,1,.011,1.636c-.251.61.324,1.15.159,1.756l-.676-.5c.014-.37-.054-.675-.513-.679l-.065-.091a.948.948,0,0,1,.076-.555c.136-.229.3-.441.424-.676a.33.33,0,0,0,.035-.491.428.428,0,0,1-.027-.327l.073-.084Z",
    transform: "translate(-477.508 -123.946)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1991",
    "data-name": "Path 1991",
    d: "M535.131,162.661a.358.358,0,0,1-.17.344c-.5.073-.594-.359-.8-.656-.058-.375-.636-.56-.383-1.051.18-.1.25-.411.535-.3s.3.331.258.615C534.505,162.08,535.175,162.182,535.131,162.661Z",
    transform: "translate(-481.953 -123.128)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1992",
    "data-name": "Path 1992",
    d: "M533.069,162.129c-.047.45.647.526.506,1.023.216.7.517,1.408-.1,2.067a.241.241,0,0,1-.232-.021,5.6,5.6,0,0,0-.508-3.069Z",
    transform: "translate(-481.241 -123.959)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    d: "M527.738,159.565c0,.054,0,.108-.006.162l0,0c-.635.091-.816-.241-.739-.813a.317.317,0,0,1,.245-.121C527.663,158.878,527.983,159.033,527.738,159.565Z",
    transform: "translate(-477.084 -121.562)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    d: "M528.4,159.372c.1-.436-.309-.483-.508-.69a.48.48,0,0,1,.363-.156.512.512,0,0,1,.365.159.423.423,0,0,1-.055.508Z",
    transform: "translate(-477.75 -121.368)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    d: "M530.316,159.451l.006-.483a.209.209,0,0,1,.323-.013l0,.5Z",
    transform: "translate(-479.497 -121.626)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    d: "M529.744,154.237l.346.169c.213.312-.155.544-.111.832a.333.333,0,0,1-.338.116.511.511,0,0,1-.286-.226.5.5,0,0,1-.024-.35C529.5,154.626,529.385,154.243,529.744,154.237Z",
    transform: "translate(-478.771 -118.285)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1997",
    "data-name": "Path 1997",
    d: "M526.554,151.537l0,.336a.485.485,0,0,1,.1.421.34.34,0,0,1-.142.167.374.374,0,0,1-.319-.045,1.448,1.448,0,0,1-.382-.54.36.36,0,0,1,.044-.216.8.8,0,0,1,.387-.222A.323.323,0,0,1,526.554,151.537Z",
    transform: "translate(-476.247 -116.269)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1998",
    "data-name": "Path 1998",
    d: "M527.609,148.744a1.124,1.124,0,0,1,.166.675l-.167,0c-.218-.147-.6-.112-.569-.535.095-.264.224-.474.557-.359A.148.148,0,0,1,527.609,148.744Z",
    transform: "translate(-477.129 -114.152)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M528.482,153.513q0-.258,0-.517l.662.349c-.156.138.109.552-.325.508A.608.608,0,0,1,528.482,153.513Z",
    transform: "translate(-478.173 -117.392)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M526.237,149.359c.064.275.377.3.5.509l-.171,0-.328,0a.4.4,0,0,1-.291-.194c-.073-.183-.218-.368,0-.551C526.12,149.114,526.3,149.09,526.237,149.359Z",
    transform: "translate(-476.263 -114.605)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2001",
    "data-name": "Path 2001",
    d: "M531.549,155.635l.158-.8h.176l-.16.71q-.016.058-.038.114C531.625,155.729,531.578,155.723,531.549,155.635Z",
    transform: "translate(-480.388 -118.717)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    d: "M529.712,157.662a.271.271,0,0,0,.136.028c.138.316.534.095.7.346l-.853.036-.324.014-.348-.053c-.066-.17.024-.275.149-.366a.232.232,0,0,1,.2.037Z",
    transform: "translate(-478.551 -120.744)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    d: "M545.871,157.651a1.559,1.559,0,0,0,.176-.817c0-.179-.073-.475.211-.458s.306.3.28.534a7.405,7.405,0,0,1-.159.74c-.024.235.078.5-.168.682C545.792,158.261,545.7,158.024,545.871,157.651Z",
    transform: "translate(-490.67 -119.822)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    d: "M549.707,165.77h.168c.128.364.048.9.676.854-.021.433-.42.434-.673.6a.351.351,0,0,1-.341-.093v0a.229.229,0,0,1,0-.336C549.845,166.5,549.652,166.111,549.707,165.77Z",
    transform: "translate(-493.324 -126.576)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    d: "M545.121,160.914a.952.952,0,0,0,.339.681c-.149.144-.151.512-.507.342.161-.378-.338-.645-.167-1.024Z",
    transform: "translate(-489.92 -123.085)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    d: "M547.514,168.99q0,.168,0,.336c-.047,0-.093.005-.139.005l-.712-.335C546.943,168.628,547.23,168.958,547.514,168.99Z",
    transform: "translate(-491.301 -128.772)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    d: "M550.89,164.939c.1-.341.508-.252.676-.5.115-.057.114-.114,0-.171-.043-.038-.057-.076-.043-.114s.029-.057.043-.057c.281-.239.127-.565.168-.852-.031-.373.39-.289.506-.513h.337c-.093.315-.437.681.169.853v.341c-.3.354-.214.94-.809,1.15-.347.122.279.311.135.554-.113.234-.132.5-.221.737-.366.2-.57-.167-.856-.252a3.13,3.13,0,0,1-.092-.336A4.532,4.532,0,0,1,550.89,164.939Z",
    transform: "translate(-494.339 -124.394)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2008",
    "data-name": "Path 2008",
    d: "M552.934,166.138v.171c-.253-.192-.143-.44-.163-.739C553.018,165.768,552.9,165.97,552.934,166.138Z",
    transform: "translate(-495.707 -126.433)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2009",
    "data-name": "Path 2009",
    d: "M534.344,140.553c-.282.068-.616-.11-.851.183l-.337-.012a.209.209,0,0,1,0-.313,2.519,2.519,0,0,1,1.177-.178c0,.055,0,.11,0,.165S534.34,140.5,534.344,140.553Z",
    transform: "translate(-481.498 -108.201)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2010",
    "data-name": "Path 2010",
    d: "M553.851,177.493a.305.305,0,0,1-.335.341l-.108-.025a3.81,3.81,0,0,0-.988-.157.5.5,0,0,1-.323-.153,1.209,1.209,0,0,1-.161-.6c-.068-.821.648-.52,1.01-.726a1.407,1.407,0,0,1,.186-.109.553.553,0,0,0,.382-.274l.172-.344c.27-.087.4.17.6.254a.823.823,0,0,1,.382.443.632.632,0,0,1-.062.467,1.2,1.2,0,0,1-.263.214C554.056,176.954,554.069,177.309,553.851,177.493Z",
    transform: "translate(-495.106 -133.517)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2011",
    "data-name": "Path 2011",
    d: "M556.571,170.618a.321.321,0,0,1,.347.346.1.1,0,0,1,.039.113q-.022.055-.044.055c-.227.1-.465.459-.691.042C556.04,170.839,556.407,170.775,556.571,170.618Z",
    transform: "translate(-498.169 -130.062)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2012",
    "data-name": "Path 2012",
    d: "M555.214,175.837l.111.36-.437-.022a.4.4,0,0,1-.442.1.315.315,0,0,1-.154-.168.788.788,0,0,1,.175-.53l.072-.085Z",
    transform: "translate(-496.805 -133.569)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2013",
    "data-name": "Path 2013",
    d: "M558.739,174.427c-.262.03-.328-.235-.5-.34-.033-.268.234-.333.337-.509a.239.239,0,0,1,.235-.013C559.132,173.881,559.053,174.163,558.739,174.427Z",
    transform: "translate(-499.658 -132.163)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2014",
    "data-name": "Path 2014",
    d: "M559.176,172.35h-.166a.359.359,0,0,1-.172-.345c0-.056,0-.112,0-.168l.159,0,.512,0v.341C559.448,172.332,559.358,172.435,559.176,172.35Z",
    transform: "translate(-500.093 -130.936)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    "data-name": "Path 2015",
    d: "M554.051,173.736c-.415-.348-.126-.518.17-.685.53.23-.1.458,0,.687h0l-.085.058Z",
    transform: "translate(-496.487 -131.812)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2016",
    "data-name": "Path 2016",
    d: "M403.311,93.333l.543.458c-.257.154-.465,0-.681-.1a.261.261,0,0,1-.11-.169.357.357,0,0,1,.062-.2A.147.147,0,0,1,403.311,93.333Z",
    transform: "translate(-387.608 -74.468)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2017",
    "data-name": "Path 2017",
    d: "M402.521,93.89a.808.808,0,0,0,.03.156c-.012.058-.025.116-.038.173l-.3,0q-.005-.171-.011-.342l.069-.072C402.373,93.778,402.464,93.781,402.521,93.89Z",
    transform: "translate(-386.986 -74.826)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2018",
    "data-name": "Path 2018",
    d: "M402.542,92.616l-.153.017a.3.3,0,0,1-.34.037.124.124,0,0,1-.044-.137c.017-.044.034-.066.05-.066l-.012-.022a.551.551,0,0,1,.271-.146h.1Z",
    transform: "translate(-386.838 -73.751)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2019",
    "data-name": "Path 2019",
    d: "M402.192,91.85a1.194,1.194,0,0,1,.007-.155.325.325,0,0,1,.358.166h-.025A.243.243,0,0,1,402.192,91.85Z",
    transform: "translate(-386.978 -73.316)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    "data-name": "Path 2020",
    d: "M400.956,94.7l.161.155Z",
    transform: "translate(-386.085 -75.479)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    d: "M401.719,92.855c0,.054,0,.109,0,.163.058.039.076.076.054.112s-.041.052-.062.052l.009.013-.186-.031.019-.327A1.241,1.241,0,0,1,401.719,92.855Z",
    transform: "translate(-386.502 -74.139)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    d: "M402.168,92.256l.34.012a.316.316,0,0,1-.35.147C402.163,92.362,402.166,92.309,402.168,92.256Z",
    transform: "translate(-386.954 -73.721)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M447.851,107.742a1.061,1.061,0,0,0-.668.169h-.347a.349.349,0,0,1,.013-.5l-.013-.019,1.011-.014Q447.85,107.561,447.851,107.742Z",
    transform: "translate(-419.144 -84.595)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    d: "M437.392,107.126c0-.106,0-.211,0-.316l1.747-.029a.253.253,0,0,1,.114.017c0,.409-.357.391-.6.511A1.411,1.411,0,0,1,437.392,107.126Z",
    transform: "translate(-412.396 -84.164)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    d: "M445.065,107.5l-.013.5c-.009.068-.017.135-.026.2a.578.578,0,0,1-.157-.035c-.148-.172-.4-.009-.551-.183a.361.361,0,0,1,.063-.456Z",
    transform: "translate(-417.36 -84.679)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    d: "M442.776,107.057v.472c-.132.121-.292.07-.443.072a.464.464,0,0,1-.276-.206.2.2,0,0,1,.048-.213l.509-.337Z",
    transform: "translate(-415.754 -84.21)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    d: "M502.3,140.112l-.33.011-.4-.355.224-.19.507.015.342.36C502.636,140.241,502.49,140.226,502.3,140.112Z",
    transform: "translate(-458.742 -107.746)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M530.02,138.643c0,.1,0,.209,0,.313v.026a.462.462,0,0,1-.438.1,1.4,1.4,0,0,1-.629-.637,2.2,2.2,0,0,1-.174-.279.419.419,0,0,1-.012-.316l.073-.079C529.57,137.594,529.464,138.581,530.02,138.643Z",
    transform: "translate(-478.359 -106.434)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M527.631,135.306l.505-.506-.167.853,0,.01a.286.286,0,0,1-.323.048.337.337,0,0,1-.113-.2A.306.306,0,0,1,527.631,135.306Z",
    transform: "translate(-477.491 -104.31)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M513.3,136.012c.255-.937.878-.753,1.519-.511.19.253-.064.355-.169.508a.323.323,0,0,1-.22.259.3.3,0,0,1-.362-.2c-.041-.084.1-.259-.054-.258-.133,0,.1.2-.05.271a.585.585,0,0,1-.216.082.687.687,0,0,1-.446-.149Z",
    transform: "translate(-467.208 -104.673)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M523.855,137.028l0,.18c.078.5-.461.611-.6.973-.257.33-.541.534-.935.2.164-.127-.237-.468.184-.5.26.029.325-.232.491-.341.112-.1.142-.25.239-.357.076-.082.195-.087.278-.157l0,0A.228.228,0,0,1,523.855,137.028Z",
    transform: "translate(-473.713 -105.857)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M524.461,134.59l-.178.178c-.5-.069-.451-.565-.664-.858,0-.055,0-.111,0-.166l.174-.175.167,0c.113.017.224.192.338,0h.165C524.585,133.911,524.081,134.251,524.461,134.59Z",
    transform: "translate(-474.66 -103.423)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M518.934,139.333l-.173.343a.247.247,0,0,1-.191.085c-.254-.013-.478-.174-.74-.152a.576.576,0,0,1-.47-.343.245.245,0,0,1,.133-.211,2.583,2.583,0,0,1,.8-.071.764.764,0,0,1,.644.178C518.932,139.219,518.933,139.276,518.934,139.333Z",
    transform: "translate(-470.141 -107.311)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M517.846,138.313l-.836.024a.141.141,0,0,1-.193,0c-.065-.19.087-.261.19-.36l.171-.169a.938.938,0,0,0,.68.151A.249.249,0,0,1,517.846,138.313Z",
    transform: "translate(-469.738 -106.474)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M523.6,134.789l.664.858a.52.52,0,0,1-.339.336C523.925,135.554,523.52,135.239,523.6,134.789Z",
    transform: "translate(-474.639 -104.302)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M520.56,138.469q.006-.176.012-.352c.4-.214.591-.028.671.365Z",
    transform: "translate(-472.453 -106.63)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M513.868,138.3c.051.013.1.028.151.044,0,.049,0,.1,0,.146-.3.226-.47.6-.824.774a.6.6,0,0,1-.526-.249c-.1-.421.6-.724.169-1.193h.51C513.5,138.008,513.733,138.1,513.868,138.3Z",
    transform: "translate(-466.747 -106.486)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    d: "M507.714,143.358l-.5.175c-.231-.17-.921-.312-.024-.547.138-.036.243-.2.363-.3.1.011.119.107.168.171l0,.173A.218.218,0,0,1,507.714,143.358Z",
    transform: "translate(-462.473 -109.978)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    d: "M510.243,142.92q0-.166.008-.331c.36.009.726.027.673-.515l.507.173c.057.039.075.077.054.112s-.041.052-.061.052C511.1,142.747,510.769,143.064,510.243,142.92Z",
    transform: "translate(-465.003 -109.539)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M509.4,140.918l-.168-.171c.183-.247-.053-.352-.165-.5l.185-.187c.152-.067.308-.141.417.062C509.862,140.484,509.5,140.655,509.4,140.918Z",
    transform: "translate(-464.151 -108.042)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    d: "M511.417,137.815c.017.116.159.264-.061.318-.057.014-.186-.051-.194-.1-.035-.194.126-.2.255-.223Z",
    transform: "translate(-465.662 -106.477)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M521.7,125.673c-.056.341-.278.682,0,1.023-.009.238.033.489-.162.681l-.009.008-.333-.007q0-.339,0-.678t0-.685C521.207,125.669,521.451,125.67,521.7,125.673Z",
    transform: "translate(-472.907 -97.747)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M504.187,141.071l.347-.159.34.151c-.281.011-.28.591-.687.347Q504.186,141.241,504.187,141.071Z",
    transform: "translate(-460.629 -108.704)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M527,136.775h-.338c.068-.147.2-.166.337-.174Z",
    transform: "translate(-476.859 -105.605)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M522.41,129.994c.014-.237-.084-.5.163-.681C522.8,129.608,522.9,129.873,522.41,129.994Z",
    transform: "translate(-473.783 -100.365)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M437.865,108.02c.006.055.014.11.021.165-.174.232-.445.178-.679.233-.228-.079-.5-.015-.69-.22l-.343-.006a.385.385,0,0,1,.339-.182Z",
    transform: "translate(-411.517 -85.049)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M437.409,108.667c.232.018.49-.078.672.159-.011.1-.114.118-.163.183h0C437.682,109,437.417,109.026,437.409,108.667Z",
    transform: "translate(-412.408 -85.518)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M439.239,108.987l.163-.183.7-.172.146.18c-.029.106-.126.118-.207.15Z",
    transform: "translate(-413.73 -85.496)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M442.112,109.423l.207-.15.505,0c.169.036.376-.038.489.167Z",
    transform: "translate(-415.805 -85.956)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M515.537,170.225l-.84,0-.166-.331.082-.091a4.519,4.519,0,0,1,.951-.2.46.46,0,0,1,.353.1.284.284,0,0,1-.039.352A.374.374,0,0,0,515.537,170.225Z",
    transform: "translate(-468.099 -129.327)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    d: "M511.5,169.387l.336-.341h0a.637.637,0,0,1,.523-.13.441.441,0,0,1,.185.119c.056.188-.094.259-.2.357l0,0-.49.166A.383.383,0,0,1,511.5,169.387Z",
    transform: "translate(-465.907 -128.83)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2052",
    "data-name": "Path 2052",
    d: "M510.613,170.625a.384.384,0,0,1,.353.174c-.131.2-.34.156-.528.177a.358.358,0,0,1-.165-.348Z",
    transform: "translate(-465.024 -130.067)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    d: "M527.446,170.051q-.058,0-.116-.008,0-.077,0-.153c.046-.087.1-.085.15-.006l-.007,0Z",
    transform: "translate(-477.34 -129.491)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    d: "M520.668,168.648l-.171.168-.318.007c-.282-.064-.347-.3-.415-.535a.4.4,0,0,1,.182-.3.482.482,0,0,1,.578-.029A.621.621,0,0,1,520.668,168.648Z",
    transform: "translate(-471.878 -128.087)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M519.406,169.274l.353.528a.611.611,0,0,0-.044.129c-.193.071-.325-.071-.479-.138l-.01-.347a.137.137,0,0,1-.041-.124c.009-.043.02-.065.031-.065A.157.157,0,0,1,519.406,169.274Z",
    transform: "translate(-471.458 -129.067)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    d: "M525.473,164.647H525.4l-.075.007a1.2,1.2,0,0,1-.022-.149c-.219-.245-.261-.584-.445-.848-.087-.3-.412-.531-.271-.9.233-.187.473-.317.758-.1.057.2-.013.431.126.617.189.26,0,.6.176.86Z",
    transform: "translate(-475.333 -124.255)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    d: "M522.543,168.5l-.182-.687.07-.075a.633.633,0,0,1,.3-.071.659.659,0,0,1,.3.075.393.393,0,0,1,.125.17.365.365,0,0,1-.105.392l-.219.2Z",
    transform: "translate(-473.753 -127.944)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    d: "M524.966,166.213c.378.2.326.551.317.889l-.076,0-.076,0a.984.984,0,0,1-.519-.371v0c-.173-.232-.061-.4.121-.551A.2.2,0,0,1,524.966,166.213Z",
    transform: "translate(-475.316 -126.853)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M524.837,168.209a.515.515,0,0,1,.519.371c-.132.22-.328.151-.516.116Q524.838,168.452,524.837,168.209Z",
    transform: "translate(-475.541 -128.33)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M557.795,202.785l.334.035c.013.463.526.205.672.478-.155.259-.494.116-.676.317l-.315.024-.183-.324q0-.173-.006-.346Z",
    transform: "translate(-499.214 -153.19)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M550.675,178.047c-.219.252-.513.147-.775.151s-.355.089-.243.344c-.229.334-.2.93-.833.856a.541.541,0,0,1-.347.337l-.013-.331c.173-.389.672-.552.7-1.039.093-.281.218-.526.567-.523A4.378,4.378,0,0,1,550.675,178.047Z",
    transform: "translate(-492.602 -135.255)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M549.759,181.19c.5-.06.381-.744.833-.856q0,.344,0,.688a1.065,1.065,0,0,1-.333.679l-.006,0C549.886,181.736,549.972,181.315,549.759,181.19Z",
    transform: "translate(-493.537 -137.048)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M555,183.8l-.341,1.01-.329.033c-.01-.223-.11-.358-.345-.361l.172-.51c.267-.121.506-.379.84-.174Z",
    transform: "translate(-496.587 -139.483)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M554.8,183.075c-.292,0-.482.5-.839.174l-.173-.177a.229.229,0,0,1,0-.337C554.123,182.851,554.628,182.456,554.8,183.075Z",
    transform: "translate(-496.392 -138.76)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M552.24,182.783c0,.112,0,.225,0,.338l-.669.341a.916.916,0,0,1,.333-.679Z",
    transform: "translate(-494.847 -138.809)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M558.838,180.6c.005-.329-.059-.687.341-.855a.769.769,0,0,1-.006.852Z",
    transform: "translate(-500.093 -136.626)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M560.045,180.592q0-.426.006-.852l.335,0q.078.059.053.118c-.017.04-.034.06-.051.06l-.174.679h-.084Z",
    transform: "translate(-500.965 -136.619)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068",
    "data-name": "Path 2068",
    d: "M533.7,172.981h.17c.147-.067.306.066.452-.027a.235.235,0,0,1,.049.379l-.488.132a.213.213,0,0,0-.369.026C533.27,173.206,533.347,173.041,533.7,172.981Z",
    transform: "translate(-481.705 -131.742)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    d: "M551.5,176.2c-.257-.026-.334.224-.5.334v-1.183a.161.161,0,0,1,.2-.036,2.508,2.508,0,0,0,.639.41.56.56,0,0,1,.159.151q0,.076.009.152C551.871,176.2,551.629,176.038,551.5,176.2Z",
    transform: "translate(-494.43 -133.428)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    d: "M550.066,170.579c.273.249.145.572.157.869-.179.095-.228-.068-.312-.161l-.183-.695Z",
    transform: "translate(-493.516 -130.034)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M550.386,173.1l.312.161q.016.167.032.333a.129.129,0,0,1-.03.179h-.146Z",
    transform: "translate(-493.99 -131.845)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M536.46,170.353a.356.356,0,0,0-.168-.349,1.013,1.013,0,0,1,.507-1.194h.338c.132.6.367,1.222-.318,1.662A.3.3,0,0,1,536.46,170.353Z",
    transform: "translate(-483.79 -128.762)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M536.012,166.625a4.909,4.909,0,0,0-.507,1.194c-.113.188-.223.016-.334,0,.159-.561.448-1.115.035-1.7-.084-.118.008-.261.131-.349.247.2.342.564.674.683C536.012,166.512,536.012,166.569,536.012,166.625Z",
    transform: "translate(-483.004 -126.578)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M539.265,167.785l.493-.406C539.826,167.82,539.537,167.765,539.265,167.785Z",
    transform: "translate(-485.96 -127.733)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M526.183,143.3a.3.3,0,0,0-.335-.336.291.291,0,0,1-.047-.343.831.831,0,0,1,.927-.47.507.507,0,0,1,.2.138,1.073,1.073,0,0,1,.113.59,1.047,1.047,0,0,1-.067.35.439.439,0,0,1-.151.175.812.812,0,0,1-.662.092A.142.142,0,0,1,526.183,143.3Z",
    transform: "translate(-476.212 -109.581)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M520.335,150.158c0-.245,0-.493-.334-.514.067-.146.21-.305.189-.438-.1-.631.225-.351.475-.247a.65.65,0,0,1,.29.364,1.228,1.228,0,0,1,.064.465.743.743,0,0,1-.093.323A.537.537,0,0,1,520.335,150.158Z",
    transform: "translate(-472.049 -114.381)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M518.849,143.6c-.445-.1-.962.386-1.351-.17-.08-.275.095-.359.3-.418a2.685,2.685,0,0,1,.367.025,1.136,1.136,0,0,1,.715.2A.313.313,0,0,1,518.849,143.6Z",
    transform: "translate(-470.227 -110.216)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M513.3,144a1.29,1.29,0,0,0,.513-.852.164.164,0,0,1,.169-.054.29.29,0,0,1,.16.228C514.22,144,513.9,144.177,513.3,144Z",
    transform: "translate(-467.21 -110.27)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    d: "M522.4,143.758l0-.338a.485.485,0,0,1,.2-.146.984.984,0,0,1,.731.054l.086.092q0,.169,0,.339l-.341,0a.584.584,0,0,1-.673,0Z",
    transform: "translate(-473.781 -110.371)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    d: "M515.834,142.442l-.169-.177c-.064-.144.017-.23.12-.308.339-.132.647-.188.725.309a.592.592,0,0,0-.338.342Z",
    transform: "translate(-468.901 -109.389)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    d: "M525.485,146.307l0,.182c.089.166-.01.276-.109.388a1.26,1.26,0,0,1-.388.184.247.247,0,0,1-.192-.071A.746.746,0,0,1,525.485,146.307Z",
    transform: "translate(-475.514 -112.583)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2082",
    "data-name": "Path 2082",
    d: "M523.06,148.736l.176.008a.155.155,0,0,1,.058.128c0,.049-.011.074-.022.074a.678.678,0,0,1-.187.131,1.513,1.513,0,0,1-.538.173.375.375,0,0,1-.156-.342C522.569,148.671,522.83,148.766,523.06,148.736Z",
    transform: "translate(-473.775 -114.329)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    d: "M522.411,145.115l.673,0C522.859,145.239,522.633,145.715,522.411,145.115Z",
    transform: "translate(-473.789 -111.726)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    d: "M520.321,153.412a.429.429,0,0,1,.5,0c.5.036.712.232.385.721a.6.6,0,0,1-.467.09,1.748,1.748,0,0,1-.424-.177,1.5,1.5,0,0,1-.332-.291A.313.313,0,0,1,520.321,153.412Z",
    transform: "translate(-472.034 -117.634)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2085",
    "data-name": "Path 2085",
    d: "M521.682,159.99c-.157-.114-.2-.381-.468-.343q-.01-.178-.021-.356l.093-.089a.571.571,0,0,1,.61.048.508.508,0,0,1,.1.368A.427.427,0,0,1,521.682,159.99Z",
    transform: "translate(-472.91 -121.807)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2086",
    "data-name": "Path 2086",
    d: "M520.318,157.612c-.455-.053-.3-.413-.337-.68a.382.382,0,0,1,.3-.13.473.473,0,0,1,.207.082.6.6,0,0,1-.02.54,1.888,1.888,0,0,1-.12.185Z",
    transform: "translate(-472.035 -120.129)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M520.323,155.513l-.342.006q0-.341,0-.683a.363.363,0,0,1,.347.177A.371.371,0,0,1,520.323,155.513Z",
    transform: "translate(-472.034 -118.715)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    d: "M516.125,167.571a.47.47,0,0,1-.026.125l-.321.015a1.081,1.081,0,0,1-.853-.174v-.008a.23.23,0,0,1,0-.338l.165-.335c.172.044.346.267.513-.009a.211.211,0,0,1,.227-.027A.632.632,0,0,1,516.125,167.571Z",
    transform: "translate(-468.331 -127.316)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    d: "M513.366,168.193q0,.169,0,.338l-.674,0,.175-.336Z",
    transform: "translate(-466.769 -128.319)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    d: "M517.731,165.69l-.167-.009c0-.108,0-.216,0-.323l.168-.042.494-.139a.371.371,0,0,1-.009.574A.44.44,0,0,1,517.731,165.69Z",
    transform: "translate(-470.289 -126.15)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    d: "M522.951,159.732l.191-.358a.832.832,0,0,1,.25-.183c.213-.063.278-.3.462-.4a.284.284,0,0,1,.3.076.825.825,0,0,0,.674.85l0,.342a.411.411,0,0,1-.211.14.457.457,0,0,1-.466-.144c-.225-.157-.447.076-.671,0a.49.49,0,0,1-.5-.17Q522.965,159.81,522.951,159.732Z",
    transform: "translate(-474.179 -121.55)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M522.54,162.731c.183.01.381-.027.5.17.008.329.442.48.35.851l-.189.017a.717.717,0,0,1-.544-.04.618.618,0,0,1-.186-.126.772.772,0,0,1-.123-.542Z",
    transform: "translate(-473.742 -124.392)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M520.624,163.906c.2.124.182.328.185.523a.427.427,0,0,1-.17.135.921.921,0,0,1-.641.035q-.022-.168-.044-.336l.353-.339Z",
    transform: "translate(-472.015 -125.236)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    d: "M515,140.868l-.17.17-.16,0-.182-.007c0-.055.006-.11.007-.165.222-.305.295-.8.843-.7l.506.186a.176.176,0,0,1-.006.219C515.613,140.822,515.177,140.454,515,140.868Z",
    transform: "translate(-468.071 -108.163)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    d: "M566.116,204.669l.843,0q-.005.174-.011.348L566.12,205Q566.118,204.834,566.116,204.669Z",
    transform: "translate(-505.349 -154.544)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    d: "M561.74,205.606l.192.308-.2.051-.473-.006q-.01-.171-.02-.342A.329.329,0,0,1,561.74,205.606Z",
    transform: "translate(-501.824 -155.137)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M560.438,204.972l-.505.011-.5-.055c.078-.427.428-.26.676-.317l.508.016.2.259Z",
    transform: "translate(-500.522 -154.503)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M561.271,177.5c0-.059,0-.118,0-.178q0-.255,0-.51c.118-.143.177-.339.366-.419a.283.283,0,0,1,.309.077q0,.167,0,.333c-.285.14-.373.429-.5.684A1.566,1.566,0,0,0,561.271,177.5Z",
    transform: "translate(-501.849 -134.2)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M560.725,173.883a.309.309,0,0,1-.338.341l-.339-.344c.032-.284.239-.566,0-.85l.337-.171a.445.445,0,0,1,.507,0,.3.3,0,0,1,.068.338C560.862,173.418,560.934,173.7,560.725,173.883Z",
    transform: "translate(-500.967 -131.616)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M563.091,173.349v-.337c.393-.107.786.284,1.18,0l-.34.68-.675-.335A.1.1,0,0,1,563.091,173.349Z",
    transform: "translate(-503.165 -131.77)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M562.649,174.259l.166.009q0,.339,0,.678h-.338C562.5,174.709,562.4,174.441,562.649,174.259Z",
    transform: "translate(-502.723 -132.68)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M531.192,142.116l.506,0a1.189,1.189,0,0,0,.167.674c-.233.194-.435.06-.64-.059a.494.494,0,0,1-.138-.188.632.632,0,0,1-.017-.235A.389.389,0,0,1,531.192,142.116Z",
    transform: "translate(-480.039 -109.57)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M531.716,145.157l-.5-.176a.373.373,0,0,1-.067-.472c.36-.178.5.179.736.307Z",
    transform: "translate(-480.059 -111.255)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M532.112,144.407c-.288.023-.433-.242-.663-.338a.128.128,0,0,1-.035-.118c.01-.04.021-.06.032-.06l.668.178Q532.113,144.238,532.112,144.407Z",
    transform: "translate(-480.288 -110.846)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M528.843,147.157l0-.179a.973.973,0,0,1-.091-.384c.028-.151.163-.209.257-.3h0c.158-.033.226.021.179.188l.168.5C529.231,147.177,529.029,147.145,528.843,147.157Z",
    transform: "translate(-478.363 -112.565)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M529.858,144.333l-.179-.188q0-.164.007-.328c.234-.1.084-.592.5-.512,0,.053,0,.106.008.158s0,.119,0,.178q0,.251-.006.5,0,.089,0,.179Z",
    transform: "translate(-479.038 -110.419)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M527.621,164.924a1.578,1.578,0,0,1-.333-.86c.067-.317.239-.477.575-.4.269.153.248.352.092.575Z",
    transform: "translate(-477.311 -125.049)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M529.094,164.019c-.006-.186.03-.386-.165-.509q-.084-.054-.058-.111c.017-.039.034-.058.052-.058l.175,0a.317.317,0,0,1,.323.385C529.407,163.931,529.274,164,529.094,164.019Z",
    transform: "translate(-478.449 -124.827)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M524.956,157.628l-.331.026a.469.469,0,0,1-.376.081.265.265,0,0,1-.182-.185.487.487,0,0,1,.331-.417,1.273,1.273,0,0,1,1.228.164l-.164.3-.33.025Z",
    transform: "translate(-474.984 -120.311)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M526.1,156.91l-1.344-.009a.181.181,0,0,1,.021-.234,1.033,1.033,0,0,1,.613-.151,1.848,1.848,0,0,1,.382.025.7.7,0,0,1,.331.182l.183.158Z",
    transform: "translate(-475.459 -119.923)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M528.464,155.517l-.338,0a.5.5,0,0,1,0-.682v0a.31.31,0,0,1,.339.34C528.467,155.289,528.466,155.4,528.464,155.517Z",
    transform: "translate(-477.82 -118.715)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M523.337,153.1c.209-.393-.08-.533-.34-.688,0-.114.008-.228.011-.342a.439.439,0,0,1,.328-.131.78.78,0,0,1,.511.3.52.52,0,0,1,.334.514c-.016.037-.031.074-.046.112-.179.235-.378.428-.708.315Z",
    transform: "translate(-474.212 -116.629)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M524.47,150.271l-.505-.168c-.237-.341-.03-.595.164-.851l.165,0a.1.1,0,0,1,.173,0l.17.514c.121.2-.182.192-.167.341C524.47,150.161,524.47,150.216,524.47,150.271Z",
    transform: "translate(-474.834 -114.665)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M527.25,154.836q0,.341,0,.682h-.336a.5.5,0,0,1,0-.682l0,0Z",
    transform: "translate(-476.942 -118.712)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M525.632,151.541c-.471-.377.223-.172.167-.341l.176.167A.361.361,0,0,1,525.632,151.541Z",
    transform: "translate(-475.996 -116.101)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M525.6,147.843l-.173,0a1.5,1.5,0,0,0,0-.169.341.341,0,0,1,.33-.175c.222-.082.388-.4.685-.17.014.115.189.229,0,.344-.26-.026-.329.236-.5.341A.35.35,0,0,0,525.6,147.843Z",
    transform: "translate(-475.965 -113.258)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M551.52,174.932c.01-.06.019-.119.03-.179.325-.182.507.317.823.178l0,0c.084.216-.076.348-.169.5C551.791,175.528,551.66,175.224,551.52,174.932Z",
    transform: "translate(-494.809 -133.006)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M552.8,178.075c.117-.209.322-.153.5-.172l.512,0c0,.062-.006.123-.009.185Z",
    transform: "translate(-495.735 -135.3)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M553.99,176l.169-.5.167,0c.194.26-.083.362-.173.526A.859.859,0,0,1,553.99,176Z",
    transform: "translate(-496.593 -133.566)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    d: "M402.168,93.644c0-.055.005-.109.008-.164l.336,0c-.005.061-.01.121-.016.182Z",
    transform: "translate(-386.961 -74.602)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    d: "M525.411,138.695c.061-.422.578-.456.69-.834l.336,0c0,.108,0,.216,0,.323,0,.306-.367.436-.359.749a.491.491,0,0,1-.453.04A.369.369,0,0,1,525.411,138.695Z",
    transform: "translate(-475.955 -106.511)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    d: "M527.37,139.7c-.617-.594.383-.372.335-.68l.178.186a.412.412,0,0,1,.038.373C527.769,139.766,527.6,139.879,527.37,139.7Z",
    transform: "translate(-477.225 -107.343)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M529.43,140q.008-.158.017-.316l.495.684c0,.054,0,.108,0,.162a.365.365,0,0,1-.5,0l-.005-.008A.4.4,0,0,1,529.43,140Z",
    transform: "translate(-478.789 -107.819)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M515.66,138.167c-.258-.064-.511-.134-.519-.477l.154-.023q.11-.083.16.047a.337.337,0,0,0,.353.139Z",
    transform: "translate(-468.539 -106.348)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M515.394,136.954c-.053-.017-.106-.033-.16-.047l-.178-.258a.6.6,0,0,1,.534-.02Z",
    transform: "translate(-468.478 -105.588)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M522.588,140.828l.185.189a.235.235,0,0,1,.029.23.763.763,0,0,1-.848.342c-.193-.07-.395-.129-.452-.37a.289.289,0,0,1,.083-.221c.056,0,.112.009.167.012C522.125,141.393,522.348,141.069,522.588,140.828Z",
    transform: "translate(-473.133 -108.644)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M520.047,140.89l-.007.189a.439.439,0,0,1-.2.115.41.41,0,0,1-.465-.288v-.175C519.646,140.57,519.826,140.821,520.047,140.89Z",
    transform: "translate(-471.595 -108.536)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M514.689,169.408a1.328,1.328,0,0,1,.853.174c-.3.3-.678.113-1.017.168Z",
    transform: "translate(-468.095 -129.187)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M520.009,165.93a.911.911,0,0,1,.651-.164.5.5,0,0,1-.012.679l-.014,0-.489.172a.491.491,0,0,1-.163-.512Z",
    transform: "translate(-472.026 -126.567)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M518.679,166.981c.191.126.157.326.163.512l-.17.162-.154.046-.352-.714Z",
    transform: "translate(-470.724 -127.447)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    d: "M527.567,163.329c0,.056,0,.112.006.169-.257-.028-.329.23-.5.332a.442.442,0,0,1-.006-.51Z",
    transform: "translate(-477.093 -124.815)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    d: "M523.273,165.769l.5.184-.166.5-.335,0A.491.491,0,0,1,523.273,165.769Z",
    transform: "translate(-474.314 -126.576)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    d: "M522.75,165.768q0,.34,0,.68l-.339,0q.006-.339.012-.679l.16-.005Z",
    transform: "translate(-473.791 -126.575)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    d: "M525.794,141.165c0-.055,0-.109.006-.164l.505-.017.5-.177q0,.261,0,.521c-.416-.118-.666.255-1.01.35l0-.006A.375.375,0,0,1,525.794,141.165Z",
    transform: "translate(-476.159 -108.629)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    d: "M529.7,142.689h.5c0,.06,0,.119,0,.178-.222.116-.139.536-.5.512Z",
    transform: "translate(-479.056 -109.982)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    d: "M527.306,146.647l-.685.17.183-.333a1.045,1.045,0,0,1,.668-.18Z",
    transform: "translate(-476.829 -112.578)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    d: "M523.475,149.375l-.164.851h-.334q-.011-.258-.023-.516A.547.547,0,0,1,523.475,149.375Z",
    transform: "translate(-474.181 -114.789)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    d: "M517.18,141.456l.5.17c.071.407-.4.269-.5.5l-.173-.168a.476.476,0,0,0-.675-.171C516.446,141.239,516.883,141.527,517.18,141.456Z",
    transform: "translate(-469.402 -109.086)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    d: "M519.382,142.595c-.036-.372.385-.282.5-.5a1.365,1.365,0,0,1,.166,0l.346.328q.087.059.057.118c-.02.038-.04.058-.06.058l-.171,0Z",
    transform: "translate(-471.601 -109.551)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    d: "M523.015,142.591q0-.088,0-.175c.353.074.58-.176.842-.335q0,.254,0,.507Z",
    transform: "translate(-474.225 -109.545)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    "data-name": "Path 2141",
    d: "M522.176,156.068l.5,0v0a.261.261,0,0,1,.068.319.441.441,0,0,1-.25.243.381.381,0,0,1-.383-.235A.279.279,0,0,1,522.176,156.068Z",
    transform: "translate(-473.555 -119.6)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    d: "M521.544,155.635l0,.295a.109.109,0,0,1-.175.047c-.053,0-.106-.005-.159-.012q0-.25.005-.5A.323.323,0,0,1,521.544,155.635Z",
    transform: "translate(-472.923 -119.167)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M523.682,158.914l.147.044a.332.332,0,0,1-.007.483l-.327.005c0-.114,0-.228-.006-.343a.138.138,0,0,1-.046-.128c.01-.046.021-.068.033-.068A.184.184,0,0,1,523.682,158.914Z",
    transform: "translate(-474.533 -121.622)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M521.967,158.516c0,.054-.009.107-.018.16l-.642,0q0-.092.006-.185a.647.647,0,0,1,.651-.18.142.142,0,0,1,.042.137C521.993,158.493,521.98,158.516,521.967,158.516Z",
    transform: "translate(-472.992 -121.194)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    d: "M521.9,157.5a.762.762,0,0,1-.626.155c-.08-.195.083-.324.127-.485l.175-.047.331.193A.129.129,0,0,1,521.9,157.5Z",
    transform: "translate(-472.951 -120.359)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    d: "M524.814,159.644q0-.242.007-.483l.344.007C525.159,159.411,525.15,159.651,524.814,159.644Z",
    transform: "translate(-475.524 -121.825)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M523.583,157.473c0-.062,0-.123.007-.184l.171-.174a.108.108,0,0,1,.164.021l.007.175-.148.314-.174.03Z",
    transform: "translate(-474.635 -120.333)",
    fill: "#23262c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M524.387,155.523c-.055-.005-.11-.012-.165-.021,0-.1,0-.208,0-.313.369.1.522-.337.847-.347q0,.341,0,.682Z",
    transform: "translate(-475.097 -118.72)",
    fill: "#23262c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbkhazia);
export default __webpack_public_path__ + "static/media/abkhazia.b8fe0c9f0d95369a1362042ad7831e41.svg";
export { ForwardRef as ReactComponent };